/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import { computed, nextTick, reactive, readonly, watch } from "vue";
// eslint-disable-next-line import/no-cycle
import {
  Maybe,
  OperatorType,
  TemplateAndTemplateElementsUpdateInput,
  Templates,
  TemplatesElementsInputItem,
  TemplatesInputItem,
  TemplatesParts,
  TemplatesPartsInputItem,
  TemplatesPartsUpdateInputItem,
  TemplatesUpdateInputItem
} from "@/types/generated-types/graphql";
// eslint-disable-next-line import/no-cycle
import {
  asInt,
  br2nl,
  createDomFromString,
  generateSha1HashWithSalt,
  getFirstParent,
  getFirstParentWithId,
  getParents,
  showToastError,
  showToastSuccess
} from "@/helpers";
import { resolveWhatsappTemplateCategory } from "@/utils/whatsapp-template-category";
// eslint-disable-next-line import/no-cycle
import {
  CustomMutation,
  Delete,
  Get,
  Insert,
  List,
  ListSettings,
  Request,
  Update
} from "@/composables/GraphQL";
// eslint-disable-next-line import/no-cycle
import {
  ActiveLiveEditorItemData,
  Configuration,
  Content,
  FieldsGroup,
  FormFields,
  HistoryType,
  Property,
  Section,
  SelectedSyncElement,
  SmartLists,
  StringMap,
  TemplateInformations,
  TemplateParentTypeEnum,
  TemplatePart,
  TemplateStructureEnum,
  Translation,
  TypeCampaignEnum,
  RichTextingData,
  WhatsappData
} from "@/types";
import {
  NextStepEnum,
  ElementPartTypeEnum,
  ResponsiveDisplayStackEnum,
  TemplateWidth,
  WidgetTypeEnum
} from "@/types/enums";
// eslint-disable-next-line import/no-cycle
import {
  addSelectorToRules,
  addSpmElementId,
  addTranslation,
  applyClassBasedStyles,
  applyStylesAdditionnalConfig,
  clearPlaceholder,
  createNewStylesheet,
  formatStylesForSection,
  formatTranslationsForSection,
  generateUniqStructureId,
  getBase64FromUrl,
  getCssOfElement,
  getElementFromIframe,
  getSectionParent,
  getTemplateIframe,
  getTemplateIframeDocument,
  getTemplateParentTypeByType,
  getTranslationIdsFromElement,
  getWidgetType,
  getWidgetTypeFromTemplate,
  isDisplayTemplate,
  isElementVisible,
  isEmailTemplate,
  isFacebookTemplate,
  isPushTemplate,
  isSmsTemplate,
  removeElementStyle,
  replaceTranslationsByKey,
  sanitizeSection,
  stripUnwantedAttributes,
  hasLostSyncedTranslations,
  hasUntranslatedCopies,
  parseStoredJson,
  translationsReferencedBy,
  savedTranslationsReferencedBy,
  getElementStylesheet,
  isRichTextingTemplate,
  isWhatsappTemplate,
  getChildItemsId,
  isV4Template,
  syncTranslationsFromDOM,
  withDesktopLayout
} from "@/components/template-builder/utils/helpers";
import {
  decodeRedirectTemplateId,
  extractRedirectEncodedIds,
  countRedirectReferences,
} from "@/components/template-builder/utils/redirect-utils";
import { hasOnlyConditionalVoucher, htmlHasVoucher } from "@/components/template-builder/utils/voucher-detection";
// eslint-disable-next-line import/no-cycle
import { validateWhatsappVariablePosition } from "@/components/template-builder/validators";
import {
  faChevronLeft,
  faChevronRight
} from "@/components/template-builder/utils/icons-definition";
// eslint-disable-next-line import/no-cycle
import { refreshWhatsappSmartlist } from "@/components/template-builder/setters/whatsapp-smart-product-list";
// eslint-disable-next-line import/no-cycle
import { refreshRcsSmartlist } from "@/components/template-builder/setters/rcs-smart-product-list";
import { parsePhoneNumber } from "libphonenumber-js";
import moment from "moment";
// eslint-disable-next-line import/no-cycle
import {
  checkIfSavePointNeeded,
  createHistory,
  markTranslationsAsChanged
} from "@/composables/template-editor/History";
// eslint-disable-next-line import/no-cycle
import { getShopDefaultLang, UserState } from "@/composables/User";
// eslint-disable-next-line import/no-cycle
import {
  duplicateCssOfElement,
  duplicateElement
} from "@/components/template-builder/utils/action-buttons-handlers";
import { Md5 } from "ts-md5";
// eslint-disable-next-line import/no-cycle
import {
  clearCssPropertyCache,
  getAttributeByName,
  getContent,
  getCssPropertyByName
} from "@/components/template-builder/getters";
// eslint-disable-next-line import/no-cycle
import { i18n } from "@/i18n";
// eslint-disable-next-line import/no-cycle
import {
  ACTIONS_BUTTON_GROUP,
  BUILDER_ELEMENT_ACTIVE_CLASS,
  BUILDER_ELEMENT_HOVER_CLASS,
  BUILDER_EMBED_REPLACED_ELEMENT_CLASS,
  BUILDER_SORTABLE_CHOSEN_CLASS,
  BUILDER_SORTABLE_DRAG_CLASS,
  BUILDER_SORTABLE_GHOST_CLASS,
  CUSTOM_WIDGET_CSS_PREFIX,
  HIDE_MOBILE_ATTRIBUTE,
  MEDIA_URL_PART_RELOAD_CACHE,
  PERCENTAGE_WIDTH_ATTRIBUTE,
  PRODUCTS_LISTS_CLASSES,
  TEMPLATE_COLUMN_IDENTIFIER,
  TEMPLATE_PART_ELEMENT_IDENTIFIER,
  TEMPLATE_PART_ELEMENT_PART_TYPE,
  TEMPLATE_PART_ELEMENT_PART_TYPES,
  TEMPLATE_PART_ELEMENT_SUBTYPE,
  TEMPLATE_SECTION_CLASS,
  TEMPLATE_SECTION_IDENTIFIER,
  TEMPLATE_SYNC_ELEMENT_CLASS,
  TEMPLATE_SYNC_ELEMENT_IDENTIFIER,
  TEMPLATE_SYNC_ELEMENT_IDs,
  TEMPLATE_SYNC_ELEMENT_NAME,
  TEMPLATE_WIDGET_IDENTIFIER,
  TEMPLATE_WIDGET_IDENTIFIER_PREFIX,
  TRANSLATION_ATTRIBUTE,
  TRANSLATION_MARKUP,
  VARIABLES_V3_TO_V4,
  WIDGET_DRAGGABLE_CLASS,
  WIDGETS_PLACEHOLDER_IDENTIFIER
} from "@/components/template-builder/utils/constants";
// eslint-disable-next-line import/no-cycle
import {
  addOrUpdateDynamicStyle,
  cleanupDynamicStyle,
  clearDynamicStylesCache,
  computeActiveSection,
  getDynamicStylesForSelector,
  getTemplateForms,
  getTemplateFormButtons,
  getTemplateWidgets,
  removeDynamicStyle,
  moveDynamicStyleFromSectionToAnother
} from "@/components/template-builder/utils/parser";
// eslint-disable-next-line import/no-cycle
import { rawPrivacyPolicy, rawTrackingMention } from "@/components/template-builder/config/templates/popup/raw-html-config";
import {
  DEFAULT_MOBILE_DEVICE,
  DESKTOP_LAYOUT_NARROWEST_WIDTH,
  EditorDevice,
  isMobileViewportWidth
} from "@/configs/editor-devices";
// eslint-disable-next-line import/no-cycle
import { rawMandatoryVariablesWidget } from "@/components/template-builder/config/templates/email/raw-html-config";
// eslint-disable-next-line import/no-cycle
import { rawWidgetDisclosure } from "@/components/template-builder/config/templates/popup-v4/raw-html-config";
// eslint-disable-next-line import/no-cycle
import {
  destroyIframeSortables,
  resetListeners
} from "@/components/template-builder/utils/listeners";
// eslint-disable-next-line import/no-cycle
import {
  getWidgetStructures,
  RAW_PLACEHOLDER_STRUCTURE_MAP
} from "@/components/template-builder/utils/raw-html-templates";
// eslint-disable-next-line import/no-cycle
import {
  createTranslationIdentifier,
  generateTranslations,
  translateDocument,
  updateTranslation,
  fixMissingTranslations,
  unwrapImageWidgetTranslations
} from "@/components/template-builder/utils/translate";
// eslint-disable-next-line import/no-cycle
import {
  refreshSmartProductList,
  toggleFormFieldsError,
  clearSmartListRenderCache
} from "@/components/template-builder/callbacks";
// eslint-disable-next-line import/no-cycle
import { store } from "@/store";
// eslint-disable-next-line import/no-cycle
import {
  getLocalStorageElement,
  removeLocalStorageElement,
  setLocalStorageElement
} from "@/helpers/LocalStorage";
// eslint-disable-next-line import/no-cycle
import {
  addItemElementDecorations,
  removeActiveItemElementDecorations,
  removeItemElementDecorations
} from "@/components/template-builder/utils/active-item-builder";
// eslint-disable-next-line import/no-cycle
import {
  AutomatedScenarioState,
  getEditingTemplateFromCampaign
} from "@/composables/AutomatedScenarios";
// eslint-disable-next-line import/no-cycle
import { ErrorConfigForm } from "@/types/automated-scenarios";
import { maxLength, minLength, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
// eslint-disable-next-line import/no-cycle
import { localizedTextInputValidator } from "@/helpers/CustomValidator";
import CryptoJS from "crypto-js";
import { loadImage } from "@/composables/loadImage";
// eslint-disable-next-line import/no-cycle
import { retrieveServicesData } from "@/composables/shop/MyShopParameters";
import { ZipFile } from "@/types/zip-file-uploader-types";
// eslint-disable-next-line import/no-cycle
import { uploadFileToMedia } from "@/composables/configs/configuration";
import beautifier from "js-beautify";
// eslint-disable-next-line import/no-cycle
import {
  reorderColumn,
  setSmartListImageWidth,
  validateAndRepairAllVml,
  restoreIntegrationImagesCanonicalSrc,
  copyVmlTableOffsets,
  copyVmlButtons,
  getWidgetCodeWithoutVmlShape,
  restoreWidgetCodeInVmlShape
} from "@/components/template-builder/setters";

// eslint-disable-next-line import/no-cycle
import { TemplateTypeEnum } from "@/composables/shop/Templates";
import {
  useTemplatesApi,
  TemplateFetchResult
} from "@/composables/templates/useTemplatesApi";
import { nestCall, NestApiType } from "@/composables/nestApi";
import { restoreVariablesInElement } from "@/components/template-builder/utils/variable-image";
// eslint-disable-next-line import/no-cycle
import { restoreCountdownTokensInHtml } from "@/components/template-builder/utils/countdown-email-i18n";

// eslint-disable-next-line import/no-cycle
import { getFormFieldsConfigs } from "@/components/template-builder/config/fields/form-fields-config";
// eslint-disable-next-line import/no-cycle
import getTemplateConfiguration from "@/components/template-builder/config/templates-config";
// eslint-disable-next-line import/no-cycle
import { getFormWidgetsForNextStep } from "@/components/template-builder/config/funnels-config";

import axios from "axios";
import * as cheerio from "cheerio";
import { groupBy } from "lodash";
// eslint-disable-next-line import/no-cycle
import { getDefaultPanel } from "@/components/template-builder/config/sync-elements-config";
// eslint-disable-next-line import/no-cycle
import { customDataDisplay } from "@/components/template-builder/utils/elements-save-definitions";
import getElementStructureConfig from "@/components/template-builder/config/elements-structure-config";
import {
  WhatsappValidationStatus,
  isPendingStatus
} from "@/composables/flows/useWhatsappTemplateValidation";

let translation: any;
(async () => {
  translation = await i18n;
})();

// WhatsApp carousel MutationObservers tracking for cleanup
const whatsappButtonTextObservers: MutationObserver[] = [];
const whatsappCtaObservers: MutationObserver[] = [];

export function cleanupWhatsappObservers(): void {
  whatsappButtonTextObservers.forEach(obs => obs.disconnect());
  const btnCount = whatsappButtonTextObservers.length;
  whatsappButtonTextObservers.length = 0;
  whatsappCtaObservers.forEach(obs => obs.disconnect());
  const ctaCount = whatsappCtaObservers.length;
  whatsappCtaObservers.length = 0;
}

// RCS carousel MutationObservers tracking for cleanup
const rcsButtonTextObservers: MutationObserver[] = [];
const rcsCtaObservers: MutationObserver[] = [];

export function cleanupRcsObservers(): void {
  rcsButtonTextObservers.forEach(obs => obs.disconnect());
  rcsButtonTextObservers.length = 0;
  rcsCtaObservers.forEach(obs => obs.disconnect());
  rcsCtaObservers.length = 0;
}

export interface TemplateRaw {
  id_template: number;
  id_campaign: number | null;
  created_from_campaign: string | null;
  template_config: string;
  label?: string;
  date_modification?: string | null;
  version?: number;
  type?: string;
}

interface TemplateLangRaw {
  id_template: number;
  lang: string;
  subject: string;
  from_email: string;
  from_name: string;
}

export interface FunnelTemplate {
  id: number;
  name: string;
  type: string;
  isGameFunnel?: boolean;
  isGameFunnelGroup?: boolean;
  isGameResult?: boolean;
}

export interface FunnelStep {
  template: FunnelTemplate | null;
  nextSteps: FunnelStep[];
}
interface ListResponse<T> {
  items: Array<T>;
  total: number;
  err: string;
}

export class Template {
  id: number;

  type: string;

  idCampaign: number | null;

  createdFromCampaign: string | null;

  informations: TemplateInformations;

  content: Content;

  sections: Section[];

  translations: Translation[];

  configuration: Configuration;

  activeSection: string | number;

  smartLists: SmartLists;

  edited: boolean;

  forms: FormFields;

  funnel: FunnelStep;

  originTemplateId: string | null;

  dateModification: string | null;

  version: number;

  constructor(
    id = 0,
    type = "",
    idCampaign: number | null = null,
    createdFromCampaign: string | null = null,
    informations = { name: "", lang: "" },
    config: Content = { design: 0, sections: [], forms: {} },
    sections: Section[] = [],
    templateConfig = {},
    edited = false,
    funnel: FunnelStep | null = null,
    dateModification: string | null = null,
    version = 3
  ) {
    this.id = id;
    this.type = type;
    this.idCampaign = idCampaign;
    this.createdFromCampaign = createdFromCampaign;
    this.informations = informations;
    this.content = config;
    this.sections = sections;
    this.configuration = templateConfig;
    this.translations = [];
    this.sections.forEach(section => {
      const sectionTranslation = JSON.parse(
        (section.translations && section.translations !== ""
          ? section.translations
          : "{}"
        ).replace(/(\r\n|\n|\r)/gm, " ")
      );
      if (sectionTranslation) {
        Object.keys(sectionTranslation).forEach((language: string) => {
          Object.keys(sectionTranslation[language]).forEach((key: string) => {
            this.translations.push(
              ...(addTranslation(
                sectionTranslation[language],
                key,
                section.id_template_elements,
                language,
                type
              ) ?? [])
            );
          });
        });
      }
      const sectionData = JSON.parse(section.data || "{}");
      if (Array.isArray(sectionData) && sectionData.length === 0) {
        section.data = "";
      }
    });
    this.activeSection = -1;
    this.smartLists = {};
    this.forms = {};
    this.edited = edited;
    this.configuration.forms = config.forms;
    if (!funnel) {
      this.funnel = { template: null, nextSteps: [] };
    } else {
      this.funnel = funnel;
    }
    this.originTemplateId = null;
    this.dateModification = dateModification;
    this.version = version;
  }
}

// Interface pour représenter un conflit de version détecté
export interface TemplateVersionConflict {
  templateId: number;
  templateName: string;
  localDate: string;
  remoteDate: string;
  templateType: string;
}

interface ToolbarPanels {
  informationPanel: boolean;
  translationPanel: boolean;
  designPanel: boolean;
  configurationPanel: boolean;
  historyPanel: boolean;
  cssPanel: boolean;
  cssPanelMediaQueries: boolean;
  loadElementsPanel: boolean;
  widgetsPanel: boolean;
}

interface HistoryRestoreProgress {
  isRestoring: boolean;
  current: number;
  total: number;
  actionDetail: string;
}

interface LeftToolbarState {
  show: ToolbarPanels;
  hasChanged: boolean;
  needToTranslate: boolean;
  panelLoading: boolean;
  historyRestoreProgress: HistoryRestoreProgress;
}

interface State {
  isTemplateEditorVisible: boolean;
  isLeftToolbarVisible: boolean;
  isConfigurationPanelVisible: boolean;
  lastRollbackId: number;
  leftToolbar: LeftToolbarState; // which tabs are visible in left toolbar
  hasAny: boolean;
  templates: Array<Template>;
  templatesLinkedToCampaign: Array<Template>; // array of templates linked to campaign
  index: number;
  template: Template | null;
  intervals: Record<string, number | null> | null;
  advancedModeEnabled: boolean;
  refreshTemplatesList: boolean;
  isColumnWidgetModalVisible: boolean;
  isLoadElementsModalVisible: boolean;
  loadElementsType: string[];
  testEmailSent: boolean;
  templateWidth: string;
  mobileDevice: EditorDevice;
  selectedTranslationId: string;
  showConfigurationPanelCallback: Function | null;
  sectionsToRefresh: number[];
  templatesFromFunnel: {
    [key: string]: Array<Template>;
  };
  teaserTemplates: {
    [key: string]: Template;
  };
  teaserCreationInProgress: boolean;
  funnelStepKey: number;
  additionalLoadElementsParams: {
    elementPartType: string;
    elementSubtype: string;
    fromSyncElement?: boolean;
  } | null;
  versionConflicts: TemplateVersionConflict[];
  preventDateModificationUpdate: boolean;
  initialWhatsappDataHash: string | null;
  isOpenedFromScenario: boolean;
  whatsappHashChangeConfirmCallback: (() => Promise<void>) | null;
  showWhatsappHashChangeModal: boolean;
  whatsappHashChanged: boolean;
  widgetsPanelCollapsedSections: Record<string, boolean>;
}

const state = reactive<State>({
  isTemplateEditorVisible: false,
  isLeftToolbarVisible: false,
  isConfigurationPanelVisible: false,
  lastRollbackId: 0,
  leftToolbar: {
    show: {
      informationPanel: false,
      translationPanel: false,
      designPanel: false,
      configurationPanel: false,
      historyPanel: false,
      cssPanel: false,
      cssPanelMediaQueries: false,
      loadElementsPanel: false,
      widgetsPanel: false
    },
    hasChanged: false,
    needToTranslate: false,
    panelLoading: false,
    historyRestoreProgress: {
      isRestoring: false,
      current: 0,
      total: 0,
      actionDetail: ""
    }
  },
  hasAny: false,
  templates: [],
  templatesLinkedToCampaign: [],
  index: -1,
  template: null,
  intervals: null,
  advancedModeEnabled: false,
  refreshTemplatesList: false,
  isColumnWidgetModalVisible: false,
  isLoadElementsModalVisible: false,
  testEmailSent: false,
  templateWidth: TemplateWidth.DESKTOP,
  mobileDevice: DEFAULT_MOBILE_DEVICE,
  selectedTranslationId: "",
  showConfigurationPanelCallback: null,
  sectionsToRefresh: [],
  templatesFromFunnel: {},
  teaserTemplates: {},
  teaserCreationInProgress: false,
  funnelStepKey: 0,
  loadElementsType: [],
  additionalLoadElementsParams: null,
  versionConflicts: [],
  preventDateModificationUpdate: false,
  initialWhatsappDataHash: null,
  isOpenedFromScenario: false,
  whatsappHashChangeConfirmCallback: null,
  showWhatsappHashChangeModal: false,
  whatsappHashChanged: false,
  widgetsPanelCollapsedSections: {
    native: false,
    structure: false,
    form: true,
    game: false,
    apps: false
  } as Record<string, boolean>
});

let translator: any;
(async () => {
  translator = await i18n;
})();

export const TemplateEditorState = readonly(state);

const TEMPLATE_RAW_FIELDS = [
  "id_template",
  "created_from_campaign",
  "id_campaign",
  "template_config",
  "label",
  "date_modification",
  "version",
  "type"
];

const templateRawCache = new Map<number, TemplateRaw>();
const deferredGamePrizeTemplatesByOrigin: Record<string, any[]> = {};

const mergeTemplatesIntoFunnelList = (
  originId: string,
  templates: any[],
  funnel: any
) => {
  if (!state.templatesFromFunnel[originId]) {
    state.templatesFromFunnel[originId] = [];
  }
  const list = state.templatesFromFunnel[originId];
  for (const tmpl of templates) {
    if (!list.find((t: { id: number }) => t.id === tmpl.id)) {
      tmpl.funnel = funnel;
      tmpl.originTemplateId = originId;
      list.push(tmpl);
    }
  }
};

export const flushDeferredGamePrizeTemplates = async (
  originTemplateId?: string
) => {
  if (!state.template) return;
  const originId = originTemplateId || String(
    state.template.originTemplateId || state.template.id
  );
  const queued = deferredGamePrizeTemplatesByOrigin[originId] || [];
  if (!queued.length) return;
  await nextTick();
  await nextTick();
  mergeTemplatesIntoFunnelList(originId, queued, state.template.funnel);
  delete deferredGamePrizeTemplatesByOrigin[originId];
};

const isGameWidgetHtml = (html: string | undefined | null): boolean => {
  if (!html) return false;
  return (
    html.includes("spm_widget_game_wheel") ||
    html.includes("spm_widget_game_slot_machine") ||
    html.includes("spm_widget_game_scratch_card")
  );
};

/**
 * After "save for all instances" or "unlink and save" on a synced game widget, ensure
 * prize result templates exist (new prizes), merge deferred funnel templates from save,
 * rebuild funnel steps from the iframe DOM, and refresh template_config (games_data, etc.).
 */
export const afterSyncedGameWidgetBulkSave = async (ctx: {
  elementType: string;
  elementId: string;
}): Promise<void> => {
  if (!state.template) return;
  if (ctx.elementType !== TemplateStructureEnum.WIDGET) return;

  const el = getElementFromIframe(`#${ctx.elementId}`);
  if (!isGameWidgetHtml(el?.outerHTML)) return;

  await nextTick();
  await nextTick();
  await new Promise<void>(resolve => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });

  store.commit("general/showTheSpinner");
  try {
    const prizeOutcome = await createGamePrizeTemplates(false);
    if (prizeOutcome === false) {
      return;
    }
    await flushDeferredGamePrizeTemplates();
    syncGameFunnelSteps();
    updateSectionsInState(false);
    await updateTemplateConfiguration();
    updateTemplateConfigurationNextIdTemplate();
  } finally {
    store.commit("general/hideTheSpinner");
  }
};

const getCachedTemplateRaw = async (
  id: number
): Promise<TemplateRaw | null> => {
  const cached = templateRawCache.get(id);
  if (cached?.template_config !== undefined) return cached;
  const { item } = await Get<TemplateRaw>({
    name: "Templates",
    id,
    keyName: "id_template",
    fields: TEMPLATE_RAW_FIELDS
  });
  if (item) templateRawCache.set(id, item);
  return item ?? null;
};

const getPartialCachedTemplateRaw = (id: number): TemplateRaw | undefined =>
  templateRawCache.get(id);

export const invalidateTemplateRawCache = (id: number) => {
  templateRawCache.delete(id);
};

/**
 * Vérifie si des templates en localStorage ont des versions plus récentes en base de données
 * @returns Liste des conflits détectés
 */
export const checkTemplateVersionConflicts = async (): Promise<TemplateVersionConflict[]> => {
  const conflicts: TemplateVersionConflict[] = [];

  const templatesSavedInLocalStorage = JSON.parse(
    getLocalStorageElement("templates") ?? "{}"
  );

  if (Object.keys(templatesSavedInLocalStorage).length === 0) {
    return conflicts;
  }

  const templates: Template[] = templatesSavedInLocalStorage.templates || [];

  const templatesWithDates = templates.filter(
    (t: any) => t.dateModification && t.id
  );
  if (templatesWithDates.length === 0) return conflicts;

  const ids = templatesWithDates.map((t: any) => t.id);

  try {
    const { items } = await List<TemplateRaw>({
      name: "Templates",
      settings: {
        filter: [
          {
            field: "id_template",
            value: ids.join(","),
            operator: OperatorType.In
          }
        ],
        limit: ids.length,
        offset: 0,
        order: []
      },
      fields: ["id_template", "date_modification", "label"]
    });

    const remoteById = new Map<number, TemplateRaw>();
    (items ?? []).forEach((item: TemplateRaw) => {
      remoteById.set(item.id_template, item);
      templateRawCache.set(item.id_template, {
        ...templateRawCache.get(item.id_template),
        ...item
      } as TemplateRaw);
    });

    for (const template of templatesWithDates) {
      const remote = remoteById.get((template as any).id);
      if (!remote) continue;

      const localDate = moment(
        (template as any).dateModification,
        "YYYY-MM-DD HH:mm:ss",
        true
      );
      const remoteDate = moment(
        remote.date_modification,
        "YYYY-MM-DD HH:mm:ss",
        true
      );

      const hasLocalChanges = (template as any).edited === true;
      const hasRemoteChanges =
        localDate.isValid() &&
        remoteDate.isValid() &&
        !localDate.isSame(remoteDate);
      if (hasLocalChanges && hasRemoteChanges) {
        conflicts.push({
          templateId: (template as any).id,
          templateName:
            (template as any).informations?.name ||
            remote.label ||
            `Template ${(template as any).id}`,
          localDate: localDate.format("DD/MM/YYYY HH:mm"),
          remoteDate: remoteDate.format("DD/MM/YYYY HH:mm"),
          templateType: (template as any).type
        });
      }
    }
  } catch (error) {
    console.error("Error checking template version conflicts:", error);
  }

  return conflicts;
};

/**
 * Recharge un template depuis la base de données et met à jour le localStorage
 * @param templateId ID du template à recharger
 * @returns true si le rechargement a réussi
 */
export const reloadTemplateFromDatabase = async (
  templateId: number
): Promise<boolean> => {
  try {
    // Récupérer le template actuel depuis localStorage
    const templatesSavedInLocalStorage = JSON.parse(
      getLocalStorageElement("templates") ?? "{}"
    );

    if (Object.keys(templatesSavedInLocalStorage).length === 0) {
      return false;
    }

    const templates = templatesSavedInLocalStorage.templates || [];
    const templateIndex = templates.findIndex(
      (t: Template) => t.id === templateId
    );

    if (templateIndex === -1) {
      return false; // Template non trouvé
    }

    const templateType = templates[templateIndex].type;

    // Fermer l'éditeur actuel
    await hideTemplateEditor();

    // Désactiver le template actuel dans state
    const stateIndex = state.templates.findIndex(t => t.id === templateId);
    if (stateIndex > -1) {
      state.templates.splice(stateIndex, 1);
    }

    // Supprimer du localStorage temporairement
    templates.splice(templateIndex, 1);
    setLocalStorageElement(
      "templates",
      JSON.stringify({
        templates,
        index: templates.length > 0 ? 0 : 0
      })
    );

    // Recharger depuis la BDD (avec skipConflictCheck = true pour éviter la boucle)
    const reloadedTemplate = await activate(
      templateId,
      "",
      templateType,
      -1,
      true,
      null,
      true
    );

    if (!reloadedTemplate) {
      return false;
    }

    await showToastSuccess(
      translation.global.t(
        "templateBuilder.confirm.versionConflict.reloadSuccess"
      )
    );

    return true;
  } catch (error) {
    console.error(
      `Erreur lors du rechargement du template ${templateId}:`,
      error
    );
    await showToastError(
      translation.global.t(
        "templateBuilder.confirm.versionConflict.reloadError"
      )
    );
    return false;
  }
};

const getTemplatesSavedInLocalStorage = async () => {
  // Get templates from local storage if exists
  const templatesSavedInLocalStorage = JSON.parse(
    getLocalStorageElement("templates") ?? "{}"
  );
  if (Object.keys(templatesSavedInLocalStorage).length > 0) {
    state.templates = templatesSavedInLocalStorage.templates.map(
      (template: Template) => {
        const t = new Template(
          template.id,
          template.type,
          template.idCampaign,
          template.createdFromCampaign,
          template.informations,
          template.content,
          template.sections,
          template.configuration,
          template.edited,
          template.funnel,
          template.dateModification,
          template.version
        );
        // Restore originTemplateId lost by constructor (defaults to null)
        if (template.originTemplateId) {
          t.originTemplateId = template.originTemplateId;
        }
        return t;
      }
    );
    state.hasAny = true;
    state.index = templatesSavedInLocalStorage.index;
    // eslint-disable-next-line prefer-destructuring
    state.template = state.templates[templatesSavedInLocalStorage.index];
  }
  const elementSyncCurrentTemplate = JSON.parse(
    getLocalStorageElement("elementSyncCurrentTemplate") ?? "{}"
  );
  if (elementSyncCurrentTemplate && elementSyncCurrentTemplate.template) {
    const templateIndex = state.templates.findIndex(
      t => t.id === elementSyncCurrentTemplate.template.id
    );
    if (templateIndex > -1) {
      const t = new Template(
        elementSyncCurrentTemplate.template.id,
        elementSyncCurrentTemplate.template.type,
        elementSyncCurrentTemplate.template.idCampaign,
        elementSyncCurrentTemplate.template.createdFromCampaign,
        elementSyncCurrentTemplate.template.informations,
        elementSyncCurrentTemplate.template.content,
        elementSyncCurrentTemplate.template.sections,
        elementSyncCurrentTemplate.template.configuration,
        false,
        elementSyncCurrentTemplate.template.funnel,
        elementSyncCurrentTemplate.template.dateModification,
        elementSyncCurrentTemplate.template.version
      );
      if (elementSyncCurrentTemplate.template.originTemplateId) {
        t.originTemplateId =
          elementSyncCurrentTemplate.template.originTemplateId;
      }
      state.templates[templateIndex] = t;
      state.index = elementSyncCurrentTemplate.index;
      state.template = state.templates[templateIndex];
      state.hasAny = true;
    }
  }
  const templatesLinkedToCampaignSavedInLocalStorage = JSON.parse(
    getLocalStorageElement("templatesLinkedToCampaign") ?? "{}"
  );
  if (Object.keys(templatesLinkedToCampaignSavedInLocalStorage).length > 0) {
    state.templatesLinkedToCampaign = templatesLinkedToCampaignSavedInLocalStorage.templates.map(
      (template: Template) => {
        const t = new Template(
          template.id,
          template.type,
          template.idCampaign,
          template.createdFromCampaign,
          template.informations,
          template.content,
          template.sections,
          template.configuration,
          template.edited,
          template.funnel,
          template.dateModification,
          template.version
        );
        if (template.originTemplateId) {
          t.originTemplateId = template.originTemplateId;
        }
        return t;
      }
    );
  }
  const templatesFromFunnelSavedInLocalStorage = JSON.parse(
    getLocalStorageElement("templatesFromFunnel") ?? "{}"
  );
  // Clean up corrupted "null" key from stale localStorage data
  delete templatesFromFunnelSavedInLocalStorage["null"];
  if (Object.keys(templatesFromFunnelSavedInLocalStorage).length > 0) {
    state.templatesFromFunnel = templatesFromFunnelSavedInLocalStorage;
    state.templates.forEach(template => {
      Object.keys(state.templatesFromFunnel).forEach(funnelId => {
        const templateIndex = state.templatesFromFunnel[funnelId].findIndex(
          funnelTemplate => funnelTemplate.id === template.id
        );
        if (templateIndex !== -1) {
          state.templatesFromFunnel[funnelId][templateIndex] = template;
        }
      });
    });
  }

  const teaserTemplatesSavedInLocalStorage = JSON.parse(
    getLocalStorageElement("teaserTemplates") ?? "{}"
  );
  if (Object.keys(teaserTemplatesSavedInLocalStorage).length > 0) {
    state.teaserTemplates = teaserTemplatesSavedInLocalStorage;
    state.teaserCreationInProgress = true;
  }

  // Vérifier les conflits de version après le chargement
  const conflicts = await checkTemplateVersionConflicts();
  state.versionConflicts = conflicts;
};

/**
 * Réinitialise la liste des conflits de version
 */
export const clearVersionConflicts = (): void => {
  state.versionConflicts = [];
};

/**
 * Active ou désactive la prévention de mise à jour de dateModification
 */
export const setPreventDateModificationUpdate = (prevent: boolean): void => {
  state.preventDateModificationUpdate = prevent;
};

watch(
  [() => UserState.isAuthenticated, () => UserState.activeShop?.id],
  async () => {
    // wait for user to be authenticated and active shop to be set
    if (UserState.isAuthenticated && UserState.activeShop?.id) {
      await getTemplatesSavedInLocalStorage();
    }
  }
);

// Return array of HTMLStyleElement for active template split by section and type
export const getActiveTemplateStylesheets = (
  elementType = ""
): HTMLStyleElement[] => {
  const sections = elementType
    ? state.template?.sections.filter(section => section.type === elementType)
    : state.template?.sections;
  const stylesheets =
    sections?.reduce((acc: HTMLStyleElement[], section: Section) => {
      const sectionStyles =
        section.css != null && section.css !== ""
          ? JSON.parse(section.css.replace(/(\r\n|\n|\r|<br>)/gm, " "))
          : [];
      const sectionData = JSON.parse(
        section.data && section.data !== "" ? section.data : "{}"
      );
      if (Object.keys(sectionStyles).length > 0) {
        acc.push(
          ...Object.keys(sectionStyles).map((styleType: string) => {
            const s = document.createElement("style");

            // If styles are for mobile devices, we add the media query rule if it's not in the CSS rule
            if (
              new RegExp("_mobile$").test(styleType) &&
              !new RegExp("@media").test(sectionStyles[styleType])
            ) {
              s.innerHTML = `@media only screen and (max-width: 600px) { ${sectionStyles[styleType]} }`;
            } else {
              s.innerHTML = sectionStyles[styleType];
            }

            if (
              sectionData[HIDE_MOBILE_ATTRIBUTE] &&
              new RegExp("_mobile$").test(styleType)
            ) {
              s.innerHTML = `/*${HIDE_MOBILE_ATTRIBUTE} ${s.innerHTML} ${HIDE_MOBILE_ATTRIBUTE}*/`;
            }

            s.setAttribute("data-spm-styles", styleType);
            s.setAttribute(
              "data-spm-section",
              section.id_template_elements.toString()
            );
            s.setAttribute("type", "text/css");
            return s;
          })
        );
      }
      return acc;
    }, []) ?? [];

  return stylesheets;
};

// Return full html document for active template
export const getActiveTemplateFullHtml = (): string => {
  if (state.template?.type === TemplateParentTypeEnum.EMAIL) {
    // First get design
    const design = state.template?.sections.filter(
      (section: Section) =>
        section.id_template_elements === state.template?.content.design
    )[0].html;
    const sections = state.template?.sections
      .filter(
        (section: Section) =>
          state.template?.content.sections.includes(
            section.id_template_elements
          ) ||
          state.template?.content.sections.includes(
            section.id_template_elements.toString()
          )
      )
      .sort((a: Section, b: Section) => {
        if (
          state.template &&
          state.template.content.sections.indexOf(
            a.id_template_elements.toString()
          ) >
            state.template.content.sections.indexOf(
              b.id_template_elements.toString()
            )
        )
          return 1;
        return -1;
      })
      .map((section: Section) => addSpmElementId(section).html);
    return design.replace(
      "{SECTIONS}",
      `<spm-sections>${sections.join(" ")}</spm-sections>`
    );
  }
  return (
    state.template?.sections
      .map((section: Section) => addSpmElementId(section).html)
      .join(" ") ?? ""
  );
};

function closePanels() {
  // Check if we need to reapply translations when closing a panel
  let needToTranslate = false;

  // Check if at least one panel is opened and open designPanel in case of SMS or Push notification
  let onePanelIsOpened = false;

  if (state.leftToolbar.show.translationPanel) {
    needToTranslate = true;
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(state.leftToolbar.show)) {
    state.leftToolbar.show[key as keyof ToolbarPanels] = false;
  }

  let resetStructure = true;

  if (
    getTemplateParentTypeByType(state.template?.type ?? "") ===
      TemplateParentTypeEnum.SMS ||
    getTemplateParentTypeByType(state.template?.type ?? "") ===
      TemplateParentTypeEnum.PUSHNOTIFICATIONS ||
    isWhatsappTemplate(state.template?.type ?? "") ||
    isRichTextingTemplate(state.template?.type ?? "")
  ) {
    state.leftToolbar.show.designPanel = true;
    onePanelIsOpened = true;
  } else if (
    getTemplateParentTypeByType(state.template?.type ?? "") ===
      TemplateParentTypeEnum.EMAIL &&
    !state.template?.informations.imported
  ) {
    const selectedSyncElement =
      store.getters["liveEditor/getSelectedSyncElement"];
    if (!selectedSyncElement) {
      state.leftToolbar.show.widgetsPanel = true;
    } else {
      const defaultPanel = getDefaultPanel(selectedSyncElement.elementType);
      state.leftToolbar.show[defaultPanel as keyof ToolbarPanels] = true;
      if (defaultPanel === "configurationPanel") {
        resetStructure = false;
      }
    }
    onePanelIsOpened = true;
  } else if (state.template?.informations.imported) {
    state.leftToolbar.show.translationPanel = true;
    onePanelIsOpened = true;
  } else if (state.template?.type === TemplateTypeEnum.TEASER) {
    state.leftToolbar.show.informationPanel = true;
    onePanelIsOpened = true;
  }

  if (!state.isTemplateEditorVisible) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(state.leftToolbar.show)) {
      state.leftToolbar.show[key as keyof ToolbarPanels] = false;
    }
    onePanelIsOpened = false;
  }

  state.isLeftToolbarVisible = onePanelIsOpened;
  state.leftToolbar.needToTranslate = needToTranslate;

  return resetStructure;
}

const formatDesignHtml = (
  design: Element,
  sections: Element,
  designId: string,
  syncElementId = "",
  syncElementName = ""
): string => {
  // Remove useless elements from design
  // eslint-disable-next-line no-unused-expressions
  design.querySelectorAll("title, meta")?.forEach(item => item.remove());

  if (!syncElementId && !syncElementName) {
    const structure =
      '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "http://www.w3.org/TR/REC-html40/loose.dtd">' +
      '<html xmlns="http://www.w3.org/1999/xhtml" lang="en" xml:lang="en" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">' +
      "<head>" +
      "<title>{var=template.subject}</title>" +
      '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
      '<meta name="viewport" content="width=device-width">' +
      '<meta name="format-detection" content="telephone=no">' +
      "<!--[if mso]><xml><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->" +
      "</head>" +
      '<body data-spmelementid="{DESIGN_ID}">' +
      "{SPM_TEMPLATE}" +
      "</body>" +
      "</html>";

    // We format design element to include doctype, metas, and structure
    return structure
      .replace("{DESIGN_ID}", designId)
      .replace(
        "{SPM_TEMPLATE}",
        design.innerHTML.replace(sections.outerHTML, "{SECTIONS}")
      );
  }
  const structure =
    '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "http://www.w3.org/TR/REC-html40/loose.dtd">' +
    '<html xmlns="http://www.w3.org/1999/xhtml" lang="en" xml:lang="en" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">' +
    "<head>" +
    "<title>{var=template.subject}</title>" +
    '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
    '<meta name="viewport" content="width=device-width">' +
    '<meta name="format-detection" content="telephone=no">' +
    "<!--[if mso]><xml><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml><![endif]-->" +
    "</head>" +
    `<body data-spmelementid="{DESIGN_ID}" ${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}="{SYNC_ELEMENT_ID}" ${TEMPLATE_SYNC_ELEMENT_NAME}="{SYNC_ELEMENT_NAME}">` +
    "{SPM_TEMPLATE}" +
    "</body>" +
    "</html>";
  // We format design element to include doctype, metas, and structure
  return structure
    .replace("{DESIGN_ID}", designId)
    .replace("{SYNC_ELEMENT_ID}", syncElementId)
    .replace("{SYNC_ELEMENT_NAME}", syncElementName)
    .replace(
      "{SPM_TEMPLATE}",
      design.innerHTML.replace(sections.outerHTML, "{SECTIONS}")
    );
};

// TODO: element sync state is going to be retrieved from state, not in the HTML attributes anymore
const getElementSyncIfExists = ($: cheerio.CheerioAPI, identifier: string) => {
  const syncElementAttributeName = "data-spm-element-sync-id";
  const syncedElements = $(`[${syncElementAttributeName}]`);

  const elementSync: { id: string | undefined; type: string | null } = {
    id: "",
    type: null
  };

  syncedElements.each((_, syncedElement) => {
    const cheerioSyncedElement = $(syncedElement);
    const foundTranslationElementInside =
      cheerioSyncedElement.find(identifier).length > 0;
    if (
      foundTranslationElementInside ||
      cheerioSyncedElement.attr(identifier)
    ) {
      elementSync.id = cheerioSyncedElement.attr(syncElementAttributeName);
      elementSync.type = cheerioSyncedElement.hasClass(TEMPLATE_SECTION_CLASS)
        ? TemplateStructureEnum.SECTION
        : TemplateStructureEnum.WIDGET;
    }
  });

  return elementSync;
};

export const sortTranslationInState = () => {
  const template = getTemplateIframeDocument();
  if (template) {
    const matches = template.body.innerHTML.match(
      /LANG_([a-z0-9]+)(\.[\w-]+)?/gi
    );
    if (matches && matches.length) {
      const extractedKeys = matches
        .map(str => str.replace("LANG_", ""))
        .filter(Boolean) as string[];

      if (state.template) {
        state.template.translations = state.template.translations.sort(
          (a, b) => extractedKeys.indexOf(a.key) - extractedKeys.indexOf(b.key)
        );
      }
    }
    // Add group to translations
    const $ = cheerio.load(template.body.innerHTML);
    const customKeyName = "custom-key-for-group";
    if (state.template) {
      state.template.translations.forEach(translation => {
        const { key, fieldType } = translation;
        const elementIdentifier = `[id="LANG_${key}"]`;

        const elementSync = getElementSyncIfExists($, elementIdentifier);

        if (elementSync.id) {
          translation.syncGroupId = `${elementSync.type}.${elementSync.id}`;
        }

        let isMarkup = false;
        const keySplitted = key.split('.');
        // Game widget translations (data-spm-text, data-spm-slot-symbol, data-spm-slot-prize) are stored in JSON attributes,
        // not as DOM elements with data-spmtranslationid-*. Assign groupKey by finding the widget element directly.
        const isGameTranslation = fieldType === 'data-spm-text' || fieldType === 'data-spm-slot-symbol' || fieldType === 'data-spm-slot-prize';
        if (isGameTranslation) {
          const gameWidgetSelectors = [
            '.spm_widget_game_wheel',
            '.spm_widget_game_scratch_card',
            '.spm_widget_game_slot_machine',
          ];
          for (const selector of gameWidgetSelectors) {
            const widget = $(`${selector}[data-prizes*="${key}"], ${selector}[data-symbols*="${key}"], ${selector}[data-win-combinations*="${key}"]`);
            if (widget.length) {
              const widgetGroupKey = widget.attr(customKeyName) || createTranslationIdentifier();
              widget.attr(customKeyName, widgetGroupKey);
              translation.groupKey = widgetGroupKey;
              break;
            }
          }
          if (!translation.groupKey) {
            // Fallback: use section ID as groupKey
            translation.groupKey = `game-prizes-${translation.section}`;
          }
        }

        isMarkup = (keySplitted.length > 1 && keySplitted[1] === 'text')
          || (keySplitted.length === 1 && (fieldType === 'html' || fieldType === 'text' || fieldType === 'textarea'));
        if (isGameTranslation) {
          // Already handled above, skip markup/attribute branches
        } else if (isMarkup) {
          const element = $(elementIdentifier);
          if (element.length) {
            const parent = element.parent().eq(0);
            if (parent) {
              let groupKey = createTranslationIdentifier();
              if (parent.parent() && parent.parent().attr(customKeyName)) {
                parent.attr(customKeyName, parent.parent().attr(customKeyName));
              }
              if (parent.attr(customKeyName) === undefined) {
                parent.attr(customKeyName, groupKey);
              } else {
                groupKey = parent.attr(customKeyName) as string;
              }
              translation.groupKey = groupKey;
            }
            const htmlElement = template.body.querySelector(elementIdentifier);
            if (
              htmlElement &&
              state.template &&
              state.template.type !== TemplateTypeEnum.PUSHNOTIFICATIONS
            ) {
              const isVisible = isElementVisible(htmlElement);
              translation.hidden = !isVisible;
            }
            // SYNC ELEMENT WARNING
            const section = element.closest(`.${TEMPLATE_SECTION_CLASS}`);
            if (
              section &&
              section.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
              !section.attr(TEMPLATE_PART_ELEMENT_PART_TYPE)
            ) {
              translation.syncElement = {
                id: section.attr("id") ?? "",
                type: TemplateStructureEnum.SECTION,
                syncElementId:
                  section.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) ?? ""
              };
            } else {
              const widget = element.closest("[data-widgettype]");
              if (
                widget &&
                widget.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
                !widget.attr(TEMPLATE_PART_ELEMENT_PART_TYPE)
              ) {
                translation.syncElement = {
                  id: widget.attr("id") ?? "",
                  type: TemplateStructureEnum.WIDGET,
                  syncElementId:
                    section.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) ?? ""
                };
              }
            }
          }
        } else {
          let attributeIdentifier = "";
          let attributeName = "";
          const attributeFieldTypes: Record<string, any> = {
            link: "href",
            image: "src",
            placeholder: "placeholder",
            "data-redirect": "data-redirect",
            "data-selectoptionlabel": "data-selectoptionlabel",
            "data-selectoptionplaceholder": "data-selectoptionplaceholder"
          };
          if (keySplitted.length > 1) {
            attributeIdentifier = `[data-spmtranslationid-${keySplitted[1]}="LANG_${key}"]`;
          } else if (
            keySplitted.length === 1 &&
            attributeFieldTypes[fieldType]
          ) {
            // Some translations in model don't have the type in the key
            attributeIdentifier = `[data-spmtranslationid-${attributeFieldTypes[fieldType]}="LANG_${key}"]`;
          } else if (keySplitted.length === 1 && fieldType === "attribute") {
            const regex = new RegExp(
              `${TRANSLATION_ATTRIBUTE}-[^=]*="LANG_${key}"`,
              "gm"
            );
            const attributeNameRegex = new RegExp(
              `${TRANSLATION_ATTRIBUTE}-([^=]*)="LANG_${key}"`
            );
            const attribute = $("body")
              .html()
              ?.match(regex);
            const attributeNames = $("body")
              .html()
              ?.match(attributeNameRegex);
            if (attribute && attribute.length) {
              attributeIdentifier = `[${attribute[0]}]`;
              if (attributeNames && attributeNames.length > 1) {
                // eslint-disable-next-line prefer-destructuring
                attributeName = attributeNames[1];
              }
            }
          }

          const attributeSync = getElementSyncIfExists($, attributeIdentifier);
          if (attributeSync) {
            translation.syncGroupId = `${attributeSync.type}.${attributeSync.id}`;
          }

          let element = $(attributeIdentifier);
          if (element.length) {
            element = element.eq(0);
            let groupKey = createTranslationIdentifier();
            if (element.parent() && element.parent().attr(customKeyName)) {
              element.attr(customKeyName, element.parent().attr(customKeyName));
            }
            if (element.attr(customKeyName) === undefined) {
              element.attr(customKeyName, groupKey);
            } else {
              groupKey = element.attr(customKeyName) as string;
            }
            translation.groupKey = groupKey;
            if (attributeName) {
              translation.attributeName = attributeName;
            }
            // Check if visible
            const htmlElement = template.body.querySelector(
              attributeIdentifier
            );
            if (
              htmlElement &&
              state.template &&
              state.template.type !== TemplateTypeEnum.PUSHNOTIFICATIONS
            ) {
              const isVisible = isElementVisible(htmlElement);
              translation.hidden = !isVisible;
            }
            // SYNC ELEMENT WARNING
            const section = element.closest(`.${TEMPLATE_SECTION_CLASS}`);
            if (
              section &&
              section.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
              !section.attr(TEMPLATE_PART_ELEMENT_PART_TYPE)
            ) {
              translation.syncElement = {
                id: section.attr("id") ?? "",
                type: TemplateStructureEnum.SECTION,
                syncElementId:
                  section.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) ?? ""
              };
            } else {
              const widget = element.closest("[data-widgettype]");
              if (
                widget &&
                widget.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
                !widget.attr(TEMPLATE_PART_ELEMENT_PART_TYPE)
              ) {
                translation.syncElement = {
                  id: widget.attr("id") ?? "",
                  type: TemplateStructureEnum.WIDGET,
                  syncElementId:
                    section.attr(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) ?? ""
                };
              }
            }

            // Check if is basic link
            if (
              attributeFieldTypes[fieldType] === "href" &&
              element.contents().length
            ) {
              const firstChild = element.contents().get(0);
              if (firstChild) {
                const childType = ((firstChild as unknown) as cheerio.Element).tagName?.toLowerCase();
                if (
                  childType &&
                  (childType === "img" || childType.match(/^h[1-6]$/))
                ) {
                  translation.basicLink = true;
                }
              }
            }

            // Check if attribute contains data-redirect and hides it
            if (element.attr("data-redirect")) {
              translation.hidden = true;
            }
          }
          if (
            attributeFieldTypes[fieldType] === "href" &&
            element.length &&
            (element.attr("data-redirect") ||
              element.attr("data-to-url") ||
              element.attr("data-whatsapp-action-type") ||
              element.attr("data-rcs-action-type") ||
              element.attr("href")?.match(/^#redirect_/g))
          ) {
            translation.hidden = true;
          }
        }

        // Hide WhatsApp smartlist button text translation if smartlist is not enabled
        if (state.template && isWhatsappTemplate(state.template.type)) {
          const element = $(elementIdentifier);
          if (
            element.length &&
            element.closest(".whatsapp-smartlist-buttontext").length > 0
          ) {
            const defaultLang = getShopDefaultLang();
            const whatsappData = state.template.configuration?.whatsapp_data as
              | Record<string, any>
              | undefined;
            const smartlistConfig = whatsappData?.[defaultLang]?.smartlist as
              | Record<string, any>
              | undefined;
            const isSmartlistEnabled = smartlistConfig?.enabled === "true";
            translation.hidden = !isSmartlistEnabled;
          }
        }

        // Hide RCS smartlist button text translation if smartlist is not enabled
        if (state.template && isRichTextingTemplate(state.template.type)) {
          const element = $(elementIdentifier);
          if (
            element.length &&
            element.closest(".rcs-smartlist-buttontext").length > 0
          ) {
            const defaultLang = getShopDefaultLang();
            const rcsData = state.template.configuration?.richtexting_data as
              | Record<string, any>
              | undefined;
            const smartlistConfig = rcsData?.[defaultLang]?.smartlist as
              | Record<string, any>
              | undefined;
            const isSmartlistEnabled = smartlistConfig?.enabled === "true";
            translation.hidden = !isSmartlistEnabled;
          }
        }
      });
    }
  }
};

/**
 * Consent checkbox settings read from its HTML attributes, the ones the form
 * configs are rebuilt from.
 */
const getConsentCheckboxConfigs = (widget: HTMLElement): Record<string, any> => {
  const configs: Record<string, any> = {
    "data-consent-channel": widget.getAttribute("data-consent-channel") || "email"
  };
  const trackingConsent = widget.getAttribute("data-tracking-consent");
  if (trackingConsent !== null) {
    configs.trackingConsent = trackingConsent === "true";
  }
  return configs;
};

export const updateFormWidgets = () => {
  const allFormWidgets: Record<string, string> = {
    spm_widget_input_text: WidgetTypeEnum.INPUT_TEXT,
    spm_widget_input_email: WidgetTypeEnum.INPUT_EMAIL,
    spm_widget_input_phone: WidgetTypeEnum.INPUT_PHONE,
    spm_widget_input_password: WidgetTypeEnum.INPUT_PASSWORD,
    spm_widget_textarea: WidgetTypeEnum.TEXTAREA,
    spm_widget_input_date: WidgetTypeEnum.INPUT_DATE,
    spm_widget_input_checkbox: WidgetTypeEnum.INPUT_CHECKBOX,
    spm_widget_input_radio: WidgetTypeEnum.INPUT_RADIO,
    spm_widget_input_select: WidgetTypeEnum.INPUT_SELECT,
    spm_widget_consent_checkbox: WidgetTypeEnum.CONSENT_CHECKBOX,
    spm_widget_disclosure: WidgetTypeEnum.DISCLOSURE
  };

  // Update forms in configuration
  const widgets: HTMLElement[] = getTemplateWidgets();
  widgets.forEach(widget => {
    if (
      Object.keys(allFormWidgets).includes(
        widget.getAttribute("data-widgettype") || ""
      )
    ) {
      const widgetId = widget.id;
      const widgetType = widget.getAttribute("data-widgettype") || "";
      if (state.template) {
        if (!state.template.configuration) {
          state.template.configuration = {};
        }
        if (!state.template.configuration.forms) {
          state.template.configuration.forms = {};
        }
        if (!state.template.configuration.forms[widgetId]) {
          const formConfigs: Record<string, any> = {
            contactProperty: widget.getAttribute("data-contactproperty") || ""
          };
          if (widgetType === "spm_widget_consent_checkbox") {
            Object.assign(formConfigs, getConsentCheckboxConfigs(widget));
          }
          state.template.configuration.forms[widgetId] = {
            type: allFormWidgets[widgetType],
            configs: formConfigs
          };
        }
      }
    }
  });
};

/**
 * Get sync elements ids in template
 */
export const getSyncElementsIdsInTemplate = (fromSelector = ""): string[] => {
  const container = fromSelector
    ? getElementFromIframe(fromSelector)
    : getTemplateIframeDocument();
  if (!container) return [];

  const syncElements = container.querySelectorAll(
    `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`
  );
  const syncElementsIds = new Set<string>();
  Array.from(syncElements).forEach(syncElement => {
    const syncElementId =
      syncElement.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) || "";
    if (syncElementId) {
      syncElementsIds.add(syncElementId);
    }
  });

  return Array.from(syncElementsIds);
};

export const getSyncElementPartsInTemplate = () => {
  const template = getTemplateIframeDocument();
  if (!template) return [];

  const syncElements = template.querySelectorAll(
    `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`
  );
  const syncElementsParts = new Set();
  Array.from(syncElements).forEach(syncElement => {
    const syncElementPart = syncElement.getAttribute(
      TEMPLATE_PART_ELEMENT_PART_TYPE
    );
    if (syncElementPart === ElementPartTypeEnum.STYLES) {
      if (syncElement.getAttribute("data-widgettype")) {
        syncElementsParts.add(syncElement.getAttribute("data-widgettype"));
      }
      if (syncElement.getAttribute("data-spmelementid")) {
        syncElementsParts.add(TemplateStructureEnum.SECTION);
      }
    }
  });
  return Array.from(syncElementsParts);
};

// Update html, css and translations properties is sections objects
export const executeUpdateSectionsInState = () => {
  const template = getTemplateIframeDocument();
  if (state.template && template) {
    const sections = [];
    // Update design
    const design = template.querySelector("spm-template");
    const spmSections = design?.querySelector("spm-sections");
    if (design && spmSections) {
      sections.push(
        ...state.template.sections
          .filter(
            (current: Section) =>
              current.id_template_elements.toString() ===
              state.template?.content.design.toString()
          )
          .map((current: Section) => {
            const syncElementId = template.body.getAttribute(
              TEMPLATE_SYNC_ELEMENT_IDENTIFIER
            );
            const syncElementName = template.body.getAttribute(
              TEMPLATE_SYNC_ELEMENT_NAME
            );
            const returnValue: Section = {
              ...current,
              html: formatDesignHtml(
                design,
                spmSections,
                current.id_template_elements.toString(),
                syncElementId ?? "",
                syncElementName ?? ""
              ),
              css: formatStylesForSection(
                Array.from(
                  template.querySelectorAll(
                    `style[data-spm-section="${state.template?.content.design}"]`
                  )
                )
              ),
              translations: formatTranslationsForSection(
                state.template?.translations.filter(
                  (translation: Translation) =>
                    translation.section.toString() ===
                    current.id_template_elements.toString()
                ) ?? []
              ),
              type: "design"
            };
            if (syncElementId && syncElementName) {
              const data = {
                [TEMPLATE_SYNC_ELEMENT_IDENTIFIER]: syncElementId,
                [TEMPLATE_SYNC_ELEMENT_NAME]: syncElementName
              };
              returnValue.data = JSON.stringify(data);
            }

            const data = JSON.parse(returnValue.data || "{}");
            const designElement = template.querySelector(
              `[data-spmelementid="${state.template?.content.design}"]`
            ) as HTMLElement;
            if (
              designElement &&
              designElement.getAttribute(HIDE_MOBILE_ATTRIBUTE)
            ) {
              data[HIDE_MOBILE_ATTRIBUTE] = true;
            } else {
              delete data[HIDE_MOBILE_ATTRIBUTE];
            }
            returnValue.data = JSON.stringify(data);

            return returnValue;
          })
      );
    }
    if (design && !spmSections) {
      // For SMS/WhatsApp/Push: also capture design HTML from DOM so preview shell is persisted
      const shouldCaptureDesignHtml =
        isSmsTemplate(state.template.type) ||
        isWhatsappTemplate(state.template.type) ||
        isRichTextingTemplate(state.template.type) ||
        isPushTemplate(state.template.type);
      const designElementInDom = shouldCaptureDesignHtml
        ? (template.querySelector(
            `[data-spmelementid="${state.template?.content.design}"]`
          ) as HTMLElement | null)
        : null;

      sections.push(
        ...state.template.sections
          .filter(
            (current: Section) =>
              current.id_template_elements.toString() ===
              state.template?.content.design.toString()
          )
          .map((current: Section) => {
            const result: Section = {
              ...current,
              translations: formatTranslationsForSection(
                state.template?.translations.filter(
                  (translation: Translation) =>
                    translation.section.toString() ===
                    current.id_template_elements.toString()
                ) ?? []
              ),
              type: "design"
            };
            // Re-capture design HTML from DOM to persist preview shell elements
            if (designElementInDom) {
              const cloned = designElementInDom.cloneNode(true) as HTMLElement;
              // Strip data-spmelementid from all elements to avoid duplication
              cloned
                .querySelectorAll("[data-spmelementid]")
                .forEach(el => el.removeAttribute("data-spmelementid"));
              cloned.removeAttribute("data-spmelementid");
              // Restore {var=...} into src attributes before saving
              restoreVariablesInElement(cloned);
              result.html = cloned.outerHTML;
            }
            return result;
          })
      );
    }

    // Update sections
    state.template.content.sections.forEach((sectionId: string | number) => {
      const section = template.querySelector(
        `[data-spmelementid="${sectionId}"]`
      ) as HTMLElement;

      if (section) {
        const newSection = sanitizeSection(section, true);
        if (state.template && newSection) {
          // Restore {var=...} into src attributes before saving
          restoreVariablesInElement(newSection);
          // GUARD: Ensure smart list widgets contain original s-engine code, not rendered products
          restoreSmartListsInClonedSection(newSection);
          sections.push(
            ...state.template.sections
              .filter(
                (current: Section) =>
                  current.id_template_elements.toString() ===
                  sectionId.toString()
              )
              .map((current: Section) => {
                const synchronizedWidgets = section.querySelectorAll(
                  `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}][data-widgettype]`
                );
                // Synchroniser les traductions du DOM avec le state avant de sauvegarder
                syncTranslationsFromDOM(
                  newSection.outerHTML,
                  state.template?.translations ?? []
                );
                const returnValue: Section = {
                  ...current,
                  // E-mail countdown: mirror the label tokens into the GIF URL so
                  // the backend resolves them per recipient language.
                  html: restoreCountdownTokensInHtml(
                    replaceTranslationsByKey(
                      newSection.outerHTML,
                      state.template?.translations ?? []
                    )
                  ),
                  css: formatStylesForSection(
                    Array.from(
                      template.querySelectorAll(
                        `style[data-spm-section="${sectionId}"]`
                      )
                    )
                  ),
                  translations: formatTranslationsForSection(
                    state.template?.translations.filter(
                      (translation: Translation) =>
                        translation.section.toString() ===
                        current.id_template_elements.toString()
                    ) ?? []
                  ),
                  data: section.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
                    ? JSON.stringify({
                        [TEMPLATE_SYNC_ELEMENT_IDENTIFIER]: section.getAttribute(
                          TEMPLATE_SYNC_ELEMENT_IDENTIFIER
                        )
                      })
                    : current.data,
                  type: "section"
                };
                // Update sync widgets ids
                if (synchronizedWidgets.length) {
                  const data = JSON.parse(returnValue.data || "{}");
                  if (!data[TEMPLATE_SYNC_ELEMENT_IDs]) {
                    data[TEMPLATE_SYNC_ELEMENT_IDs] = [];
                  }
                  Array.from(synchronizedWidgets).forEach(
                    synchronizedWidget => {
                      if (
                        !data[TEMPLATE_SYNC_ELEMENT_IDs].find(
                          (item: string) =>
                            item ===
                            synchronizedWidget.getAttribute(
                              TEMPLATE_SYNC_ELEMENT_IDENTIFIER
                            )
                        )
                      ) {
                        data[TEMPLATE_SYNC_ELEMENT_IDs].push(
                          synchronizedWidget.getAttribute(
                            TEMPLATE_SYNC_ELEMENT_IDENTIFIER
                          )
                        );
                      }
                    }
                  );
                  returnValue.data = JSON.stringify(data);
                } else {
                  const data = JSON.parse(returnValue.data || "{}");
                  if (data[TEMPLATE_SYNC_ELEMENT_IDs]) {
                    delete data[TEMPLATE_SYNC_ELEMENT_IDs];
                  }
                  returnValue.data = JSON.stringify(data);
                }

                const syncElementId = section.getAttribute(
                  TEMPLATE_SYNC_ELEMENT_IDENTIFIER
                );
                const syncElementName = section.getAttribute(
                  TEMPLATE_SYNC_ELEMENT_NAME
                );
                if (syncElementId && syncElementName) {
                  const returnValueData = JSON.parse(returnValue.data || "{}");
                  returnValueData[
                    TEMPLATE_SYNC_ELEMENT_IDENTIFIER
                  ] = syncElementId;
                  returnValueData[TEMPLATE_SYNC_ELEMENT_NAME] = syncElementName;

                  if (section.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)) {
                    returnValueData[
                      TEMPLATE_PART_ELEMENT_PART_TYPE
                    ] = section.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE);
                  }

                  returnValue.data = JSON.stringify(returnValueData);
                } else {
                  const returnValueData = JSON.parse(returnValue.data || "{}");
                  delete returnValueData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
                  delete returnValueData[TEMPLATE_SYNC_ELEMENT_NAME];
                  delete returnValueData[TEMPLATE_PART_ELEMENT_PART_TYPE];
                  returnValue.data = JSON.stringify(returnValueData);
                }
                return returnValue;
              })
          );
        }
      }
    });
    state.template.sections = sections;

    // Get all synced elements
    const syncElementsIds = getSyncElementsIdsInTemplate();
    if (!state.template.configuration[TEMPLATE_SYNC_ELEMENT_IDs]) {
      state.template.configuration[TEMPLATE_SYNC_ELEMENT_IDs] = [];
    }
    if (!state.template.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES]) {
      state.template.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES] = [];
    }
    const syncElementsParts = getSyncElementPartsInTemplate();
    state.template.configuration[TEMPLATE_SYNC_ELEMENT_IDs] = [
      ...syncElementsIds
    ];
    state.template.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES] = [
      ...syncElementsParts
    ];

    nextTick().then(() => {
      // Sort translations
      sortTranslationInState();
    });

    // Notify preview window of changes (display templates only)
    updateTemplatePreviewDisplay();
  }
};

let updateSectionsTimeout: ReturnType<typeof setTimeout> | null = null;

// Update html, css, and translations properties in sections objects
export const updateSectionsInState = (useTimeout = true) => {
  if (useTimeout) {
    if (updateSectionsTimeout) {
      clearTimeout(updateSectionsTimeout);
    }
    updateSectionsTimeout = setTimeout(() => {
      executeUpdateSectionsInState();
      updateSectionsTimeout = null; // Reset timeout reference
    }, 300); // Ajustez le délai selon vos besoins
  } else {
    // Exécute immédiatement sans timeout
    executeUpdateSectionsInState();
  }
};

export const updateFormsInState = (
  templateState: any = null,
  templateIframe: Document | null = null
) => {
  const template = templateIframe || getTemplateIframeDocument();
  const templateInState = templateState || state.template;

  const formWidgets = getTemplateForms(templateIframe);
  const formWidgetsFieldConfig = getFormFieldsConfigs();

  // Preserve existing widget-button configurations only if the button still exists in the DOM.
  // Widget-buttons are managed separately via BaseLink and contain metadata
  // (actions_to_take, user_disabled_actions) that cannot be reconstructed from DOM.
  // We validate against the DOM to clean up ghost configs from deleted buttons.
  const allWidgetIds = new Set(
    getTemplateWidgets(templateIframe)
      .map(w => w.id)
      .filter(Boolean)
  );
  const existingButtonWidgets: Record<string, any> = {};
  if (templateInState?.configuration?.forms) {
    Object.entries(templateInState.configuration.forms).forEach(
      ([widgetId, config]) => {
        if (
          config &&
          typeof config === "object" &&
          (config as any).type === "widget-button"
        ) {
          // Only preserve if the button widget still exists in the DOM
          if (allWidgetIds.has(widgetId)) {
            existingButtonWidgets[widgetId] = { ...(config as any) };
          }
        }
      }
    );
  }

  // Redundancy: detect buttons with data-send-form="true" in DOM
  // that are missing from configuration.forms
  const formButtons = getTemplateFormButtons(templateIframe);
  formButtons.forEach(button => {
    const buttonId = button.id;
    if (buttonId && !existingButtonWidgets[buttonId]) {
      existingButtonWidgets[buttonId] = {
        type: "widget-button",
        configs: {
          contactProperty: "",
          actions_to_take: []
        }
      };
    }
  });

  const allFormWidgets: Record<string, string> = {
    spm_widget_input_text: WidgetTypeEnum.INPUT_TEXT,
    spm_widget_input_email: WidgetTypeEnum.INPUT_EMAIL,
    spm_widget_input_phone: WidgetTypeEnum.INPUT_PHONE,
    spm_widget_input_password: WidgetTypeEnum.INPUT_PASSWORD,
    spm_widget_textarea: WidgetTypeEnum.TEXTAREA,
    spm_widget_input_date: WidgetTypeEnum.INPUT_DATE,
    spm_widget_input_checkbox: WidgetTypeEnum.INPUT_CHECKBOX,
    spm_widget_input_radio: WidgetTypeEnum.INPUT_RADIO,
    spm_widget_input_select: WidgetTypeEnum.INPUT_SELECT,
    spm_widget_consent_checkbox: WidgetTypeEnum.CONSENT_CHECKBOX,
    spm_widget_disclosure: WidgetTypeEnum.DISCLOSURE
  };

  const stateWidgetConfig: Record<string, any> = {};

  // First, get all individual form widgets and their metadata
  const widgets: HTMLElement[] = getTemplateWidgets(templateIframe);
  widgets.forEach(widget => {
    if (
      Object.keys(allFormWidgets).includes(
        widget.getAttribute("data-widgettype") || ""
      )
    ) {
      const widgetId = widget.id;
      const widgetType = widget.getAttribute("data-widgettype") || "";

      if (!stateWidgetConfig[widgetId]) {
        const configs: Record<string, any> = {
          contactProperty: widget.getAttribute("data-contactproperty") || ""
        };
        // Persist widget-specific data attributes needed by evaluators
        if (widgetType === "spm_widget_consent_checkbox") {
          Object.assign(configs, getConsentCheckboxConfigs(widget));
        }
        if (widgetType === "spm_widget_disclosure") {
          configs["data-disclosure-channels"] =
            widget.getAttribute("data-disclosure-channels") || "";
        }
        stateWidgetConfig[widgetId] = {
          type: allFormWidgets[widgetType],
          configs
        };
      }
    }
  });

  // Then, process form widgets configurations
  formWidgets.forEach(formWidget => {
    const widgetType = formWidget.getAttribute("data-widgettype");
    const widgetId = formWidget.getAttribute("id") || "";
    if (widgetType) {
      const widgetTypeEnum = getWidgetType(widgetType);
      const widgeFieldConfig =
        formWidgetsFieldConfig[
          widgetTypeEnum as keyof typeof formWidgetsFieldConfig
        ] || "";
      if (widgeFieldConfig) {
        const widgetConfig = getTemplateConfiguration(
          getTemplateParentTypeByType(templateInState?.type),
          widgetTypeEnum,
          false,
          isV4Template()
        );
        if (widgetConfig && widgetConfig.widget) {
          const { items } = widgetConfig.widget;
          items.forEach(item => {
            const { tabPanel } = item;
            if (tabPanel) {
              tabPanel.items.forEach((tabItem: FieldsGroup) => {
                const filteredItems =
                  tabItem.items?.filter(
                    e => e.fieldId && widgeFieldConfig.includes(e.fieldId)
                  ) || [];
                filteredItems.forEach(filteredItem => {
                  if (!stateWidgetConfig[widgetId]) {
                    stateWidgetConfig[widgetId] = {
                      type: "",
                      configs: {
                        contactProperty: ""
                      }
                    };
                  }
                  if (!stateWidgetConfig[widgetId].configs) {
                    stateWidgetConfig[widgetId].configs = {};
                  }
                  const filteredItemValue = filteredItem.properties[0].getter(
                    filteredItem.selector.replace("{SELECTOR}", `#${widgetId}`),
                    filteredItem.properties[0].name
                  );
                  if (filteredItem.fieldId !== undefined) {
                    stateWidgetConfig[widgetId].configs[
                      filteredItem.fieldId
                    ] = filteredItemValue;
                  }
                });
              });
            }
          });
        }
      }
    }
  });

  // Merge existing button widgets with new DOM-based configurations
  const finalWidgetConfig = { ...stateWidgetConfig };
  Object.entries(existingButtonWidgets).forEach(([widgetId, config]) => {
    finalWidgetConfig[widgetId] = config;
  });

  if (templateInState && templateInState.configuration) {
    if (!Object.keys(finalWidgetConfig).length) {
      delete templateInState.configuration.forms;
    } else {
      templateInState.configuration.forms = finalWidgetConfig;
    }
  }
};

export async function hideLeftToolbar(e = null, force = false, name = "") {
  // Trigger history save before hiding the panels
  let historyType: HistoryType | null = null;

  if (state.leftToolbar.hasChanged) {
    if (state.leftToolbar.show.cssPanel) {
      historyType = HistoryType.ADVANCED_CSS_STATIC_CHANGE;
    } else if (state.leftToolbar.show.cssPanelMediaQueries) {
      historyType = HistoryType.ADVANCED_CSS_STATIC_MOBILE_CHANGE;
    } else if (state.leftToolbar.show.configurationPanel) {
      // Create history for design or element (section, line, column, widget) updates
      const activeItemData = store.getters["liveEditor/getActiveItemData"];
      const structureType =
        activeItemData?.type ??
        store.getters["liveEditor/getSelectedStructure"]?.type;

      if (structureType) {
        switch (structureType) {
          case TemplateStructureEnum.WIDGET:
            historyType = HistoryType.WIDGET_CHANGE;
            break;
          case TemplateStructureEnum.COLUMN:
            historyType = HistoryType.COLUMN_CHANGE;
            break;
          case TemplateStructureEnum.LINE:
            historyType = HistoryType.ROW_CHANGE;
            break;
          case TemplateStructureEnum.SECTION:
            historyType = HistoryType.SECTION_CHANGE;
            break;
          default:
            break;
        }
      }
    }
  }

  if (historyType) {
    // Update state
    updateSectionsInState(false);

    if (!store.getters["liveEditor/getSelectedSyncElement"]) {
      createHistory(historyType);
    }
  }
  // Hide decorations and action buttons
  removeItemElementDecorations();
  if (!force) {
    const resetStructure = closePanels();
    if (resetStructure) {
      store.commit("liveEditor/resetSelectedStructure");
    }
  } else if (force && name) {
    if (
      !state.leftToolbar.show[name as keyof ToolbarPanels] ||
      (name === "configurationPanel" && e)
    ) {
      state.leftToolbar.show[name as keyof ToolbarPanels] = true;
      // eslint-disable-next-line no-restricted-syntax
      for (const key of Object.keys(state.leftToolbar.show)) {
        if (key !== name) {
          state.leftToolbar.show[key as keyof ToolbarPanels] = false;
        }
      }
      state.isLeftToolbarVisible = true;
    } else {
      closePanels();
    }
  }
}

const delay = (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const resetTemplateToDesktop = async () => {
  if (state.templateWidth !== TemplateWidth.DESKTOP) {
    state.templateWidth = TemplateWidth.DESKTOP;
    store.commit("liveEditor/setMobileEditMode", false);

    // Delay 1s because of the transition css
    await delay(1000);
  }
};

export async function togglePanel(name: keyof ToolbarPanels, e: any = null) {
  if (name !== "configurationPanel") {
    store.commit("liveEditor/resetSelectedStructure");
  }
  state.showConfigurationPanelCallback = null;

  // Afficher le loader pendant la transition entre panels
  state.leftToolbar.panelLoading = true;

  // Délai de transition pour une UX fluide
  await new Promise(resolve => setTimeout(resolve, 300));

  await hideLeftToolbar(e, true, name);

  // Désactiver le loading après la transition
  state.leftToolbar.panelLoading = false;
}

export function setChangeInLeftToolbar(newValue = true) {
  state.leftToolbar.hasChanged = newValue;
}

export function startHistoryRestore(total: number) {
  state.leftToolbar.historyRestoreProgress = {
    isRestoring: true,
    current: 0,
    total,
    actionDetail: ""
  };
}

export function updateHistoryRestoreProgress(
  current: number,
  total: number,
  actionDetail: string
) {
  state.leftToolbar.historyRestoreProgress = {
    isRestoring: true,
    current,
    total,
    actionDetail
  };
}

export function endHistoryRestore() {
  state.leftToolbar.historyRestoreProgress = {
    isRestoring: false,
    current: 0,
    total: 0,
    actionDetail: ""
  };
}

export function showTemplateEditor() {
  state.isTemplateEditorVisible = true;
}

export function setTemplate(template: Template) {
  state.template = template;
}

export function setTemplateConfigurationKey(key: string, value: any) {
  if (state.template) {
    state.template.configuration[key] = value;
  }
}

export function updateWhatsappValidationStatuses(
  rootStatus: string,
  templateData?: { languages?: Record<string, { category?: string }> },
  funnels?: Array<{
    id: number;
    template?: {
      status?: string;
      languages?: Record<string, { category?: string }>;
    };
  }>
) {
  const originId =
    state.template?.originTemplateId || String(state.template?.id);

  const extractCategory = (
    existingCategory: string | null | undefined,
    languages?: Record<string, { category?: string }>
  ): string | null => {
    if (!languages) {
      return resolveWhatsappTemplateCategory(existingCategory) ?? null;
    }
    return resolveWhatsappTemplateCategory(
      existingCategory,
      ...Object.values(languages).map((lang) => lang.category),
    );
  };

  // Update root template in state.templates
  const rootTmpl = state.templates.find(
    tmpl => String(tmpl.id) === String(originId)
  );
  if (rootTmpl) {
    rootTmpl.configuration.templateValidationStatus = rootStatus;
    const rootCategory = extractCategory(
      rootTmpl.configuration.templateCategory,
      templateData?.languages,
    );
    if (rootCategory) {
      rootTmpl.configuration.templateCategory = rootCategory;
    }
  }

  // Update funnel templates in state.templatesFromFunnel
  if (funnels && funnels.length > 0 && state.templatesFromFunnel[originId]) {
    const funnelTemplates = state.templatesFromFunnel[originId];
    for (const funnelResult of funnels) {
      const funnelTmpl = funnelTemplates.find(
        tmpl => tmpl.id === funnelResult.id
      );
      if (funnelTmpl) {
        funnelTmpl.configuration.templateValidationStatus =
          funnelResult.template?.status || null;
        const funnelCategory = extractCategory(
          funnelTmpl.configuration.templateCategory,
          funnelResult.template?.languages,
        );
        if (funnelCategory) {
          funnelTmpl.configuration.templateCategory = funnelCategory;
        }
      }
    }
  }

  // Update current template (whether root or funnel)
  if (state.template) {
    if (String(state.template.id) === String(originId)) {
      state.template.configuration.templateValidationStatus = rootStatus;
      const rootCategory = extractCategory(
        state.template.configuration.templateCategory,
        templateData?.languages,
      );
      if (rootCategory) {
        state.template.configuration.templateCategory = rootCategory;
      }
    } else if (funnels) {
      const currentFunnel = funnels.find(f => f.id === state.template?.id);
      if (currentFunnel) {
        state.template.configuration.templateValidationStatus =
          currentFunnel.template?.status || null;
        const funnelCategory = extractCategory(
          state.template.configuration.templateCategory,
          currentFunnel.template?.languages,
        );
        if (funnelCategory) {
          state.template.configuration.templateCategory = funnelCategory;
        }
      }
    }
  }
}

export function createTeaserTemplate(
  parentTemplateName: string,
  parentLang: string
): Template {
  const sectionId = Date.now().toString();
  const lineId = `spm_row_${generateUniqStructureId()}`;
  const columnId = `spm_column_${generateUniqStructureId()}`;
  const widgetId = `spm_widget_${generateUniqStructureId()}`;

  // Structure: spm_body > spm_content (styled container) > rows/columns/widgets
  const teaserHtml = `
    <div id="spm_body" class="spm_display_V4 spm_teaser spm_position_bl spm_shape_circle" data-spmelementid="${sectionId}">
      <div id="spm_content">
        <a class="spm_close_button spm_closeposition_tr spm_icon-cancel-1" href="#spm_close"></a>
        <div id="${lineId}" class="spm_draggable_row spm_row">
          <div class="spm_columns">
            <div class="spm_column spm_droppable_widget spm_droppable" style="width: 100%;" id="${columnId}">
              <div id="${widgetId}" class="spm_widget_display_image spm_draggable_widget spm_widget" data-widgettype="spm_widget_display_image">
                <img src="https://media.shopimind.io/clients/shopFiles/5458/699e07e390cd9.png" width="100%" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  const teaserSection = {
    id_template_elements: sectionId,
    name: "Teaser Section",
    data: "",
    html: teaserHtml,
    css: "[]",
    translations: "{}",
    type: "teaser"
  };

  return new Template(
    0,
    "teaser",
    null,
    null,
    { name: `Teaser - ${parentTemplateName}`, lang: parentLang || "fr" },
    { design: 0, sections: [sectionId], forms: {} },
    [teaserSection],
    { displayMode: "after_close" },
    false,
    null,
    null,
    4
  );
}

export function addTeaserTemplate(
  parentTemplateId: number,
  parentTemplateName: string,
  parentLang: string
): Template {
  const teaserTemplate = createTeaserTemplate(parentTemplateName, parentLang);
  teaserTemplate.configuration.parentPopupId = parentTemplateId;
  teaserTemplate.originTemplateId = String(parentTemplateId);

  // Store teaser in dedicated teaserTemplates storage (keyed by popup id)
  const popupId = String(parentTemplateId);
  state.teaserTemplates[popupId] = teaserTemplate;

  // Set as current template
  state.template = teaserTemplate;

  // Open information panel by default for teaser
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(state.leftToolbar.show)) {
    state.leftToolbar.show[key as keyof ToolbarPanels] = false;
  }
  state.leftToolbar.show.informationPanel = true;
  state.isLeftToolbarVisible = true;

  return teaserTemplate;
}

/**
 * Prepare teaser data for backend and create it via API
 * Call this after the teaser is loaded in iframe and translated
 */
export async function prepareTeaserDataForBackend(): Promise<{
  id_template: number;
  sections_mapping?: Record<string, string>;
} | null> {
  if (!state.template || state.template.type !== TemplateTypeEnum.TEASER) {
    return null;
  }

  // Skip if already in progress or already created
  if (state.teaserCreationInProgress) {
    return null;
  }

  state.teaserCreationInProgress = true;

  // Generate translations (like translation panel does) - this adds spmtranslation tags
  fixMissingTranslations();

  // Update sections in state with the translated HTML (uses replaceTranslationsByKey to convert to {LANG_xxx})
  updateSectionsInState(false);

  // Re-check after updates in case state changed
  if (!state.template || state.template.type !== TemplateTypeEnum.TEASER) {
    return null;
  }

  const teaserTemplate = state.template;

  // Get campaign info from flow store
  const activeFlow = store.getters["flowEditor/getActiveFlowIdentifier"];
  let idCampaign: number | null = null;
  let createdFromCampaign: string | null = null;

  if (activeFlow) {
    idCampaign = activeFlow.id;
    createdFromCampaign = `${teaserTemplate.type}_${activeFlow.type}`;
  }

  // Format sections like executeSave does
  const formattedSections = teaserTemplate.sections.map(section => ({
    id_template_elements:
      typeof section.id_template_elements === "string"
        ? parseInt(section.id_template_elements, 10)
        : section.id_template_elements,
    data: section.data || "{}",
    html: section.html.replace(/\s*data-spmelementid="[^"]*"/g, ""),
    css: section.css,
    translations: section.translations,
    type: "section"
  }));

  // Build body_structure like other templates
  const sectionIds = formattedSections.map(s => String(s.id_template_elements));

  const teaserInput = {
    type: teaserTemplate.type,
    idCampaign,
    createdFromCampaign,
    informations: teaserTemplate.informations,
    content: teaserTemplate.content,
    sections: formattedSections,
    configuration: {
      ...teaserTemplate.configuration,
      body_structure: {
        sections: sectionIds
      },
      informations: teaserTemplate.informations
    }
  };

  try {
    const response = await nestCall(
      "post",
      NestApiType.CLIENT_API,
      "/templates",
      {},
      "",
      teaserInput
    );

    if (response?.success && response?.data) {
      const { id_template, sections_mapping } = response.data;

      // Update template id in state
      if (state.template) {
        state.template.id = id_template;

        // Update section ids using the mapping
        if (sections_mapping) {
          state.template.sections = state.template.sections.map(section => {
            const oldId = String(section.id_template_elements);
            const newId = sections_mapping[oldId];
            if (newId) {
              // Update translations section id
              let updatedTranslations = section.translations;
              if (section.translations) {
                try {
                  const translations =
                    typeof section.translations === "string"
                      ? JSON.parse(section.translations)
                      : section.translations;
                  // Only process if translations is an array
                  if (Array.isArray(translations)) {
                    const updatedTranslationsArray = translations.map(
                      (t: any) => ({
                        ...t,
                        section: parseInt(newId, 10)
                      })
                    );
                    updatedTranslations = JSON.stringify(
                      updatedTranslationsArray
                    );
                  }
                } catch (e) {
                  console.error("Error updating translations:", e);
                }
              }

              return {
                ...section,
                id_template_elements: parseInt(newId, 10),
                translations: updatedTranslations
              };
            }
            return section;
          });

          // Update body_structure with new section ids
          if (state.template.configuration.body_structure?.sections) {
            state.template.configuration.body_structure.sections = state.template.configuration.body_structure.sections.map(
              (oldId: string) => sections_mapping[oldId] || oldId
            );
          }

          // Update content.sections with new section ids
          if (state.template.content?.sections) {
            state.template.content.sections = state.template.content.sections.map(
              oldId => sections_mapping[String(oldId)] || oldId
            );
          }

          // Update template-level translations with new section ids
          if (
            state.template.translations &&
            Array.isArray(state.template.translations)
          ) {
            state.template.translations = state.template.translations.map(
              (t: any) => {
                const oldSectionId = String(t.section);
                const newSectionId = sections_mapping[oldSectionId];
                if (newSectionId) {
                  return {
                    ...t,
                    section: parseInt(newSectionId, 10)
                  };
                }
                return t;
              }
            );
          }
        }

        // Update in teaserTemplates storage
        const { parentPopupId } = state.template.configuration;
        if (parentPopupId) {
          state.teaserTemplates[String(parentPopupId)] = state.template;

          // Add teaser id to parent popup configuration
          const parentPopup =
            state.templates.find(t => t.id === parentPopupId) ||
            state.templatesLinkedToCampaign.find(t => t.id === parentPopupId);
          if (parentPopup) {
            parentPopup.configuration.teaserId = id_template;
          }
        }
      }

      return response.data;
    }
    console.error("Failed to create teaser:", response?.message);
    return null;
  } catch (error) {
    console.error("Error creating teaser:", error);
    return null;
  }
}

export function getTeaserForPopup(popupId: number): Template | null {
  const id = String(popupId);
  return state.teaserTemplates[id] || null;
}

export function deleteTeaser(popupId: number): void {
  const id = String(popupId);
  if (state.teaserTemplates[id]) {
    delete state.teaserTemplates[id];
  }

  // Remove teaserId from popup configuration
  const popup =
    state.templates.find(t => t.id === popupId) ||
    state.templatesLinkedToCampaign.find(t => t.id === popupId);
  if (popup && popup.configuration.teaserId) {
    delete popup.configuration.teaserId;
    markTemplateAsEdited();
  }
}

export function activateTeaser(popupId: number): void {
  const teaser = getTeaserForPopup(popupId);
  if (teaser) {
    state.template = teaser;
    // Open information panel by default for teaser
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(state.leftToolbar.show)) {
      state.leftToolbar.show[key as keyof ToolbarPanels] = false;
    }
    state.leftToolbar.show.informationPanel = true;
    state.isLeftToolbarVisible = true;
  }
}

export function activatePopupFromTeaser(): void {
  if (state.template?.type !== TemplateTypeEnum.TEASER) {
    return;
  }
  // Resolve the parent popup id: originTemplateId, falling back to the
  // configuration link so teasers loaded without originTemplateId still resolve.
  const popupId =
    state.template.originTemplateId ??
    (state.template.configuration?.parentPopupId != null
      ? String(state.template.configuration.parentPopupId)
      : undefined);
  if (!popupId) {
    return;
  }
  // The popup may live in either bucket — campaign popups are in
  // templatesLinkedToCampaign (mirror deleteTeaser/fetchTeaserForPopup lookup).
  const popup =
    state.templates.find(t => String(t.id) === popupId) ||
    state.templatesLinkedToCampaign.find(t => String(t.id) === popupId);
  if (popup) {
    state.template = popup;
  }
}

/**
 * Fetch and prepare teaser for a popup if it exists
 */
export async function fetchTeaserForPopup(
  popupId: number,
  popupName: string,
  popupLang: string,
  popupConfiguration?: any
): Promise<Template | null> {
  // Check if teaser already loaded
  const existingTeaser = getTeaserForPopup(popupId);
  if (existingTeaser) {
    return existingTeaser;
  }

  // Use provided configuration or find popup in state
  let teaserId: number | undefined;
  if (popupConfiguration?.teaserId) {
    teaserId = popupConfiguration.teaserId;
  } else {
    const popup =
      state.templates.find(t => t.id === popupId) ||
      state.templatesLinkedToCampaign.find(t => t.id === popupId);
    teaserId = popup?.configuration?.teaserId;
  }

  if (!teaserId) {
    return null;
  }

  // Fetch teaser template from backend
  const preparedTeaser = await prepareTemplate(
    teaserId,
    "",
    TemplateTypeEnum.TEASER
  );
  if (!preparedTeaser) {
    return null;
  }

  const teaserTemplate = preparedTeaser.template;
  teaserTemplate.configuration.parentPopupId = asInt(popupId);
  teaserTemplate.originTemplateId = String(popupId);

  // Store in teaserTemplates
  state.teaserTemplates[String(popupId)] = teaserTemplate;

  // Mark as already created so we don't re-create it
  state.teaserCreationInProgress = true;

  return teaserTemplate;
}

export function hideTemplateEditor() {
  state.isTemplateEditorVisible = false;
  state.teaserCreationInProgress = false;
  hideLeftToolbar();
}

export function showConfigurationPanel() {
  state.isConfigurationPanelVisible = true;
}

export function hideConfigurationPanel() {
  state.isConfigurationPanelVisible = false;
}

export function showColumnWidgetModal() {
  state.isColumnWidgetModalVisible = true;
}

export function resetNeedToTranslate() {
  state.leftToolbar.needToTranslate = false;
}

export function toggleWidgetsPanelSection(section: string) {
  state.widgetsPanelCollapsedSections[section] = !state
    .widgetsPanelCollapsedSections[section];
}

export function removeColumnWidgetPlaceholders() {
  const template = getTemplateIframeDocument();
  const placeholders = template?.querySelectorAll(
    ".sortable-group-line.sortable-placeholder"
  );
  (placeholders ?? []).forEach(placeholder => placeholder.remove());
}

export function hideColumnWidgetModal() {
  // Remove column widget's placeholders from template (if any)
  removeColumnWidgetPlaceholders();

  // Hide the modal
  state.isColumnWidgetModalVisible = false;
}

export function showElementsModal(
  types = [TemplateStructureEnum.SECTION],
  additionalLoadElementsParams: {
    elementPartType: string;
    elementSubtype: string;
    fromSyncElement?: boolean;
  } | null = null
) {
  state.isLoadElementsModalVisible = true;
  state.loadElementsType = types;
  if (additionalLoadElementsParams) {
    state.additionalLoadElementsParams = additionalLoadElementsParams;
  }
}

function removeSectionWidgetPlaceholders() {
  const template = getTemplateIframeDocument();
  const placeholders = template?.querySelectorAll(
    ".sortable-group-section.sortable-placeholder"
  );
  (placeholders ?? []).forEach(placeholder => placeholder.remove());
}

export function hideElementsModal() {
  // Remove column widget's placeholders from template (if any)
  removeSectionWidgetPlaceholders();

  // Hide the modal
  state.isLoadElementsModalVisible = false;
  state.loadElementsType = [];
  state.additionalLoadElementsParams = null;
}

export function calculateClock() {
  const now = new Date();

  const template = getTemplateIframeDocument();
  // Support both old (#display-time) and new (#push-display-time) selectors
  const time =
    template?.querySelector("#push-display-time") ??
    template?.querySelector("#display-time");
  const date =
    template?.querySelector("#push-display-date") ??
    template?.querySelector("#display-date");

  if (time && date) {
    const dateStr = now.toLocaleDateString("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long"
    });
    date.innerHTML = dateStr;

    const h = now.getHours();
    let m: number | string = now.getMinutes();

    if (m < 10) {
      m = `0${m}`;
    }

    time.innerHTML = `${h}:${m}`;
  }

  // Also update status bar time
  const statusBarTime = template?.querySelector(".push-status-bar__time");
  if (statusBarTime) {
    const h = now.getHours();
    let m: number | string = now.getMinutes();
    if (m < 10) {
      m = `0${m}`;
    }
    statusBarTime.innerHTML = `${h}:${m}`;
  }
}

/* Start the clock and its interval for push notifications templates */
export function launchPushNotificationsClock() {
  calculateClock();

  if (state.intervals === null) {
    state.intervals = {};
  }

  if (state.intervals?.pushNotificationsClock) {
    window.clearInterval(state.intervals.pushNotificationsClock);
    state.intervals.pushNotificationsClock = null;
  }

  state.intervals.pushNotificationsClock = window.setInterval(() => {
    calculateClock();
  }, 1000);
}

/* Stop the clock and its interval for push notifications templates */
export function stopPushNotificationsClock() {
  if (state.intervals?.pushNotificationsClock) {
    window.clearInterval(state.intervals.pushNotificationsClock);
    state.intervals.pushNotificationsClock = null;
  }
}

/* Launch additional functions in editor after activation of a template */
export function triggerAdditionalEditorActivationFunctions() {
  if (isPushTemplate(state.template?.type)) {
    launchPushNotificationsClock();
  } else {
    stopPushNotificationsClock();
  }
}

/* Launch additional functions in editor before deactivation */
export function triggerAdditionalEditorDeactivationFunctions() {
  stopPushNotificationsClock();
}

// Return the translation object for a specific key for specific language
export const getTranslationByKeyAndLang = (key: string, lang: string) => {
  if (state.template) {
    const translationToReturn = state.template.translations.filter(
      (translation: Translation) =>
        translation.key === key && translation.language === lang
    );

    if (translationToReturn && translationToReturn.length > 0) {
      return translationToReturn[0];
    }
  }

  return null;
};

// replace translation value in state object
export const replaceTranslationInState = (
  key: string,
  language: string,
  value: string
) => {
  if (state.template) {
    const translation = getTranslationByKeyAndLang(key, language);

    if (translation) {
      // Get shop default language
      const defaultLanguage = getShopDefaultLang();

      // If translation to replace is set to default language, we synchronize the new value with all translations having the same old value
      if (translation.language === defaultLanguage) {
        state.template.translations
          .filter(
            (currentTranslation: Translation) =>
              currentTranslation.key === translation.key &&
              currentTranslation.value === translation.value
          )
          .forEach((currentTranslation: Translation) => {
            currentTranslation.value = value;
          });
      } else {
        // Else we set the new value
        translation.value = value;
      }
    }
  }
};

/**
 * Replace translation value in state object for every language available.
 *
 * NOTE: Depuis l'ajout de syncTranslationsFromDOM() dans executeUpdateSectionsInState,
 * il n'est plus nécessaire d'appeler cette fonction manuellement dans les setters.
 * syncTranslationsFromDOM synchronise automatiquement les valeurs du DOM avec le state
 * avant la sauvegarde. Les setters peuvent simplement modifier les attributs/contenus
 * du DOM et la synchronisation se fait automatiquement.
 *
 * Elle n'est appliquée par syncTranslationsFromDOM qu'aux liens et redirections
 * (replaceDefaultLanguageTranslation) ; les autres valeurs passent par replaceTranslationInState.
 */
export const replaceTranslationInStateAllLanguages = (
  key: string,
  value: string
) => {
  if (state.template) {
    state.template.translations
      .filter((translation: Translation) => translation.key === key)
      .forEach((translation: Translation) => {
        // eslint-disable-next-line no-param-reassign
        translation.value = value;
      });
  }
};

export const updateTranslationPropertyInStateAllLanguages = <
  K extends keyof Translation
>(
  key: string,
  property: K,
  value: Translation[K]
) => {
  if (state.template) {
    state.template.translations
      .filter((translation: Translation) => translation.key === key)
      .forEach((translation: Translation) => {
        // eslint-disable-next-line no-param-reassign
        if (Object.prototype.hasOwnProperty.call(translation, property)) {
          translation[property] = value;
        }
      });
  }
};

export const backwardCompatibilityMediaRestrictionClasses = (
  template: Document
) => {
  const showForDesktopElements = template.querySelectorAll(
    ".spm_draggable_row.hide-for-small.show-for-desktop"
  );
  const showForMobileElements = template.querySelectorAll(
    ".spm_draggable_row.show-for-small.hide-for-desktop"
  );

  // Helper function to move classes from parent to child elements
  const moveClasses = (
    elements: NodeListOf<Element>,
    classesToAdd: string[],
    classesToRemove: string[]
  ) => {
    elements.forEach(element => {
      if (element.nodeType === Node.ELEMENT_NODE) {
        // Find all child elements with class .spm_draggable_widget
        const childWidgets = element.querySelectorAll(".spm_draggable_widget");
        // Add classes to child elements
        childWidgets.forEach(child => {
          if (child.nodeType === Node.ELEMENT_NODE) {
            classesToAdd.forEach(cls => child.classList.add(cls));
            child.classList.remove("show-for-all");
          }
        });

        // Remove classes from parent element
        classesToRemove.forEach(cls => element.classList.remove(cls));
      }
    });
  };

  // Handle showForDesktopElements
  if (showForDesktopElements) {
    moveClasses(
      showForDesktopElements,
      ["hide-for-small", "show-for-desktop"],
      ["hide-for-small", "show-for-desktop"]
    );
  }

  // Handle showForMobileElements
  if (showForMobileElements) {
    moveClasses(
      showForMobileElements,
      ["show-for-small", "hide-for-desktop"],
      ["show-for-small", "hide-for-desktop"]
    );
  }

  return true;
};

export const setTemplateConfigurationKeyInState = (
  key: string,
  value: any,
  template: Template | null = null
) => {
  // If a template is provided, find the matching mutable reference from internal state
  // to avoid writing to a readonly proxy (e.g. when called from History.ts with TemplateEditorState)
  let templateState: Template | null = null;
  if (template) {
    if (state.template && state.template.id === template.id) {
      templateState = state.template;
    } else if (
      state.template?.originTemplateId &&
      state.templatesFromFunnel[state.template.originTemplateId]
    ) {
      templateState =
        (state.templatesFromFunnel[state.template.originTemplateId].find(
          t => t.id === template.id
        ) as Template) ?? null;
    }
  } else {
    templateState = state.template;
  }

  if (templateState) {
    templateState.configuration[key] = value;
  }
};

export const isTemplateRelatedToCampaignBulk = () => {
  if (state.template) {
    const { idCampaign } = state.template;
    return (
      AutomatedScenarioState.scenario &&
      String(AutomatedScenarioState.scenario.id) === String(idCampaign) &&
      AutomatedScenarioState.scenario.type === TypeCampaignEnum.BULK
    );
  }
  return false;
};

const getTypeCampaignRelatedToTemplate = (idCampaignFromTemplate: any) => {
  if (idCampaignFromTemplate && idCampaignFromTemplate > 0) {
    if (
      AutomatedScenarioState.scenario &&
      Number(AutomatedScenarioState.scenario.id) ===
        Number(idCampaignFromTemplate)
    ) {
      return AutomatedScenarioState.scenario.type;
    }
    if (
      AutomatedScenarioState.automationCampaigns.some(
        campaign =>
          Number(campaign.scenario?.id) === Number(idCampaignFromTemplate)
      )
    ) {
      return TypeCampaignEnum.AUTOMATION;
    }
    if (
      AutomatedScenarioState.bulkCampaigns.some(
        campaign =>
          Number(campaign.scenario?.id) === Number(idCampaignFromTemplate)
      )
    ) {
      return TypeCampaignEnum.BULK;
    }
  }

  return null;
};

const verifyIfTheCurrentTemplateIsRedirection = (
  idTemplate: number,
  fromCampaign = false
) => {
  const dataToUse = fromCampaign
    ? state.templatesLinkedToCampaign
    : state.templates;

  const primaryTemplateToSwitch = dataToUse.filter((c: any) => {
    if (c.configuration.nextIdTemplate) {
      const [keyNextIdTemplate, valueNextIdTemplate] = Object.entries(
        c.configuration.nextIdTemplate
      )[0];
      const valueNextIdTemplateNumber =
        valueNextIdTemplate && Array.isArray(valueNextIdTemplate)
          ? valueNextIdTemplate.map(Number)
          : [];
      if (
        valueNextIdTemplateNumber &&
        Array.isArray(valueNextIdTemplateNumber) &&
        valueNextIdTemplateNumber.includes(Number(state.template?.id))
      ) {
        return true;
      }
    }
    return false;
  });

  return primaryTemplateToSwitch.length ? primaryTemplateToSwitch[0].id : false;
};

const getRichTextingDataFromTemplate = (
  template: HTMLElement | Document
): RichTextingData => {
  const getAttr = (el: Element | null, attr: string) =>
    el?.getAttribute(attr) || "";

  const img = template.querySelector(".rcs-message__header img");
  const titleElement = template.querySelector(
    `.rcs-message__body .rcs-message__title ${TRANSLATION_MARKUP}`
  );
  const titleId = getAttr(titleElement, "id");
  const bodyElement = template.querySelector(
    `.rcs-message__body .rcs-message__text ${TRANSLATION_MARKUP}`
  );
  const bodyId = getAttr(bodyElement, "id");

  // Extract links from body text content
  const bodyText = bodyElement?.textContent || "";
  const links = extractUrlsFromText(bodyText);

  const fallbackId = getAttr(
    template.querySelector(`.rcs-message__fallback ${TRANSLATION_MARKUP}`),
    "id"
  );

  const ctas = Array.from(
    template.querySelectorAll(".rcs-message__cta__item")
  ).map(cta => ({
    actionType: getAttr(cta, "data-rcs-action-type"),
    href: getAttr(cta, `${TRANSLATION_ATTRIBUTE}-href`),
    content: getAttr(cta.querySelector(TRANSLATION_MARKUP), "id"),
    description:
      getAttr(cta, `${TRANSLATION_ATTRIBUTE}-data-rcs-url-description`) ||
      cta.getAttribute("data-rcs-url-description") ||
      ""
  }));

  // Get smartlist button text translation key from HTML (from the hidden source element)
  const buttonTextSource = template.querySelector(
    ".rcs-smartlist-buttontext-source"
  );
  const buttonTextTranslationNode = buttonTextSource
    ? buttonTextSource.querySelector(TRANSLATION_MARKUP)
    : null;
  const smartlistButtonText = getAttr(buttonTextTranslationNode, "id");

  return {
    image: img
      ? {
          src: getAttr(img, `${TRANSLATION_ATTRIBUTE}-src`),
          showImage: JSON.parse(img.getAttribute("data-show-image") || "false"),
          mediaHeight: img.getAttribute("data-media-height") || "tall"
        }
      : undefined,
    title: titleId || undefined,
    body: bodyId,
    ctas,
    fallback: fallbackId,
    links,
    smartlistButtonText: smartlistButtonText || undefined
  };
};

const fillRichTextingDataTranslation = (
  data: RichTextingData,
  translations: Translation[],
  template?: any
): RichTextingData => {
  const translate = (key: string) =>
    translations.find(t => key && key.replace("LANG_", "").startsWith(t.key))
      ?.value ?? "";

  const translatedBody = translate(data.body);
  const translatedLinks = extractUrlsFromText(translatedBody);

  // Get existing smartlist config from richtexting_data (default language)
  const targetTemplate = template || state.template;
  const defaultLang = getShopDefaultLang();
  const rcsData = targetTemplate?.configuration?.richtexting_data as
    | Record<string, any>
    | undefined;
  const existingSmartlist = (rcsData?.[defaultLang]?.smartlist ?? {}) as Record<
    string,
    any
  >;

  // Get buttonText from HTML translation (data.smartlistButtonText contains the translation key)
  const smartlistButtonText = data.smartlistButtonText
    ? translate(data.smartlistButtonText)
    : "";

  // Build smartlist object if there's any config
  const smartlist =
    Object.keys(existingSmartlist).length || smartlistButtonText
      ? {
          ...existingSmartlist,
          ...(smartlistButtonText ? { buttonText: smartlistButtonText } : {})
        }
      : undefined;

  return {
    image: data.image && {
      src: translate(data.image.src),
      showImage: data.image.showImage,
      mediaHeight: data.image.mediaHeight || "tall"
    },
    title: data.title ? translate(data.title) : undefined,
    body: translatedBody,
    ctas: data.ctas.map(cta => ({
      actionType: cta.actionType,
      href: translate(cta.href),
      content: translate(cta.content),
      description: cta.description
        ? translate(cta.description) || cta.description
        : ""
    })),
    fallback: translate(data.fallback),
    links: translatedLinks,
    smartlist
  };
};

/**
 * Extract URLs from text content
 */
const extractUrlsFromText = (text: string): string[] => {
  if (!text) return [];

  // Regex pattern to match URLs (http://, https://, www., etc.)
  const urlPattern = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/gi;
  const matches = text.match(urlPattern);

  return matches ? [...new Set(matches)] : [];
};

const getWhatsappDataFromTemplate = (
  template: HTMLElement | Document
): WhatsappData => {
  const getAttr = (el: Element | null, attr: string) =>
    el?.getAttribute(attr) || "";

  const img = template.querySelector(".whatsapp-message__header img");
  const bodyElement = template.querySelector(
    `.whatsapp-message__body .whatsapp-message__text ${TRANSLATION_MARKUP}`
  );
  const bodyId = getAttr(bodyElement, "id");

  // Extract links from body text content
  const bodyText = bodyElement?.textContent || "";
  const links = extractUrlsFromText(bodyText);

  const fallbackId = getAttr(
    template.querySelector(`.whatsapp-message__fallback ${TRANSLATION_MARKUP}`),
    "id"
  );

  const ctas = Array.from(
    template.querySelectorAll(".whatsapp-message__cta__item")
  ).map(cta => ({
    actionType: getAttr(cta, "data-whatsapp-action-type"),
    href: getAttr(cta, `${TRANSLATION_ATTRIBUTE}-href`),
    content: getAttr(cta.querySelector(TRANSLATION_MARKUP), "id")
  }));

  // Get smartlist button text translation key from HTML (from the hidden source element)
  const buttonTextSource = template.querySelector(
    ".whatsapp-smartlist-buttontext-source"
  );
  const buttonTextTranslationNode = buttonTextSource
    ? buttonTextSource.querySelector(TRANSLATION_MARKUP)
    : null;
  const smartlistButtonText = getAttr(buttonTextTranslationNode, "id");

  return {
    image: img
      ? {
          src: getAttr(img, `${TRANSLATION_ATTRIBUTE}-src`),
          alt: getAttr(img, `${TRANSLATION_ATTRIBUTE}-alt`),
          showImage: JSON.parse(img.getAttribute("data-show-image") || "false")
        }
      : undefined,
    body: bodyId,
    ctas,
    fallback: fallbackId,
    links,
    smartlistButtonText: smartlistButtonText || undefined
  };
};

export const fillWhatsappDataTranslation = (
  data: WhatsappData,
  translations: Translation[],
  template?: any
): WhatsappData => {
  const translate = (key: string) =>
    translations.find(t => key && key.replace("LANG_", "").startsWith(t.key))
      ?.value ?? "";

  const translatedBody = translate(data.body);
  const translatedLinks = extractUrlsFromText(translatedBody);

  // Get existing smartlist config from whatsapp_data (default language)
  // Use provided template or fallback to state.template
  const targetTemplate = template || state.template;
  const defaultLang = getShopDefaultLang();
  const whatsappData = targetTemplate?.configuration?.whatsapp_data as
    | Record<string, any>
    | undefined;
  const existingSmartlist = (whatsappData?.[defaultLang]?.smartlist ??
    {}) as Record<string, any>;

  // Get buttonText from HTML translation (data.smartlistButtonText contains the translation key)
  const smartlistButtonText = data.smartlistButtonText
    ? translate(data.smartlistButtonText)
    : "";

  // Build smartlist object if there's any config
  const smartlist =
    Object.keys(existingSmartlist).length || smartlistButtonText
      ? {
          ...existingSmartlist,
          ...(smartlistButtonText ? { buttonText: smartlistButtonText } : {})
        }
      : undefined;

  return {
    image: data.image && {
      src: translate(data.image.src),
      alt: translate(data.image.alt),
      showImage: data.image.showImage
    },
    body: translatedBody,
    ctas: data.ctas.map((cta: any) => ({
      actionType: cta.actionType,
      href: translate(cta.href),
      content: translate(cta.content)
    })),
    fallback: translate(data.fallback),
    links: translatedLinks,
    smartlist
  };
};

export const getRedirectsFromTemplate = () => {
  const { template: templateState } = state;

  const template = getTemplateIframeDocument();

  const currentRedirects: { [key: string]: (string | number)[] } = {};

  if (template && templateState) {
    const defaultLang = getShopDefaultLang();
    if (state.template && UserState.activeShop) {
      const otherLanguages = UserState.activeShop.langs
        .filter(lang => lang.id !== defaultLang)
        .map(lang => lang.id);
      const languages = [defaultLang, ...otherLanguages];

      const redirectsElements = Array.from(
        template.querySelectorAll("[data-redirect]")
      );
      if (redirectsElements.length > 0) {
        redirectsElements.forEach(element => {
          const redirect = element.getAttribute("data-redirect");
          if (redirect) {
            if (redirect === 'game_result' || redirect === 'game_prizes') {
              return;
            }
            try {
              const idRedirect = window.atob(redirect);
              languages.forEach(lang => {
                if (
                  !Object.prototype.hasOwnProperty.call(currentRedirects, lang)
                ) {
                  currentRedirects[lang] = [];
                }

                if (currentRedirects[lang].indexOf(asInt(idRedirect)) === -1) {
                  currentRedirects[lang].push(asInt(idRedirect));
                }
              });
            } catch (e) {
              // Skip invalid base64 data-redirect values
            }
          }
        });
      }

      // Include game prize template IDs
      const wheelElement = template.querySelector(".spm_widget_game_wheel");
      if (wheelElement) {
        try {
          const prizes = JSON.parse(
            wheelElement.getAttribute("data-prizes") || "[]"
          );
          prizes.forEach((prize: any) => {
            if (prize.templateId) {
              // templateId should be base64 encoded in data-prizes
              try {
                const decodedTemplateId = Number(
                  atob(String(prize.templateId))
                );
                if (!Number.isNaN(decodedTemplateId) && decodedTemplateId > 0) {
                  languages.forEach(lang => {
                    if (
                      !Object.prototype.hasOwnProperty.call(
                        currentRedirects,
                        lang
                      )
                    ) {
                      currentRedirects[lang] = [];
                    }
                    if (
                      currentRedirects[lang].indexOf(decodedTemplateId) === -1
                    ) {
                      currentRedirects[lang].push(decodedTemplateId);
                    }
                  });
                }
              } catch {
                // Ignore decode errors
              }
            }
          });
        } catch (e) {
          // Invalid prizes JSON
        }
      }

      const slotElementRedirects = template.querySelector('.spm_widget_game_slot_machine');
      if (slotElementRedirects) {
        try {
          const combinations = JSON.parse(slotElementRedirects.getAttribute('data-win-combinations') || '[]');
          combinations.forEach((combo: any) => {
            if (combo.templateId) {
              try {
                const decodedTemplateId = Number(atob(String(combo.templateId)));
                if (!Number.isNaN(decodedTemplateId) && decodedTemplateId > 0) {
                  languages.forEach((lang) => {
                    if (!Object.prototype.hasOwnProperty.call(currentRedirects, lang)) {
                      currentRedirects[lang] = [];
                    }
                    if (currentRedirects[lang].indexOf(decodedTemplateId) === -1) {
                      currentRedirects[lang].push(decodedTemplateId);
                    }
                  });
                }
              } catch {
                // Ignore decode errors
              }
            }
          });
        } catch (e) {
          // Invalid win-combinations JSON
        }
      }

      const scratchElementRedirects = template.querySelector('.spm_widget_game_scratch_card');
      if (scratchElementRedirects) {
        try {
          const prizes = JSON.parse(scratchElementRedirects.getAttribute('data-prizes') || '[]');
          prizes.forEach((prize: any) => {
            if (prize.templateId) {
              try {
                const decodedTemplateId = Number(atob(String(prize.templateId)));
                if (!Number.isNaN(decodedTemplateId) && decodedTemplateId > 0) {
                  languages.forEach((lang) => {
                    if (!Object.prototype.hasOwnProperty.call(currentRedirects, lang)) {
                      currentRedirects[lang] = [];
                    }
                    if (currentRedirects[lang].indexOf(decodedTemplateId) === -1) {
                      currentRedirects[lang].push(decodedTemplateId);
                    }
                  });
                }
              } catch {
                // Ignore decode errors
              }
            }
          });
        } catch (e) {
          // Invalid prizes JSON
        }
      }
    }
  }

  return currentRedirects;
};

export const updateTemplateConfigurationNextIdTemplate = () => {
  const currentRedirects = getRedirectsFromTemplate();
  setTemplateConfigurationKeyInState(
    "nextIdTemplate",
    Object.keys(currentRedirects).length ? currentRedirects : false
  );
};

interface GamePrizeBase {
  label: string;
  translationKey?: string;
  templateId?: number;
  probability: number;
  color: string;
  image: string;
  stock?: number | null;
}

interface GameWheelBase {
  prizes: GamePrizeBase[];
  spinDuration: number;
  resultApiUrl: string;
}

interface GameSlotMachineBase {
  prizes: GamePrizeBase[];
  symbols: any[];
  winCombinations: any[];
  reelsCount: number;
  spinDuration: number;
}

interface GameScratchCardBase {
  prizes: GamePrizeBase[];
  revealThreshold: number;
  brushSize: number;
}

interface GamesBaseData {
  wheel?: GameWheelBase;
  slotMachine?: GameSlotMachineBase;
  scratchCard?: GameScratchCardBase;
}

/**
 * Extract base game data from the template DOM (with translation keys for labels)
 */
const getGamesDataFromTemplate = (
  template: HTMLElement | Document
): GamesBaseData => {
  const data: GamesBaseData = {};

  const wheelElement = template.querySelector(".spm_widget_game_wheel");
  if (wheelElement) {
    const prizesJson = wheelElement.getAttribute("data-prizes") || "[]";
    let prizes: GamePrizeBase[] = [];
    try {
      const rawPrizes = JSON.parse(prizesJson);
      prizes = rawPrizes.map((p: any) => {
        let templateId: number | undefined;
        if (p.templateId) {
          // templateId should be base64 encoded in data-prizes
          try {
            const decoded = Number(atob(String(p.templateId)));
            if (!Number.isNaN(decoded) && decoded > 0) {
              templateId = decoded;
            }
          } catch {
            // Ignore decode errors
          }
        }
        return {
          label: p.label || "",
          translationKey: p.translationKey || undefined,
          templateId,
          probability: Number(p.probability) || 0,
          color: p.color || "",
          image: p.image || "",
          stock: (p.stock != null && Number(p.stock) > 0) ? Number(p.stock) : null,
        };
      });
    } catch (e) {
      // Invalid prizes JSON
    }

    data.wheel = {
      prizes,
      spinDuration:
        Number(wheelElement.getAttribute("data-spin-duration")) || 4000,
      resultApiUrl: wheelElement.getAttribute("data-result-api-url") || ""
    };
  }

  const slotElement = template.querySelector(".spm_widget_game_slot_machine");
  if (slotElement) {
    let symbols: any[] = [];
    let winCombinations: any[] = [];
    let prizes: GamePrizeBase[] = [];
    try {
      symbols = JSON.parse(slotElement.getAttribute("data-symbols") || "[]");
      winCombinations = JSON.parse(
        slotElement.getAttribute("data-win-combinations") || "[]"
      );
      prizes = winCombinations.map((combo: any) => {
        let templateId: number | undefined;
        if (combo.templateId) {
          try {
            const decoded = Number(atob(String(combo.templateId)));
            if (!Number.isNaN(decoded) && decoded > 0) {
              templateId = decoded;
            }
          } catch {
            // Ignore decode errors
          }
        }
        return {
          label: combo.prize || "",
          templateId,
          probability: Number(combo.probability) || 0,
          color: "",
          image: "",
          stock: (combo.stock != null && Number(combo.stock) > 0) ? Number(combo.stock) : null,
        };
      });
    } catch (e) {
      // Invalid JSON
    }

    data.slotMachine = {
      prizes,
      symbols,
      winCombinations,
      reelsCount: Number(slotElement.getAttribute("data-reels-count")) || 3,
      spinDuration:
        Number(slotElement.getAttribute("data-spin-duration")) || 2000
    };
  }

  const scratchElement = template.querySelector('.spm_widget_game_scratch_card');
  if (scratchElement) {
    const prizesJson = scratchElement.getAttribute('data-prizes') || '[]';
    let prizes: GamePrizeBase[] = [];
    try {
      const rawPrizes = JSON.parse(prizesJson);
      prizes = rawPrizes.map((p: any) => {
        let templateId: number | undefined;
        if (p.templateId) {
          try {
            const decoded = Number(atob(String(p.templateId)));
            if (!Number.isNaN(decoded) && decoded > 0) {
              templateId = decoded;
            }
          } catch {
            // Ignore decode errors
          }
        }
        return {
          label: p.label || '',
          translationKey: p.translationKey || undefined,
          templateId,
          probability: Number(p.probability) || 0,
          color: '',
          image: p.image || '',
          stock: (p.stock != null && Number(p.stock) > 0) ? Number(p.stock) : null,
        };
      });
    } catch (e) {
      // Invalid prizes JSON
    }

    data.scratchCard = {
      prizes,
      revealThreshold: Number(scratchElement.getAttribute('data-reveal-threshold')) || 50,
      brushSize: Number(scratchElement.getAttribute('data-brush-size')) || 30,
    };
  }

  return data;
};

/**
 * Resolve translation keys in game data for a specific language
 */
const fillGamesDataTranslation = (
  baseData: GamesBaseData,
  translations: Translation[]
): Record<string, any> => {
  // Build key→value map for fast exact lookup
  const translationMap = new Map<string, string>();
  translations.forEach(t => translationMap.set(t.key, t.value));

  const result: Record<string, any> = {};

  if (baseData.wheel) {
    result.wheel = {
      prizes: baseData.wheel.prizes.map(prize => ({
        label: prize.translationKey
          ? translationMap.get(prize.translationKey) ?? prize.label
          : prize.label,
        ...(prize.templateId ? { templateId: prize.templateId } : {}),
        probability: prize.probability,
        color: prize.color,
        image: prize.image,
        ...(prize.stock != null && prize.stock > 0 ? { stock: prize.stock } : {}),
      })),
      spinDuration: baseData.wheel.spinDuration,
      resultApiUrl: baseData.wheel.resultApiUrl
    };
  }

  if (baseData.slotMachine) {
    result.slotMachine = {
      prizes: baseData.slotMachine.winCombinations.map((combo: any) => {
        let templateId: number | undefined;
        if (combo.templateId) {
          try {
            const decoded = Number(atob(String(combo.templateId)));
            if (!Number.isNaN(decoded) && decoded > 0) {
              templateId = decoded;
            }
          } catch {
            /* ignore */
          }
        }
        return {
          label: combo.translationKey
            ? translationMap.get(combo.translationKey) ?? combo.prize ?? ""
            : combo.prize ?? "",
          ...(templateId ? { templateId } : {}),
          probability: Number(combo.probability) || 0,
          ...(combo.stock != null && Number(combo.stock) > 0 ? { stock: Number(combo.stock) } : {}),
        };
      }),
      symbols: baseData.slotMachine.symbols.map((s: any) => ({
        ...s,
        text: s.translationKey
          ? translationMap.get(s.translationKey) ?? s.text
          : s.text,
        label: s.translationKey
          ? translationMap.get(s.translationKey) ?? s.label
          : s.label
      })),
      winCombinations: baseData.slotMachine.winCombinations.map((c: any) => ({
        ...c,
        prize: c.translationKey
          ? translationMap.get(c.translationKey) ?? c.prize
          : c.prize
      })),
      reelsCount: baseData.slotMachine.reelsCount,
      spinDuration: baseData.slotMachine.spinDuration
    };
  }

  if (baseData.scratchCard) {
    result.scratchCard = {
      prizes: baseData.scratchCard.prizes.map((prize) => ({
        label: prize.translationKey
          ? (translationMap.get(prize.translationKey) ?? prize.label)
          : prize.label,
        ...(prize.templateId ? { templateId: prize.templateId } : {}),
        probability: prize.probability,
        image: prize.image,
        ...(prize.stock != null && prize.stock > 0 ? { stock: prize.stock } : {}),
      })),
      revealThreshold: baseData.scratchCard.revealThreshold,
      brushSize: baseData.scratchCard.brushSize,
    };
  }

  return result;
};

/**
 * Update template's configuration in state according to its content
 */
export const updateTemplateConfiguration = async () => {
  const { template: templateState } = state;

  const template = getTemplateIframeDocument();

  if (template && templateState) {
    if (isRichTextingTemplate(templateState.type)) {
      const baseData = getRichTextingDataFromTemplate(template);
      const grouped = groupBy(templateState.translations, t => t.language);

      const translatedData = Object.fromEntries(
        Object.entries(grouped).map(([lang, langTranslations]) => [
          lang,
          fillRichTextingDataTranslation(
            baseData,
            langTranslations,
            templateState
          )
        ])
      );

      setTemplateConfigurationKeyInState("richtexting_data", translatedData);
    }
    if (isWhatsappTemplate(templateState.type)) {
      const baseData = getWhatsappDataFromTemplate(template);
      const grouped = groupBy(templateState.translations, t => t.language);

      const translatedData = Object.fromEntries(
        Object.entries(grouped).map(([lang, langTranslations]) => [
          lang,
          fillWhatsappDataTranslation(baseData, langTranslations)
        ])
      );

      setTemplateConfigurationKeyInState("whatsapp_data", translatedData);
    }

    // Games data (display/embed templates)
    const hasGame = !!template.querySelector(
      ".spm_widget_game_wheel, .spm_widget_game_slot_machine, .spm_widget_game_scratch_card"
    );
    setTemplateConfigurationKeyInState("hasGame", hasGame);
    if (hasGame) {
      const gamesBaseData = getGamesDataFromTemplate(template);

      // Preserve existing templateIds from games_data if not present in iframe DOM
      const existingGamesData = templateState.configuration.games_data;
      let templateIdsRestored = false;

      // Wheel: restore templateIds
      if (existingGamesData?.wheel?.prizes && gamesBaseData.wheel?.prizes) {
        const existingPrizes = existingGamesData.wheel.prizes;
        gamesBaseData.wheel.prizes.forEach((prize, index) => {
          if (!prize.templateId && existingPrizes[index]?.templateId) {
            // eslint-disable-next-line no-param-reassign
            prize.templateId = existingPrizes[index].templateId;
            templateIdsRestored = true;
          }
        });
      }

      // Slot machine: restore templateIds
      if (
        existingGamesData?.slotMachine?.prizes &&
        gamesBaseData.slotMachine?.prizes
      ) {
        const existingPrizes = existingGamesData.slotMachine.prizes;
        gamesBaseData.slotMachine.prizes.forEach((prize, index) => {
          if (!prize.templateId && existingPrizes[index]?.templateId) {
            // eslint-disable-next-line no-param-reassign
            prize.templateId = existingPrizes[index].templateId;
            templateIdsRestored = true;
          }
        });
      }

      // Scratch card: restore templateIds
      if (existingGamesData?.scratchCard?.prizes && gamesBaseData.scratchCard?.prizes) {
        const existingPrizes = existingGamesData.scratchCard.prizes;
        gamesBaseData.scratchCard.prizes.forEach((prize, index) => {
          if (!prize.templateId && existingPrizes[index]?.templateId) {
            // eslint-disable-next-line no-param-reassign
            prize.templateId = existingPrizes[index].templateId;
            templateIdsRestored = true;
          }
        });
      }

      // Ensure templateIds in iframe data-prizes are always base64 encoded (wheel)
      if (gamesBaseData.wheel?.prizes) {
        const wheelElement = template.querySelector(".spm_widget_game_wheel");
        if (wheelElement) {
          try {
            const iframePrizes = JSON.parse(
              wheelElement.getAttribute("data-prizes") || "[]"
            );
            let needsUpdate = false;
            gamesBaseData.wheel.prizes.forEach((prize, index) => {
              if (prize.templateId && iframePrizes[index]) {
                const expectedBase64 = btoa(String(prize.templateId));
                if (
                  !iframePrizes[index].templateId ||
                  typeof iframePrizes[index].templateId === "number"
                ) {
                  iframePrizes[index].templateId = expectedBase64;
                  needsUpdate = true;
                }
              }
            });
            if (needsUpdate) {
              wheelElement.setAttribute(
                "data-prizes",
                JSON.stringify(iframePrizes)
              );
            }
          } catch (e) {
            // Ignore parse errors
          }
        }
      }

      // Ensure templateIds in iframe data-win-combinations are always base64 encoded (slot machine)
      if (gamesBaseData.slotMachine?.prizes) {
        const slotElement = template.querySelector(
          ".spm_widget_game_slot_machine"
        );
        if (slotElement) {
          try {
            const iframeCombinations = JSON.parse(
              slotElement.getAttribute("data-win-combinations") || "[]"
            );
            let needsUpdate = false;
            gamesBaseData.slotMachine.prizes.forEach((prize, index) => {
              if (prize.templateId && iframeCombinations[index]) {
                const expectedBase64 = btoa(String(prize.templateId));
                if (
                  !iframeCombinations[index].templateId ||
                  typeof iframeCombinations[index].templateId === "number"
                ) {
                  iframeCombinations[index].templateId = expectedBase64;
                  needsUpdate = true;
                }
              }
            });
            if (needsUpdate) {
              slotElement.setAttribute(
                "data-win-combinations",
                JSON.stringify(iframeCombinations)
              );
            }
          } catch (e) {
            // Ignore parse errors
          }
        }
      }

      // Ensure templateIds in iframe data-prizes are always base64 encoded (scratch card)
      if (gamesBaseData.scratchCard?.prizes) {
        const scratchElement = template.querySelector('.spm_widget_game_scratch_card');
        if (scratchElement) {
          try {
            const iframePrizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
            let needsUpdate = false;
            gamesBaseData.scratchCard.prizes.forEach((prize, index) => {
              if (prize.templateId && iframePrizes[index]) {
                const expectedBase64 = btoa(String(prize.templateId));
                if (!iframePrizes[index].templateId || typeof iframePrizes[index].templateId === 'number') {
                  iframePrizes[index].templateId = expectedBase64;
                  needsUpdate = true;
                }
              }
            });
            if (needsUpdate) {
              scratchElement.setAttribute('data-prizes', JSON.stringify(iframePrizes));
            }
          } catch (e) {
            // Ignore parse errors
          }
        }
      }

      // Save games_data without language key: games_data[gameType].prizes
      const defaultLang = getShopDefaultLang();
      const defaultTranslations = templateState.translations.filter(
        t => t.language === defaultLang
      );
      const gamesDataFlat = fillGamesDataTranslation(
        gamesBaseData,
        defaultTranslations
      );
      setTemplateConfigurationKeyInState("games_data", gamesDataFlat);
    } else {
      delete templateState.configuration.games_data;
    }

    const bodyOuterHTML = template.querySelector("body")?.outerHTML ?? "";
    // Check if a form widget is in the template
    const hasForm = !!template.querySelector(".spm_form");

    // Check if voucher is in the template, in any language (not only the one displayed)
    const hasVoucher = htmlHasVoucher(bodyOuterHTML, templateState.translations);

    // Check if all voucher content is inside a block conditioned by voucher_is_configured
    const body = template.querySelector("body");
    const hasConditionalVoucher = hasVoucher && !!body && hasOnlyConditionalVoucher(body, templateState.translations);
    setTemplateConfigurationKeyInState("hasForm", hasForm);
    setTemplateConfigurationKeyInState("hasVoucher", hasVoucher);
    setTemplateConfigurationKeyInState(
      "hasConditionalVoucher",
      hasConditionalVoucher
    );

    // Check for redirect templates
    const oldRedirects: (string | number)[] = [];

    if (templateState.configuration.nextIdTemplate) {
      Object.keys(templateState.configuration.nextIdTemplate).forEach(
        (lang: string) => {
          if (templateState.configuration.nextIdTemplate[lang]) {
            if (
              Array.isArray(templateState.configuration.nextIdTemplate[lang])
            ) {
              // It's an array of IDs
              templateState.configuration.nextIdTemplate[lang].forEach(
                (id: string | number) => {
                  if (oldRedirects.indexOf(id) === -1) {
                    oldRedirects.push(id);
                  }
                }
              );
            } else if (
              oldRedirects.indexOf(
                templateState.configuration.nextIdTemplate[lang]
              ) === -1
            ) {
              // It's an ID
              oldRedirects.push(
                templateState.configuration.nextIdTemplate[lang]
              );
            }
          }
        }
      );
    }

    // We search for new redirects in the template
    const currentRedirects = getRedirectsFromTemplate();

    updateSectionsInState(false);

    setTemplateConfigurationKeyInState(
      "nextIdTemplate",
      Object.keys(currentRedirects).length ? currentRedirects : false
    );
    setTemplateConfigurationKeyInState(
      "informations",
      JSON.parse(JSON.stringify(templateState.informations))
    );
  }
};

export const fixUndefinedFieldTypeInTranslations = (): void => {
  if (state.template) {
    state.template.translations
      .filter(translation => translation.fieldType === undefined)
      .forEach(translation => {
        const { key } = translation;
        const splittedKey = key.split(".");
        if (splittedKey && splittedKey.length > 1) {
          switch (splittedKey[1]) {
            case "text":
            case "alt":
              translation.fieldType = "text";
              break;
            case "href":
              translation.fieldType = "link";
              break;
            case "src":
              translation.fieldType = "image";
              break;
            default:
              break;
          }
        }
      });
  }
};

// Hide model editing iframe
export const hideIframeTemplateWrapper = () => {
  const iframeElement = document.querySelector(
    "iframe.template-wrapper"
  ) as HTMLIFrameElement | null;
  if (iframeElement) {
    iframeElement.style.transition = "none";
    iframeElement.style.opacity = "0";
  }
};

// Show template editing iframe
export const showIframeTemplateWrapper = () => {
  // Cibler l'iframe avec document.querySelector et affirmer le type
  const iframeElement = document.querySelector(
    "iframe.template-wrapper"
  ) as HTMLIFrameElement | null;
  if (iframeElement) {
    // Applique une transition pour l'opacité
    iframeElement.style.transition = "opacity 0.5s ease-in-out";
    // Change l'opacité pour déclencher l'effet
    requestAnimationFrame(() => {
      iframeElement.style.opacity = "1";
    });
  }
};

interface TemplateObject {
  template: Template;
  idCampaign: number | null;
}

async function buildTemplateFromRawAndElements(
  raw: TemplateFetchResult,
  nameOverride: string
): Promise<TemplateObject | null> {
  const type = raw.type ?? "";
  const templateConfiguration = JSON.parse(raw.template_config ?? "{}");

  // Migrate games_data from old format (games_data[lang][gameType]) to new format (games_data[gameType])
  if (templateConfiguration.games_data) {
    const gd = templateConfiguration.games_data;
    // Detect old format: keys are language codes (2-letter strings) instead of game types
    const keys = Object.keys(gd);
    const isOldFormat =
      keys.length > 0 &&
      keys.every(
        k =>
          k.length === 2 && !["wheel", "slotMachine", "scratchCard"].includes(k)
      );
    if (isOldFormat) {
      // Take the first language's data as the canonical games_data
      const firstLang = keys[0];
      templateConfiguration.games_data = gd[firstLang];
    }
  }

  const structure = templateConfiguration.body_structure ?? {
    sections: [],
    design: null
  };

  let label = nameOverride;
  if (label === "") {
    label = raw.label ?? "";
  }

  const idCampaign =
    raw.id_campaign && raw.id_campaign > 0 ? raw.id_campaign : null;
  const createdFromCampaign = raw.created_from_campaign ?? null;

  let informations: TemplateInformations | null = null;
  if (
    Object.prototype.hasOwnProperty.call(
      templateConfiguration,
      "informations"
    ) &&
    Object.keys(templateConfiguration.informations).length > 0
  ) {
    informations = {
      name: label,
      lang: templateConfiguration.informations.lang,
      imported: templateConfiguration.informations.imported === true
    };

    if (getTemplateParentTypeByType(type) === TemplateParentTypeEnum.EMAIL) {
      informations.subject = { ...templateConfiguration.informations.subject };
      informations.previewText = {
        ...templateConfiguration.informations.previewText
      };
      informations.fromEmail = {
        ...templateConfiguration.informations.fromEmail
      };
      informations.fromName = {
        ...templateConfiguration.informations.fromName
      };
    } else if (
      getTemplateParentTypeByType(type) === TemplateParentTypeEnum.SMS
    ) {
      informations.fromName = {
        ...templateConfiguration.informations.fromName
      };
    }
  } else {
    const items: any = [];

    informations = {
      name: label,
      lang: getShopDefaultLang()
    };

    if (getTemplateParentTypeByType(type) === TemplateParentTypeEnum.EMAIL) {
      informations.subject = items.reduce(
        (acc: StringMap, item: TemplateLangRaw) => ({
          ...acc,
          [item.lang]: item.subject
        }),
        {}
      );
      informations.fromEmail = items.reduce(
        (acc: StringMap, item: TemplateLangRaw) => ({
          ...acc,
          [item.lang]: item.from_email
        }),
        {}
      );
      informations.fromName = items.reduce(
        (acc: StringMap, item: TemplateLangRaw) => ({
          ...acc,
          [item.lang]: item.from_name
        }),
        {}
      );
    } else if (
      getTemplateParentTypeByType(type) === TemplateParentTypeEnum.SMS
    ) {
      informations.fromName = items.reduce(
        (acc: StringMap, item: TemplateLangRaw) => ({
          ...acc,
          [item.lang]: item.from_name
        }),
        {}
      );
    }
  }

  // Check if the template is edited from a campaign (old system)
  const editingTemplateFromCampaign = getEditingTemplateFromCampaign();
  if (
    editingTemplateFromCampaign &&
    editingTemplateFromCampaign.idTemplate === raw.id_template
  ) {
    const form =
      AutomatedScenarioState.selectedOperator.currentConfigurationForm;

    if (form) {
      if (getTemplateParentTypeByType(type) === TemplateParentTypeEnum.EMAIL) {
        informations.subject = { ...form.template_message_subject };
        informations.previewText = { ...form.template_message_preview_text };
        informations.fromEmail = { ...form.template_message_expmail };
        informations.fromName = { ...form.template_message_expname };
      } else if (
        getTemplateParentTypeByType(type) === TemplateParentTypeEnum.SMS
      ) {
        informations.fromName = { ...form.template_message_expname };
      }
    }
  }

  // Check if the template is edited from a flow (new system)
  const flowEditingTemplate = store.getters['flowEditor/getEditingTemplate'];
  if (flowEditingTemplate && flowEditingTemplate.idTemplate === raw.id_template && flowEditingTemplate.informations) {
    const flowInfo = flowEditingTemplate.informations;
    if (getTemplateParentTypeByType(type) === TemplateParentTypeEnum.EMAIL) {
      if (flowInfo.subject && Object.keys(flowInfo.subject).length > 0) {
        informations.subject = { ...flowInfo.subject };
      }
      if (flowInfo.previewText && Object.keys(flowInfo.previewText).length > 0) {
        informations.previewText = { ...flowInfo.previewText };
      }
      if (flowInfo.fromEmail && Object.keys(flowInfo.fromEmail).length > 0) {
        informations.fromEmail = { ...flowInfo.fromEmail };
      }
      if (flowInfo.fromName && Object.keys(flowInfo.fromName).length > 0) {
        informations.fromName = { ...flowInfo.fromName };
      }
    } else if (getTemplateParentTypeByType(type) === TemplateParentTypeEnum.SMS) {
      if (flowInfo.fromName && Object.keys(flowInfo.fromName).length > 0) {
        informations.fromName = { ...flowInfo.fromName };
      }
    }
  }

  // If sender name/email are empty, get default values from database
  if (
    getTemplateParentTypeByType(type) === TemplateParentTypeEnum.EMAIL &&
    Object.prototype.hasOwnProperty.call(informations, "fromEmail") &&
    informations.fromEmail &&
    !Object.values(informations.fromEmail).some(
      value => value !== null && value !== ""
    )
  ) {
    const field = reactive<Record<string, any>>({
      shopRequiredDataEmail_senderEmail: {}
    });

    await retrieveServicesData(UserState.activeShop?.id ?? 0, field);
    informations.fromEmail = field.shopRequiredDataEmail_senderEmail;
  }

  if (
    Object.prototype.hasOwnProperty.call(informations, "fromName") &&
    informations.fromName &&
    !Object.values(informations.fromName).some(
      value => value !== null && value !== ""
    )
  ) {
    let key = "shopRequiredDataEmail_senderName";
    if (getTemplateParentTypeByType(type) === TemplateParentTypeEnum.SMS) {
      key = "shopRequiredDataSms_senderName";
    }

    const field = reactive<Record<string, any>>({
      shopRequiredDataEmail_senderName: {},
      shopRequiredDataSms_senderName: {}
    });

    await retrieveServicesData(UserState.activeShop?.id ?? 0, field);
    informations.fromName = field[key];
  }

  const t: Template = new Template(
    raw.id_template,
    type,
    idCampaign,
    createdFromCampaign,
    informations,
    {
      design: asInt(structure.design),
      sections: structure.sections.map((sectionId: any) =>
        sectionId ? sectionId.toString() : sectionId
      ),
      forms: templateConfiguration.forms || {}
    },
    unwrapImageWidgetTranslations(
      (raw.elements as Section[]).map(el => ({
        ...el,
        id_template_elements: asInt(el.id_template_elements)
      }))
    ),
    templateConfiguration,
    false,
    null,
    raw.date_modification ?? "",
    raw.version ?? 3
  );

  return { template: t, idCampaign };
}

export async function prepareTemplate(
  id: number,
  name: string,
  type: string
): Promise<TemplateObject | null> {
  const { fetchTemplates } = useTemplatesApi();
  const numericId = Number(id);
  const fetched = await fetchTemplates([numericId]);
  const raw = fetched[numericId];

  if (!raw) return null;

  // Populate cache so conflict check path (getCachedTemplateRaw) still works
  templateRawCache.set(id, {
    id_template: raw.id_template,
    id_campaign: raw.id_campaign,
    created_from_campaign: raw.created_from_campaign,
    template_config: raw.template_config ?? "",
    label: raw.label,
    date_modification: raw.date_modification,
    version: raw.version,
    type: raw.type
  });

  return buildTemplateFromRawAndElements(raw, name);
}

export const fetchTemplate = async (idTemplate: number) => {
  const preparedTemplate = await prepareTemplate(idTemplate, "", "");
  return preparedTemplate?.template ?? null;
};

// Recursively collect all redirect template IDs from sections HTML, avoiding duplicates and cycles
function collectRedirectIds(
  sections: Array<{ html: string }>,
  visited: Set<number>,
  queue: number[],
  translations?: Array<{ value: string }>
): void {
  const processMatches = (text: string) => {
    const encoded = extractRedirectEncodedIds(text);
    for (const enc of encoded) {
      const numId = decodeRedirectTemplateId(enc);
      if (numId && !visited.has(numId)) {
        visited.add(numId);
        queue.push(numId);
      }
    }
  };

  // Scan section HTML
  for (const section of sections) {
    processMatches(section.html);
  }

  // Scan translation values (code widget content is stored in translations, not in section HTML)
  if (translations) {
    for (const t of translations) {
      if (t.value && (t.value.includes('redirect_') || t.value.includes('data-redirect'))) {
        processMatches(t.value);
      }
    }
  }
}

// Build funnel tree recursively from already-fetched map (no network calls)
async function buildFunnelTree(
  idTemplate: number,
  currentNextSteps: FunnelStep[],
  originTemplateId: string,
  fetchedMap: Record<number, TemplateFetchResult>,
  visited: Set<number>,
  init: boolean
): Promise<Template[]> {
  const result: Template[] = [];

  let resolvedTemplate: Template | null =
    init && state.template ? state.template : null;

  if (!resolvedTemplate) {
    const raw = fetchedMap[idTemplate];
    if (raw) {
      // Populate cache for conflict check path
      templateRawCache.set(idTemplate, {
        id_template: raw.id_template,
        id_campaign: raw.id_campaign,
        created_from_campaign: raw.created_from_campaign,
        template_config: raw.template_config ?? "",
        label: raw.label,
        date_modification: raw.date_modification,
        version: raw.version,
        type: raw.type
      });
      const prepared = await buildTemplateFromRawAndElements(raw, "");
      resolvedTemplate = prepared?.template ?? null;
      // Ensure redirect translations are materialized as data-redirect HTML attributes
      if (resolvedTemplate) {
        fixDataRedirectAttribute(resolvedTemplate);
      }
    }
  }

  if (!resolvedTemplate) return result;

  if (!state.templatesFromFunnel[originTemplateId]) {
    state.templatesFromFunnel[originTemplateId] = [];
  }
  if (
    !state.templatesFromFunnel[originTemplateId].find(
      t => t.id === resolvedTemplate!.id
    ) &&
    state.template
  ) {
    resolvedTemplate.funnel = state.template.funnel;
    resolvedTemplate.originTemplateId = originTemplateId;
    state.templatesFromFunnel[originTemplateId].push(resolvedTemplate);
  }

  // Collect redirect IDs from sections AND translations
  const allTextSources: string[] = resolvedTemplate.sections.map((s: any) => s.html);
  // Also scan translation values (code widget content is stored in translations)
  if (resolvedTemplate.translations) {
    for (const t of resolvedTemplate.translations) {
      if (t.value && (t.value.includes('redirect_') || t.value.includes('data-redirect'))) {
        allTextSources.push(t.value);
      }
    }
  }

  for (const text of allTextSources) {
    const encoded = extractRedirectEncodedIds(text);
    for (const enc of encoded) {
      const childId = decodeRedirectTemplateId(enc);
      if (!childId) continue;

      // Skip if this child is already in currentNextSteps (avoid duplicates from multiple text sources)
      if (currentNextSteps.some(s => s.template?.id === childId)) continue;

      const childRaw = fetchedMap[childId];
      if (!childRaw) continue;

      // Populate cache for child
      templateRawCache.set(childId, {
        id_template: childRaw.id_template,
        id_campaign: childRaw.id_campaign,
        created_from_campaign: childRaw.created_from_campaign,
        template_config: childRaw.template_config ?? "",
        label: childRaw.label,
        date_modification: childRaw.date_modification,
        version: childRaw.version,
        type: childRaw.type
      });

      // eslint-disable-next-line no-await-in-loop
      const childPrepared = await buildTemplateFromRawAndElements(childRaw, "");
      const childTemplate = childPrepared?.template ?? null;
      if (!childTemplate) continue;

      result.push(childTemplate);
      if (
        !state.templatesFromFunnel[originTemplateId].find(
          t => t.id === childTemplate.id
        ) &&
        state.template
      ) {
        childTemplate.funnel = state.template.funnel;
        childTemplate.originTemplateId = originTemplateId;
        state.templatesFromFunnel[originTemplateId].push(childTemplate);
      }

      const nextStep: FunnelStep = {
        template: {
          id: childTemplate.id,
          name: childTemplate.informations.name,
          type: childTemplate.type
        },
        nextSteps: []
      };
      currentNextSteps.push(nextStep);

      // Recurse into child (already in fetchedMap, no new network calls)
      if (!visited.has(childId)) {
        visited.add(childId);
        // eslint-disable-next-line no-await-in-loop
        const childResults = await buildFunnelTree(
          childId,
          nextStep.nextSteps,
          originTemplateId,
          fetchedMap,
          visited,
          false
        );
        result.push(...childResults);
      }
    }
  }

  if (!init) {
    await loadGameFunnelSteps(
      resolvedTemplate.sections,
      currentNextSteps,
      originTemplateId,
      fetchedMap,
      resolvedTemplate.informations.name || "",
      resolvedTemplate.type || "",
      visited
    );
  }

  return result;
}

export const fetchNextFunnels = async (
  idTemplate: number,
  currentNextSteps: FunnelStep[],
  originTemplateId: string,
  init = false
) => {
  const { fetchTemplates } = useTemplatesApi();

  // Step 1: resolve root sections (already in state when init=true)
  let rootSections: Section[] = [];
  if (init && state.template) {
    rootSections = state.template.sections;
  } else {
    const rootPrepared = await prepareTemplate(idTemplate, "", "");
    rootSections = rootPrepared?.template?.sections ?? [];
  }

  // Step 2: fetch all funnel templates.
  // If root has configuration.funnels, use those IDs to fetch everything in a single batch
  // (like game prize templates). Otherwise fall back to BFS level-by-level.
  const visited = new Set<number>([Number(idTemplate)]);
  const fetchedMap: Record<number, TemplateFetchResult> = {};

  // When not initializing, the root template must also be in fetchedMap
  // so buildFunnelTree can resolve it (init=true uses state.template instead)
  if (!init) {
    const rootFetched = await fetchTemplates([idTemplate]);
    Object.assign(fetchedMap, rootFetched);
  }

  const funnelsList: Array<{ id: number }> =
    (init && state.template?.configuration?.funnels) || [];
  const allFunnelIds = funnelsList
    .map(f => f.id)
    .filter(id => !visited.has(id));

  const masterConfig = init && state.template?.configuration ? state.template.configuration : null;

  if (allFunnelIds.length > 0) {
    // Single batch fetch using known funnel IDs from root configuration
    const fetched = await fetchTemplates(allFunnelIds);
    Object.assign(fetchedMap, fetched);
    allFunnelIds.forEach((id) => visited.add(id));

    // BFS pass to discover deeper levels not listed in funnels
    // Include root translations on first pass (code widget content is in translations)
    const rootTranslations = init && state.template?.translations
      ? (state.template.translations as Array<{ value: string }>)
      : undefined;
    let deeperSections: Array<{ html: string }> = [
      ...rootSections,
      ...Object.values(fetched).flatMap((r) => r.elements),
    ];
    let isFirstBfsPass = true;
    while (deeperSections.length > 0) {
      const deeperIds: number[] = [];
      collectRedirectIds(deeperSections, visited, deeperIds, isFirstBfsPass ? rootTranslations : undefined);
      isFirstBfsPass = false;
      if (deeperIds.length === 0) break;
      // eslint-disable-next-line no-await-in-loop
      const deeperFetched = await fetchTemplates(deeperIds);
      Object.assign(fetchedMap, deeperFetched);
      deeperSections = Object.values(deeperFetched).flatMap((r) => r.elements);
    }
  } else {
    // Fallback: BFS level-by-level (for new funnels not yet saved)
    const fallbackRootTranslations = init && state.template?.translations
      ? (state.template.translations as Array<{ value: string }>)
      : undefined;
    let currentLevelSections: Array<{ html: string }> = rootSections;
    let bfsLevel = 0;
    while (currentLevelSections.length > 0) {
      const levelIds: number[] = [];
      collectRedirectIds(currentLevelSections, visited, levelIds, bfsLevel === 0 ? fallbackRootTranslations : undefined);
      if (levelIds.length === 0) break;

      // eslint-disable-next-line no-await-in-loop
      const levelFetched = await fetchTemplates(levelIds);
      Object.assign(fetchedMap, levelFetched);

      // Collect sections of this level to discover the next level
      currentLevelSections = Object.values(levelFetched).flatMap((r) => r.elements);
      bfsLevel++;
    }
  }

  // Step 3: build funnel tree in-memory from fully-populated fetchedMap
  const templates = await buildFunnelTree(
    idTemplate,
    currentNextSteps,
    originTemplateId,
    fetchedMap,
    new Set<number>([Number(idTemplate)]),
    init
  );
  return { templates, fetchedMap };
};

export const refreshFunnel = () => {
  if (state.template) {
    state.templatesFromFunnel[state.template.originTemplateId || ""].forEach(
      t => {
        if (state.template) {
          t.funnel = state.template?.funnel;
        }
      }
    );
    state.funnelStepKey += 1;
  }
};

export const findFunnelStepByTemplate = (
  steps: FunnelStep[],
  templateId: number
): FunnelStep | null => {
  const idStr = String(templateId);
  // eslint-disable-next-line no-restricted-syntax
  for (const step of steps) {
    if (step.template && String(step.template.id) === idStr) {
      return step;
    }
    if (step.nextSteps && step.nextSteps.length > 0) {
      const found = findFunnelStepByTemplate(step.nextSteps, templateId);
      if (found) return found;
    }
  }
  return null;
};

export const reInitFunnels = async () => {
  if (state.template) {
    const step = findFunnelStepByTemplate(
      [state.template.funnel],
      state.template.id
    );
    if (step) {
      state.template.funnel.nextSteps = [];
      const { fetchedMap: funnelFetchedMap } = await fetchNextFunnels(
        state.template.id,
        step.nextSteps,
        String(state.template.originTemplateId),
        true
      );
      // Also reload game prize funnel steps (reuse already-fetched data)
      const visitedIds = new Set<number>([state.template.id]);
      await loadGameFunnelSteps(
        state.template.sections,
        step.nextSteps,
        String(state.template.originTemplateId),
        funnelFetchedMap,
        undefined,
        undefined,
        visitedIds
      );
      refreshFunnel();
    }
  }
};

export const generateNextStepName = (
  currentName: string,
  nextTemplateType: TemplateParentTypeEnum,
  t: Function,
  toUpdateItem: Templates | null = null
) => {
  if (state.template) {
    const configNextIdTemplate = state.template.configuration?.nextIdTemplate;
    if (
      toUpdateItem &&
      configNextIdTemplate &&
      typeof configNextIdTemplate === "object"
    ) {
      const langs = Object.keys(configNextIdTemplate);
      for (const lang of langs) {
        const ids = configNextIdTemplate[lang];
        if (Array.isArray(ids)) {
          const idx = ids.findIndex(id => Number(id) === Number(toUpdateItem.id_template));
          if (idx !== -1) {
            const name = `${currentName} - ${t(
              `templates.channels.${nextTemplateType}`
            )} #${idx + 1}`;
            return name;
          }
        }
      }
    }

    const step = findFunnelStepByTemplate(
      [state.template.funnel],
      state.template.id
    );
    if (step) {
      let position = step.nextSteps.length + 1;
      if (toUpdateItem) {
        const idx = step.nextSteps.findIndex(s => s.template?.id === toUpdateItem.id_template);
        if (idx !== -1) {
          position = idx + 1;
        }
      }
      const name = `${currentName} - ${t(
          `templates.channels.${nextTemplateType}`
        )} #${position}`;
      return name;
    }
  }
  return "";
};

/**
 * Remove a direct child step (by template ID) from the current template's funnel node.
 * Used when changing a redirect link so the old target is removed before the new one is added.
 */
export const removeStepFromCurrentFunnel = (templateIdToRemove: number) => {
  if (!state.template) return;
  const step = findFunnelStepByTemplate(
    [state.template.funnel],
    state.template.id
  );
  if (step) {
    const idx = step.nextSteps.findIndex(
      s => s.template?.id === templateIdToRemove
    );
    if (idx !== -1) {
      step.nextSteps.splice(idx, 1);
      refreshFunnel();
    }
  }
};

/**
 * Same as removeStepFromCurrentFunnel, but keeps the step while another element of the
 * current template still redirects to it. `editedElement` is the widget whose redirect is
 * being changed: its own references are ignored.
 */
export const removeStepFromCurrentFunnelIfUnreferenced = (
  templateIdToRemove: number,
  editedElement: Element | null
) => {
  const encoded = btoa(String(templateIdToRemove));
  const refsInTemplate = countRedirectReferences(
    getTemplateIframeDocument()?.body?.outerHTML,
    encoded
  );
  const refsInEditedElement = countRedirectReferences(
    editedElement?.outerHTML,
    encoded
  );
  if (refsInTemplate > refsInEditedElement) return;
  removeStepFromCurrentFunnel(templateIdToRemove);
};

export const addStepToFunnel = (newFunnelStep: FunnelStep) => {
  if (state.template) {
    const step = findFunnelStepByTemplate(
      [state.template.funnel],
      state.template.id
    );
    if (
      step &&
      !step.nextSteps.find(
        item => item.template?.id === newFunnelStep.template?.id
      )
    ) {
      step.nextSteps.push(newFunnelStep);
      refreshFunnel();
    }
  }
};

export const addTemplateToFunnels = (template: Template) => {
  if (state.template && state.template.funnel) {
    const stepName =
      template?.informations?.name
      || (template as any)?.label
      || `Template ${template.id}`;
    const addToFunnel = (funnel: FunnelStep) => {
      if (state.template) {
        if (
          funnel.template?.id === state.template.id &&
          !funnel.nextSteps.find(item => item.template?.id === template.id)
        ) {
          funnel.nextSteps.push({
            template: {
              id: template.id,
              name: stepName,
              type: template.type
            },
            nextSteps: []
          });
        } else {
          funnel.nextSteps.forEach(nextStep => {
            addToFunnel(nextStep);
          });
        }
      }
    };

    addToFunnel(state.template.funnel);

    if (
      state.template.originTemplateId &&
      !state.templatesFromFunnel[state.template.originTemplateId || ""].find(
        t => t.id === template.id
      ) &&
      state.template
    ) {
      template.funnel = state.template.funnel;
      template.originTemplateId = state.template.originTemplateId;
      state.templatesFromFunnel[state.template.originTemplateId].push(template);
    }

    refreshFunnel();
  }
};

/**
 * After adding a template to the funnel tree, discover its sub-redirects (and their sub-redirects, etc.)
 * via BFS and attach them to the funnel tree. This handles N levels of nested redirections.
 */
export const discoverAndAttachSubFunnels = async (template: Template) => {
  if (!state.template?.funnel || !state.template?.originTemplateId) return;

  const { fetchTemplates } = useTemplatesApi();
  const originTemplateId = state.template.originTemplateId;

  // Collect all template IDs already in the funnel tree to avoid duplicates
  const existingIds = new Set<number>();
  const collectExistingIds = (step: FunnelStep) => {
    if (step.template?.id) existingIds.add(step.template.id);
    step.nextSteps.forEach(collectExistingIds);
  };
  collectExistingIds(state.template.funnel);

  // BFS queue: templates whose sections we need to scan for redirects
  const queue: Template[] = [template];

  while (queue.length > 0) {
    const current = queue.shift()!;

    // Scan sections for redirect IDs
    const childIds: number[] = [];
    collectRedirectIds(current.sections, new Set(existingIds), childIds);

    if (childIds.length === 0) continue;

    // Fetch all discovered children in one batch
    const fetched = await fetchTemplates(childIds);

    for (const childId of childIds) {
      const raw = fetched[childId];
      if (!raw) continue;

      // Build the template object
      const prepared = await prepareTemplate(childId, raw.label || '', raw.type || '');
      if (!prepared?.template) continue;

      const childTemplate = prepared.template;
      fixDataRedirectAttribute(childTemplate);

      existingIds.add(childId);

      // Find the parent step in the funnel tree and add the child
      const parentStep = findFunnelStepByTemplate([state.template!.funnel], current.id);
      if (parentStep && !parentStep.nextSteps.find((s) => s.template?.id === childId)) {
        parentStep.nextSteps.push({
          template: {
            id: childTemplate.id,
            name: childTemplate.informations.name,
            type: childTemplate.type,
          },
          nextSteps: [],
        });
      }

      // Track in templatesFromFunnel
      if (!state.templatesFromFunnel[originTemplateId]?.find((t) => t.id === childTemplate.id)) {
        if (!state.templatesFromFunnel[originTemplateId]) {
          state.templatesFromFunnel[originTemplateId] = [];
        }
        childTemplate.funnel = state.template!.funnel;
        childTemplate.originTemplateId = originTemplateId;
        state.templatesFromFunnel[originTemplateId].push(childTemplate);
      }

      // Add to BFS queue to discover deeper levels
      queue.push(childTemplate);
    }
  }

  refreshFunnel();
};

export const addChildStepsToFunnelStep = (parentTemplateId: number, childSteps: FunnelStep[]) => {
  if (state.template && state.template.funnel) {
    const findAndAddToStep = (funnel: FunnelStep): boolean => {
      if (funnel.template?.id === parentTemplateId) {
        // Work directly with state, not readonly export
        childSteps.forEach(childStep => {
          funnel.nextSteps.push(childStep);
        });
        return true;
      }

      // Search in nested steps
      // eslint-disable-next-line no-restricted-syntax
      for (const nextStep of funnel.nextSteps) {
        if (findAndAddToStep(nextStep)) {
          return true;
        }
      }
      return false;
    };

    const found = findAndAddToStep(state.template.funnel);

    if (found) {
      refreshFunnel();
    }
  }
};

/**
 * Recursively remove all game funnel steps (isGameFunnel) from the funnel tree.
 */
export const removeGameStepsFromTree = (steps: FunnelStep[]): void => {
  for (let i = steps.length - 1; i >= 0; i--) {
    if (steps[i].template?.isGameFunnel) {
      steps.splice(i, 1);
    } else {
      removeGameStepsFromTree(steps[i].nextSteps);
    }
  }
};

/**
 * Find the FunnelStep whose template contains a #redirect_game_prizes link.
 * Checks the current template's iframe DOM first, then all templates in the funnel via stored sections.
 * Returns null if no template has this redirect (game steps should fallback to wheel template).
 */
export const findGamePrizesRedirectStepInFunnel = (): FunnelStep | null => {
  if (!state.template) return null;

  const originId = String(state.template.originTemplateId || state.template.id);

  // 1. Check the current template's iframe DOM and state translations
  const iframeDoc = getTemplateIframeDocument();
  if (iframeDoc) {
    const hasRedirect = iframeDoc.querySelector('[data-redirect="game_prizes"]')
      || iframeDoc.querySelector('[data-redirect="game_result"]')
      || iframeDoc.querySelector('a[href="#redirect_game_prizes"]')
      || iframeDoc.querySelector('a[href="#redirect_game_result"]');
    if (hasRedirect) {
      return findFunnelStepByTemplate(
        [state.template.funnel],
        state.template.id
      );
    }
  }

  // 1b. Check current template's state translations (may be updated before iframe DOM reflects the change)
  if (state.template?.translations) {
    for (const t of state.template.translations) {
      if (t.value === '#redirect_game_prizes' || t.value === '#redirect_game_result') {
        return findFunnelStepByTemplate([state.template.funnel], state.template.id);
      }
    }
  }

  // 2. Check all templates in the funnel via stored sections and translations
  const templates = state.templatesFromFunnel[originId];
  if (templates) {
    for (const tmpl of templates) {
      // Skip current template only if we already checked it via iframe
      if (iframeDoc && tmpl.id === state.template.id) continue;

      // Check section HTML (works when fixDataRedirectAttribute has been applied)
      for (const section of (tmpl.sections || [])) {
        if (section.html.includes('data-redirect="game_prizes"')
          || section.html.includes('data-redirect="game_result"')
          || section.html.includes('#redirect_game_prizes')
          || section.html.includes('#redirect_game_result')) {
          return findFunnelStepByTemplate([state.template.funnel], tmpl.id);
        }
      }

      // Check translations (redirect values are stored as translation values before fixDataRedirectAttribute materializes them)
      for (const t of (tmpl.translations || [])) {
        if (t.value === '#redirect_game_prizes'
          || t.value === '#redirect_game_result') {
          return findFunnelStepByTemplate([state.template.funnel], tmpl.id);
        }
      }
    }
  }

  return null;
};

/**
 * Collect all game funnel template IDs from the entire funnel tree.
 */
const collectGameTemplateIds = (steps: FunnelStep[]): number[] => {
  const ids: number[] = [];
  steps.forEach(s => {
    if (s.template?.isGameFunnel && s.template.id > 0) {
      ids.push(s.template.id);
    }
    ids.push(...collectGameTemplateIds(s.nextSteps));
  });
  return ids;
};

/**
 * Force-remove all game funnel steps and related template references.
 * Used on widget deletion to avoid DOM timing issues (widget still present during async cleanup).
 */
export const cleanupGameFunnelsAfterWidgetRemoval = (): void => {
  if (!state.template) return;

  const gameTemplateIds = collectGameTemplateIds([state.template.funnel]);
  removeGameStepsFromTree(state.template.funnel.nextSteps);

  const originId = String(state.template.originTemplateId || state.template.id);
  if (gameTemplateIds.length > 0 && state.templatesFromFunnel[originId]) {
    state.templatesFromFunnel[originId] = state.templatesFromFunnel[originId]
      .filter(t => !gameTemplateIds.includes(t.id));
  }

  if (state.template.configuration?.games_data) {
    delete state.template.configuration.games_data;
  }

  refreshFunnel();
};

/**
 * Resolve game widget nodes from the live iframe, or fall back to section HTML in state
 * (iframe can lag behind store right after save / reset).
 */
function resolveGameWidgetDomNodes(): {
  wheel: Element | null;
  slot: Element | null;
  scratch: Element | null;
} {
  const doc = getTemplateIframeDocument();
  let wheel = doc?.querySelector(".spm_widget_game_wheel") ?? null;
  let slot = doc?.querySelector(".spm_widget_game_slot_machine") ?? null;
  let scratch = doc?.querySelector(".spm_widget_game_scratch_card") ?? null;
  if (wheel || slot || scratch) {
    return { wheel, slot, scratch };
  }
  if (state.template?.sections) {
    for (const section of state.template.sections) {
      const html = section.html;
      if (!html || html.indexOf("spm_widget_game_") === -1) continue;
      const div = document.createElement("div");
      div.innerHTML = html;
      wheel = div.querySelector(".spm_widget_game_wheel");
      slot = div.querySelector(".spm_widget_game_slot_machine");
      scratch = div.querySelector(".spm_widget_game_scratch_card");
      if (wheel || slot || scratch) {
        return { wheel, slot, scratch };
      }
    }
  }
  return { wheel: null, slot: null, scratch: null };
}

/**
 * Sync game funnel steps from data-prizes in the iframe DOM.
 * Creates virtual (id < 0) or real funnel steps for each prize.
 * Removes stale game funnel steps for prizes that no longer exist.
 */
export const syncGameFunnelSteps = () => {
  if (!state.template) return;

  // Keep cleanup possible even if game widget/config is already gone but stale game steps remain.
  const existingGameStepIds = collectGameTemplateIds([state.template.funnel]);

  const {
    wheel: wheelElement,
    slot: slotElement,
    scratch: scratchElement
  } = resolveGameWidgetDomNodes();
  const gameElement = wheelElement || slotElement || scratchElement;

  // If this template has no game widget and no games_data, it is not the game host.
  // Do not touch game steps: prizes may belong to another template in the same funnel tree.
  // (existingGameStepIds is global — must not be used here or nested edits wipe root prizes.)
  if (!gameElement && !state.template.configuration?.games_data) {
    return;
  }

  const gameStep = findFunnelStepByTemplate(
    [state.template.funnel],
    state.template.id
  );
  if (!gameStep) return;

  // Collect template IDs of existing game funnel steps from the entire tree
  const gameTemplateIds = existingGameStepIds;

  // Remove ALL existing game funnel steps from the entire tree
  removeGameStepsFromTree(state.template.funnel.nextSteps);

  if (!gameElement) {
    // Game widget was deleted from this template: clean up game prize templates
    if (gameTemplateIds.length > 0) {
      const originId = String(
        state.template.originTemplateId || state.template.id
      );
      if (state.templatesFromFunnel[originId]) {
        state.templatesFromFunnel[originId] = state.templatesFromFunnel[
          originId
        ].filter(t => !gameTemplateIds.includes(t.id));
      }
    }
    // Clear games_data to prevent old templateIds from being restored to new prizes
    if (state.template.configuration.games_data) {
      delete state.template.configuration.games_data;
    }
    refreshFunnel();
    return;
  }

  let prizes: any[] = [];
  try {
    if (wheelElement) {
      prizes = JSON.parse(wheelElement.getAttribute("data-prizes") || "[]");
    } else if (slotElement) {
      // For slot machine, win combinations serve as prizes
      const combinations = JSON.parse(
        slotElement.getAttribute("data-win-combinations") || "[]"
      );
      prizes = combinations.map((combo: any) => ({
        label: combo.prize || "Win",
        probability: combo.probability,
        templateId: combo.templateId
      }));
    } else if (scratchElement) {
      prizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
    }
  } catch (e) {
    refreshFunnel();
    return;
  }

  // Find where to attach game steps: redirect target step or the game template itself
  const targetStep = findGamePrizesRedirectStepInFunnel() || gameStep;

  const templateName = state.template.informations.name || "";
  const templateType = state.template.type || "";
  const originId = String(state.template.originTemplateId || state.template.id);

  prizes.forEach((prize: any, index: number) => {
    const prizeLabel = prize.label || `Prize ${index + 1}`;
    const fullName = `${templateName} - ${prizeLabel}`;

    let templateId = -(index + 1);
    if (prize.templateId) {
      // templateId can be a number or base64 encoded string
      if (typeof prize.templateId === "number") {
        templateId = prize.templateId;
      } else {
        try {
          const decoded = atob(String(prize.templateId));
          const num = Number(decoded);
          if (!Number.isNaN(num) && num > 0) {
            templateId = num;
          } else {
            // Fallback to direct number conversion
            const directNum = Number(prize.templateId);
            if (!Number.isNaN(directNum) && directNum > 0) {
              templateId = directNum;
            }
          }
        } catch {
          // Fallback to direct number conversion
          const directNum = Number(prize.templateId);
          if (!Number.isNaN(directNum) && directNum > 0) {
            templateId = directNum;
          }
        }
      }
    }

    const funnelStep: FunnelStep = {
      template: {
        id: templateId,
        name: fullName,
        type: templateType,
        isGameFunnel: true
      },
      nextSteps: []
    };
    targetStep.nextSteps.push(funnelStep);

    // Also update informations.name in templatesFromFunnel for existing templates
    if (templateId > 0 && state.templatesFromFunnel[originId]) {
      const tmpl = state.templatesFromFunnel[originId].find(
        t => String(t.id) === String(templateId)
      );
      if (tmpl && tmpl.informations) {
        tmpl.informations.name = fullName;
      }
    }
  });

  refreshFunnel();
};

/**
 * Sync game funnel steps for a specific template (not necessarily the active one).
 * Uses the template data from templatesFromFunnel to extract game widget prizes.
 * @param templateId - The ID of the template to sync game funnel steps for
 */
export const syncGameFunnelStepsForTemplate = (templateId: number, forceAttachToTemplateId?: number) => {
  if (!state.template) return;

  const originId = String(state.template.originTemplateId || state.template.id);
  const templates = state.templatesFromFunnel[originId];
  if (!templates) return;

  const targetTemplate = templates.find(t => t.id === templateId);
  if (!targetTemplate) return;

  // Find the funnel step for this template (the game template)
  const gameStep = findFunnelStepByTemplate(
    [state.template.funnel],
    templateId
  );
  if (!gameStep) return;

  // Parse HTML to find game widget and extract prizes
  const parser = new DOMParser();
  const htmlContent = targetTemplate.sections?.[0]?.html || "";
  const doc = parser.parseFromString(htmlContent, "text/html");

  const wheelElement = doc.querySelector('.spm_widget_game_wheel');
  const slotElement = doc.querySelector('.spm_widget_game_slot_machine');
  const scratchElement = doc.querySelector('.spm_widget_game_scratch_card');
  if (!wheelElement && !slotElement && !scratchElement) {
    // No game widget in this template — don't touch existing game steps
    return;
  }

  // Remove existing game funnel steps before rebuilding them
  removeGameStepsFromTree(state.template.funnel.nextSteps);

  let prizes: any[] = [];
  try {
    if (wheelElement) {
      prizes = JSON.parse(wheelElement.getAttribute("data-prizes") || "[]");
    } else if (slotElement) {
      const combinations = JSON.parse(
        slotElement.getAttribute("data-win-combinations") || "[]"
      );
      prizes = combinations.map((combo: any) => ({
        label: combo.prize || "Win",
        probability: combo.probability,
        templateId: combo.templateId
      }));
    } else if (scratchElement) {
      prizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
    }
  } catch (e) {
    refreshFunnel();
    return;
  }

  // Find where to attach game steps: forced target, detected redirect step, or the game template itself
  const forceStep = forceAttachToTemplateId ? findFunnelStepByTemplate([state.template.funnel], forceAttachToTemplateId) : null;
  const attachStep = forceStep || findGamePrizesRedirectStepInFunnel() || gameStep;

  const templateName = targetTemplate.informations?.name || "";
  const templateType = targetTemplate.type || "";

  prizes.forEach((prize: any, index: number) => {
    const prizeLabel = prize.label || `Prize ${index + 1}`;
    const fullName = `${templateName} - ${prizeLabel}`;

    let prizeTemplateId = -(index + 1);
    if (prize.templateId) {
      try {
        const decoded = Number(atob(String(prize.templateId)));
        if (!Number.isNaN(decoded) && decoded > 0) {
          prizeTemplateId = decoded;
        }
      } catch {
        // Ignore decode errors
      }
    }

    const funnelStep: FunnelStep = {
      template: {
        id: prizeTemplateId,
        name: fullName,
        type: templateType,
        isGameFunnel: true
      },
      nextSteps: []
    };
    attachStep.nextSteps.push(funnelStep);
  });

  // Update the root template funnel in state.templates
  const rootTemplateIndex = state.templates.findIndex(
    t => String(t.id) === originId
  );
  if (rootTemplateIndex !== -1 && state.template) {
    state.templates[rootTemplateIndex].funnel = state.template.funnel;
  }

  refreshFunnel();
};

/**
 * Re-sync game funnel steps by finding the template with a game wheel in the funnel.
 * Tries the current template's iframe first, then searches all templates in the funnel.
 * Used when #redirect_game_prizes is set/removed and game steps need to be relocated.
 */
export const resyncGameFunnelSteps = (forceAttachToTemplateId?: number) => {
  if (!state.template) return;

  // 1. Check if the current template has a game widget (use live sync)
  const iframeDoc = getTemplateIframeDocument();
  if (iframeDoc?.querySelector('.spm_widget_game_wheel') || iframeDoc?.querySelector('.spm_widget_game_slot_machine') || iframeDoc?.querySelector('.spm_widget_game_scratch_card')) {
    syncGameFunnelSteps();
    return;
  }

  // 2. Search all templates in the funnel for one with a game widget
  const originId = String(state.template.originTemplateId || state.template.id);
  const templates = state.templatesFromFunnel[originId];
  if (!templates) return;

  for (const tmpl of templates) {
    for (const section of (tmpl.sections || [])) {
      if (section.html.includes('spm_widget_game_wheel') || section.html.includes('spm_widget_game_slot_machine') || section.html.includes('spm_widget_game_scratch_card')) {
        syncGameFunnelStepsForTemplate(tmpl.id, forceAttachToTemplateId);
        return;
      }
    }
  }
};

/**
 * Check if the current template is a game prize template.
 * A template is a game prize template if it's part of a funnel and its ID
 * is found in the parent template's games_data.
 */
export const isGamePrizeTemplate = (): boolean => {
  if (!state.template || !state.template.originTemplateId) {
    return false;
  }

  const currentTemplateId = state.template.id;

  // Find the direct parent of the current template in the funnel tree
  const findParentStep = (
    step: FunnelStep,
    targetId: number
  ): FunnelStep | null => {
    for (const nextStep of step.nextSteps) {
      if (nextStep.template?.id === targetId) {
        return step;
      }
      const found = findParentStep(nextStep, targetId);
      if (found) return found;
    }
    return null;
  };

  const parentStep = findParentStep(state.template.funnel, currentTemplateId);
  const parentTemplateId = parentStep?.template?.id;

  if (!parentTemplateId) {
    return false;
  }

  // Find the parent template in templatesFromFunnel or templates
  const originId = String(state.template.originTemplateId);
  const parentTemplate =
    state.templatesFromFunnel[originId]?.find(t => t.id === parentTemplateId) ||
    state.templates.find(t => t.id === parentTemplateId);

  if (!parentTemplate?.configuration?.games_data) {
    return false;
  }

  const gamesData = parentTemplate.configuration.games_data;

  if (!gamesData?.wheel?.prizes) {
    return false;
  }

  return gamesData.wheel.prizes.some(
    (prize: any) => prize.templateId === currentTemplateId
  );
};

/** Decode prize templateId from game widget JSON (base64-encoded id or plain number). */
export function decodeGamePrizeTemplateIdFromRaw(raw: unknown): number | null {
  if (raw == null || raw === "") return null;
  if (typeof raw === "number" && !Number.isNaN(raw) && raw > 0) return raw;
  const str = String(raw);
  try {
    const decoded = atob(str);
    const num = Number(decoded);
    if (!Number.isNaN(num) && num > 0) return num;
  } catch {
    // not valid base64
  }
  const directNum = Number(str);
  if (!Number.isNaN(directNum) && directNum > 0) return directNum;
  return null;
}

/**
 * Load game funnel steps from section HTML (used on template load, before iframe is ready).
 * Fetches and prepares templates for prizes that already have templateIds.
 */
export const loadGameFunnelSteps = async (
  sections: Section[],
  currentNextSteps: FunnelStep[],
  originTemplateId: string,
  prefetchedMap?: Record<number, TemplateFetchResult>,
  templateName?: string,
  templateType?: string,
  visited?: Set<number>
) => {
  if (!state.template) return;

  const { fetchTemplates } = useTemplatesApi();
  const name = templateName || state.template.informations.name || "";
  const type = templateType || state.template.type || "";

  for (const section of sections) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = section.html;
    const wheelElement = tempDiv.querySelector('.spm_widget_game_wheel');
    const slotElement = tempDiv.querySelector('.spm_widget_game_slot_machine');
    const scratchElement = tempDiv.querySelector('.spm_widget_game_scratch_card');
    const gameElement = wheelElement || slotElement || scratchElement;
    if (!gameElement) {
      // eslint-disable-next-line no-continue
      continue;
    }

    let prizes: any[] = [];
    try {
      if (wheelElement) {
        prizes = JSON.parse(wheelElement.getAttribute("data-prizes") || "[]");
      } else if (slotElement) {
        const combinations = JSON.parse(
          slotElement.getAttribute("data-win-combinations") || "[]"
        );
        prizes = combinations.map((combo: any) => ({
          label: combo.prize || "Win",
          probability: combo.probability,
          templateId: combo.templateId
        }));
      } else if (scratchElement) {
        prizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
      }
    } catch (e) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // Collect all prize template IDs
    const prizeTemplateIds: number[] = prizes
      .map((p: any) => decodeGamePrizeTemplateIdFromRaw(p.templateId))
      .filter((id): id is number => id != null);

    // Use prefetched data if available, only fetch missing templates
    const missingIds = prizeTemplateIds.filter(id => !prefetchedMap?.[id]);
    const freshlyFetched =
      missingIds.length > 0 ? await fetchTemplates(missingIds) : {};
    const fetchedMap = { ...prefetchedMap, ...freshlyFetched };

    if (!state.templatesFromFunnel[originTemplateId]) {
      state.templatesFromFunnel[originTemplateId] = [];
    }

    // Find where to attach game steps: redirect target step, or the current template (wheel host)
    const redirectStep = findGamePrizesRedirectStepInFunnel();
    const targetNextSteps = redirectStep
      ? redirectStep.nextSteps
      : currentNextSteps;

    for (let index = 0; index < prizes.length; index++) {
      const prize = prizes[index];
      const prizeTemplateId = decodeGamePrizeTemplateIdFromRaw(
        prize.templateId
      );
      const funnelStep: FunnelStep = {
        template: {
          id: prizeTemplateId ?? -(index + 1),
          name: `${name} - ${prize.label || `Prize ${index + 1}`}`,
          type,
          isGameFunnel: true
        },
        nextSteps: []
      };
      targetNextSteps.push(funnelStep);

      if (prizeTemplateId && fetchedMap[prizeTemplateId]) {
        const fetchedRaw = fetchedMap[prizeTemplateId];
        // Populate cache for conflict check path
        templateRawCache.set(prizeTemplateId, {
          id_template: fetchedRaw.id_template,
          id_campaign: fetchedRaw.id_campaign,
          created_from_campaign: fetchedRaw.created_from_campaign,
          template_config: fetchedRaw.template_config ?? "",
          label: fetchedRaw.label,
          date_modification: fetchedRaw.date_modification,
          version: fetchedRaw.version,
          type: fetchedRaw.type
        });
        // eslint-disable-next-line no-await-in-loop
        const prepared = await buildTemplateFromRawAndElements(fetchedRaw, "");
        const fetchedTemplate = prepared?.template ?? null;
        if (
          fetchedTemplate &&
          !state.templatesFromFunnel[originTemplateId].find(
            t => t.id === fetchedTemplate.id
          ) &&
          state.template
        ) {
          fetchedTemplate.funnel = state.template.funnel;
          fetchedTemplate.originTemplateId = originTemplateId;
          state.templatesFromFunnel[originTemplateId].push(fetchedTemplate);
        }

        // Recurse into the prize template to discover its redirections
        const trackVisited = visited || new Set<number>();
        if (!trackVisited.has(prizeTemplateId)) {
          trackVisited.add(prizeTemplateId);
          // eslint-disable-next-line no-await-in-loop
          await buildFunnelTree(
            prizeTemplateId,
            funnelStep.nextSteps,
            originTemplateId,
            fetchedMap,
            trackVisited,
            false
          );
        }
      }
    }
    // Only process the first section containing a game widget
    break;
  }
};

/**
 * Rebuild game prize funnel steps from the loaded template-part HTML (after duplicate),
 * including nested funnels via fetch + buildFunnelTree — same data as the part, not only iframe.
 */
export const reloadGameFunnelStepsFromLoadedPartHtml = async (
  widgetPartHtml: string
): Promise<void> => {
  if (!state.template?.funnel) return;
  const gameLike =
    widgetPartHtml.includes("spm_widget_game_wheel") ||
    widgetPartHtml.includes("spm_widget_game_slot_machine") ||
    widgetPartHtml.includes("spm_widget_game_scratch_card");
  if (!gameLike) return;

  removeGameStepsFromTree(state.template.funnel.nextSteps);

  const hostStep = findFunnelStepByTemplate(
    [state.template.funnel],
    state.template.id
  );
  if (!hostStep) return;

  const originTemplateId = String(
    state.template.originTemplateId || state.template.id
  );
  const stubSection: Section = {
    id_template_elements: "loaded-part-game-widget",
    html: widgetPartHtml,
    css: "",
    translations: "",
    type: "design",
  };
  const visited = new Set<number>([state.template.id]);
  await loadGameFunnelSteps(
    [stubSection],
    hostStep.nextSteps,
    originTemplateId,
    undefined,
    state.template.informations?.name,
    state.template.type,
    visited
  );
  refreshFunnel();
};

/**
 * Update labels of existing game prize templates during save.
 * Renames templates in the database to match current prize labels.
 */
export const updateGamePrizeTemplateLabels = async (): Promise<void> => {
  if (!state.template) return;

  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return;

  const wheelElement = iframeDoc.querySelector('.spm_widget_game_wheel');
  const slotElement = iframeDoc.querySelector('.spm_widget_game_slot_machine');
  const scratchElement = iframeDoc.querySelector('.spm_widget_game_scratch_card');
  if (!wheelElement && !slotElement && !scratchElement) return;

  let prizes: any[] = [];
  try {
    if (wheelElement) {
      prizes = JSON.parse(wheelElement.getAttribute("data-prizes") || "[]");
    } else if (slotElement) {
      const combinations = JSON.parse(
        slotElement.getAttribute("data-win-combinations") || "[]"
      );
      prizes = combinations.map((combo: any) => ({
        label: combo.prize || "Win",
        probability: combo.probability,
        templateId: combo.templateId
      }));
    } else if (scratchElement) {
      prizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
    }
  } catch (e) {
    return;
  }

  // Build translation map for resolving labels from translationKeys
  const defaultLang = getShopDefaultLang();
  const translationMap = new Map<string, string>();
  state.template.translations
    .filter(t => t.language === defaultLang)
    .forEach(t => translationMap.set(t.key, t.value));

  const { renameTemplate } = useTemplatesApi();
  const templateName = state.template.informations.name || "";

  for (const prize of prizes) {
    if (!prize.templateId) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // Resolve label from translation if translationKey exists
    let prizeLabel = prize.label || "";
    if (prize.translationKey && translationMap.has(prize.translationKey)) {
      prizeLabel = translationMap.get(prize.translationKey) || prizeLabel;
    }

    if (!prizeLabel) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const expectedName = `${templateName} - ${prizeLabel}`;

    let templateId: number;
    try {
      templateId = Number(atob(prize.templateId));
    } catch {
      templateId = Number(prize.templateId);
    }

    if (Number.isNaN(templateId) || templateId <= 0) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // Only rename if the name has actually changed
    const originId = String(
      state.template.originTemplateId || state.template.id
    );
    const prizeTemplate = state.templatesFromFunnel[originId]?.find(
      t => t.id === templateId
    );
    // Skip rename if template is not loaded in the funnel state — avoids
    // unnecessary API calls when game prize templates weren't fully resolved
    if (!prizeTemplate) {
      // eslint-disable-next-line no-continue
      continue;
    }
    const currentName = prizeTemplate.informations?.name ?? "";
    if (currentName === expectedName) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // eslint-disable-next-line no-await-in-loop
    await renameTemplate(templateId, expectedName);
    if (prizeTemplate?.informations) {
      prizeTemplate.informations.name = expectedName;
    }
  }
};

/**
 * Create templates for game prizes that don't have a templateId yet.
 * Called during the save flow. Updates data-prizes in the iframe DOM with new templateIds.
 * Returns true if any templates were created.
 *
 * Strip all widgets, add a title and text widgets, clean config, executeSave.
 */
export const createGamePrizeTemplates = async (skipUiSync = false): Promise<boolean | null> => {
  if (!state.template) return null;

  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return null;

  const wheelElement = iframeDoc.querySelector('.spm_widget_game_wheel');
  const slotElement = iframeDoc.querySelector('.spm_widget_game_slot_machine');
  const scratchElement = iframeDoc.querySelector('.spm_widget_game_scratch_card');
  const gameElement = wheelElement || slotElement || scratchElement;
  if (!gameElement) return null;

  let prizes: any[] = [];
  let isSlotMachine = false;
  try {
    if (wheelElement) {
      prizes = JSON.parse(wheelElement.getAttribute("data-prizes") || "[]");
    } else if (slotElement) {
      isSlotMachine = true;
      const combinations = JSON.parse(
        slotElement.getAttribute("data-win-combinations") || "[]"
      );
      prizes = combinations.map((combo: any) => ({
        label: combo.prize || "Win",
        probability: combo.probability,
        templateId: combo.templateId
      }));
    } else if (scratchElement) {
      prizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
    }
  } catch (e) {
    return null;
  }

  const prizesNeedingTemplates = prizes.filter((p: any) => !p.templateId);
  if (prizesNeedingTemplates.length === 0) {
    return null;
  }

  const { duplicateTemplateBatch, fetchTemplates } = useTemplatesApi();
  const templateName = state.template.informations.name || "";
  const originTemplateId = String(
    state.template.originTemplateId || state.template.id
  );
  let created = false;

  // Resolve idCampaign and originCall from active flow
  const activeFlow = store.getters["flowEditor/getActiveFlowIdentifier"];
  const resolvedIdCampaign: number | null = activeFlow
    ? activeFlow.id
    : state.template.idCampaign;
  const resolvedOriginCall: string | null = activeFlow ? activeFlow.type : null;

  // Build batch items for all prizes that need a template — single network request
  const batchItems = prizes
    .map((prize: any, i: number) => ({ prize, i }))
    .filter(({ prize }: { prize: any }) => !prize.templateId)
    .map(({ prize, i }: { prize: any; i: number }) => ({
      id_template: state.template!.id,
      name: `${templateName} - ${prize.label || `Prize ${i + 1}`}`,
      idShopOfTemplate: UserState.activeShop?.id ?? undefined,
      originCall: resolvedOriginCall ?? undefined,
      idCampaign: resolvedIdCampaign ?? undefined,
      originTemplateId: state.template!.id,
      rootTemplateId: state.template!.funnel.template?.id ?? undefined,
      skipRedirects: true,
      resetTeaser: true,
      _prizeIndex: i
    }));

  const batchPayload = batchItems.map(({ _prizeIndex: _, ...item }) => item);
  const batchResult = await duplicateTemplateBatch(batchPayload);
  if (!batchResult.success || !batchResult.data?.length) return false;

  // Map by position: backend returns results in the same order as input
  const newTemplateIds: number[] = batchResult.data.map(entry =>
    Number(entry.id_template_new)
  );

  // Fetch all new templates with their elements in a single request
  const fetchedTemplates = await fetchTemplates(newTemplateIds);
  // Post-process all new templates in parallel (build in-memory only, no save yet)
  const { updateTemplates } = useTemplatesApi();
  const prizeTemplateInputs: any[] = [];
  // Collect funnel entries here; mutating state.templatesFromFunnel inside parallel
  // callbacks triggers interleaved Vue flushes and breaks directives (e.g. v-tooltip on WidgetsPanel).
  const pendingFunnelTemplates: any[] = [];

  await Promise.all(
    batchItems.map(
      async (
        {
          _prizeIndex: i,
          name: newName
        }: { _prizeIndex: number; name: string },
        batchIndex: number
      ) => {
        const newTemplateId = newTemplateIds[batchIndex];
        if (!newTemplateId) return;

        prizes[i].templateId = btoa(String(newTemplateId));
        created = true;

        try {
          const fetchedRaw = fetchedTemplates[newTemplateId];
          if (fetchedRaw) {
            // Populate cache for conflict check path
            templateRawCache.set(newTemplateId, {
              id_template: fetchedRaw.id_template,
              id_campaign: fetchedRaw.id_campaign,
              created_from_campaign: fetchedRaw.created_from_campaign,
              template_config: fetchedRaw.template_config ?? "",
              label: fetchedRaw.label,
              date_modification: fetchedRaw.date_modification,
              version: fetchedRaw.version,
              type: fetchedRaw.type
            });
            const preparedTemplate = await buildTemplateFromRawAndElements(
              fetchedRaw,
              newName
            );
            if (preparedTemplate) {
              const { template } = preparedTemplate;
              // Update informations.name to match the prize-specific label
              template.informations.name = newName;

              // Collect translation keys and widget IDs to remove
              const translationKeysToRemove: string[] = [];
              const widgetIdsToRemove: string[] = [];

              // Track first column position for inserting widgets
              let firstColumnContainer: HTMLElement | null = null;
              let targetSectionIndex = -1;

              if (template && template.sections) {
                template.sections.forEach((section, sectionIndex) => {
                  if (section.type === "design") return;

                  const tempElement = document.createElement("div");
                  tempElement.innerHTML = section.html;

                  // Find ALL draggable widgets
                  const allWidgets = tempElement.querySelectorAll(
                    ".spm_draggable_widget"
                  );

                  allWidgets.forEach(widget => {
                    // Collect translation keys from widget HTML
                    const widgetHTML = widget.outerHTML;
                    const translationMatches = widgetHTML.match(
                      /{LANG_([^}]+)}/g
                    );
                    if (translationMatches) {
                      translationMatches.forEach(match => {
                        const key = match
                          .replace("{LANG_", "")
                          .replace("}", "");
                        translationKeysToRemove.push(key);
                      });
                    }

                    // Collect widget ID for CSS cleanup
                    if (widget.id) {
                      widgetIdsToRemove.push(widget.id);
                    }

                    widget.remove();
                  });

                  // Remove empty rows/columns: keep only one row with one column
                  const rows = tempElement.querySelectorAll(".spm_row");
                  let keptOneRow = false;
                  rows.forEach(row => {
                    const columns = row.querySelectorAll(".spm_column");
                    const hasWidgets = row.querySelector(
                      ".spm_draggable_widget"
                    );
                    if (!hasWidgets && keptOneRow) {
                      row.remove();
                    } else if (!hasWidgets && !keptOneRow) {
                      // Keep first empty row but remove extra empty columns (keep one)
                      let keptOneColumn = false;
                      columns.forEach(col => {
                        if (keptOneColumn) {
                          col.remove();
                        } else {
                          // Set column to full width
                          (col as HTMLElement).style.width =
                            "calc(100% - 1.5px)";
                          keptOneColumn = true;
                        }
                      });
                      keptOneRow = true;
                      if (!firstColumnContainer) {
                        firstColumnContainer =
                          (columns[0] as HTMLElement) || null;
                        targetSectionIndex = sectionIndex;
                      }
                    }
                  });

                  // Update section HTML
                  section.html = tempElement.innerHTML;

                  // Clean CSS: parse as JSON, remove keys matching removed widget IDs
                  if (section.css) {
                    try {
                      const cssObject = JSON.parse(section.css);
                      widgetIdsToRemove.forEach(widgetId => {
                        const suffix = widgetId.replace(
                          TEMPLATE_WIDGET_IDENTIFIER_PREFIX,
                          ""
                        );
                        const cssKey = `${CUSTOM_WIDGET_CSS_PREFIX}${suffix}`;
                        delete cssObject[cssKey];
                        delete cssObject[`${cssKey}_mobile`];
                      });
                      section.css = JSON.stringify(cssObject);
                    } catch (e) {
                      // Keep CSS as-is if parsing fails
                    }
                  }

                  // If we haven't found a column yet, try to find one in this section
                  if (!firstColumnContainer) {
                    const column = tempElement.querySelector(".spm_column");
                    if (column) {
                      firstColumnContainer = column as HTMLElement;
                      targetSectionIndex = sectionIndex;
                    }
                  }
                });

                // Remove collected translation keys
                if (template.translations) {
                  template.translations = template.translations.filter(
                    translation =>
                      !translationKeysToRemove.some(
                        key =>
                          translation.key === key ||
                          translation.key.startsWith(`${key}.`)
                      )
                  );
                }

                // Add title + text widgets using getWidgetStructures
                if (targetSectionIndex >= 0) {
                  const targetSection =
                    template.sections.filter(s => s.type !== "design")[0] ||
                    template.sections[targetSectionIndex];

                  if (targetSection) {
                    const sectionElement = document.createElement("div");
                    sectionElement.innerHTML = targetSection.html;

                    const targetContainer =
                      sectionElement.querySelector(".spm_column") ||
                      sectionElement.firstElementChild;

                    if (targetContainer) {
                      const templateParentType = getTemplateParentTypeByType(
                        template.type
                      );
                      const widgetStructures = getWidgetStructures(
                        () => "",
                        {},
                        true
                      )[templateParentType];

                      const titleHtml = (widgetStructures[
                        WidgetTypeEnum.TITLE
                      ] as Function)("Félicitations !");
                      const textHtml = (widgetStructures[
                        WidgetTypeEnum.TEXT
                      ] as Function)(
                        "<p>Merci d'avoir joué ! Vous pouvez récupérer votre lot en suivant les instructions ci-dessous.</p>"
                      );

                      // Generate translations for both widgets and insert them
                      [titleHtml, textHtml].forEach(rawHtml => {
                        // eslint-disable-next-line prefer-const
                        let {
                          newHtml,
                          translationsArray
                        } = generateTranslations(rawHtml, {
                          newElement: false,
                          translateVariables: true,
                          forceTranslateHiddenElement: true
                        });

                        const widgetElement = document.createElement("div");
                        widgetElement.innerHTML = newHtml;

                        targetContainer.appendChild(
                          widgetElement.firstElementChild as Element
                        );

                        translationsArray = translationsArray.map(
                          translation => ({
                            ...translation,
                            section: targetSection.id_template_elements
                          })
                        );

                        if (translationsArray && translationsArray.length > 0) {
                          template.translations.push(...translationsArray);
                        }
                      });

                      targetSection.html = sectionElement.innerHTML;
                    }
                  }
                }

                // Rebuild sections with updated translations
                const sections: Section[] = [];
                sections.push(
                  ...template.sections.map((current: Section) => ({
                    ...current,
                    translations: formatTranslationsForSection(
                      template.translations.filter(
                        (translation: Translation) =>
                          translation.section.toString() ===
                          current.id_template_elements.toString()
                      ) ?? []
                    )
                  }))
                );
                template.sections = sections;

                // Clean ALL inherited configuration keys
                delete template.configuration.forms;
                delete template.configuration.funnels;
                delete template.configuration.games_data;
                delete template.configuration.nextIdTemplate;
                delete template.configuration.teaserId;
                template.configuration.hasGame = false;
                template.configuration.hasForm = false;
                template.configuration.hasVoucher = false;
              }

              // Collect template input for batch save
              prizeTemplateInputs.push({
                id: template.id,
                type: template.type,
                idCampaign: template.idCampaign,
                informations: template.informations,
                content: template.content,
                sections: template.sections,
                configuration: { ...template.configuration }
              });

              // Always collect prize templates for templatesFromFunnel after Promise.all (element save uses
              // skipUiSync but navigation still needs real IDs and list entries).
              if (state.template) {
                pendingFunnelTemplates.push(template);
              }
            }
          }
        } catch (e) {
          // Continue with other prizes if one fails
        }
      }
    )
  );
  // Single batch save for all prize templates
  if (prizeTemplateInputs.length > 0) {
    const prizeResult = await updateTemplates(prizeTemplateInputs);
    if (!prizeResult.success) {
      await showToastError("noSave");
      return false;
    }
  }

  // Merge prize templates into templatesFromFunnel.
  // During element save (skipUiSync), defer this merge so SaveElementModal handler
  // can finish without triggering directive-hook crashes from WidgetsPanel re-renders.
  if (pendingFunnelTemplates.length > 0 && state.template) {
    const snapshot = pendingFunnelTemplates.slice();
    const oid = originTemplateId;
    if (skipUiSync) {
      if (!deferredGamePrizeTemplatesByOrigin[oid]) {
        deferredGamePrizeTemplatesByOrigin[oid] = [];
      }
      const queued = deferredGamePrizeTemplatesByOrigin[oid];
      snapshot.forEach((tmpl: any) => {
        if (!queued.find((t: { id: number }) => t.id === tmpl.id)) {
          queued.push(tmpl);
        }
      });
    } else {
      mergeTemplatesIntoFunnelList(oid, snapshot, state.template.funnel);
    }
  }

  if (created) {
    // Update the game element's data attribute with new templateIds
    if (isSlotMachine && slotElement) {
      const combinations = JSON.parse(
        slotElement.getAttribute("data-win-combinations") || "[]"
      );
      prizes.forEach((prize: any, i: number) => {
        if (combinations[i] && prize.templateId) {
          combinations[i].templateId = prize.templateId;
        }
      });
      slotElement.setAttribute('data-win-combinations', JSON.stringify(combinations));
    } else if (scratchElement) {
      scratchElement.setAttribute('data-prizes', JSON.stringify(prizes));
    } else if (wheelElement) {
      wheelElement.setAttribute("data-prizes", JSON.stringify(prizes));
    }

    // Full template save: sync here. Element save: SaveElementModal done() callback runs sync after parent reset().
    if (!skipUiSync) {
      syncGameFunnelSteps();
      updateTemplateConfigurationNextIdTemplate();
    }
  }

  return created;
};

function collectTemplateIds(step: FunnelStep, templateIds: Set<string>): void {
  if (step.template) {
    templateIds.add(String(step.template.id));
  }

  step.nextSteps.forEach(nextStep => {
    collectTemplateIds(nextStep, templateIds);
  });
}

function removeNextStepsAndUpdateTemplates(
  step: FunnelStep,
  templateIdToRemove: string,
  templatesFromFunnel: Array<Template>
): void {
  const removedTemplateIds = new Set<string>();

  // Helper function to remove next steps and collect template IDs to remove
  function removeNextSteps(s: FunnelStep, idToRemove: string): void {
    s.nextSteps = s.nextSteps.filter(nextStep => {
      const shouldRemove =
        nextStep.template && idToRemove === String(nextStep.template.id);
      if (shouldRemove && nextStep.template) {
        removedTemplateIds.add(String(nextStep.template.id));
      }
      return !shouldRemove;
    });

    // Recurse into remaining nextSteps
    s.nextSteps.forEach(next => removeNextSteps(next, idToRemove));
  }

  // Remove next steps and collect template IDs
  removeNextSteps(step, templateIdToRemove);

  // Collect all template IDs in the updated funnel step
  const allTemplateIds = new Set<string>();
  collectTemplateIds(step, allTemplateIds);

  // Remove templates from templatesFromFunnel
  const updatedTemplates = templatesFromFunnel.filter(template =>
    allTemplateIds.has(String(template.id))
  );

  templatesFromFunnel.length = 0;
  templatesFromFunnel.push(...updatedTemplates);
}

export const refreshNextSteps = () => {
  const funnels: FunnelStep[] = [];

  const getNextSteps = (funnel: FunnelStep) => {
    if (state.template) {
      if (
        funnel.template?.id === state.template.id &&
        !funnels.find(item => item.template?.id === state.template?.id)
      ) {
        funnels.push(funnel);
      } else {
        // eslint-disable-next-line no-restricted-syntax
        for (const nextStep of funnel.nextSteps) {
          getNextSteps(nextStep);
        }
      }
    }
  };
  if (state.template) {
    getNextSteps(state.template.funnel);
    const template = getTemplateIframeDocument();
    if (template) {
      const templateIdsToRemove = new Set<string>();
      if (state.template && template) {
        funnels.forEach(funnel => {
          funnel.nextSteps.forEach(nextStep => {
            if (nextStep.template) {
              // Skip game funnel steps: they are linked via data-prizes, not data-redirect
              if (nextStep.template.isGameFunnel) return;
              const { id } = nextStep.template;
              const btoaId = btoa(String(id));
              const element = template.querySelector(
                `[data-redirect="${btoaId}"]`
              );
              if (!element) {
                templateIdsToRemove.add(String(id));
              }
            }
          });
        });
      }
      Array.from(templateIdsToRemove).forEach(templateId => {
        if (state.template && state.template.originTemplateId) {
          removeNextStepsAndUpdateTemplates(
            state.template.funnel,
            templateId,
            state.templatesFromFunnel[state.template.originTemplateId]
          );
        }
      });
      state.funnelStepKey += 1;
    }
  }
};

export const removeTemplateFromFunnels = (element: HTMLElement) => {
  const templateDoc = getTemplateIframeDocument();

  const countRedirectRefs = (
    root: ParentNode,
    redirectValue: string
  ): number => countRedirectReferences(
    (root as HTMLElement).outerHTML || (root as Document).body?.outerHTML,
    redirectValue
  );

  const hasInterTemplateReference = (redirectValue: string): boolean => {
    if (!state.template || !state.template.originTemplateId) return false;
    const funnelTemplates = state.templatesFromFunnel[state.template.originTemplateId];
    if (!funnelTemplates?.length) return false;

    const currentTemplateId = Number(state.template.id);
    return funnelTemplates.some((tmpl) => {
      if (Number(tmpl.id) === currentTemplateId) {
        return false;
      }

      const hasInSections = (tmpl.sections || []).some((section: any) => {
        const html = section?.html || '';
        return html.includes(`data-redirect="${redirectValue}"`)
          || html.includes(`data-redirect='${redirectValue}'`)
          || html.includes(`#redirect_${redirectValue}`)
          || html.includes(`#spin_redirect_${redirectValue}`);
      });

      if (hasInSections) {
        return true;
      }

      return (tmpl.translations || []).some((translation: any) => {
        const value = translation?.value;
        if (typeof value !== 'string') return false;
        return value === `#redirect_${redirectValue}`
          || value === `#spin_redirect_${redirectValue}`
          || value === `base64:#redirect_${redirectValue}`
          || value === `base64:#spin_redirect_${redirectValue}`
          || value.includes(`#redirect_${redirectValue}`)
          || value.includes(`#spin_redirect_${redirectValue}`);
      });
    });
  };

  const redirectValuesToRemove = new Set<string>(
    extractRedirectEncodedIds(element.outerHTML),
  );

  redirectValuesToRemove.forEach((dataNextStep) => {
    // Keep next step if another element still points to the same redirect.
    const refsInRemovedElement = countRedirectRefs(element, dataNextStep);
    const refsInTemplate = templateDoc
      ? countRedirectRefs(templateDoc, dataNextStep)
      : refsInRemovedElement;
    const stillReferencedOutsideRemovedElement =
      refsInTemplate > refsInRemovedElement;
    if (stillReferencedOutsideRemovedElement) {
      return;
    }

    let templateId = '';
    try {
      templateId = atob(dataNextStep);
    } catch {
      return;
    }

    if (templateId) {
      if (hasInterTemplateReference(dataNextStep)) {
        // Another template still points to this target:
        // remove only the direct link from the current template.
        removeStepFromCurrentFunnel(Number(templateId));
        return;
      }
      if (
        state.template &&
        state.template.originTemplateId &&
        state.templatesFromFunnel[state.template.originTemplateId]
      ) {
        removeNextStepsAndUpdateTemplates(
          state.template.funnel,
          templateId,
          state.templatesFromFunnel[state.template.originTemplateId]
        );
        // Update templatesFromFunnel to use the origin template from state.templates
        const originTemplateIndex = state.templates.findIndex(
          t => String(t.id) === String(state.template?.originTemplateId)
        );
        const templatesStateFunnelIndex = state.templatesFromFunnel[
          state.template.originTemplateId
        ].findIndex(
          t => String(t.id) === String(state.template?.originTemplateId)
        );
        if (originTemplateIndex !== -1 && templatesStateFunnelIndex !== -1) {
          state.templatesFromFunnel[state.template.originTemplateId][
            templatesStateFunnelIndex
          ] = state.templates[originTemplateIndex];
        }

        // Update funnel in each templates
        state.templatesFromFunnel[state.template.originTemplateId].forEach(
          t => {
            if (state.template) {
              t.funnel = state.template?.funnel;
            }
          }
        );
      }
    }
  });
  state.funnelStepKey += 1;
};

export const fixDataRedirectAttribute = (template: any) => {
  const translations = template.translations.filter((t: any) =>
    t.value.match(/^#(?:spin_)?redirect_/g)
  );
  translations.forEach((t: any) => {
    const id = t.value
      .replace("base64:", "")
      .replace("#spin_redirect_", "")
      .replace("#redirect_", "") ?? "";
    template.sections.forEach((s: any) => {
      const alreadyHasRedirect = new RegExp(`data-redirect=['"]${id}['"]`).test(
        s.html
      );
      if (!alreadyHasRedirect) {
        const pattern = new RegExp(`\\{LANG_${t.key}\\}["']`, "g");
        s.html = s.html.replace(
          pattern,
          `{LANG_${t.key}}" data-redirect="${id}"`
        );
      }
    });
  });
};

/**
 * Add a template to templatesFromFunnel for a given origin.
 * Returns the index of the template in the list (existing or newly appended).
 * Must be called from TemplateEditor (not from components) because state is readonly outside.
 */
export function addToFunnelList(originId: string, template: Template): number {
  if (!state.templatesFromFunnel[originId]) {
    state.templatesFromFunnel[originId] = [];
  }
  const existing = state.templatesFromFunnel[originId].findIndex(
    t => String(t.id) === String(template.id)
  );
  if (existing !== -1) {
    return existing;
  }
  state.templatesFromFunnel[originId].push(template);
  return state.templatesFromFunnel[originId].length - 1;
}

export async function activate(
  rawId: number,
  name: string,
  type: string,
  preparedTemplateIndex = -1,
  initFunnel = true,
  rootTemplate: {
    idTemplate: number;
    type: string;
    name: string;
  } | null = null,
  skipConflictCheck = false
): Promise<Maybe<Template>> {
  // Normalize id to number — API may pass it as string at runtime
  const id = Number(rawId);

  const preActivate = () => {
    fixUndefinedFieldTypeInTranslations();

    showTemplateEditor();
    triggerAdditionalEditorActivationFunctions();

    sortTranslationInState();

    // Do NOT call updateFormsInState() here — the iframe still shows the previous
    // template at this point (it loads asynchronously). Calling it now would read
    // the wrong DOM and overwrite the current template's forms config (e.g. losing
    // actions_to_take for widget-buttons). Forms will be synchronized later when
    // the iframe finishes loading (via beforeSaveTemplate, action-buttons-handlers, etc.).

    store.commit("liveEditor/refreshConfigurationPanelKey");
  };

  store.commit("liveEditor/setCheckSyncElements", true);
  hideIframeTemplateWrapper();
  await hideLeftToolbar(null, true);
  destroyIframeSortables();

  const prepare = async (
    idTemplate: number,
    templateName: string,
    templateType: string,
    showEditor = true,
    skipConflictCheck = false
  ) => {
    const ex = state.templates.findIndex(s => s.id === idTemplate);
    const exCampaign = state.templatesLinkedToCampaign.findIndex(
      s => s.id === idTemplate
    );
    if (ex !== -1 || exCampaign !== -1) {
      // Vérifier si le template vient du localStorage et s'il y a un conflit de version
      const templateToActivate =
        ex !== -1
          ? state.templates[ex]
          : state.templatesLinkedToCampaign[exCampaign];

      if (!skipConflictCheck && templateToActivate.dateModification) {
        try {
          // Use cache if available; otherwise do a full fetch (populates cache for prepareTemplate too)
          let cachedRaw = getPartialCachedTemplateRaw(id);
          if (!cachedRaw) {
            cachedRaw = (await getCachedTemplateRaw(id)) ?? undefined;
          }

          if (cachedRaw) {
            const localDate = moment(
              templateToActivate.dateModification,
              "YYYY-MM-DD HH:mm:ss",
              true
            );
            const remoteDate = moment(
              cachedRaw.date_modification,
              "YYYY-MM-DD HH:mm:ss",
              true
            );

            const hasLocalChanges = templateToActivate.edited === true;
            const hasRemoteChanges =
              localDate.isValid() &&
              remoteDate.isValid() &&
              !localDate.isSame(remoteDate);

            if (hasLocalChanges && hasRemoteChanges) {
              const conflict: TemplateVersionConflict = {
                templateId: id,
                templateName:
                  templateToActivate.informations?.name ||
                  cachedRaw.label ||
                  `Template ${id}`,
                localDate: localDate.format("DD/MM/YYYY HH:mm"),
                remoteDate: remoteDate.format("DD/MM/YYYY HH:mm"),
                templateType: templateToActivate.type
              };

              state.preventDateModificationUpdate = true;
              setTimeout(() => {
                state.versionConflicts = [conflict];
              }, 100);
            }
          }
        } catch (error) {
          console.error(
            `Error checking template version conflict for template ${id}:`,
            error
          );
        }
      }

      if (ex !== -1) {
        state.index = ex;
        state.template = state.templates[ex];
        state.template.originTemplateId = String(state.templates[ex].id);
      } else {
        state.template = state.templatesLinkedToCampaign[exCampaign];
      }

      if (showEditor) {
        showTemplateEditor();
        triggerAdditionalEditorActivationFunctions();
        sortTranslationInState();
        store.commit("liveEditor/setFunnelsLoading", true);
        try {
          await reInitFunnels();
        } finally {
          store.commit("liveEditor/setFunnelsLoading", false);
        }
      }
      return state.template;
    }

    const result = await prepareTemplate(
      idTemplate,
      templateName,
      templateType
    );
    if (!result) {
      return null;
    }

    const { template: t, idCampaign } = result;

    if (idCampaign !== null) {
      state.templatesLinkedToCampaign.push(t);
    } else {
      state.templates.push(t);
      state.index = state.templates.length - 1;
    }
    state.template = t;

    fixDataRedirectAttribute(state.template);

    if (initFunnel && state.template.funnel) {
      state.template.originTemplateId = String(state.template.id);

      const { fetchedMap: funnelFetchedMap } = await fetchNextFunnels(
        idTemplate,
        state.template.funnel.nextSteps,
        String(state.template.id),
        true
      );

      // Load game prize funnel steps (reuse already-fetched data)
      const visitedIds = new Set<number>([idTemplate]);
      await loadGameFunnelSteps(
        t.sections,
        state.template.funnel.nextSteps,
        String(state.template.id),
        funnelFetchedMap,
        undefined,
        undefined,
        visitedIds
      );
      state.template.funnel.template = {
        id: t.id,
        name: t.informations.name,
        type: t.type
      };
    }

    // Load teaser if exists for popup templates
    if (t.type === TemplateTypeEnum.POPUP) {
      await fetchTeaserForPopup(
        idTemplate,
        t.informations.name,
        t.informations.lang || "fr",
        t.configuration
      );
    }

    state.hasAny = state.templates.length !== 0;

    if (showEditor) {
      preActivate();
    }

    return t;
  };

  if (
    state.template &&
    state.template.originTemplateId &&
    preparedTemplateIndex !== -1
  ) {
    const originId = state.template.originTemplateId;
    const funnelList = state.templatesFromFunnel[originId];

    // Verify the index still points to the expected template; recalculate by ID if stale
    let actualIndex = preparedTemplateIndex;
    if (!funnelList?.[actualIndex] || String(funnelList[actualIndex].id) !== String(id)) {
      actualIndex = funnelList?.findIndex(t => String(t.id) === String(id)) ?? -1;
    }

    if (actualIndex !== -1 && funnelList?.[actualIndex]) {
      state.template = funnelList[actualIndex];
      preActivate();
      return funnelList[actualIndex];
    }
    // Template not found in funnelList — fall through to prepare() path
  }

  if (!rootTemplate) {
    const template = await prepare(id, name, type, true, skipConflictCheck);
    return template;
  }
  await prepare(
    rootTemplate.idTemplate,
    rootTemplate.name,
    rootTemplate.type,
    false,
    skipConflictCheck
  );
  if (
    state.template &&
    state.template.originTemplateId &&
    state.templatesFromFunnel[state.template.originTemplateId]
  ) {
    const templateFromFunnelIndex = state.templatesFromFunnel[
      state.template.originTemplateId
    ].findIndex(t => t.id === id);
    state.template =
      state.templatesFromFunnel[state.template.originTemplateId][
        templateFromFunnelIndex
      ];
    preActivate();
  }
  return state.template;
}

export function rename(id: number, name: string): void {
  if (state.template) {
    state.template.informations.name = name;
  }
}

export const deleteTemplate = async (
  idTemplate: number
): Promise<boolean | string> => {
  // Check if used as reference template
  const templates = await List<Templates>({
    name: "Templates",
    settings: {
      filter: [
        {
          field: "id_shop",
          operator: OperatorType.Equals,
          value: UserState.activeShop?.id ?? 0
        },
        {
          field: "deleted",
          operator: OperatorType.Equals,
          value: 0
        },
        {
          field: "id_template_reference",
          operator: OperatorType.Equals,
          value: idTemplate
        }
      ],
      order: [{ field: "id_template", type: "ASC" }],
      offset: 0,
      limit: 1
    },
    fields: ["id_template"]
  });

  if (templates.err !== "") {
    return templates.err;
  }

  if (templates.total > 0) {
    return "templates.confirm.delete.error.messageTemplateReference";
  }

  // Check if used in an automated scenario
  const workflows = await List<Templates>({
    name: "Templates",
    settings: {
      filter: [
        {
          field: "id_shop",
          operator: OperatorType.Equals,
          value: UserState.activeShop?.id ?? 0
        },
        {
          field: "deleted",
          operator: OperatorType.Equals,
          value: 0
        },
        {
          field: "id_campaign",
          operator: OperatorType.IsNotNull,
          value: "null"
        },
        {
          field: "template_config",
          operator: OperatorType.Contains,
          value: idTemplate
        }
      ],
      order: [{ field: "id_template", type: "ASC" }],
      offset: 0,
      limit: 1
    },
    fields: ["id_template"]
  });

  if (workflows.err !== "") {
    return workflows.err;
  }

  if (workflows.total > 0) {
    // TODO : récupérer la liste des scénarios qui contient ce modèle et créer des liens permettant d'éditer la boite concernée
    return "templates.confirm.delete.error.messageUsedInWorkflows";
  }

  // We can delete the template
  const templateInput: TemplatesUpdateInputItem[] = [
    {
      id_template: idTemplate,
      id_shop: UserState.activeShop?.id ?? 0,
      deleted: true,
      date_modification: moment().format("YYYY-MM-DD HH:mm:ss")
    }
  ];

  const update = await Update<TemplatesUpdateInputItem>({
    name: "Templates",
    input: templateInput,
    type: "TemplatesUpdateInput"
  });

  if (update.err !== "") {
    return update.err;
  }

  invalidateTemplateRawCache(idTemplate);

  // After template deletion, we check if the template is opened in state and local storage.
  // If true, we need to remove it
  const templatesInLocalStorage = JSON.parse(
    getLocalStorageElement("templates") ?? "{}"
  );
  if (Object.keys(templatesInLocalStorage).length > 0) {
    const newTemplatesToStore: Template[] = templatesInLocalStorage.templates.filter(
      (template: Template) => template.id !== idTemplate
    );

    if (newTemplatesToStore.length === 0) {
      // If there is no template, we hide the editor icon and reset everything
      state.hasAny = false;
      state.templates = [];
      state.index = -1;
      removeLocalStorageElement("templates");
      removeLocalStorageElement("elementSyncCurrentTemplate");
    } else {
      const index: number = newTemplatesToStore.length - 1;
      setLocalStorageElement(
        "templates",
        JSON.stringify({ templates: newTemplatesToStore, index })
      );
      state.templates = newTemplatesToStore;
      state.index = index;
    }
  }

  return true;
};

export function setRefreshTemplatesList(refreshList: boolean) {
  state.refreshTemplatesList = refreshList;
}

export function deactivate(id: number, hideTmpEditor = true): void {
  hideIframeTemplateWrapper();

  invalidateTemplateRawCache(id);

  if (state.template && state.template.originTemplateId) {
    // Invalidate all funnel templates for this origin
    if (state.templatesFromFunnel[state.template.originTemplateId]) {
      state.templatesFromFunnel[state.template.originTemplateId].forEach(t =>
        invalidateTemplateRawCache(t.id)
      );
      delete state.templatesFromFunnel[state.template.originTemplateId];
    }
    if (state.teaserTemplates[state.template.originTemplateId]) {
      delete state.teaserTemplates[state.template.originTemplateId];
    }
    state.templates = state.templates.filter(
      s => String(s.id) !== String(state.template?.originTemplateId)
    );
    state.templatesLinkedToCampaign = state.templatesLinkedToCampaign.filter(
      s => String(s.id) !== String(state.template?.originTemplateId)
    );
  }

  // Also delete teaser for this template id
  if (state.teaserTemplates[String(id)]) {
    delete state.teaserTemplates[String(id)];
  }

  state.templates = state.templates.filter(s => s.id !== id);
  state.templatesLinkedToCampaign = state.templatesLinkedToCampaign.filter(
    s => s.id !== id
  );
  state.index = state.templates.length - 1;
  state.hasAny = state.templates.length !== 0;
  state.template = null;
  triggerAdditionalEditorDeactivationFunctions();

  // Clear entire cache when editor is fully closed
  if (!state.hasAny && !state.templatesLinkedToCampaign.length) {
    templateRawCache.clear();
  }

  if (hideTmpEditor) {
    hideTemplateEditor();
  }
}

export function updateTemplateInformations(informations: TemplateInformations) {
  if (state.template) {
    state.template.informations = {
      ...state.template.informations,
      ...informations
    };
  }
}

export function markTemplateAsEdited() {
  if (state.template) {
    state.template.edited = true;
  }
}

// Track last known active section before reset, so createHistory can use it as fallback
let _lastActiveSection: number | string = -1;

export const resetActiveSection = () => {
  if (state.template) {
    if (state.template.activeSection !== -1) {
      _lastActiveSection = state.template.activeSection;
    }
    state.template.activeSection = -1;
  }
};

export const getLastActiveSection = (): number | string => _lastActiveSection;

export const setActiveSection = (sectionId: number | string) => {
  if (state.template) {
    state.template.activeSection = sectionId;
  }
};

export const addTranslationsToState = (translations: Translation[]) => {
  translations.forEach(translation => {
    if (
      state.template &&
      !state.template.translations.find(
        t => t.key === translation.key && t.language === translation.language
      )
    ) {
      state.template.translations.push(translation);
    }
  });
};

// eslint-disable-next-line max-len
export const getSectionIdsFromIframe = (widthDesign = false) =>
  (Array.from(
    getTemplateIframeDocument().querySelectorAll("[data-spmelementid]")
  ) as HTMLElement[]).reduce(
    (acc: (string | number)[], section: HTMLElement) => {
      const sectionId = section.getAttribute("data-spmelementid");
      if (!widthDesign) {
        if (
          sectionId &&
          sectionId.toString() !==
            (state.template?.content.design ?? "").toString()
        )
          acc.push(sectionId);
      } else if (sectionId && sectionId.toString() !== "".toString())
        acc.push(sectionId);

      return acc;
    },
    []
  );

export const getSectionIdsFromTemplate = (template: Template) =>
  template.sections.map(s => String(s.id_template_elements));

// Refresh sections order in config
export const refreshSectionsConfig = (sections: number[] | null = null) => {
  if (state.template) {
    if (sections) {
      state.template.content.sections = sections;
    } else {
      state.template.content.sections = getSectionIdsFromIframe();
    }
  }
};

const addNewSectionInState = (section: Section) => {
  if (state.template && section) {
    state.template.sections.push(section);
  }
};

export const replaceSectionContent = (
  idSection: number,
  html: string | null,
  css: string | null,
  translations: string | null
) => {
  if (state.template) {
    const foundSection = state.template.sections.filter(
      (current: Section) => current.id_template_elements === idSection
    );

    if (foundSection.length) {
      foundSection.forEach((current: Section) => {
        if (html) current.html = html;
        if (css) current.css = css;
        if (translations) current.translations = translations;
      });
    } else {
      const restoredSectionFromHistory: Section = {
        id_template_elements: idSection,
        html: html ?? "",
        css: css ?? "",
        translations: translations ?? "",
        type: "section"
      };

      addNewSectionInState(restoredSectionFromHistory);
    }
  }
};

export const refreshTranslations = () => {
  if (state.template) {
    state.template.translations = [];
    state.template.sections.forEach(section => {
      const sectionTranslation = JSON.parse(
        (section.translations && section.translations !== ""
          ? section.translations
          : "{}"
        ).replace(/(\r\n|\n|\r)/gm, " ")
      );
      Object.keys(sectionTranslation).forEach((language: string) => {
        Object.keys(sectionTranslation[language]).forEach((key: string) => {
          if (state.template) {
            state.template.translations.push(
              ...(addTranslation(
                sectionTranslation[language],
                key,
                section.id_template_elements,
                language,
                state.template.type
              ) ?? [])
            );
          }
        });
      });
    });
  }
};

export const htmlHasSmartlist = (html: string) => {
  const $ = cheerio.load(html);
  return $("[s-nb], [s-grid]", ".spm_product_list_element").length > 0;
};

/**
 * Restore smart list original code in a CLONED section element (not the live DOM).
 * Used by executeUpdateSectionsInState to ensure captured HTML always contains
 * the proprietary s-engine= code instead of rendered product HTML.
 */
const restoreSmartListsInClonedSection = (clonedSection: HTMLElement): void => {
  if (!state.template) return;

  const widgetSelectors = [
    '[data-widgettype="spm_smart_products_list"]',
    '[data-widgettype="spm_fb_productslist"]',
    '[data-widgettype="spm_widget_import_zip"]'
  ];

  clonedSection
    .querySelectorAll(widgetSelectors.join(", "))
    .forEach((widget: Element) => {
      const widgetId = widget.getAttribute("id") ?? "";
      if (state.template && state.template.smartLists[widgetId]) {
        const capturedTables = Array.from(widget.querySelectorAll("table"));
        restoreWidgetCodeInVmlShape(
          widget as HTMLElement,
          state.template.smartLists[widgetId]
        );

        // Reproduce responsive class logic from restoreSmartListsOriginalCode
        const hasResponsiveParent =
          widget.closest(".row.spm_responsive") !== null;
        widget.querySelectorAll(".row").forEach(row => {
          if (hasResponsiveParent) {
            row.classList.add("spm_responsive");
          } else {
            row.classList.remove("spm_responsive");
          }
        });

        // The stored code predates the VML repair of the save
        copyVmlTableOffsets(capturedTables, widget);
        copyVmlButtons(capturedTables, widget);
      }
    });
};

/**
 * Restore each original code of smart lists widgets (before refreshing the page or saving the template)
 * @param widgetId if specified, restore only specific widget original code
 */
export const restoreSmartListsOriginalCode = (
  widgetId: Maybe<string> = null
): boolean => {
  clearSmartListRenderCache();
  let returnValue = false;
  const widgets: HTMLElement[] = getTemplateWidgets();
  widgets
    .filter(
      (widget: HTMLElement) =>
        (widget.getAttribute("data-widgettype") === "spm_smart_products_list" ||
          widget.getAttribute("data-widgettype") === "spm_fb_productslist" ||
          widget.getAttribute("data-widgettype") === "spm_widget_import_zip") &&
        (!widgetId ||
          widgetId === widget.getAttribute("id") ||
          getFirstParent(widget, `#${widgetId}`))
    )
    .forEach((widget: HTMLElement) => {
      const widgetElementId = widget.getAttribute("id") ?? "";
      if (
        state.template &&
        Object.keys(state.template.smartLists).includes(widgetElementId)
      ) {
        restoreWidgetCodeInVmlShape(
          widget,
          state.template.smartLists[widgetElementId]
        );

        // Check if any parent has .row.spm_responsive
        const hasResponsiveParent =
          widget.closest(".row.spm_responsive") !== null;

        if (hasResponsiveParent) {
          // Apply .spm_responsive to all .row children inside the widget
          widget.querySelectorAll(".row").forEach(row => {
            row.classList.add("spm_responsive");
          });
        } else {
          widget.querySelectorAll(".row").forEach(row => {
            row.classList.remove("spm_responsive");
          });
        }
        returnValue = true;
      }
    });

  return returnValue;
};

/**
 * Remove all hover classes
 */
export const removeHoverStyles = () => {
  const template = getTemplateIframeDocument();

  if (template) {
    const elements = template.querySelectorAll(
      `.${BUILDER_ELEMENT_HOVER_CLASS}`
    );

    if (elements) {
      elements.forEach(element =>
        element.classList.remove(BUILDER_ELEMENT_HOVER_CLASS)
      );
    }
  }
};

/**
 * Remove all active items classes
 */
export const removeActiveStyles = () => {
  const template = getTemplateIframeDocument();

  if (template) {
    const elements = template.querySelectorAll(
      `.${BUILDER_ELEMENT_ACTIVE_CLASS}`
    );

    if (elements) {
      elements.forEach(element =>
        element.classList.remove(BUILDER_ELEMENT_ACTIVE_CLASS)
      );
    }
  }
};

/**
 * Remove all sortable items classes
 */
export const removeSortableStyles = () => {
  const template = getTemplateIframeDocument();

  if (template) {
    const elements = template.querySelectorAll(
      `.${BUILDER_SORTABLE_DRAG_CLASS}, .${BUILDER_SORTABLE_GHOST_CLASS}, .${BUILDER_SORTABLE_CHOSEN_CLASS}`
    );

    if (elements) {
      elements.forEach(element => {
        element.classList.remove(BUILDER_SORTABLE_DRAG_CLASS);
        element.classList.remove(BUILDER_SORTABLE_GHOST_CLASS);
        element.classList.remove(BUILDER_SORTABLE_CHOSEN_CLASS);
      });
    }
  }
};

/**
 * Remove all editor buttons
 */
export const removeEditorButtons = () => {
  const template = getTemplateIframeDocument();
  if (template) {
    const actionsButtonsRemain = template.querySelectorAll(
      `.${ACTIONS_BUTTON_GROUP}, [id$="-button-identifier"]`
    );
    actionsButtonsRemain.forEach(button => {
      button.remove();
    });
  }
};

export const restoreState = (oldState: any) => {
  const { index, template, funnelTemplate } = oldState;
  if (!funnelTemplate) {
    if (state.templates[index]) {
      Object.assign(state.templates[index], template);
    } else {
      state.templates[index] = template;
    }

    if (state.template) {
      Object.assign(state.template, state.templates[index]);
    } else {
      state.template = state.templates[index];
    }
  } else {
    const templateFunnelIndex = state.templatesFromFunnel[String(template.originTemplateId)].findIndex((item) => String(item.id) === String(funnelTemplate.id));
    if (templateFunnelIndex !== -1) {
      if (state.templatesFromFunnel[String(template.originTemplateId)][templateFunnelIndex]) {
        Object.assign(state.templatesFromFunnel[String(template.originTemplateId)][templateFunnelIndex], funnelTemplate);
      } else {
        state.templatesFromFunnel[String(template.originTemplateId)][templateFunnelIndex] = funnelTemplate;
      }

      if (state.template) {
        Object.assign(state.template, state.templatesFromFunnel[String(template.originTemplateId)][templateFunnelIndex]);
      } else {
        state.template = state.templatesFromFunnel[String(template.originTemplateId)][templateFunnelIndex];
      }
    }
  }
};

export const saveTemplatesInLocalStorage = () => {
  if (
    state.hasAny ||
    state.templatesLinkedToCampaign.length ||
    Object.keys(state.templatesFromFunnel).length
  ) {
    const currentTemplateState =
      store.getters["liveEditor/getCurrentTemplateState"];
    if (currentTemplateState) {
      setLocalStorageElement(
        "elementSyncCurrentTemplate",
        JSON.stringify({
          template: currentTemplateState.template,
          index: currentTemplateState.index
        })
      );
    } else {
      removeLocalStorageElement("elementSyncCurrentTemplate");
    }
    restoreSmartListsOriginalCode();

    // Remove all hover styles
    removeHoverStyles();

    // Remove all active styles
    removeActiveStyles();

    // Remove all sortable styles
    removeSortableStyles();

    const syncElementWarning =
      store.getters["liveEditor/getSyncElementWarning"];
    if (syncElementWarning && syncElementWarning.rejectCallback) {
      syncElementWarning.rejectCallback();
    }

    // Clear elements placeholder
    clearPlaceholder(true);

    // update sections in state first
    updateSectionsInState(false);

    // then save templates in local storage
    if (state.hasAny) {
      setLocalStorageElement(
        "templates",
        JSON.stringify({ templates: state.templates, index: state.index })
      );
    } else {
      removeLocalStorageElement("templates");
    }

    if (state.templatesLinkedToCampaign.length) {
      setLocalStorageElement(
        "templatesLinkedToCampaign",
        JSON.stringify({ templates: state.templatesLinkedToCampaign })
      );
    } else {
      removeLocalStorageElement("templatesLinkedToCampaign");
    }

    if (Object.keys(state.templatesFromFunnel).length) {
      setLocalStorageElement(
        "templatesFromFunnel",
        JSON.stringify(state.templatesFromFunnel)
      );
    } else {
      removeLocalStorageElement("templatesFromFunnel");
    }

    if (Object.keys(state.teaserTemplates).length) {
      setLocalStorageElement(
        "teaserTemplates",
        JSON.stringify(state.teaserTemplates)
      );
    } else {
      removeLocalStorageElement("teaserTemplates");
    }
  } else {
    removeLocalStorageElement("templates");
    removeLocalStorageElement("templatesLinkedToCampaign");
    removeLocalStorageElement("templatesFromFunnel");
    removeLocalStorageElement("teaserTemplates");
    removeLocalStorageElement("elementSyncCurrentTemplate");
  }
};

export const UpdateTemplateColumnInDb = async (
  templatesInput: TemplatesUpdateInputItem[]
) => {
  const { id, err } = await Update<TemplatesUpdateInputItem>({
    name: "Templates",
    input: templatesInput,
    type: "TemplatesUpdateInput"
  });

  if (err === "") {
    templatesInput.forEach(input => {
      if (input.id_template) invalidateTemplateRawCache(input.id_template);
    });
    return id;
  }

  throw new Error(err);
};

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const updateTemplateColumn = async (field: string, data: any) => {
  // Update the current template
  const input: TemplatesUpdateInputItem = {
    id_template: data.id_template,
    id_shop: UserState.activeShop?.id ?? 0,
    [field]: data[field],
    date_modification: moment().format("YYYY-MM-DD HH:mm:ss")
  };

  await UpdateTemplateColumnInDb([input]).catch((err: Error) => {
    showToastError(err.message);
  });
};

export const toggleAdvancedMode = () => {
  state.advancedModeEnabled = !state.advancedModeEnabled;
};

const insertNewTemplateElement = async (
  tmpId: string | null,
  section: Section
): Promise<Maybe<number | null>> => {
  if (!tmpId) {
    return null;
  }

  const inputsElements: TemplatesElementsInputItem[] = [
    {
      id_template: state.template?.id,
      id_shop: UserState.activeShop?.id ?? 0,
      type: "section",
      data: section.data,
      html: section.html,
      css: section.css,
      translations: section.translations,
      date_creation: moment().format("YYYY-MM-DD HH:mm:ss"),
      date_modification: moment().format("YYYY-MM-DD HH:mm:ss")
    }
  ];

  const { id, err } = await Insert<TemplatesElementsInputItem>({
    name: "TemplatesElements",
    input: inputsElements,
    type: "TemplatesElementsInput"
  });

  if (err !== "") {
    await showToastError(err);
    return null;
  }

  return id;
};

export const addNewSectionToState = async (
  clonedElement: HTMLElement,
  customCssTypes: string[] = ["dynamic"],
  replaceSectionId = ""
) => {
  // Update the sections config in the state
  refreshSectionsConfig();

  // Add the new section in state template's sections list
  const newSection: Section = {
    id_template_elements: clonedElement.getAttribute("data-spmelementid") ?? "",
    name: "",
    data: "",
    html: "",
    css: "",
    translations: "",
    type: ""
  };

  if (replaceSectionId && state.template && state.template.sections) {
    state.template.sections = state.template.sections.filter(
      section =>
        section.id_template_elements.toString() !== replaceSectionId.toString()
    );
  }

  addNewSectionInState(newSection);
  updateSectionsInState(false);

  const section = [
    ...(state.template?.sections.filter(
      (current: Section) =>
        current.id_template_elements.toString() ===
        clonedElement.getAttribute("data-spmelementid")
    ) || [])
  ];

  if (section.length) {
    const tmpId = clonedElement.getAttribute("data-spmelementid") ?? null;
    const newId = !replaceSectionId
      ? await insertNewTemplateElement(tmpId, section[0])
      : replaceSectionId;

    if (newId) {
      // Save new ID in HTML and section
      const template = getTemplateIframeDocument();

      if (template) {
        // Change ID of element in HTML
        if (replaceSectionId) {
          const sectionToReplace = template.querySelector(
            `[data-spmelementid="${replaceSectionId}"]`
          ) as HTMLElement;
          if (sectionToReplace) {
            sectionToReplace.remove();
          }
        }
        const sectionHtml = template.querySelector(
          `[data-spmelementid="${tmpId}"]`
        ) as HTMLElement;
        sectionHtml.setAttribute("data-spmelementid", newId.toString());

        // Update the config of the template in the state and mark the section as active
        refreshSectionsConfig();
        setActiveSection(newId);

        // Update the ID of the section in the template's sections config
        const savedSection = state.template?.sections.filter(
          (current: Section) => current.id_template_elements === tmpId
        );

        if (savedSection) {
          savedSection[0].id_template_elements = parseInt(newId.toString(), 10);

          const updateCSSSectionId = (type = "dynamic") => {
            // Update CSS section ID
            if (replaceSectionId) {
              const dynamicStylesheetToReplace = getElementFromIframe(
                `style[data-spm-styles="${type}"][data-spm-section="${replaceSectionId}"]`
              );
              if (dynamicStylesheetToReplace) {
                dynamicStylesheetToReplace.remove();
              }
            }
            const dynamicStylesheet = getElementFromIframe(
              `style[data-spm-styles="${type}"][data-spm-section="${tmpId}"]`
            );
            if (dynamicStylesheet) {
              dynamicStylesheet.setAttribute(
                "data-spm-section",
                newId.toString()
              );
            }
          };

          customCssTypes.forEach(type => {
            updateCSSSectionId(type);
          });

          if (
            replaceSectionId &&
            state.template &&
            state.template.translations
          ) {
            state.template.translations = state.template.translations.filter(
              trans => trans.section.toString() !== replaceSectionId
            );
          }

          // Update section ID in translations
          const translationsOfElement = state.template?.translations.filter(
            (current: Translation) => current.section === tmpId
          );

          if (translationsOfElement) {
            translationsOfElement.forEach((currentTranslation: Translation) => {
              currentTranslation.section = newId.toString();
            });
          }
        }
      }
    }
  }
};

interface GetAllSectionsArgs {
  shopId: number;
  type: string[];
  templateType: string[];
  limit: number;
  offset: number;
  idTemplatePart?: string;
  elementPartType?: string;
  elementSubtype?: string;
  includeAllElementsPartType?: boolean;
  version?: number;
}

export interface LoadElementsPartsWithUsageResponse {
  items: TemplatePart[];
  total: number;
  usageBySyncId: Record<string, number>;
}

export const getTemplatesParts = async ({
  shopId,
  type,
  templateType,
  limit = 0,
  offset = 0,
  idTemplatePart = "",
  elementPartType = "",
  elementSubtype = "",
  includeAllElementsPartType = false,
  version
}: GetAllSectionsArgs): Promise<Array<TemplatePart> | null> => {
  const filter = [
    {
      field: "id_shop",
      operator: OperatorType.Equals,
      value: shopId
    },
    {
      field: "id_template",
      operator: OperatorType.IsNull,
      value: ""
    }
  ];
  if (type.length) {
    filter.push({
      field: "type",
      operator: OperatorType.In,
      value: type.join(",")
    });
  }
  if (idTemplatePart) {
    filter.push({
      field: "id_template_parts",
      operator: OperatorType.Equals,
      value: idTemplatePart
    });
  }
  if (templateType.length) {
    filter.push({
      field: "template_type",
      operator: OperatorType.In,
      value: templateType.join(",")
    });
  }
  if (!elementPartType && !elementSubtype && !includeAllElementsPartType) {
    filter.push({
      field: "json_data.data-spm-element-part-type",
      operator: OperatorType.JsonNotExists,
      value: ""
    });
  }
  if (elementPartType && !includeAllElementsPartType) {
    filter.push({
      field: "json_data.data-spm-element-part-type",
      operator: OperatorType.Equals,
      value: elementPartType
    });
  }
  if (elementSubtype) {
    filter.push({
      field: "json_data.data-spm-element-subtype",
      operator: OperatorType.Equals,
      value: elementSubtype
    });
  }
  if (version) {
    filter.push({
      field: "version",
      operator: OperatorType.Equals,
      value: version
    });
  }
  const { items, err } = await List<TemplatesParts>({
    name: "TemplatesParts",
    settings: {
      filter,
      order: [{ field: "id_template_parts", type: "DESC" }],
      limit,
      offset
    },
    fields: [
      "id_template_parts",
      "type",
      "id_template",
      "name",
      "data",
      "html",
      "css",
      "translations",
      "template_part_hash",
      "part_type",
      "version"
    ]
  });

  if (err === "") {
    return items;
  }

  return null;
};

export const getTemplatesPartsWithUsage = async ({
  shopId,
  type,
  templateType,
  limit = 0,
  offset = 0,
  idTemplatePart = "",
  elementPartType = "",
  elementSubtype = "",
  includeAllElementsPartType = false,
  version
}: GetAllSectionsArgs): Promise<LoadElementsPartsWithUsageResponse | null> => {
  const response = await nestCall(
    "get",
    NestApiType.DEFAULT,
    "/template/load-elements",
    {},
    "",
    undefined,
    true,
    {
      id_shop: shopId,
      types: type.join(","),
      template_type: templateType.join(","),
      limit,
      offset,
      id_template_parts: idTemplatePart || undefined,
      element_part_type: elementPartType || undefined,
      element_subtype: elementSubtype || undefined,
      include_all_elements_part_type: includeAllElementsPartType ? 1 : 0,
      version: version ?? undefined
    }
  );

  if (!response || response.error) {
    return null;
  }

  return {
    items: (response.items || []) as TemplatePart[],
    total: Number(response.total || 0),
    usageBySyncId: (response.usage_by_sync_id || {}) as Record<string, number>
  };
};

export const deleteSavedSection = async (
  section: TemplatePart
): Promise<boolean | string> => {
  // Remove in datatabse
  const templatePartInput: TemplatesPartsUpdateInputItem[] = [
    {
      id_template_parts: section.id_template_parts,
      id_shop: UserState.activeShop?.id ?? 0
    }
  ];

  const update = await Delete<TemplatesPartsUpdateInputItem>({
    name: "TemplatesParts",
    input: templatePartInput,
    type: "TemplatesPartsDeleteInput"
  });

  if (update.err !== "") {
    return update.err;
  }

  return true;
};

export const removeCustomWidgetCss = (selector: string) => {
  const template = getTemplateIframeDocument();
  const selectorQuery = `${CUSTOM_WIDGET_CSS_PREFIX}${selector.replace(
    `#${TEMPLATE_WIDGET_IDENTIFIER_PREFIX}`,
    ""
  )}`;
  const selectors = [selectorQuery, `${selectorQuery}_mobile`];
  if (template) {
    selectors.forEach(sel => {
      const stylesElement = template.querySelectorAll(
        `style[data-spm-styles="${sel}"]`
      );
      stylesElement.forEach(styleElement => {
        const sectionId = styleElement.getAttribute("data-spm-section");
        if (sectionId) {
          const section = state.template?.sections.find(
            s => s.id_template_elements.toString() === sectionId.toString()
          );
          if (section) {
            const sectionCss = JSON.parse(section.css);
            delete sectionCss[sel];
            section.css = JSON.stringify(sectionCss);
          }
        }
        styleElement.remove();
      });
    });
  }
};

// Delete a translation key for each language
const deleteTranslationKey = (
  originalTranslations: Record<string, any>,
  key: string
): Record<string, any> => {
  const newTranslations = { ...originalTranslations };

  Object.keys(newTranslations).forEach(lang => {
    if (Object.prototype.hasOwnProperty.call(newTranslations, lang)) {
      const translations = newTranslations[lang];

      if (Object.prototype.hasOwnProperty.call(translations, key)) {
        delete translations[key];
      }
    }
  });

  return newTranslations;
};

// Remove unused translations from each section of the current template
export const removeUnusedTranslations = (): void => {
  const template = getTemplateIframeDocument();

  // Remove unwanted translations in template
  const unwantedTranslations = Array.from(
    template.querySelectorAll(`table[${TRANSLATION_ATTRIBUTE}-align]`)
  );
  if (unwantedTranslations.length) {
    unwantedTranslations.forEach(translation => {
      translation.removeAttribute(`${TRANSLATION_ATTRIBUTE}-align`);
    });
  }

  if (template && state.template && state.template.sections) {
    const defaultLanguage = getShopDefaultLang();
    let hasChanged = false;

    state.template.sections
      .filter((section: Section) => section.type !== "design")
      .forEach((section: Section) => {
        // For each section, we will check if all translations exist in the HTML code, otherwise we remove the translation
        if (section.translations) {
          let sectionHasChanged = false;
          let translations = JSON.parse(section.translations);

          if (Object.keys(translations).length > 0) {
            const defaultTranslations = translations[defaultLanguage];

            Object.keys(defaultTranslations).forEach((key: string) => {
              // For each translation key, we check if it exists in the HTML code, otherwise we delete the key from the translations
              // Also check in data-prizes attribute for game wheel translations (they use translationKey like "abc123.data-spm-text")
              const existsInHtml = new RegExp(`LANG_${key}`).test(section.html);
              // translationKey in data-prizes is formatted as "key.data-spm-text", so we check if it starts with the key
              const existsInDataPrizes = section.html.includes(
                `${key}.data-spm-text`
              );
              // translationKey in data-symbols/data-win-combinations for slot machine
              const existsInSlotMachine =
                section.html.includes(`${key}.data-spm-slot-symbol`) ||
                section.html.includes(`${key}.data-spm-slot-prize`);
              if (
                !existsInHtml &&
                !existsInDataPrizes &&
                !existsInSlotMachine
              ) {
                translations = deleteTranslationKey(translations, key);
                sectionHasChanged = true;
                hasChanged = true;
              }
            });

            if (sectionHasChanged) {
              // In case we deleted a key, we update the section's translations string
              section.translations = JSON.stringify(translations);
            }
          }
        }
      });

    // Update global template's translations with updated sections
    if (hasChanged) {
      refreshTranslations();
    }
  }
};

/**
 * Detect and fix translations that are stored in the wrong section.
 * For each non-design section, extracts all LANG_ keys from its HTML, then checks
 * if those translations exist in that section's JSON. If a translation
 * is missing but found in another section (e.g. design), it gets moved
 * to the correct section.
 */
export const fixMisplacedTranslations = (): void => {
  if (!state.template) return;

  const defaultLanguage = getShopDefaultLang();
  let hasChanged = false;

  // Build a map: LANG key -> correct section ID (based on HTML content)
  const keyToCorrectSection: Record<string, number> = {};

  // For each non-design section, find all LANG keys in its HTML
  state.template.sections
    .filter((section: Section) => section.type !== "design")
    .forEach((section: Section) => {
      const regExp = /LANG_([a-zA-Z0-9]+)/g;
      let match;
      while ((match = regExp.exec(section.html)) !== null) {
        const key = match[1];
        keyToCorrectSection[key] = Number(section.id_template_elements);
      }
    });

  // Now check all sections (including design) for misplaced translations
  state.template.sections.forEach((section: Section) => {
    if (!section.translations || section.translations === "{}") return;

    let translations: Record<string, Record<string, any>>;
    try {
      translations = JSON.parse(section.translations);
    } catch {
      return;
    }

    if (Object.keys(translations).length === 0) return;

    const sectionId = Number(section.id_template_elements);
    let sectionChanged = false;

    // Check each key in default language
    const defaultTranslations = translations[defaultLanguage];
    if (!defaultTranslations) return;

    const keysToRemove: string[] = [];

    Object.keys(defaultTranslations).forEach((key: string) => {
      const correctSectionId = keyToCorrectSection[key];

      if (correctSectionId !== undefined && correctSectionId !== sectionId) {
        // This translation belongs to another section — need to move it
        const targetSection = state.template?.sections.find(
          (s: Section) => Number(s.id_template_elements) === correctSectionId
        );

        if (targetSection) {
          let targetTranslations: Record<string, Record<string, any>>;
          try {
            targetTranslations = JSON.parse(targetSection.translations || "{}");
          } catch {
            targetTranslations = {};
          }

          // Move the translation for all languages
          Object.keys(translations).forEach((lang: string) => {
            if (!targetTranslations[lang]) {
              targetTranslations[lang] = {};
            }
            if (translations[lang][key] && !targetTranslations[lang][key]) {
              targetTranslations[lang][key] = translations[lang][key];
            }
          });

          targetSection.translations = JSON.stringify(targetTranslations);
          keysToRemove.push(key);
          hasChanged = true;
          sectionChanged = true;
        }
      }
    });

    // Remove moved keys from current section
    if (sectionChanged) {
      keysToRemove.forEach(key => {
        Object.keys(translations).forEach(lang => {
          delete translations[lang][key];
        });
      });
      section.translations = JSON.stringify(translations);
    }
  });

  // Refresh translations in state to reflect the changes
  if (hasChanged) {
    refreshTranslations();
  }
};

export const insertSavedElement = async (
  item: TemplatePart,
  insertSelector: string,
  insertPosition: string,
  addHistory = true,
  replaceSectionId = "",
  fromSyncElement = false
) => {
  // Get dynamic style of section
  const originalCss = item.css ? JSON.parse(item.css) : null;
  let addValueToCss = false;
  let customWidgetCss: Record<string, any> | null = null;
  if (
    originalCss &&
    Object.keys(originalCss).find(key =>
      key.toLowerCase().startsWith(CUSTOM_WIDGET_CSS_PREFIX)
    )
  ) {
    addValueToCss = true;
  }
  if (addValueToCss) {
    if (originalCss) {
      const keys = Object.keys(originalCss).filter(key =>
        key.toLowerCase().startsWith(CUSTOM_WIDGET_CSS_PREFIX)
      );
      keys.forEach(key => {
        if (!customWidgetCss) {
          customWidgetCss = {};
        }
        customWidgetCss[key] = originalCss[key];
      });
    }
  }

  // ✅ OPTIMISATION : Parsing conditionnel des traductions (évite regex coûteuse)
  const elementTranslations = (() => {
    if (!item.translations || item.translations === "") return {};

    try {
      // Essayer d'abord sans regex (cas le plus fréquent)
      return JSON.parse(item.translations);
    } catch {
      // Fallback avec regex seulement si nécessaire
      return JSON.parse(item.translations.replace(/(\r\n|\n|\r)/gm, " "));
    }
  })();

  let syncElementId = "";
  let syncElement: { name: string; syncElementId: string } | null = null;

  if (item.data) {
    const data = JSON.parse(item.data || "{}");
    if (data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]) {
      if (!isTemplateRelatedToCampaignBulk()) {
        syncElementId = data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
      } else {
        // Remove sync element in data
        delete data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
        delete data[TEMPLATE_SYNC_ELEMENT_IDs];
        delete data[TEMPLATE_SYNC_ELEMENT_NAME];

        item.data = JSON.stringify(data);
        // Remove sync element identifier in html
        if (item.html) {
          item.html = item.html.replace(
            /\s*data-spm-element-sync-(name|id)="[^"]*"/g,
            ""
          );

          // Supprimer "spm_sync-element" de la classe sans affecter les autres classes
          item.html = item.html.replace(/\s*spm_sync-element\s*/g, " ");
        }
      }
    }
  }
  if (syncElementId) {
    syncElement = {
      name: item.name ?? "",
      syncElementId
    };
  }

  // ✅ OPTIMISATION : Utiliser DocumentFragment (plus rapide que innerHTML)
  const createHtmlElement = (html: string): HTMLElement => {
    const template = document.createElement("template");
    template.innerHTML = html.trim();
    return template.content.firstElementChild as HTMLElement;
  };

  const htmlElement = createHtmlElement(item.html ?? "");

  const templatePartData = JSON.parse(item.data || "{}");
  if (!templatePartData[TEMPLATE_PART_ELEMENT_PART_TYPE]) {
    // Insert the HTMLELement in the template
    await duplicateElement(
      {
        selector: insertSelector,
        type:
          (item.type as TemplateStructureEnum) ?? TemplateStructureEnum.SECTION
      },
      (item.type as TemplateStructureEnum) ?? TemplateStructureEnum.SECTION,
      htmlElement,
      originalCss,
      insertPosition,
      elementTranslations,
      customWidgetCss,
      syncElement,
      addHistory,
      null,
      replaceSectionId
    );
  } else {
    // Replace css
    const elementPartType = templatePartData[TEMPLATE_PART_ELEMENT_PART_TYPE];
    const template = getTemplateIframeDocument();
    if (elementPartType === ElementPartTypeEnum.STYLES) {
      const element = template.querySelector(`${insertSelector}`);

      // Handle smart list widget
      if (
        getWidgetType(element?.getAttribute("data-widgettype") || "") ===
        WidgetTypeEnum.SMART_PRODUCT_LIST
      ) {
        const itemData: ActiveLiveEditorItemData = {
          selector: `#${element?.id}`,
          type: TemplateStructureEnum.WIDGET
        };

        let refreshConfigPanel = true;

        let syncElementData: {
          name: string;
          syncElementId: string;
          elementPartType?: ElementPartTypeEnum;
        } | null = null;
        if (fromSyncElement) {
          if (
            element &&
            element.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
            element.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
          ) {
            syncElementData = {
              name: element.getAttribute(TEMPLATE_SYNC_ELEMENT_NAME) || "",
              syncElementId:
                element.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) || "",
              elementPartType: element.getAttribute(
                TEMPLATE_PART_ELEMENT_PART_TYPE
              ) as ElementPartTypeEnum
            };
            refreshConfigPanel = false;
          } else if (
            element &&
            !element.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
            templatePartData[TEMPLATE_PART_ELEMENT_PART_TYPE] &&
            templatePartData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]
          ) {
            syncElementData = {
              name: item.name || "",
              syncElementId: templatePartData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER],
              elementPartType: templatePartData[
                TEMPLATE_PART_ELEMENT_PART_TYPE
              ] as ElementPartTypeEnum
            };
            refreshConfigPanel = false;
          }
        } else if (
          !fromSyncElement &&
          templatePartData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]
        ) {
          syncElementData = {
            name: item.name || "",
            syncElementId: templatePartData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER],
            elementPartType: templatePartData[
              TEMPLATE_PART_ELEMENT_PART_TYPE
            ] as ElementPartTypeEnum
          };
        }

        const newElementId = await duplicateElement(
          itemData,
          itemData.type,
          htmlElement,
          originalCss,
          "bottom",
          elementTranslations,
          null,
          syncElementData,
          false,
          `#${element?.id}`,
          element?.getAttribute("data-spmelementid") || "",
          true
        );

        let addElementPartIdentifier = "";
        if (element) {
          const parentSection = getSectionParent(element as HTMLElement);
          if (
            parentSection &&
            parentSection.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
            !parentSection.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) &&
            (syncElementData !== null ||
              (syncElementData === null &&
                templatePartData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]))
          ) {
            addElementPartIdentifier =
              element.getAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER) ||
              generateUniqStructureId();
          }
        }
        // eslint-disable-next-line no-unused-expressions
        element?.remove();
        removeCustomWidgetCss(`#${element?.id}`);

        await nextTick();

        cleanupDynamicStyle();
        removeActiveItemElementDecorations();
        updateSectionsInState(false);
        removeUnusedTranslations();
        refreshSectionsConfig();
        resetListeners();
        store.commit("liveEditor/resetSelectedStructure");

        // Refresh configuration panel (refresh selected sync element and selected structure)
        if (fromSyncElement && refreshConfigPanel) {
          const currentSelectedSyncElement =
            store.getters["liveEditor/getSelectedSyncElement"];
          const elementType = TemplateStructureEnum.WIDGET;
          store.commit("liveEditor/setSelectedSyncElement", null);

          const selectedSyncElementData: SelectedSyncElement = {
            elementId: newElementId,
            elementType,
            elementName: currentSelectedSyncElement.elementName,
            initialState: null,
            structureConfiguration: getElementStructureConfig(
              newElementId || "",
              elementType
            ),
            syncElementId: currentSelectedSyncElement.syncElementId
          };
          store.commit(
            "liveEditor/setSelectedSyncElement",
            selectedSyncElementData
          );
        }

        store.dispatch("liveEditor/prepareStructureConfiguration", {
          type: TemplateStructureEnum.WIDGET,
          identifier: newElementId,
          widgetType: WidgetTypeEnum.SMART_PRODUCT_LIST
        });

        // Check if inside synced section and apply identifier
        if (isEmailTemplate(TemplateEditorState.template?.type)) {
          const newElement = getElementFromIframe(`#${newElementId}`);
          if (addElementPartIdentifier) {
            newElement.setAttribute(
              TEMPLATE_PART_ELEMENT_IDENTIFIER,
              addElementPartIdentifier
            );
          } else {
            newElement.removeAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER);
          }
        }
      } else {
        const data = JSON.parse(item.data || "{}");
        let itemName = item.name || "";
        // Manage sync element data
        if (fromSyncElement) {
          if (
            element &&
            element.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
            element.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
          ) {
            data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] = element.getAttribute(
              TEMPLATE_SYNC_ELEMENT_IDENTIFIER
            );
            data[TEMPLATE_SYNC_ELEMENT_NAME] = element.getAttribute(
              TEMPLATE_SYNC_ELEMENT_NAME
            );
            itemName = element.getAttribute(TEMPLATE_SYNC_ELEMENT_NAME) || "";
          } else {
            delete data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
            delete data[TEMPLATE_SYNC_ELEMENT_IDs];
            delete data[TEMPLATE_SYNC_ELEMENT_NAME];
          }
          item.data = JSON.stringify(data);
        }

        let parentSectionId = null;
        if (
          item.type === TemplateStructureEnum.SECTION ||
          item.type === TemplateStructureEnum.EMPTY_SECTION
        ) {
          parentSectionId = element?.getAttribute("data-spmelementid") ?? "";
        } else {
          let sectionClass = `.${TEMPLATE_SECTION_CLASS}`;
          if (isDisplayTemplate(TemplateEditorState.template?.type)) {
            sectionClass = "#spm_body";
          }
          const closestSection = element?.closest(sectionClass);
          parentSectionId =
            closestSection?.getAttribute("data-spmelementid") ?? "";
        }

        if (parentSectionId && element) {
          const elementId = element.id;
          const structureConfigurationData: Record<string, any> = {
            type: item.type,
            identifier: elementId
          };
          if (element.getAttribute("data-widgettype")) {
            structureConfigurationData.widgetType = getWidgetType(
              element.getAttribute("data-widgettype")
            );

            // Apply additional styles
            applyStylesAdditionnalConfig(
              htmlElement,
              element as HTMLElement,
              getTemplateParentTypeByType(state.template?.type),
              element.getAttribute("data-widgettype") || ""
            );
          }

          // Apply css
          removeElementStyle(insertSelector);
          duplicateCssOfElement(
            parentSectionId,
            htmlElement.id,
            elementId,
            null,
            originalCss
          );
          // Apply class based styles
          applyClassBasedStyles(htmlElement, element as HTMLElement);

          // Manage responsive display stack (rtl, ltr)
          if (item.type === TemplateStructureEnum.SECTION) {
            if (!htmlElement.classList.contains("spm_responsive")) {
              element.classList.remove("spm_responsive");
              const rows = Array.from(element.querySelectorAll(".row"));
              rows.forEach(row => {
                row.classList.remove("spm_responsive");
                Array.from(element.querySelectorAll(".spm_responsive")).forEach(
                  child => {
                    (child as HTMLElement).classList.remove("spm_responsive");
                  }
                );
              });
            }
            const column = htmlElement?.querySelector(".columns");
            if (column) {
              const direction =
                column.getAttribute("dir") || ResponsiveDisplayStackEnum.LTR;
              const elementColumns = Array.from(
                element.querySelectorAll(".columns")
              );
              elementColumns.forEach(elementColumn => {
                reorderColumn(elementColumn, direction);
              });
            }
          }

          // Check if the new item is not sync and if there was an old sync item
          if (
            !data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] &&
            element.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE)
          ) {
            element.removeAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER);
            element.removeAttribute(TEMPLATE_SYNC_ELEMENT_NAME);
            element.removeAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER);
          }
          // Remove part type attribute first
          element.removeAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE);

          // Add sync class and sync id if item is sync
          if (data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]) {
            element.setAttribute(
              TEMPLATE_SYNC_ELEMENT_IDENTIFIER,
              data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]
            );
            element.setAttribute(TEMPLATE_SYNC_ELEMENT_NAME, itemName);
            element.setAttribute(
              TEMPLATE_PART_ELEMENT_PART_TYPE,
              elementPartType
            );
          }

          updateSectionsInState(false);
          store.commit("liveEditor/resetSelectedStructure");
          store.dispatch(
            "liveEditor/prepareStructureConfiguration",
            structureConfigurationData
          );
          await nextTick();
          store.commit("liveEditor/refreshConfigurationPanelKey");

          // Refresh action buttons to update save button visibility based on sync status
          if (element && data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]) {
            removeItemElementDecorations(element as HTMLElement);
            addItemElementDecorations(
              element as HTMLElement,
              item.type as TemplateStructureEnum
            );
          }

          // Check if inside synced section and apply identifier
          if (
            isEmailTemplate(TemplateEditorState.template?.type) &&
            data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] &&
            elementPartType === ElementPartTypeEnum.STYLES
          ) {
            const newElement = getElementFromIframe(`#${elementId}`);
            const parentSection = getSectionParent(newElement);
            if (
              parentSection &&
              parentSection.hasAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) &&
              !parentSection.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) &&
              !newElement.hasAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER)
            ) {
              newElement.setAttribute(
                TEMPLATE_PART_ELEMENT_IDENTIFIER,
                generateUniqStructureId()
              );
            }
          }
        }
      }
    }
  }

  markTemplateAsEdited();
};

/**
 * Insert new template part in database
 * @param inputParts
 */
const insertNewTemplatePart = async (
  inputParts: TemplatesPartsInputItem[]
): Promise<Maybe<number | null>> => {
  if (!inputParts.length) {
    return null;
  }

  const insert = await Insert<TemplatesPartsInputItem>({
    name: "TemplatesParts",
    input: inputParts,
    type: "TemplatesPartsInput"
  });

  if (insert.err !== "") {
    await showToastError(insert.err);
    return null;
  }

  return insert.id;
};

/**
 * Update template part in database
 * @param inputParts
 */
const updateTemplatePart = async (
  inputParts: TemplatesPartsUpdateInputItem[]
): Promise<Maybe<number | null>> => {
  if (!inputParts.length) {
    return null;
  }

  const update = await Update<TemplatesPartsUpdateInputItem>({
    name: "TemplatesParts",
    input: inputParts,
    type: "TemplatesPartsUpdateInput"
  });

  if (update.err !== "") {
    return null;
  }

  return update.id;
};

/**
 * Duplicate template part in database
 * @param inputParts
 */
const duplicateTemplatePart = async (parts: any): Promise<any> => {
  const update = await CustomMutation<any>({
    name: "DuplicateTemplatesParts",
    input: parts,
    type: "TemplatesPartsDuplicateInput"
  });

  if (update.err !== "") {
    await showToastError(update.err);
    return null;
  }

  return update;
};

/**
 * Duplicate template part in database
 * @param inputParts
 */
const duplicateTemplateFunnels = async (parts: any): Promise<any> => {
  const update = await CustomMutation<any>({
    name: "DuplicateTemplateFunnels",
    input: parts,
    type: "DuplicateTemplateFunnelsInput"
  });

  if (update.err !== "") {
    await showToastError(update.err);
    return null;
  }

  return update;
};

/**
 * Calculate part hash based on html, css and translations
 * @param html
 * @param css
 * @param translations
 */
export const calculatePartHash = (
  html: string,
  css: string,
  translations: string
): string => {
  // On récupère l'intégralité des ID à remplacer
  const ids = [...html.matchAll(new RegExp('id="(spm_.*?[0-9]+.*?)"', "g"))];

  if (ids) {
    ids.reverse();

    let i = 1;
    // Loop on each translation key to generate a new one and store in the state
    ids.forEach(id => {
      const newId = id[1].replace(new RegExp("[0-9]+"), i.toString());
      html = html.replace(id[1], newId);
      css = css.replace(id[1], newId);
      i += 1;
    });
  }

  return Md5.hashStr(`${html}${css}${translations}`);
};

/**
 * Check if a part already exists with the same name. In that case, return its ID
 * @param type
 * @param name
 * @param selector
 */
export const checkIfPartExistsWithSameName = async (
  type: string,
  name: string,
  selector: string,
  returnObject = false
): Promise<Maybe<any>> => {
  const parts = await List<TemplatesParts>({
    name: "TemplatesParts",
    settings: {
      filter: [
        {
          field: "id_shop",
          operator: OperatorType.Equals,
          value: UserState.activeShop?.id ?? 0
        },
        {
          field: "type",
          operator: OperatorType.Equals,
          value: type
        },
        {
          field: "template_type",
          operator: OperatorType.Equals,
          value: getTemplateParentTypeByType(TemplateEditorState.template?.type)
        },
        {
          field: "name",
          operator: OperatorType.Equals,
          value: name
        }
      ],
      order: [{ field: "id_template_parts", type: "ASC" }],
      limit: 1,
      offset: 0
    },
    fields: [
      "id_template_parts",
      "type",
      "id_template",
      "name",
      "data",
      "html",
      "css",
      "translations"
    ]
  });

  if (parts.err !== "") {
    return parts.err;
  }

  let returnValue = null;

  if (parts.items.length > 0) {
    // We check if the template linked to the part if different from the current template
    if (
      parts.items[0].id_template &&
      parts.items[0].id_template > 0 &&
      parts.items[0].id_template !== state.template?.id
    ) {
      // Then, we check if the part to save contains a part ID in the HTML code
      const activeStructure = getElementFromIframe(selector);

      if (activeStructure && selector) {
        sanitizeSection(activeStructure);

        // We check if the current section contains a part ID
        const partHtml = activeStructure.outerHTML;
        const regExpIdPart = new RegExp('id="spm_section_([a-zA-Z0-9]*)"');
        const matches = regExpIdPart.exec(partHtml);

        if (matches && matches.length) {
          // If true, we get the template linked to the part from the database
          const template = await Get<Templates>({
            name: "Templates",
            id: parts.items[0].id_template,
            keyName: "id_template",
            fields: ["id_template_reference"]
          });

          if (template.item) {
            // We get the part ID linked to the reference template
            const htmlId = `spm_section_${matches[1]}`;
            const filters = [
              {
                field: "id_shop",
                operator: OperatorType.Equals,
                value: UserState.activeShop?.id ?? 0
              },
              {
                field: "type",
                operator: OperatorType.Equals,
                value: type
              },
              {
                field: "template_type",
                operator: OperatorType.Equals,
                value: getTemplateParentTypeByType(
                  TemplateEditorState.template?.type
                )
              },
              {
                field: "html",
                operator: OperatorType.Like,
                value: `%id="${htmlId}"%`
              }
            ];

            if (template.item.id_template_reference) {
              filters.push({
                field: "id_template",
                operator: OperatorType.Equals,
                value: template.item.id_template_reference
              });
            }

            const referencePart = await List<TemplatesParts>({
              name: "TemplatesParts",
              settings: {
                filter: filters,
                order: [{ field: "id_template_parts", type: "ASC" }],
                limit: 1,
                offset: 0
              },
              fields: ["id_template_parts"]
            });

            if (referencePart.items && referencePart.items.length) {
              // If we found an ID, we use that ID for erasing
              returnValue = referencePart.items[0].id_template_parts;
            }
          }
        }
      }
    }

    // Otherwise, we erase the current part
    returnValue = parts.items[0].id_template_parts;
    if (returnObject) {
      // eslint-disable-next-line prefer-destructuring
      returnValue = parts.items[0];
    }
  }

  return returnValue;
};

/**
 * Check if a part already exists with the same name. In that case, return its ID
 * @param type
 * @param name
 * @param selector
 */
export const getTemplatePartsById = async (id: number): Promise<Maybe<any>> => {
  const parts = await List<TemplatesParts>({
    name: "TemplatesParts",
    settings: {
      filter: [
        {
          field: "id_shop",
          operator: OperatorType.Equals,
          value: UserState.activeShop?.id ?? 0
        },
        {
          field: "id_template_parts",
          operator: OperatorType.Equals,
          value: id
        }
      ],
      order: [{ field: "id_template_parts", type: "ASC" }],
      limit: 1,
      offset: 0
    },
    fields: [
      "id_template_parts",
      "type",
      "id_template",
      "name",
      "data",
      "html",
      "css",
      "translations"
    ]
  });

  if (parts.err !== "") {
    return parts.err;
  }

  if (parts.items.length > 0) {
    return parts.items[0];
  }

  return null;
};

export const getTemplatePartsBySyncElementIds = async (
  idShop: number,
  syncElementIds: Array<string>
) => {
  const query = `query ( $id_shop: Int!, $sync_element_ids: String! ) {
    TemplatePartsBySyncElementIds(id_shop: $id_shop, sync_element_ids: $sync_element_ids)
      {
        items {
          id_template_parts
          id_template
          type
          name
          data
          html
          css
          translations
          template_part_hash
          part_type
        }
        total
      }
    }`;

  const variables = {
    id_shop: idShop,
    sync_element_ids: Array.from(syncElementIds).join(",")
  };

  const { data, err } = await Request<ListResponse<TemplatesParts>>({
    name: "TemplatePartsBySyncElementIds",
    query,
    variables
  });

  const result: ListResponse<TemplatesParts> = data ?? {
    items: [],
    total: 0,
    err
  };

  return result;
};

const savePart = async (
  element: {
    type: any;
    data: any;
    html: any;
    css: any;
    translations: any;
    hash: any;
  },
  type: string,
  name: string,
  eraseId: Maybe<number> = null,
  options: {
    shouldDuplicateRedirects?: boolean;
  } = {}
) => {
  const idShop = UserState.activeShop?.id ?? 0;
  const cleanedHtml = element.html.replace(/spm_active_element/g, "");
  const templateId = asInt(TemplateEditorState.template?.id ?? 0);
  const rootTemplateId = asInt(
    TemplateEditorState.template?.originTemplateId || templateId
  );

  const response = await nestCall(
    "post",
    NestApiType.DEFAULT,
    "/template/save-part",
    {},
    "",
    {
      idShop,
      idTemplate: templateId || undefined,
      type,
      templateType: getTemplateParentTypeByType(
        TemplateEditorState.template?.type
      ),
      partType: element.type || null,
      name,
      eraseId: eraseId || undefined,
      data: element.data || null,
      html: cleanedHtml,
      css: element.css || null,
      translations: element.translations || null,
      hash: element.hash || null,
      originTemplateId: templateId || undefined,
      rootTemplateId: rootTemplateId || undefined,
      version: TemplateEditorState.template?.version ?? undefined,
      shouldDuplicateRedirects: options.shouldDuplicateRedirects !== false
    },
    true
  );
  if (!response || !response.success || !response.data?.id_template_parts) {
    throw new Error(response?.message || "");
  }

  const templatePartId = asInt(response.data.id_template_parts);
  const newSection = response.data.newSection || {
    id_template_parts: templatePartId,
    id_shop: idShop,
    name,
    type,
    data: element.data ? JSON.stringify(element.data) : null,
    html: cleanedHtml,
    css: element.css,
    translations: element.translations,
    template_part_hash: element.hash
  };

  if (eraseId) {
    try {
      if (!state.sectionsToRefresh.find(itemId => itemId === eraseId)) {
        state.sectionsToRefresh.push(eraseId);
      }
      await axios.get(
        MEDIA_URL_PART_RELOAD_CACHE.replace(
          "{ID_SHOP}",
          String(idShop)
        ).replace("{SHA1_KEY}", generateSha1HashWithSalt(eraseId, "salt-"))
      );
    } catch (err) {
      // No need to continue
    }
  }

  return {
    newSectionId: templatePartId.toString(),
    newSection
  };
};

export const saveElementInDatabase = async (
  selector: string,
  type: string,
  name: string,
  isSync: boolean,
  syncId: string,
  elementPartType: ElementPartTypeEnum | null = null,
  eraseId: Maybe<number> = null
) => {
  const template = getTemplateIframeDocument();

  // Get part element and sanitize (remove useless elements)
  const activeStructure = getElementFromIframe(selector);
  if (!activeStructure) {
    throw new Error("active_structure_not_found");
  }
  sanitizeSection(activeStructure);

  const elementId = activeStructure.getAttribute("id");
  let sectionId: any = null;
  if (type === TemplateStructureEnum.SECTION) {
    // Get part ID
    sectionId = activeStructure.getAttribute("data-spmelementid");
  } else if (type === TemplateStructureEnum.WIDGET) {
    let sectionClass = TEMPLATE_SECTION_CLASS;
    if (isDisplayTemplate(state.template?.type)) {
      sectionClass = "spm_display";
    }
    const section = activeStructure.closest(`.${sectionClass}`);
    if (section) {
      sectionId = section.getAttribute("data-spmelementid");
    }
  }

  const oldSectionId = sectionId;

  const sectionCss = template.querySelectorAll(
    `style[data-spm-section="${sectionId}"]`
  );

  let partCss: Maybe<string> = "";
  if (type === TemplateStructureEnum.SECTION) {
    partCss = formatStylesForSection(Array.from(sectionCss));
  } else if (type === TemplateStructureEnum.WIDGET) {
    // Extract widget css
    const widgetCss: Record<string, string> = {};
    Array.from(sectionCss).forEach(css => {
      const styleType = css.getAttribute("data-spm-styles");
      if (styleType) {
        const elementCss = getCssOfElement(elementId ?? "", styleType);
        if (elementCss) {
          widgetCss[styleType] = elementCss;
        }
      }
    });
    partCss = JSON.stringify(widgetCss);
  }

  // Get part data
  if (Object.keys(JSON.parse(partCss || "{}")).length === 0) {
    partCss = null;
  }

  const translationIds = getTranslationIdsFromElement(activeStructure);

  let partTranslations: Maybe<string> = formatTranslationsForSection(
    state.template?.translations.filter((translation: Translation) =>
      translationIds.includes(translation.key)
    ) ?? []
  );

  if (Object.keys(partTranslations).length === 0) {
    partTranslations = null;
  }

  let partData: Maybe<{ [key: string]: any }> = {};

  if (activeStructure.hasAttribute("data-spm_element_sync")) {
    partData["data-spm_element_sync"] =
      activeStructure.getAttribute("data-spm_element_sync") ?? "";
  }

  let partType = null;
  if (activeStructure.hasAttribute("data-spm_section_type")) {
    partData["data-spm_section_type"] =
      activeStructure.getAttribute("data-spm_section_type") ?? "";
    partType = activeStructure.getAttribute("data-spm_section_type") ?? "";
  }

  if (isSync) {
    partData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] = syncId;
  } else {
    activeStructure.removeAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE);
    activeStructure.removeAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER);
    activeStructure.removeAttribute(TEMPLATE_SYNC_ELEMENT_NAME);
  }

  const syncWidgets = activeStructure.querySelectorAll(
    `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`
  );
  const syncWidgetsId = Array.from(syncWidgets).map(element =>
    element.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
  );
  if (syncWidgetsId && syncWidgetsId.length) {
    partData[TEMPLATE_SYNC_ELEMENT_IDs] = syncWidgetsId;
  } else {
    delete partData[TEMPLATE_SYNC_ELEMENT_IDs];
  }

  if (elementPartType) {
    partData[TEMPLATE_PART_ELEMENT_PART_TYPE] = elementPartType;
    if (activeStructure.hasAttribute("data-widgettype")) {
      partData[TEMPLATE_PART_ELEMENT_SUBTYPE] =
        activeStructure.getAttribute("data-widgettype") ?? "";
    }
  }

  // Get forms data
  if (isDisplayTemplate(state.template?.type)) {
    updateFormsInState();
    const widgetFormIds = [];
    if (
      type === TemplateStructureEnum.WIDGET &&
      activeStructure.classList.contains("spm_widget_form")
    ) {
      widgetFormIds.push(activeStructure.id);
    }

    widgetFormIds.forEach(widgetForm => {
      const formOption = state.template?.configuration.forms[widgetForm];
      if (formOption && partData) {
        partData.forms = formOption;
      }
    });
  }

  if (Object.keys(partData).length === 0) {
    partData = null;
  }

  // Remove attributes for hash calculation
  activeStructure.setAttribute("data-spm_element_hash", "");
  activeStructure.removeAttribute("data-spmelementid");

  // Part hash calculation
  const partHash = calculatePartHash(
    activeStructure.outerHTML,
    partCss ?? "",
    partTranslations ?? ""
  );

  // Set hash and elementid attributes
  activeStructure.setAttribute("data-spm_element_hash", partHash);
  if (type === TemplateStructureEnum.SECTION) {
    activeStructure.setAttribute("data-spmelementid", oldSectionId ?? "");
  }

  // Get part HTML, CSS and translations
  const partHtml = restoreCountdownTokensInHtml(
    replaceTranslationsByKey(
      activeStructure.outerHTML,
      state.template?.translations ?? []
    )
  );

  const { newSection } = await savePart(
    {
      type: partType,
      data: partData,
      html: partHtml,
      css: partCss,
      translations: partTranslations,
      hash: partHash
    },
    type,
    name,
    eraseId,
    {
      // Never duplicate redirects for style-only saves or synced elements.
      shouldDuplicateRedirects:
        !isSync && elementPartType !== ElementPartTypeEnum.STYLES
    }
  );
  return {
    newSection,
    partData,
    partHtml,
    partCss,
    partTranslations,
    partHash
  };
};

/**
 * Save a new template part in database
 * @param type
 * @param name
 * @param selector
 * @param eraseId
 */
export const savePartInDatabase = async (
  idShop: number,
  type: string,
  name: string,
  selector: string,
  eraseId: Maybe<number> = null,
  isSync = false,
  existingSyncId = "",
  elementPartType: ElementPartTypeEnum | null = null
  // eslint-disable-next-line consistent-return
) => {
  const template = getTemplateIframeDocument();

  const syncId = existingSyncId || generateUniqStructureId();

  if (type === TemplateStructureEnum.DESIGN) {
    updateSectionsInState(false);
    const selectedStructure = store.getters["liveEditor/getSelectedStructure"];
    const activeStructure = isEmailTemplate(state.template?.type)
      ? template.body
      : getElementFromIframe(`#${selectedStructure.identifier}`);
    const sectionId = activeStructure.getAttribute("data-spmelementid");
    if (sectionId) {
      const design = state.template?.sections.find(
        item => item.id_template_elements.toString() === sectionId.toString()
      );
      if (design) {
        let data = JSON.parse(design.data || "{}");
        if (isDisplayTemplate(state.template?.type)) {
          data = {};
        }
        if (isSync) {
          data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] = syncId;
          data[TEMPLATE_SYNC_ELEMENT_NAME] = name;
        }

        const html = isDisplayTemplate(state.template?.type) ? "" : design.html;
        const translations = isDisplayTemplate(state.template?.type)
          ? ""
          : design.translations;

        let { css } = design;
        // Remove widgets, row, columns css if the template is a display
        if (isDisplayTemplate(state.template?.type)) {
          css = css.replace(
            /([^{}]*#spm_(?:widget|column|row)_[a-zA-Z0-9]+[^{]*{[^}]*})/gm,
            ""
          );
          // Add custom data
          const customDataDefinitions =
            customDataDisplay[type][
              getTemplateParentTypeByType(state.template?.type)
            ] || [];
          const customDatas = [];
          const $designHtml = cheerio.load(design.html);
          // eslint-disable-next-line no-restricted-syntax
          for (const customDataDefinition of customDataDefinitions) {
            const selectedElement = $designHtml("body").find(
              customDataDefinition.selector
            );
            if (selectedElement) {
              const selectedElementClasses =
                selectedElement.attr("class")?.split(" ") || [];
              const matchingClasses = selectedElementClasses.filter(cls =>
                customDataDefinition.classes.includes(cls)
              );

              const matchingAttributes = customDataDefinition.attributes
                .map(attrName => {
                  const attrValue = selectedElement.attr(attrName);
                  return attrValue !== undefined
                    ? { attribute: attrName, value: attrValue }
                    : null;
                })
                .filter(attr => attr !== null);

              customDatas.push({
                selector: customDataDefinition.selector,
                classes: matchingClasses,
                attributes: matchingAttributes
              });
            }
          }
          if (customDatas.length) {
            data.specificCssRules = customDatas;
          } else {
            delete data.specificCssRules;
          }
        }

        const hash = calculatePartHash(html, css, translations);

        const { newSection } = await savePart(
          {
            type,
            data,
            html,
            css,
            translations,
            hash
          },
          type,
          name,
          eraseId,
          {
            // Design save should not duplicate redirects for synced elements.
            shouldDuplicateRedirects: !isSync
          }
        );

        const templateState = state.template;

        if (templateState) {
          refreshSectionsConfig();
          updateSectionsInState(false);
          refreshSmartProductList();
          await refreshSmartProductList();

          const returnValue: Record<string, any> = {
            newSection,
            syncId: null,
            newPart: {
              html,
              css: design.css,
              translations,
              data: JSON.stringify(data),
              hash,
              type,
              name
            }
          };

          if (isSync) {
            returnValue.syncId = syncId;
          }

          return returnValue;
        }
      }
    }
  } else if (type !== TemplateStructureEnum.DESIGN && template) {
    // First, we need to reset the smart products lists original codes (to duplicate the real HTML code)
    restoreSmartListsOriginalCode();

    const isGameStyleOnlySave =
      type === TemplateStructureEnum.WIDGET
      && elementPartType === ElementPartTypeEnum.STYLES;

    if (!isGameStyleOnlySave) {
      await createGamePrizeTemplates(true);
    }

    let html = "";
    let css: any = "";
    let translations: any = "";
    let data = "{}";
    let hash = "";
    let section: any = null;

    if (isSync && !elementPartType && type === TemplateStructureEnum.SECTION) {
      // We need to save sync widgets first
      const activeStructure = getElementFromIframe(selector);
      sanitizeSection(activeStructure);

      const syncStylesWidgets = activeStructure.querySelectorAll(
        `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}][${TEMPLATE_PART_ELEMENT_PART_TYPE}="styles"]`
      );
      // eslint-disable-next-line no-restricted-syntax
      for (const styleWidget of syncStylesWidgets) {
        if (!styleWidget.hasAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER)) {
          styleWidget.setAttribute(
            TEMPLATE_PART_ELEMENT_IDENTIFIER,
            generateUniqStructureId()
          );
        }
      }

      const syncWidgets = activeStructure.querySelectorAll(
        `[data-widgettype][${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`
      );
      // eslint-disable-next-line no-restricted-syntax
      for (const syncWidget of syncWidgets) {
        const syncWidgetSelector = `#${syncWidget.id}`;
        const syncWidgetName =
          syncWidget.getAttribute(TEMPLATE_SYNC_ELEMENT_NAME) || "";
        const syncWidgetId =
          syncWidget.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) || "";
        const syncWigetPartType =
          (syncWidget.getAttribute(
            TEMPLATE_PART_ELEMENT_PART_TYPE
          ) as ElementPartTypeEnum) || null;
        // eslint-disable-next-line no-await-in-loop
        const syncWidgetTemplatePart = await getTemplatePartsBySyncElementIds(
          idShop,
          [syncWidgetId]
        );
        // eslint-disable-next-line no-await-in-loop
        if (
          syncWidgetTemplatePart &&
          syncWidgetTemplatePart.items &&
          syncWidgetTemplatePart.items.length
        ) {
          // eslint-disable-next-line no-await-in-loop
          await saveElementInDatabase(
            syncWidgetSelector,
            TemplateStructureEnum.WIDGET,
            syncWidgetName,
            true,
            syncWidgetId,
            syncWigetPartType,
            asInt(syncWidgetTemplatePart.items[0].id_template_parts)
          );
        }
      }

      const {
        newSection,
        partData,
        partHtml,
        partCss,
        partTranslations,
        partHash
      } = await saveElementInDatabase(
        selector,
        type,
        name,
        isSync,
        syncId,
        elementPartType,
        eraseId
      );
      html = partHtml;
      css = partCss;
      translations = partTranslations;
      data = JSON.stringify(partData);
      hash = partHash;
      section = newSection;
    } else {
      const {
        newSection,
        partData,
        partHtml,
        partCss,
        partTranslations,
        partHash
      } = await saveElementInDatabase(
        selector,
        type,
        name,
        isSync,
        syncId,
        elementPartType,
        eraseId
      );
      html = partHtml;
      css = partCss;
      translations = partTranslations;
      data = JSON.stringify(partData);
      hash = partHash;
      section = newSection;
    }

    const templateState = state.template;

    if (templateState) {
      refreshSectionsConfig();
      updateSectionsInState(false);
      refreshSmartProductList();
      await refreshSmartProductList();

      const returnValue: Record<string, any> = {
        newSection: section,
        syncId: null,
        newPart: {
          html,
          css,
          translations,
          data,
          hash,
          type,
          name
        }
      };

      if (isSync) {
        returnValue.syncId = syncId;
      }

      return returnValue;
    }
  }
};

/**
 * Save a new template part in database
 * @param item
 * @param newName
 * @param eraseId
 */
// eslint-disable-next-line consistent-return
export const duplicatePartInDatabase = async (
  item: TemplatePart,
  newName: string,
  eraseId: Maybe<number> = null
) => {
  const duplicatePartsInput: Record<string, any> = {
    id_template_parts: item.id_template_parts,
    id_shop: UserState.activeShop?.id ?? 0,
    name: newName,
    erase_id: eraseId
  };

  const templateParts = await duplicateTemplatePart(duplicatePartsInput);
  if (templateParts && templateParts.id) {
    const templateType = TemplateEditorState.template?.type
      ? [TemplateEditorState.template?.type]
      : [];
    const newTemplatePart = await getTemplatesParts({
      shopId: UserState.activeShop?.id ?? 0,
      type: [],
      templateType,
      limit: 0,
      offset: 0,
      idTemplatePart: templateParts.id,
      version: TemplateEditorState.template?.version
    });

    if (newTemplatePart && newTemplatePart.length) {
      return {
        newSectionId: newTemplatePart[0].id_template_parts,
        newSection: newTemplatePart[0]
      };
    }
  }
  return null;
};

export const duplicateTemplateFunnelsInDatabase = async (
  idTemplate: number,
  newOriginTemplateId: number,
  newRootTemplateId: number
) => {
  const response = await nestCall(
    "post",
    NestApiType.DEFAULT,
    "/template/duplicate-funnels",
    {},
    "",
    {
      idShop: UserState.activeShop?.id ?? 0,
      idTemplate,
      newOriginTemplateId,
      newRootTemplateId,
    }
  );

  if (response && response.id) {
    return response.id;
  }
  return null;
};

/**
 * Duplicate funnel-backed prize templates referenced in saved part HTML and rewrite
 * data-prizes / data-win-combinations JSON (supports numeric or base64 templateId).
 */
export const duplicateGamePrizeTemplateIdsInSavedPartHtml = async (
  html: string,
  newOriginTemplateId: number,
  newRootTemplateId: number
): Promise<string> => {
  if (!html) return html;
  const attrPattern = /data-(prizes|win-combinations)="([^"]*)"/g;
  const matches = [...html.matchAll(attrPattern)];
  if (matches.length === 0) return html;

  type ParsedSlot = { match: RegExpMatchArray; arr: any[] };
  const parsedSlots: ParsedSlot[] = [];
  const allOldIds = new Set<number>();

  for (const match of matches) {
    const decodedJson = match[2].replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    let arr: any[];
    try {
      const parsed = JSON.parse(decodedJson);
      if (!Array.isArray(parsed)) continue;
      arr = parsed;
    } catch {
      continue;
    }
    for (const item of arr) {
      if (item?.templateId != null) {
        const n = decodeGamePrizeTemplateIdFromRaw(item.templateId);
        if (n) allOldIds.add(n);
      }
    }
    parsedSlots.push({ match, arr });
  }

  if (allOldIds.size === 0) return html;

  const idMap = new Map<number, number>();
  for (const oldId of allOldIds) {
    // eslint-disable-next-line no-await-in-loop
    const newId = await duplicateTemplateFunnelsInDatabase(
      oldId,
      newOriginTemplateId,
      newRootTemplateId
    );
    if (newId) idMap.set(oldId, newId);
  }

  let out = html;
  const sortedSlots = [...parsedSlots].sort(
    (a, b) => (b.match.index ?? 0) - (a.match.index ?? 0)
  );
  for (const { match, arr } of sortedSlots) {
    for (const item of arr) {
      if (item?.templateId != null) {
        const oldId = decodeGamePrizeTemplateIdFromRaw(item.templateId);
        if (oldId && idMap.has(oldId)) {
          item.templateId = btoa(String(idMap.get(oldId)));
        }
      }
    }
    const attrKind = match[1];
    const newAttr = JSON.stringify(arr).replace(/"/g, "&quot;");
    const newFull = `data-${attrKind}="${newAttr}"`;
    const idx = match.index ?? 0;
    const len = match[0].length;
    out = `${out.slice(0, idx)}${newFull}${out.slice(idx + len)}`;
  }
  return out;
};

/**
 * Rename a template part in database
 * @param itemId
 * @param name
 */
// eslint-disable-next-line consistent-return
export const renamePartInDatabase = async (itemId: number, name: string) => {
  // We update the existing part
  const parts: TemplatesPartsUpdateInputItem[] = [
    {
      id_template_parts: itemId,
      id_shop: UserState.activeShop?.id ?? 0,
      name
    }
  ];

  const templatePartId = (await updateTemplatePart(parts)) ?? 0;
  return templatePartId;
};

/**
 * Check if a form widget already exists in the current template
 */
export const formExistsInTemplate = (): boolean => {
  const template = getTemplateIframeDocument();
  let returnValue = false;

  if (template) {
    const forms = template.querySelector(
      ".spm_widget_display_form_registration, .spm_widget_display_form_newsletter, .spm_widget_display_form_newsletter_unsubscribe"
    );

    if (forms) {
      returnValue = true;
    }
  }

  return returnValue;
};

/**
 * Check if an email widget already exists in the current template
 */
export const hasEmailWidgetInTemplate = (): boolean => {
  const template = getTemplateIframeDocument();
  let returnValue = false;

  if (template) {
    const emailWidget = template.querySelector(
      `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_input_email"]`
    );

    if (emailWidget) {
      returnValue = true;
    }
  }

  return returnValue;
};

/**
 * Check if a phone widget already exists in the current template
 */
export const hasPhoneWidgetInTemplate = (): boolean => {
  const template = getTemplateIframeDocument();
  let returnValue = false;

  if (template) {
    const phoneWidget = template.querySelector(
      `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_input_phone"]`
    );

    if (phoneWidget) {
      returnValue = true;
    }
  }

  return returnValue;
};

/**
 * Count password widgets in the current template
 */
export const countPasswordWidgetsInTemplate = (): number => {
  const template = getTemplateIframeDocument();
  let count = 0;

  if (template) {
    const passwordWidgets = template.querySelectorAll(
      `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_input_password"]`
    );
    count = passwordWidgets.length;
  }

  return count;
};

/**
 * Get display label for widget type
 * @param widgetType - The widget type attribute value
 * @returns Human readable label
 */
const getWidgetTypeLabel = (widgetType: string): string => {
  const typeLabels: Record<string, string> = {
    spm_widget_input_text: translator.global.t(
      "templateBuilder.fields.widgetTypes.textField"
    ),
    spm_widget_input_email: translator.global.t(
      "templateBuilder.fields.widgetTypes.emailField"
    ),
    spm_widget_input_phone: translator.global.t(
      "templateBuilder.fields.widgetTypes.phoneField"
    ),
    spm_widget_input_password: translator.global.t(
      "templateBuilder.fields.widgetTypes.passwordField"
    ),
    spm_widget_textarea: translator.global.t(
      "templateBuilder.fields.widgetTypes.textArea"
    ),
    spm_widget_input_date: translator.global.t(
      "templateBuilder.fields.widgetTypes.dateField"
    ),
    spm_widget_input_checkbox: translator.global.t(
      "templateBuilder.fields.widgetTypes.checkbox"
    ),
    spm_widget_input_radio: translator.global.t(
      "templateBuilder.fields.widgetTypes.radioButton"
    ),
    spm_widget_input_select: translator.global.t(
      "templateBuilder.fields.widgetTypes.selectField"
    )
  };
  return typeLabels[widgetType] || widgetType;
};

/**
 * Check if a contact property is a native property
 * @param property - The contact property to check
 * @returns True if it's a native property
 */
const isNativeProperty = (property: string): boolean => {
  const nativeProperties = [
    "email",
    "phone_number",
    "first_name",
    "last_name",
    "birthday",
    "consent_email",
    "consent_sms",
    "consent_whatsapp"
  ];
  return nativeProperties.includes(property);
};

/**
 * Get summary of form fields in the current template
 * @returns Array of form field objects with their properties
 */
export const getFormFieldsSummary = (): Array<{
  widgetType: string;
  label: string;
  contactProperty: string;
  propertyType: "native" | "custom" | "password";
  isPasswordField: boolean;
}> => {
  const template = getTemplateIframeDocument();
  const summary: Array<{
    widgetType: string;
    label: string;
    contactProperty: string;
    propertyType: "native" | "custom" | "password";
    isPasswordField: boolean;
  }> = [];

  if (template) {
    const formWidgetsSelector = `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype^="spm_widget_input"], ${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_textarea"], ${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_consent_checkbox"]`;
    const formWidgets = template.querySelectorAll(formWidgetsSelector);

    formWidgets.forEach((widget: Element) => {
      const widgetType = widget.getAttribute("data-widgettype") || "";
      const contactProperty = widget.getAttribute("data-contactproperty") || "";
      const labelElement = widget.querySelector("label");
      const label = labelElement?.textContent?.trim() || "";

      const isPasswordField = widgetType === "spm_widget_input_password";
      let propertyType: "native" | "custom" | "password" = "custom";

      if (isPasswordField) {
        propertyType = "password";
      } else if (isNativeProperty(contactProperty)) {
        propertyType = "native";
      }

      summary.push({
        widgetType: getWidgetTypeLabel(widgetType),
        label,
        contactProperty,
        propertyType,
        isPasswordField
      });
    });
  }
  return summary;
};

/**
 * Store in the state of each template_element the original code of the smart products list
 */
export const getSmartProductsListsOriginalStructure = (
  restoreBefore: boolean | null = null
) => {
  if (state.template && !Object.keys(state.template.smartLists).length) {
    const smartLists: SmartLists = {};
    let storeSmartList = true;
    const template = getTemplateIframeDocument();
    const type: TemplateParentTypeEnum = getTemplateParentTypeByType(
      state.template?.type
    );
    if (restoreBefore) {
      // Restore original code of all smart lists
      restoreSmartListsOriginalCode();
    }
    // We get all products lists according to template type
    const productsLists = template.querySelectorAll(
      `.${PRODUCTS_LISTS_CLASSES[type]}`
    );

    if (productsLists) {
      Array.from(productsLists).forEach(list => {
        // We remove the originalCode element if it's an old products' list
        const originalCode = list.querySelector(".originalCode");

        if (originalCode) {
          // If exists, we get its content to replace it in the parent of the element
          const { parentElement } = originalCode;

          if (parentElement) {
            parentElement.innerHTML = originalCode.innerHTML.trim();
          }
        }
        // For each products' list, we get the inner code and the ID of the widget, and we store the list in the state of the current template
        const widgetId = list.getAttribute("id") ?? "";
        if (list.innerHTML.match("s-engine=")) {
          smartLists[widgetId] = getWidgetCodeWithoutVmlShape(
            list as HTMLElement
          );
        } else if (!restoreBefore) {
          // Stop loop and restart with restoreBefore = true
          getSmartProductsListsOriginalStructure(true);
          storeSmartList = false;
        } else {
          storeSmartList = false;
        }
      });
    }

    if (storeSmartList) {
      state.template.smartLists = smartLists;
    }
    if (restoreBefore) {
      // Recalculate smart list with default language
      refreshSmartProductList();
    }
  }
};

/**
 * Add the original code of the smart list for widget
 * @param widgetId
 * @param html
 */
export const addSmartListOriginalCode = (
  widgetId: string,
  html: Maybe<string> = null
) => {
  const template = getTemplateIframeDocument();
  let updatedHtml = html;
  if (
    isEmailTemplate(state.template?.type) &&
    updatedHtml &&
    !updatedHtml.trimStart().match(/^<tbody[\s>]/i)
  ) {
    updatedHtml = `<tbody><tr><th>${updatedHtml}</th></tr></tbody>`;
  }

  if (template && state.template) {
    if (updatedHtml) {
      if (updatedHtml.match("s-engine=")) {
        state.template.smartLists[widgetId] = updatedHtml;
      }
    } else {
      // No-arg branch: only read from DOM on initial load (first time).
      // State is the single source of truth — all subsequent updates go through the html-arg branch.
      if (Object.keys(state.template.smartLists).includes(widgetId)) {
        return;
      }

      const widget = template.querySelector(`#${widgetId}`) as HTMLElement;
      if (!widget || !widget.innerHTML.match("s-engine=")) {
        return;
      }

      // Clean editor artifacts before reading DOM (initial load only)
      widget.classList.remove(BUILDER_ELEMENT_HOVER_CLASS);

      const actionButtonsGroup = widget.querySelector(
        "#widget-actions-buttons-group"
      );
      if (actionButtonsGroup) {
        actionButtonsGroup.remove();
      }

      widget
        .querySelectorAll(
          ".spm-padding-handles-container, .spm-padding-handles-container-row"
        )
        .forEach(el => el.remove());
      const thElement = widget.querySelector(
        ":scope > tbody > tr > th"
      ) as HTMLElement;
      if (thElement?.style.position === "relative") {
        thElement.style.removeProperty("position");
        if (!thElement.style.length) {
          thElement.removeAttribute("style");
        }
      }

      state.template.smartLists[widgetId] = getWidgetCodeWithoutVmlShape(
        widget
      );
    }
  }
};

export interface Notification {
  title: string;
  options: NotificationOptions;
}

/**
 * Get test data for push notification
 * @return Notification
 */
export const getTestPushNotificationData = (): Notification => {
  const template = getTemplateIframeDocument();
  const title: string | undefined = getContent(".push-notification-title");
  const body: string | undefined = getContent(".push-notification-body");
  // Read resolved src directly from DOM (not via getAttributeByName which returns the raw variable expression from data-var-src)
  const icon: string | undefined =
    template
      ?.querySelector(".push-notification-icon img")
      ?.getAttribute("src") ?? undefined;
  const image: string | undefined =
    template
      ?.querySelector(".push-notification-image img")
      ?.getAttribute("src") ?? undefined;
  const url: string | undefined = getAttributeByName(
    ".push-notification-link",
    "data-redirect"
  );

  return {
    title: title ?? "",
    options: {
      body: body ? br2nl(body) : "",
      icon: icon ?? "",
      image: image ?? "",
      data: {
        url: url?.match("/^http/") ? url : null
      }
    }
  };
};

/**
 * Send a notification
 * @param notificationData
 */
export const sendTestNotification = (notificationData: Notification) => {
  Notification.requestPermission().then(permission => {
    const notificationTitle = notificationData.title;
    const notificationOptions: NotificationOptions = notificationData.options;

    // If the user accepts, we send him the notification
    if (permission === "granted") {
      const notification = new Notification(
        notificationTitle,
        notificationOptions
      );

      if (notificationData.options.data.url) {
        // If there is a link, we redirect the user to the url
        notification.onclick = event => {
          event.preventDefault(); // prevent the browser from focusing the Notification's tab
          window.open(notificationData.options.data.url, "_blank");
        };
      }
    }
  });
};

/**
 * Get smart list original code for widget as an HTMLElement
 * @param widgetId
 */
export const getSmartListHtmlELementFromState = (
  widgetId: string
): Maybe<string> => {
  let returnValue = null;

  if (
    state.template &&
    Object.keys(state.template.smartLists).includes(widgetId)
  ) {
    returnValue = state.template.smartLists[widgetId];
  }

  return returnValue;
};

/**
 * Add or remove spm_just_image class
 */
export const addOrRemoveJustImageClass = (): boolean => {
  let returnValue = false;
  const template = getTemplateIframeDocument();

  if (template) {
    const rows = template.querySelectorAll(".spm_draggable_row");

    if (rows.length) {
      rows.forEach(row => {
        if (
          row.querySelectorAll(".spm_draggable_widget:not(.spm_widget_image)")
            .length === 0 &&
          row.querySelector(".spm_draggable_widget.spm_widget_image")
        ) {
          // Rows containing only images without the correct CSS properties and classes
          const cells = row.querySelectorAll("td, th");

          if (cells.length) {
            cells.forEach(cell => {
              cell.classList.add("spm_just_image");
            });
          }

          returnValue = true;
        } else {
          // Rows containing not images widgets but with images only properties
          const cells = row.querySelectorAll(
            "td.spm_just_image, th.spm_just_image"
          );

          if (cells.length) {
            cells.forEach(cell => {
              (cell as HTMLElement).style.fontSize = "";
              (cell as HTMLElement).style.lineHeight = "";
              cell.classList.remove("spm_just_image");
            });
          }

          returnValue = true;
        }
      });
    }
  }

  return returnValue;
};

/**
 * Check email template format before saving
 * @param t
 */
const checkEmailTemplateFormatOld = async (t: any): Promise<boolean> => {
  let returnValue = false;
  const template = getTemplateIframeDocument();

  if (template) {
    // We add the responsive class for not responsive products lists inside a responsive element
    const productsListsNotResponsive = template.querySelectorAll(
      ".spm_responsive .spm_product_list:not(.spm_responsive)"
    );

    if (productsListsNotResponsive.length) {
      productsListsNotResponsive.forEach(element => {
        element.classList.add("spm_responsive");
      });

      returnValue = true;
    }

    // We check if there are rows containing only images to remove spaces (font-size, line-height ...)
    if (addOrRemoveJustImageClass()) {
      returnValue = true;
    }

    const bodyHtml = template.querySelector("body")?.outerHTML ?? "";

    // We check if each variable is available in the HTML
    const hasUnsubscribeUrlLink = /\{var=template.unsubscribe_url}/.test(
      bodyHtml
    );
    // If one variable is missing, we add a new wisdget at the end of the last section and we save the section
    if (!hasUnsubscribeUrlLink) {
      checkIfSavePointNeeded().then(() => {
        const htmlToInsert = rawMandatoryVariablesWidget(
          t,
          hasUnsubscribeUrlLink
        );
        const rows = template.querySelectorAll(".spm_draggable_row");

        if (rows && rows.length) {
          const lastRow = Array.from(rows).slice(-1);

          if (lastRow) {
            const row = lastRow[0] as HTMLElement;
            row.insertAdjacentHTML("beforeend", htmlToInsert);
            resetListeners();
            const section = row.closest("[data-spmelementid]");

            if (section) {
              // Mark the contact as the current active section and save history
              const sectionId = section.getAttribute("data-spmelementid");

              if (sectionId) {
                setActiveSection(parseInt(sectionId, 10));

                // Update state
                updateSectionsInState(false);

                createHistory(HistoryType.LEGAL_MENTION_ADDED);

                resetActiveSection();
              }
            }

            returnValue = true;
          }
        }
      });
    }
  }

  return returnValue;
};

/**
 * CNIL pixels — insère un widget texte « mention de suivi » JUSTE AU-DESSUS du formulaire
 * newsletter/inscription. Technique inspirée de checkDisplayTemplateFormat / privacy policy :
 * insertAdjacentHTML + generateTranslations + resetListeners + updateSectionsInState + createHistory.
 * Idempotent : ne fait rien si une mention (.spm_tracking_mention) est déjà présente.
 * Appelé par le CTA de l'encart d'aide du widget newsletter v3.
 */
export const insertTrackingMentionAboveForm = (): boolean => {
  const template = getTemplateIframeDocument();
  if (!template) return false;
  const formWidget = template.querySelector(
    "#spm_body .spm_widget_display_form_newsletter, #spm_body .spm_widget_display_form_registration"
  );
  if (!formWidget) return false;
  // Idempotent : ne pas dupliquer la mention
  if (template.querySelector(".spm_tracking_mention")) return false;
  const section = formWidget.closest("[data-spmelementid]");
  const sectionId = section?.getAttribute("data-spmelementid");
  if (!sectionId) return false;

  checkIfSavePointNeeded().then(() => {
    setActiveSection(parseInt(sectionId, 10));
    const htmlToInsert = rawTrackingMention((i18n.global as any).t);
    const { newHtml } = generateTranslations(htmlToInsert, { newElement: true });
    formWidget.insertAdjacentHTML("beforebegin", newHtml);
    resetListeners();
    updateSectionsInState(false);
    createHistory(HistoryType.LEGAL_MENTION_ADDED);
    resetActiveSection();
  });
  return true;
};

/**
 * Ajoute (ou complète) le widget Divulgation pour couvrir le canal email — assist
 * en un clic pour le consentement au suivi des ouvertures collecté via le bouton.
 * - Si une divulgation existe : lui ajoute le canal email (contenu mis à jour si défaut).
 * - Sinon : insère une nouvelle divulgation (texte email par défaut) au-dessus du bouton (avant le CTA — CNIL pt 4.2 : consentement éclairé),
 *   en enregistrant d'abord le bon type de config puis le canal email.
 * Résilient : retourne false si l'insertion est impossible.
 */
export const insertDisclosureWidgetForEmail = async (anchorWidgetId?: string): Promise<boolean> => {
  const template = getTemplateIframeDocument();
  if (!template) return false;

  // Divulgation déjà présente : lui ajouter le canal email (pas de doublon).
  const existing = template.querySelector(
    `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_disclosure"]`
  ) as HTMLElement | null;
  if (existing) {
    const current = (existing.getAttribute("data-disclosure-channels") || "")
      .split(",")
      .filter(Boolean);
    if (!current.includes("email")) {
      const { setDisclosureChannels } = await import(
        "@/components/template-builder/setters/form"
      );
      setDisclosureChannels(`#${existing.id}`, {
        name: "data-disclosure-channels",
        value: [...current, "email"],
        getter: () => {},
        setters: []
      });
      createHistory(HistoryType.LEGAL_MENTION_ADDED);
    }
    return true;
  }

  // Sinon : insérer une nouvelle divulgation AU-DESSUS du bouton (ou du formulaire).
  const anchor =
    (anchorWidgetId && template.querySelector(`#${anchorWidgetId}`)) ||
    template.querySelector('#spm_body [data-widgettype="spm_widget_button"]') ||
    template.querySelector("#spm_body .spm_widget_form");
  if (!anchor) return false;
  const section = anchor.closest("[data-spmelementid]");
  const sectionId = section?.getAttribute("data-spmelementid");
  if (!sectionId) return false;

  await checkIfSavePointNeeded();
  setActiveSection(parseInt(sectionId, 10));
  const htmlToInsert = rawWidgetDisclosure();
  const { newHtml } = generateTranslations(htmlToInsert, { newElement: true });
  anchor.insertAdjacentHTML("beforebegin", newHtml);

  const inserted = template.querySelector(
    `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_disclosure"]`
  ) as HTMLElement | null;
  // Enregistrer d'abord la config avec le BON type (updateFormFieldConfig créerait type="").
  if (inserted) {
    addNewForm(inserted.id, "widget-disclosure");
  }
  resetListeners();
  updateSectionsInState(false);
  if (inserted) {
    inserted.setAttribute("data-disclosure-channels", "email");
    updateFormFieldConfig(inserted.id, "data-disclosure-channels", "email");
  }
  createHistory(HistoryType.LEGAL_MENTION_ADDED);
  resetActiveSection();
  return true;
};

/**
 * Check display template format before saving
 * @param t
 */
const checkDisplayTemplateFormat = async (t: any): Promise<boolean> => {
  let returnValue = false;

  cleanupDynamicStyle();

  const template = getTemplateIframeDocument();

  if (template) {
    // Remove error class from form fields for display templates
    toggleFormFieldsError(false);

    const formWidget = template.querySelector(
      "#spm_body .spm_widget_display_form_newsletter, #spm_body .spm_widget_display_form_registration"
    );

    if (formWidget) {
      const privacyPolicyLink = template.querySelector(
        '#spm_body a[href="{var=shop.privacy_policy_url}"]'
      );

      if (!privacyPolicyLink) {
        const contentElement = template.querySelector("#spm_content");

        if (contentElement) {
          const section = contentElement.closest("[data-spmelementid]");

          if (section) {
            // Mark the contact as the current active section and save history
            const sectionId = section.getAttribute("data-spmelementid");

            if (sectionId) {
              checkIfSavePointNeeded().then(() => {
                setActiveSection(parseInt(sectionId, 10));
                const htmlToInsert = rawPrivacyPolicy(t);
                const { newHtml } = generateTranslations(htmlToInsert, {
                  newElement: true
                });
                formWidget.insertAdjacentHTML("afterend", newHtml);
                resetListeners();

                // Update state
                updateSectionsInState(false);

                createHistory(HistoryType.LEGAL_MENTION_ADDED);

                resetActiveSection();
              });
            }
          }

          returnValue = true;
        }
      }
    }
  }

  return returnValue;
};

/**
 * Facebook profile picture replacement in widgets
 */
const replaceFacebookProfilePicture = (): boolean => {
  let returnValue = false;
  const template = getTemplateIframeDocument();

  if (template) {
    const fbPagePicture =
      UserState.activeShop?.linkedFacebookPage?.pagePicture ?? null;

    if (fbPagePicture) {
      // If the linked page picture is defined, we check if we need to replace it in the HTML
      (template.querySelectorAll(".fb_profile_picture") ?? []).forEach(
        picture => {
          const pictureElement = picture.querySelector("img");

          if (pictureElement) {
            const currentPicture = pictureElement.getAttribute("src");
            if (currentPicture) {
              if (fbPagePicture !== currentPicture) {
                pictureElement.setAttribute("src", fbPagePicture);
                returnValue = true;
              }
            }
          }
        }
      );
    }
  }

  return returnValue;
};

/**
 * Remove unwanted HTML attributes from template elements
 */
const removeUnwantedAttributes = (): boolean => {
  const template = getTemplateIframeDocument();
  return template ? stripUnwantedAttributes(template) : false;
};

/**
 * Check for links with spaces at the beginning or at the end, or encoded links
 */
const checkBadFormattedLinks = (): boolean => {
  let returnValue = false;
  const template = getTemplateIframeDocument();

  if (template) {
    // We check for links with spaces at the beginning or at the end, or encoded links
    const links = template.querySelectorAll("a");

    if (links.length) {
      links.forEach(link => {
        const originalHref = link.getAttribute("href");

        // We check if the link is a variable, in that case we skip the link
        if (originalHref) {
          let href = originalHref;

          if (href) {
            try {
              href = decodeURIComponent(href);
            } catch (e) {
              // Do nothing
            }

            if (href.trim() !== originalHref) {
              // If link was not good, we replace with the good value
              link.setAttribute("href", href.trim());

              // We also check the value in translations
              const translationKey = link.getAttribute(
                `${TRANSLATION_ATTRIBUTE}-href`
              );

              if (translationKey) {
                (state.template?.translations ?? [])
                  .filter(
                    current =>
                      current.key === translationKey.replace("LANG_", "")
                  )
                  .forEach(currentTranslation => {
                    if (currentTranslation.value === originalHref) {
                      replaceTranslationInState(
                        currentTranslation.key,
                        currentTranslation.language,
                        href.trim()
                      );
                    }
                  });
              }

              returnValue = true;
            }
          }
        }
      });
    }
  }

  return returnValue;
};

export const setPerfectSizeForImage = async (
  image: HTMLImageElement,
  forceMaxWidth: string | number | null
): Promise<void> => {
  const parent = getFirstParent(image, "th,td");
  let widthSetted = false;
  // Remove unused attribut
  if (image.hasAttribute(PERCENTAGE_WIDTH_ATTRIBUTE)) {
    image.removeAttribute(PERCENTAGE_WIDTH_ATTRIBUTE);
  }
  if (parent) {
    const parentStyle = window.getComputedStyle(parent);
    const paddingLeft = parseInt(parentStyle.paddingLeft || "0", 10);
    const paddingRight = parseInt(parentStyle.paddingRight || "0", 10);
    let parentWidth = parent.offsetWidth;
    parentWidth = parentWidth - paddingLeft - paddingRight;
    // When image is loaded, we calculate its width
    const currentImage = image as HTMLImageElement;
    const imgWidth = currentImage.naturalWidth;
    if (imgWidth && parentWidth) {
      // We set the proper CSS rule according to the lowest calculated width
      let maxWidth =
        imgWidth && imgWidth < parentWidth ? imgWidth : parentWidth;

      // We check if image has forced max-width
      let cssOfImage = window.getComputedStyle(image);
      let imgWidthAsPercent = "";
      // Check if parent is image widget
      const hasParentId = getFirstParentWithId(image);
      let currentMaxWidth: string | number = cssOfImage.getPropertyValue(
        "max-width"
      );
      if (
        (currentMaxWidth === "" || currentMaxWidth === "none") &&
        image.getAttribute("data-fallbackwidth")
      ) {
        currentMaxWidth = image.getAttribute("data-fallbackwidth") ?? "";
      }
      let currentWidth: string | number = 0;
      if (forceMaxWidth && typeof forceMaxWidth === "string") {
        currentMaxWidth = forceMaxWidth;
      } else if (hasParentId) {
        // Is included in image widget, we get the widget ID to create the CSS rule
        const selector2 = `#${hasParentId.id} img`;
        const cssOfImage2 = getDynamicStylesForSelector(selector2);

        currentWidth = cssOfImage2.width;
        if (new RegExp("%$").test(currentWidth)) {
          currentMaxWidth = currentWidth;
        }
      }
      if (currentMaxWidth && currentMaxWidth !== "") {
        if (!new RegExp("%$").test(currentMaxWidth)) {
          currentMaxWidth = parseInt(currentMaxWidth.replace("px", ""), 10);
        } else if (new RegExp("%$").test(currentMaxWidth)) {
          imgWidthAsPercent = currentMaxWidth.toString();
          // We set the correct value in pixels according to percentage of max width
          currentMaxWidth = 0;
          if (imgWidth) {
            maxWidth = imgWidth;
          }
        }
        if (currentMaxWidth && currentMaxWidth < maxWidth) {
          // If forced max-width is less than the calculated max-width, we keep the forced one
          maxWidth = currentMaxWidth;
        }
      }

      if (maxWidth) {
        if (hasParentId) {
          // Is included in image widget, we get the widget ID to create the CSS rule
          const selector = `#${hasParentId.id} img`;

          // Set active section in state (usefull to get/set css values in correct stylesheet)
          setActiveSection(
            computeActiveSection(TemplateStructureEnum.WIDGET, hasParentId.id)
          );
          // Add CSS rule with max-width
          removeDynamicStyle(selector, { "max-width": "", width: "" });
          removeDynamicStyle(
            selector,
            { "max-width": "", width: "" },
            false,
            "dynamic_persistent"
          );
          addOrUpdateDynamicStyle(
            selector,
            { "max-width": `${maxWidth}px` },
            false,
            "dynamic_persistent"
          );
          if (imgWidthAsPercent !== "") {
            // Recalculer le pourcentage basé sur maxWidth et parentWidth
            if (maxWidth < parentWidth) {
              // Convertir le pourcentage en valeur numérique
              const percentValue = parseFloat(
                imgWidthAsPercent.replace("%", "")
              );
              const recalculatedPercent = Math.round(
                (maxWidth / parentWidth) * 100
              );
              // Remplacer uniquement si inférieur
              if (recalculatedPercent < percentValue) {
                imgWidthAsPercent = `${recalculatedPercent}%`;
              }
            }
            addOrUpdateDynamicStyle(selector, {
              height: "auto",
              width: imgWidthAsPercent
            });
            // We add the width attribute with the correct value
            cssOfImage = window.getComputedStyle(image);
            let imgComputedWidth = 0;
            if (cssOfImage.getPropertyValue("width")) {
              imgComputedWidth = parseInt(
                cssOfImage.getPropertyValue("width"),
                10
              );
            }
            if (imgComputedWidth) {
              image.setAttribute("width", String(imgComputedWidth));
              widthSetted = true;
            }
          } else {
            removeDynamicStyle(selector, { height: "" });
            addOrUpdateDynamicStyle(
              selector,
              { width: `${maxWidth}px` },
              false,
              "dynamic_persistent"
            );
            // We add the width attribute with the correct value
            image.setAttribute("width", maxWidth);
            widthSetted = true;
          }
          image.style.maxWidth = "";
          // Reset active section
          resetActiveSection();
        } else {
          // Image is not included in image widget, we add the CSS rule on the element
          image.style.maxWidth = `${maxWidth}px`;
          // We add the width attribute with the correct value
          image.setAttribute("width", maxWidth);
          widthSetted = true;
        }
      }
    }
  }
  if (!widthSetted) {
    image.removeAttribute("width");
  }
};
/**
 * Add max-width CSS rule and width attribute for each image having a valid src attribute
 * Convert percentage to pixels and store old percentage as a data attribute of the image
 * @param template
 * @param withinSelector (optional) CSS selector to limit the scope
 */
export const fixImagesWidth = async (
  template: Document,
  withinSelector?: string
): Promise<boolean> => {
  let images: HTMLImageElement[] = [];

  if (withinSelector) {
    const roots = template.querySelectorAll(withinSelector);
    roots.forEach(root => {
      images.push(...Array.from(root.querySelectorAll("img")));
    });
  } else {
    images = Array.from(template.querySelectorAll("img"));
  }

  if (images.length) {
    images.forEach(image => {
      if (
        !getFirstParent(image, ".spm_widget_import_zip") &&
        image.hasAttribute("src") &&
        /^http/.test(image.src) &&
        !getFirstParent(image, ".spm_product_list")
      ) {
        image.setAttribute("data-fallbackwidth", String(image.offsetWidth));
        image.width = 0;
      }
    });

    await Array.from(images).reduce(async (a, image) => {
      await a;
      if (
        !getFirstParent(image, ".spm_widget_import_zip") &&
        image.hasAttribute("src") &&
        /^http/.test(image.src) &&
        !getFirstParent(image, ".spm_product_list")
      ) {
        await setPerfectSizeForImage(image, null);
      }
    }, Promise.resolve());

    // Suppression de l'attribut à la fin pour toutes les images
    images.forEach(image => image.removeAttribute("data-fallbackwidth"));
  }

  return true;
};

const checkLineHeightCssRuleForImages = () => {
  // Check if image CSS rule is set
  const design = TemplateEditorState.template?.sections.filter(
    sectionOfTemplate => sectionOfTemplate.type === "design"
  );

  if (design && design.length > 0) {
    // Get static stylesheet
    let staticStylesheet = getElementFromIframe(
      `style[data-spm-styles="static"][data-spm-section="${design[0].id_template_elements}"]`
    );

    if (!staticStylesheet) {
      // We create the style element if it doesn't exist
      staticStylesheet = createNewStylesheet(
        "static",
        design[0].id_template_elements.toString()
      );
    }

    const css = staticStylesheet.innerHTML;

    // If the rule is not in the stylesheet, we add it
    if (!new RegExp("table.spm_widget_image th", "i").test(css)) {
      staticStylesheet.append(
        "table.spm_widget_image th { line-height:0!important; font-size:0!important; mso-line-height-alt:0!important;}"
      );
    }
  }
};

const checkCssRuleForSmartProductsListsResponsiveness = () => {
  // Check if CSS rule is set
  const design = TemplateEditorState.template?.sections.filter(
    sectionOfTemplate => sectionOfTemplate.type === "design"
  );

  if (design && design.length > 0) {
    // Get static_persistent_mobile stylesheet
    const staticStylesheet = getElementFromIframe(
      `style[data-spm-styles="static_persistent_mobile"][data-spm-section="${design[0].id_template_elements}"]`
    );

    if (staticStylesheet) {
      const css = staticStylesheet.innerHTML;

      // If the rule is not in the stylesheet, we add it
      if (
        new RegExp(
          "#spm_body table.row.spm_responsive > tbody > tr > td," +
            " #spm_body table.row.spm_responsive > tbody > tr > th," +
            " #spm_body table.row.spm_responsive table.spm_draggable_row > tbody > tr > td," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th",
          "i"
        ).test(css) &&
        !new RegExp(
          "#spm_body table.row.spm_responsive > tbody > tr > td," +
            " #spm_body table.row.spm_responsive > tbody > tr > th," +
            " #spm_body table.row.spm_responsive table.spm_draggable_row > tbody > tr > td," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th," +
            " #spm_body .row.spm_responsive table > tbody > tr > th.column",
          "i"
        ).test(css)
      ) {
        staticStylesheet.innerHTML = staticStylesheet.innerHTML.replace(
          "#spm_body table.row.spm_responsive > tbody > tr > td," +
            " #spm_body table.row.spm_responsive > tbody > tr > th," +
            " #spm_body table.row.spm_responsive table.spm_draggable_row > tbody > tr > td," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th",
          "#spm_body table.row.spm_responsive > tbody > tr > td," +
            " #spm_body table.row.spm_responsive > tbody > tr > th," +
            " #spm_body table.row.spm_responsive table.spm_draggable_row > tbody > tr > td," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th," +
            " #spm_body .row.spm_responsive table.spm_draggable_widget > tbody > tr > th," +
            " #spm_body .row.spm_responsive table > tbody > tr > th.column"
        );
      }
    }
  }
};

export const checkMultipleClassesSelectors = () => {
  // Check if CSS rule is set
  const design = TemplateEditorState.template?.sections.filter(
    sectionOfTemplate => sectionOfTemplate.type === "design"
  );

  if (design && design.length > 0) {
    // Get static_persistent_mobile stylesheet
    const staticStylesheet = getElementFromIframe(
      `style[data-spm-styles="static_persistent_mobile"][data-spm-section="${design[0].id_template_elements}"]`
    );
    let updateState = false;
    let template;
    if (staticStylesheet) {
      let css = staticStylesheet.innerHTML;
      let updateCss = false;
      if (css !== "") {
        if (css.match(/table\[id="spm_body"]/gi)) {
          updateCss = true;
          css = css.replace(/table\[id="spm_body"]/gi, "#spm_body");
        }
        if (css.match(/.row:not\(\.spm_no_responsive\)/gi)) {
          updateCss = true;
          css = css.replace(
            /.row:not\(\.spm_no_responsive\)/gi,
            ".row.spm_responsive"
          );
        }
        if (
          css.match(
            /#spm_body (\.row)?\.spm_responsive\s*>\s*tbody\s*>\s*tr\s*>\s*td\s*>\s*\.columns,[^}]*display:\s*block\s*!important;/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /(#spm_body (?:\.row)?\.spm_responsive\s*>\s*tbody\s*>\s*tr\s*>\s*td\s*>\s*\.columns,[^{]*)([^}]*)(display:\s*block\s*!important;)/gi,
            "$1, #spm_body .row.spm_responsive > tbody > tr > td > .columns > tbody > tr > .column table $2 display: table !important;"
          );
        }
        if (
          css.match(
            /#spm_body\s*\.hide-for-small,\s*#spm_body\s*\.show-for-desktop\s*\{/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /(#spm_body\s*\.hide-for-small,\s*#spm_body\s*\.show-for-desktop)\s*\{/gi,
            "$1, #spm_body .row.spm_responsive > tbody > tr > td > .columns > tbody > tr > .column table.hide-for-small, #spm_body .row.spm_responsive > tbody > tr > td > .columns > tbody > tr > .column table.show-for-desktop {"
          );
        }
        if (new RegExp(".row.spm_responsive", "i").test(css)) {
          updateCss = true;
          // Issue found, we fix it
          css = css
            .replace(/\.row\.spm_responsive/gi, ".spm_responsive")
            .replace(
              /\.spm_droppable_widget\.show-for-small/gi,
              ".show-for-small"
            )
            .replace(/\.spm_draggable_row\.show-for-small/gi, ".show-for-small")
            .replace(
              /\.spm_draggable_row\.hide-for-desktop/gi,
              ".hide-for-desktop"
            )
            .replace(
              /\.spm_droppable_widget\.hide-for-desktop/gi,
              ".hide-for-desktop"
            );
        }
        if (css.match(/#spm_body\s*.spm_responsive img\s*{/gi)) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /#spm_body\s*.spm_responsive img\s*{/gi,
            "#spm_body img {"
          );
        }
        // This rule is no longer necessary with the setPerfectSizeForImage method. It also poses a problem for area shape SC-2885
        if (
          css.match(
            /#spm_body\s*img\s*{\s*width:\s*100%;\s*height:\s*auto;\s*}/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /#spm_body\s*img\s*{\s*width:\s*100%;\s*height:\s*auto;\s*}/gi,
            ""
          );
        } else if (
          css.match(
            /#spm_body\s*img\s*{\s*height:\s*auto;\s*max-width:\s*100%\s*!important;\s*}/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /#spm_body\s*img\s*{\s*height:\s*auto;\s*max-width:\s*100%\s*!important;\s*}/gi,
            ""
          );
        }
        // Responsive rule image only on widget
        // eslint-disable-next-line max-len
        if (
          !css.match(/\.spm_display_fullwidth_mobile/gi) &&
          !css.match(
            /#spm_body\s*.spm_responsive\s*.spm_widget_image\s*img\s*{\s*height\s*:\s*auto;\s*width\s*:\s*100%\s*;\s*}/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /body\s*{\s*width\s*:\s*auto;\s*min-width\s*:\s*0\s*;\s*}/gi,
            "body{\n" +
              "        width: auto;\n" +
              "        min-width: 0;\n" +
              "    }\n " +
              "#spm_body .spm_responsive .spm_widget_image img {\n" +
              "\theight:auto;\n" +
              "\twidth:100%;\n" +
              "}"
          );
        }
        // eslint-disable-next-line max-len
        if (
          !css.match(/\.spm_display_fullwidth_mobile/gi) &&
          css.match(
            /#spm_body\s*.spm_responsive\s*.spm_widget_image\s*img\s*{\s*height\s*:\s*auto;\s*width\s*:\s*100%\s*;\s*}/gi
          )
        ) {
          updateCss = true;
          css = css.replace(
            /#spm_body\s*.spm_responsive\s*.spm_widget_image\s*img\s*{\s*height\s*:\s*auto;\s*width\s*:\s*100%\s*;\s*}/gi,
            " #spm_body .spm_responsive .spm_widget_image img {\n" +
              "\theight: auto;\n" +
              "}\n" +
              "\n" +
              "#spm_body .spm_responsive .spm_widget_image img.spm_display_fullwidth_mobile {\n" +
              "\twidth: auto !important;\n" +
              "\tmax-width: 100% !important;\n" +
              "}"
          );
        }

        if (
          css.match(
            /#spm_body\s*\.spm_responsive\s*\.spm_widget_image\s*img\s*{\s*height\s*:\s*auto\s*;\s*}/gi
          )
        ) {
          updateCss = true;
          css = css.replace(
            /#spm_body\s*\.spm_responsive\s*\.spm_widget_image\s*img\s*{\s*height\s*:\s*auto\s*;\s*}/gi,
            "#spm_body .spm_responsive .spm_widget_image img {\n" +
              "\theight: auto;\n" +
              "\tmax-width: 100% !important;\n" +
              "}"
          );
        }

        // Correction responsive lors de l'utilisation cummulé de non responsive et de la restriction à un media
        // eslint-disable-next-line max-len
        if (
          css.match(
            /#spm_body\s*.show-for-small,\s*#spm_body\s*.hide-for-desktop,\s*#spm_body\s*.show-for-small\s*th,\s*#spm_body\s*.hide-for-desktop\s*th,\s*#spm_body\s*.show-for-small\s*td,\s*#spm_body\s*.hide-for-desktop\s*td,\s*#spm_body\s*.show-for-small\s*table,\s*#spm_body\s*.hide-for-desktop\s*table\s*{\s*display:\s*block\s*!important;/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /#spm_body\s*.show-for-small,\s*#spm_body\s*.hide-for-desktop,\s*#spm_body\s*.show-for-small\s*th,\s*#spm_body\s*.hide-for-desktop\s*th,\s*#spm_body\s*.show-for-small\s*td,\s*#spm_body\s*.hide-for-desktop\s*td,\s*#spm_body\s*.show-for-small\s*table,\s*#spm_body\s*.hide-for-desktop\s*table\s*{\s*display:\s*block\s*!important;/gi,
            "#spm_body .show-for-small,\n" +
              "        #spm_body .hide-for-desktop,\n" +
              "        #spm_body .show-for-small th,\n" +
              "        #spm_body .hide-for-desktop th,\n" +
              "        #spm_body .show-for-small td,\n" +
              "        #spm_body .hide-for-desktop td,\n" +
              "        #spm_body .show-for-small table,\n" +
              "        #spm_body .hide-for-desktop table {\n" +
              "          display: table-cell !important;\n" +
              "          height: auto !important;\n" +
              "          overflow: visible !important;\n" +
              "          float: none !important;\n" +
              "          visibility: visible !important;\n" +
              "          width: auto !important;\n" +
              "          max-height: inherit !important;\n" +
              "        }\n" +
              "\t\t#spm_body .show-for-small .container,\n" +
              "        #spm_body .hide-for-desktop .container {\n" +
              "\t\t\twidth: 95% !important;\n" +
              "\t\t\tmin-width: 0 !important;\n" +
              "\t\t}\n" +
              "\n" +
              "        #spm_body .spm_responsive .show-for-small,\n" +
              "        #spm_body .spm_responsive .hide-for-desktop,\n" +
              "        #spm_body .spm_responsive .show-for-small th,\n" +
              "        #spm_body .spm_responsive .hide-for-desktop th,\n" +
              "        #spm_body .spm_responsive .show-for-small td,\n" +
              "        #spm_body .spm_responsive .hide-for-desktop td,\n" +
              "        #spm_body .spm_responsive .show-for-small table,\n" +
              "        #spm_body .spm_responsive .hide-for-desktop table {\n" +
              "          display: block !important;"
          );
        }

        // Correction of a responsive rule. Support for non-responsive sections
        if (
          css.match(
            /#spm_body\s*.container\s*{\s*width\s*:\s*95%\s*!\s*important\s*;\s*min-width\s*:\s*0\s*!\s*important\s*;\s*}/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /#spm_body\s*.container\s*{\s*width\s*:\s*95%\s*!\s*important\s*;\s*min-width\s*:\s*0\s*!\s*important\s*;\s*}/gi,
            "#spm_body .spm_responsive .container {\n" +
              "\twidth: 95% !important;\n" +
              "\tmin-width: 0 !important;\n" +
              "}"
          );
        }

        // eslint-disable-next-line max-len
        if (
          css.match(
            /#spm_body\s*th.show-for-small,\s*#spm_body\s*th.hide-for-desktop,\s*#spm_body\s*table.show-for-small\s*>\s*tbody\s*>\s*tr\s*>\s*td,\s*#spm_body\s*table.hide-for-desktop\s*>\s*tbody\s*>\s*tr\s*>\s*td,\s*#spm_body\s*table.show-for-small\s*>\s*tbody\s*>\s*tr\s*>\s*td\s*th.spm_droppable_widget,\s*#spm_body\s*table.hide-for-desktop\s*>\s*tbody\s*>\s*tr\s*>\s*td\s*th.spm_droppable_widget\s*{\s*max-width:\s*inherit\s*!important;/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /#spm_body\s*th.show-for-small,\s*#spm_body\s*th.hide-for-desktop,\s*#spm_body\s*table.show-for-small\s*>\s*tbody\s*>\s*tr\s*>\s*td,\s*#spm_body\s*table.hide-for-desktop\s*>\s*tbody\s*>\s*tr\s*>\s*td,\s*#spm_body\s*table.show-for-small\s*>\s*tbody\s*>\s*tr\s*>\s*td\s*th.spm_droppable_widget,\s*#spm_body\s*table.hide-for-desktop\s*>\s*tbody\s*>\s*tr\s*>\s*td\s*th.spm_droppable_widget\s*{\s*max-width:\s*inherit\s*!important;/gi,
            "#spm_body .spm_responsive th.show-for-small,\n" +
              "        #spm_body .spm_responsive th.hide-for-desktop,\n" +
              "        #spm_body .spm_responsive table.show-for-small>tbody>tr>td,\n" +
              "        #spm_body .spm_responsive table.hide-for-desktop>tbody>tr>td,\n" +
              "        #spm_body .spm_responsive table.show-for-small>tbody>tr>td th.spm_droppable_widget,\n" +
              "        #spm_body .spm_responsive table.hide-for-desktop>tbody>tr>td th.spm_droppable_widget {\n" +
              "          max-width: inherit !important;"
          );
        }

        // eslint-disable-next-line max-len
        if (
          css.match(
            /#spm_body\s+.show-for-small,\s*#spm_body\s+.hide-for-desktop,\s*#spm_body\s+.show-for-small\s+th,\s*#spm_body\s+.hide-for-desktop\s+th,\s*#spm_body\s+.show-for-small\s+td,\s*#spm_body\s+.hide-for-desktop\s+td,\s*#spm_body\s+.show-for-small\s+table,\s*#spm_body\s+.hide-for-desktop\s+table\s*\{\s*display:\s*table-cell\s*!important;\s*height:\s*auto\s*!important;\s*overflow:\s*visible\s*!important;\s*float:\s*none\s*!important;\s*visibility:\s*visible\s*!important;\s*width:\s*auto\s*!important;/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /(#spm_body\s+.show-for-small,\s*#spm_body\s+.hide-for-desktop,\s*#spm_body\s+.show-for-small\s+th,\s*#spm_body\s+.hide-for-desktop\s+th,\s*#spm_body\s+.show-for-small\s+td,\s*#spm_body\s+.hide-for-desktop\s+td,\s*#spm_body\s+.show-for-small\s+table,\s*#spm_body\s+.hide-for-desktop\s+table\s*\{\s*display:\s*table-cell\s*!important;\s*height:\s*auto\s*!important;\s*overflow:\s*visible\s*!important;\s*float:\s*none\s*!important;\s*visibility:\s*visible\s*!important;)\s*width:\s*auto\s*!important;/gi,
            "$1"
          );
        }

        // eslint-disable-next-line max-len
        if (css.match(/(<|&lt;)br\s*\/*(>|&gt;)/gi)) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "");
        }

        // Replace old rule preventing non-responsive sections to use the 95% width rule.
        if (
          css.match(
            /#spm_body\s+\.spm_responsive\s+\.container\s*{\s*width\s*:\s*95%\s*!important\s*;/gi
          )
        ) {
          updateCss = true;
          css = css.replace(
            /#spm_body\s+\.spm_responsive\s+\.container\s*{\s*width\s*:\s*95%\s*!important\s*;/gi,
            "#spm_body .container { width: 95% !important;"
          );
        }

        if (
          css.match(
            /#spm_body\s+\.container\s*{\s*width\s*:\s*95%\s*!important\s*;\s*min-width\s*:\s*0\s*!important\s*;\s*}/gi
          )
        ) {
          updateCss = true;

          css = css.replace(
            /#spm_body\s+\.container\s*{\s*width\s*:\s*95%\s*!important\s*;\s*min-width\s*:\s*0\s*!important\s*;\s*}/gi,
            "#spm_body .container {\n\twidth: 95% !important;\n}\n\n#spm_body .spm_responsive .container {\n\tmin-width: 0 !important;\n}"
          );
        }

        if (
          css.match(
            /table#spm_body\s+\.spm_responsive\s+table\.button\s*{\s*width\s*:\s*100%\s*!important\s*;\s*}/gi
          )
        ) {
          if (
            !css.match(/\.column table\.button\.spm_display_fullwidth_mobile/gi)
          ) {
            template = getTemplateIframeDocument();
            updateState = true;
            template
              .querySelectorAll("table#spm_body table.button")
              .forEach(el => {
                el.classList.add("spm_display_fullwidth_mobile");
              });
          }
          updateCss = true;
          css = css.replace(
            /table#spm_body\s+\.spm_responsive\s+table\.button\s*{\s*width\s*:\s*100%\s*!important\s*;\s*}/gi,
            // eslint-disable-next-line max-len
            "#spm_body .spm_responsive > tbody > tr > td > .columns > tbody > tr > .column table.button {\n\twidth: auto !important;\n}\n\n#spm_body .spm_responsive > tbody > tr > td > .columns > tbody > tr > .column table.button.spm_display_fullwidth_mobile {\n\twidth: 100% !important;\n}"
          );
        }
      }
      if (updateCss) {
        staticStylesheet.innerHTML = css.replace(
          /(<|&lt;)br\s*\/*(>|&gt;)/g,
          ""
        );
      }
    }
    const staticStylesheet2 = getElementFromIframe(
      `style[data-spm-styles="static"][data-spm-section="${design[0].id_template_elements}"]`
    );

    if (staticStylesheet2) {
      let css = staticStylesheet2.innerHTML;
      let updateCss = false;
      if (css !== "") {
        // eslint-disable-next-line max-len
        if (
          css.match(
            /.show-for-small,\s*.hide-for-desktop,\s*.show-for-small\s+th,\s*.hide-for-desktop\s+th,\s*.show-for-small\s+td,\s*.hide-for-desktop\s+td,\s*.show-for-small\s+table,\s*.hide-for-desktop\s+table\s*\{\s*display:\s*none\s*!important;\s*width:\s*0\s*!important;/gi
          )
        ) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(
            /(.show-for-small,\s*.hide-for-desktop,\s*.show-for-small\s+th,\s*.hide-for-desktop\s+th,\s*.show-for-small\s+td,\s*.hide-for-desktop\s+td,\s*.show-for-small\s+table,\s*.hide-for-desktop\s+table\s*{\s*display:\s*none\s*!important;)\s*width:\s*0\s*!important;/gi,
            "$1"
          );
        }
        // eslint-disable-next-line max-len
        if (css.match(/(<|&lt;)br\s*\/*(>|&gt;)/gi)) {
          updateCss = true;
          // eslint-disable-next-line max-len
          css = css.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "");
        }

        if (
          css.match(
            /table\.spm_widget_image\s*th\s*{\s*line-height\s*:\s*0\s*!important;\s*font-size\s*:\s*0\s*!important;\s*mso-line-height-alt\s*:\s*0\s*!important;\s*}/gi
          )
        ) {
          updateCss = true;
          css = css.replace(
            /table\.spm_widget_image\s*th\s*{\s*line-height\s*:\s*0\s*!important;\s*font-size\s*:\s*0\s*!important;\s*mso-line-height-alt\s*:\s*0\s*!important;\s*}/gi,
            "body table#spm_body table.spm_widget_image th, body table#spm_body table .spm_just_image {\n" +
              "\tline-height: 1px !important;\n" +
              "\tfont-size: 1px !important;\n" +
              "\tmso-line-height-alt: 1px !important;\n" +
              "}"
          );
        }

        if (
          css.match(
            /body\s+table#spm_body\s+table\.spm_widget_image\s*th\s*,\s*body\s+table#spm_body\s+table\s+\.spm_just_image\s*{\s*line-height\s*:\s*0\s*!important;\s*font-size\s*:\s*0\s*!important;\s*mso-line-height-alt\s*:\s*0\s*!important;\s*}/gi
          )
        ) {
          css = css.replace(
            /body\s+table#spm_body\s+table\.spm_widget_image\s*th\s*,\s*body\s+table#spm_body\s+table\s+\.spm_just_image\s*{\s*line-height\s*:\s*0\s*!important;\s*font-size\s*:\s*0\s*!important;\s*mso-line-height-alt\s*:\s*0\s*!important;\s*}/gi,
            "body table#spm_body table.spm_widget_image th, body table#spm_body table .spm_just_image {\n" +
              "\tline-height: 1px !important;\n" +
              "\tfont-size: 1px !important;\n" +
              "\tmso-line-height-alt: 1px !important;\n" +
              "}"
          );

          updateCss = true;
        }

        if (
          css.match(
            /table\.button\s+th\s*{[^}]*width\s*:\s*auto\s*!important\s*;/i
          )
        ) {
          updateCss = true;
          css = css.replace(
            /table\.button\s+th\s*{([^}]*)width\s*:\s*auto\s*!important\s*;([^}]*)}/i,
            (match, before, after) =>
              `table.button th {\n${before.trim()}\n${after.trim()}\n}`.replace(
                /\n{2,}/g,
                "\n"
              )
          );
        }
      }
      if (updateCss) {
        staticStylesheet2.innerHTML = css.replace(
          /(<|&lt;)br\s*\/*(>|&gt;)/g,
          ""
        );
      }
    }
    if (updateState) {
      updateSectionsInState(false);
    }
  }
};

export const removeBrFromStylesheets = () => {
  const template = getTemplateIframeDocument();

  if (template) {
    const stylesheets = template.querySelectorAll("style[data-spm-styles]");

    let updateState = false;
    stylesheets.forEach(stylesheet => {
      const css = beautifier.css(stylesheet.innerHTML);
      if (stylesheet.innerHTML !== "" && css.match(/(\r\n|\n|\r|<br>)/gm)) {
        updateState = true;
        stylesheet.innerHTML = css.replace(/(\r\n|\n|\r|<br>)/gm, "");
      }
    });

    if (updateState) {
      updateSectionsInState(false);
    }
  }
};

const checkCssRulesForHeadingsColors = () => {
  const sections = TemplateEditorState.template?.sections.filter(
    sectionOfTemplate => sectionOfTemplate.type === "section"
  );

  if (sections && sections.length > 0) {
    sections.forEach((section: Section) => {
      // Get dynamic stylesheet
      const dynamicStylesheet = getElementFromIframe(
        `style[data-spm-styles="dynamic"][data-spm-section="${section.id_template_elements}"]`
      );

      if (dynamicStylesheet) {
        const css = dynamicStylesheet.innerHTML;

        if (
          new RegExp(
            "#spm_[a-z]{3,}_[a-z0-9]*[^,]*h4\\s*?\\{\\s+color",
            "i"
          ).test(css)
        ) {
          dynamicStylesheet.innerHTML = dynamicStylesheet.innerHTML.replace(
            /(#spm_[a-z]{3,}_[a-z0-9]*[^,]*) h4\s*?\{(\s+color)/gi,
            "$1 h4, $1 h1 a, $1 h2 a, $1 h3 a, $1 h4 a {$2"
          );
        }

        if (
          new RegExp("(#spm_body th h)([1234])\\s*?\\{\\s+color", "i").test(css)
        ) {
          dynamicStylesheet.innerHTML = dynamicStylesheet.innerHTML.replace(
            /(#spm_body th h)([1234])\s*?\{(\s+color)/gi,
            "$1$2, body #spm_body th h$2 a {$3"
          );
        }
      }
    });
  }
};

const removeUnnecessaryStaticCss = () => {
  const sections = TemplateEditorState.template?.sections.filter(
    sectionOfTemplate => sectionOfTemplate.type === "design"
  );

  if (sections && sections.length > 0) {
    sections.forEach((section: Section) => {
      // Get dynamic stylesheet
      const staticStylesheet = getElementFromIframe(
        `style[data-spm-styles="static"][data-spm-section="${section.id_template_elements}"]`
      );

      if (staticStylesheet) {
        const css = staticStylesheet.innerHTML;
        // Remove an unused CSS style that is causing problems on outlook for setting button size to text width
        if (
          new RegExp(
            "table.button\\s*?th\\s*?\\{[^}]*width:\\s*auto\\s*!important;\\s*}",
            "gm"
          ).test(css)
        ) {
          staticStylesheet.innerHTML = staticStylesheet.innerHTML.replace(
            /(table.button\s*?th\s*?\{[^}]*)width:\s*auto\s*!important;(\s*})/gm,
            "$1$2"
          );
        }
      }
    });
  }
};

const removeUselessHiddenElements = (template: Document) => {
  if (template) {
    const hiddenElements = template.querySelectorAll(
      '.spm_draggable_row[style*="display: none"],' +
        ' .spm_draggable_widget[style*="display: none"],' +
        ' .spm_droppable_widget[style*="display: none"],' +
        ' .spm_section[style*="display: none"]'
    );

    if (hiddenElements && hiddenElements.length > 0) {
      let removeSection = false;

      // If there are sone hidden elements, we remove them from the template
      hiddenElements.forEach(element => {
        if (!removeSection && element.classList.contains("spm_section")) {
          removeSection = true;
        }

        element.remove();
      });

      if (removeSection) {
        refreshSectionsConfig();
      }
    }
  }
};
export const checkResponsiveClasses = (template: Document) => {
  if (!TemplateEditorState?.template?.informations.imported) {
    // We add the responsive class for section
    const allSection = template.querySelectorAll(".spm_section");

    if (allSection.length) {
      allSection.forEach(element => {
        if (element.querySelectorAll(".row.spm_responsive").length) {
          element.classList.add("spm_responsive");
        }
      });
    }
  }
};
/**
 * Outlook lays tables out from the widths written in the HTML, not from stylesheet rules, and the
 * rule sizing the mail frame lives in the editable stylesheet a shop can clear. Without it Word has
 * no bound at all: every relative width resolves against the page. Write the frame width on the body
 * and its centering wrappers, only where nothing is set. Sections, containers and rows are left as
 * designed: their width is a design choice, not part of the frame.
 */
const ensureMailFrameWidth = (template: Document): boolean => {
  let hasChanges = false;

  const body = template.querySelector('table#spm_body') as HTMLElement | null;
  if (body) {
    if (!body.getAttribute('width')) {
      body.setAttribute('width', '100%');
      hasChanges = true;
    }
    if (!body.style.width) {
      body.style.width = '100%';
      hasChanges = true;
    }
  }

  template.querySelectorAll('table#spm_body center').forEach((element) => {
    const center = element as HTMLElement;
    if (!center.style.width) {
      center.style.width = '100%';
      hasChanges = true;
    }
  });

  return hasChanges;
};

const checkEmailTemplateFormat = async (
  template: Document,
  t: any
): Promise<boolean> => {
  let hasChanges = false;

  // Do not execute if it's an imported model
  if (!TemplateEditorState?.template?.informations.imported) {
    cleanupDynamicStyle();
    // We add the responsive class for section
    checkResponsiveClasses(template);
    // A frame width Outlook can read even when the shop cleared its custom stylesheet
    if (ensureMailFrameWidth(template)) {
      hasChanges = true;
    }
    // Check and calculate max-width for images, and set pixels values if width is a percentage, and store the percentage as a data attribute
    await withDesktopLayout(
      template,
      () => fixImagesWidth(template),
      DESKTOP_LAYOUT_NARROWEST_WIDTH
    );

    // Check CSS rule for image widget
    checkLineHeightCssRuleForImages();

    // Check CSS rule for smart products lists responsiveness
    checkCssRuleForSmartProductsListsResponsiveness();

    // Fix responsive compatibility for Outlook not supporting multiple classes selector for one element
    // see https://shopimind.atlassian.net/jira/software/c/projects/SC/issues/SC-1126
    checkMultipleClassesSelectors();

    // Check CSS rules for headings colors
    checkCssRulesForHeadingsColors();

    // Clean BR from stylesheets
    removeBrFromStylesheets();

    // Validate and repair ALL VML for V4 templates (security layer)
    if (validateAndRepairAllVml(template)) {
      hasChanges = true;
    }
  }
  // Remove hidden elements which were not hidden by the builder itself
  removeUselessHiddenElements(template);

  const bodyHtml = template.querySelector("body")?.outerHTML ?? "";

  // We check if each variable is available in the HTML
  const hasUnsubscribeUrlLink = /\{var="?template.unsubscribe_url"?}/.test(
    bodyHtml
  );
  // If one variable is missing, we add a new wisdget at the end of the last section and we save the section
  if (!hasUnsubscribeUrlLink) {
    checkIfSavePointNeeded().then(() => {
      const rows = template.querySelectorAll(".spm_draggable_row");

      if (rows && rows.length) {
        const lastRow = Array.from(rows).slice(-1);

        if (lastRow) {
          const row = lastRow[0] as HTMLElement;

          resetListeners();
          const section = row.closest("[data-spmelementid]");

          if (section) {
            // Mark the contact as the current active section and save history
            const sectionId = section.getAttribute("data-spmelementid");

            if (sectionId) {
              setActiveSection(parseInt(sectionId, 10));
              const htmlToInsert = rawMandatoryVariablesWidget(
                t,
                hasUnsubscribeUrlLink
              );
              const { newHtml } = generateTranslations(htmlToInsert, {
                newElement: true,
                checkDiv: false
              });
              row.insertAdjacentHTML("afterend", newHtml);
              // Update state
              updateSectionsInState(false);

              createHistory(HistoryType.LEGAL_MENTION_ADDED);

              resetActiveSection();
            }
          }
        }
      }
    });
  }
  return hasChanges;
};

/**
 * Replace variables V3 by V4 if the user has written an old variable in the template
 */
const replaceOldVariables = () => {
  let returnValue = false;

  const arrayOfVariables = VARIABLES_V3_TO_V4;
  if (state.template) {
    state.template.translations.forEach(translation => {
      arrayOfVariables.forEach(variable => {
        if (new RegExp(variable.oldVariable).test(translation.value)) {
          // Variable has been found, we replace it
          translation.value = translation.value.replace(
            new RegExp(variable.oldVariable, "g"),
            variable.newVariable
          );
          returnValue = true;
        }
      });
    });
  }

  return returnValue;
};

export const fixMissingTranslationsForShopLanguages = () => {
  const defaultLang = getShopDefaultLang();
  if (state.template && UserState.activeShop) {
    const defaultTranslations = state.template.translations.filter(
      item => item.language === defaultLang
    );
    const otherLanguages = UserState.activeShop.langs
      .filter(lang => lang.id !== defaultLang)
      .map(lang => lang.id);
    let continueFixing = false;
    // eslint-disable-next-line no-restricted-syntax
    for (const otherLang of otherLanguages) {
      if (
        defaultTranslations.length !==
        state.template.translations.filter(item => item.language === otherLang)
          .length
      ) {
        continueFixing = true;
        break;
      }
    }
    if (continueFixing) {
      // eslint-disable-next-line no-restricted-syntax
      for (const translationItem of defaultTranslations) {
        // eslint-disable-next-line no-restricted-syntax
        for (const otherLang of otherLanguages) {
          if (
            !state.template.translations.find(
              translation =>
                translationItem.key === translation.key &&
                translation.language === otherLang
            )
          ) {
            const newTranslation = JSON.parse(JSON.stringify(translationItem));
            newTranslation.language = otherLang;
            newTranslation.callback = translationItem.callback;
            addTranslationsToState([newTranslation]);
          }
        }
      }
    }
  }
};

/**
 * Validate WhatsApp message content
 * @param template
 * @param t
 */
const validateWhatsappContent = (template: Document, t: any): boolean => {
  const whatsappMessageElement = template.querySelector(
    ".whatsapp-message__text"
  );
  if (!whatsappMessageElement) {
    return true;
  }

  const messageContent = whatsappMessageElement.innerHTML;
  const validationResult = validateWhatsappVariablePosition(messageContent);

  if (!validationResult.isValid && validationResult.errorKey) {
    showToastError(t(validationResult.errorKey));

    // Open configuration panel if closed and focus on the WhatsApp message element
    if (!state.isConfigurationPanelVisible) {
      // Click on the element to select it and open the panel
      const whatsappBody = template.querySelector(".whatsapp-message__body");
      if (whatsappBody && whatsappBody instanceof HTMLElement) {
        whatsappBody.click();
      }
    }

    return false;
  }

  return true;
};

/**
 * Validate WhatsApp CTAs (phone numbers must not be empty and must be valid)
 * @param template
 * @param t
 */
const validateWhatsappCTAs = (template: Document, t: any): boolean => {
  const ctaElements = template.querySelectorAll(".whatsapp-message__cta__item");
  if (!ctaElements || ctaElements.length === 0) {
    return true;
  }

  // Check each CTA for phone number validation
  // eslint-disable-next-line no-restricted-syntax
  for (const ctaElement of Array.from(ctaElements)) {
    const actionType = ctaElement.getAttribute("data-whatsapp-action-type");
    const href = ctaElement.getAttribute("href");

    // Only validate CALL_NUMBER type CTAs
    if (actionType === "callNumber") {
      // Remove 'tel:' prefix
      const fullNumber = href?.replace(/^tel:/, "").trim() || "";

      // Check if empty
      if (!fullNumber) {
        showToastError(
          t("templateBuilder.validation.whatsapp.phoneNumberRequired")
        );

        // Open configuration panel if closed and focus on the CTA element
        if (!state.isConfigurationPanelVisible) {
          const whatsappCtaContainer = template.querySelector(
            ".whatsapp-message__cta"
          );
          if (
            whatsappCtaContainer &&
            whatsappCtaContainer instanceof HTMLElement
          ) {
            whatsappCtaContainer.click();
          }
        }

        return false;
      }

      // Validate phone number format using libphonenumber-js
      try {
        const phoneNumber = parsePhoneNumber(fullNumber);
        if (!phoneNumber || !phoneNumber.isValid()) {
          showToastError(
            t("templateBuilder.validation.whatsapp.phoneNumberInvalid")
          );

          // Open configuration panel if closed and focus on the CTA element
          if (!state.isConfigurationPanelVisible) {
            const whatsappCtaContainer = template.querySelector(
              ".whatsapp-message__cta"
            );
            if (
              whatsappCtaContainer &&
              whatsappCtaContainer instanceof HTMLElement
            ) {
              whatsappCtaContainer.click();
            }
          }

          return false;
        }
      } catch (error) {
        // If parsing fails, the number is invalid
        showToastError(
          t("templateBuilder.validation.whatsapp.phoneNumberInvalid")
        );

        // Open configuration panel if closed and focus on the CTA element
        if (!state.isConfigurationPanelVisible) {
          const whatsappCtaContainer = template.querySelector(
            ".whatsapp-message__cta"
          );
          if (
            whatsappCtaContainer &&
            whatsappCtaContainer instanceof HTMLElement
          ) {
            whatsappCtaContainer.click();
          }
        }

        return false;
      }
    }
  }

  return true;
};

/**
 * Validate RCS message content
 * @param template
 * @param t
 */
const validateRcsContent = (template: Document, t: any): boolean => {
  const openConfigPanel = () => {
    if (!state.isConfigurationPanelVisible) {
      const rcsBody = template.querySelector(".rcs-message__body");
      if (rcsBody && rcsBody instanceof HTMLElement) {
        rcsBody.click();
      }
    }
  };

  // Determine if we are in card mode (image toggle is on)
  const imageElement = template.querySelector("img.rcs-message__image");
  const isCardMode = imageElement?.getAttribute("data-show-image") === "true";

  // Content is always required
  const rcsMessageElement = template.querySelector(".rcs-message__text");
  const messageContent =
    rcsMessageElement?.innerHTML?.replace(/<[^>]*>/g, "")?.trim() || "";

  if (!messageContent) {
    showToastError(t("templateBuilder.validation.rcs.contentRequired"));
    openConfigPanel();
    return false;
  }

  // In card mode, title is required (Vonage: at least title or media required)
  if (isCardMode) {
    const titleElement = template.querySelector(".rcs-message__title");
    const titleText = (titleElement?.textContent || "").trim();
    if (!titleText) {
      showToastError(t("templateBuilder.validation.rcs.titleRequired"));
      openConfigPanel();
      return false;
    }
  }

  // Validate max 4 suggestions per card
  const ctaItems = template.querySelectorAll(".rcs-message__cta__item");
  if (ctaItems.length > 4) {
    showToastError(t("templateBuilder.validation.rcs.maxSuggestions"));
    openConfigPanel();
    return false;
  }

  // Validate CTA button text is not empty
  // eslint-disable-next-line no-restricted-syntax
  for (const ctaItem of Array.from(ctaItems)) {
    const ctaText = (ctaItem.textContent || "").trim();
    if (!ctaText) {
      showToastError(t("templateBuilder.validation.rcs.ctaTextRequired"));
      openConfigPanel();
      return false;
    }
  }

  // Validate smartlist button text is not empty when smartlist is enabled
  const carousel = template.querySelector(".rcs-smartlist-carousel");
  if (carousel?.classList.contains("smartlist-enabled")) {
    const buttonSource = template.querySelector(
      ".rcs-smartlist-buttontext-source"
    );
    const buttonText = (buttonSource?.textContent || "").trim();
    if (!buttonText) {
      showToastError(t("templateBuilder.validation.rcs.ctaTextRequired"));
      openConfigPanel();
      return false;
    }
  }

  return true;
};

/**
 * Validate RCS CTAs (phone numbers must not be empty and must be valid)
 * @param template
 * @param t
 */
const validateRcsCTAs = (template: Document, t: any): boolean => {
  const ctaElements = template.querySelectorAll(".rcs-message__cta__item");
  if (!ctaElements || ctaElements.length === 0) {
    return true;
  }

  // Check each CTA for phone number validation
  // eslint-disable-next-line no-restricted-syntax
  for (const ctaElement of Array.from(ctaElements)) {
    const actionType = ctaElement.getAttribute("data-rcs-action-type");
    const href = ctaElement.getAttribute("href");

    // Only validate CALL_NUMBER type CTAs
    if (actionType === "callNumber") {
      // Remove 'tel:' prefix
      const fullNumber = href?.replace(/^tel:/, "").trim() || "";

      // Check if empty
      if (!fullNumber) {
        showToastError(t("templateBuilder.validation.rcs.phoneNumberRequired"));

        // Open configuration panel if closed and focus on the CTA element
        if (!state.isConfigurationPanelVisible) {
          const rcsCtaContainer = template.querySelector(".rcs-message__cta");
          if (rcsCtaContainer && rcsCtaContainer instanceof HTMLElement) {
            rcsCtaContainer.click();
          }
        }

        return false;
      }

      // Validate phone number format using libphonenumber-js
      try {
        const phoneNumber = parsePhoneNumber(fullNumber);
        if (!phoneNumber || !phoneNumber.isValid()) {
          showToastError(
            t("templateBuilder.validation.rcs.phoneNumberInvalid")
          );

          // Open configuration panel if closed and focus on the CTA element
          if (!state.isConfigurationPanelVisible) {
            const rcsCtaContainer = template.querySelector(".rcs-message__cta");
            if (rcsCtaContainer && rcsCtaContainer instanceof HTMLElement) {
              rcsCtaContainer.click();
            }
          }

          return false;
        }
      } catch (error) {
        // If parsing fails, the number is invalid
        showToastError(
          t("templateBuilder.validation.richTexting.phoneNumberInvalid")
        );

        // Open configuration panel if closed and focus on the CTA element
        if (!state.isConfigurationPanelVisible) {
          const rcsCtaContainer = template.querySelector(".rcs-message__cta");
          if (rcsCtaContainer && rcsCtaContainer instanceof HTMLElement) {
            rcsCtaContainer.click();
          }
        }

        return false;
      }
    }
  }

  return true;
};

/**
 * Mandatory checks before saving in database and exiting
 * @param t
 */
export const beforeSaveTemplate = async (t: any): Promise<boolean> => {
  // We close the left panel to trigger history saves if needed
  await hideLeftToolbar();

  // Fix misplaced translations (translations stored in wrong section)
  fixMisplacedTranslations();

  // Sync iframe DOM
  updateSectionsInState(false);

  // Remove unused translation from sections and templates
  removeUnusedTranslations();

  // Fix missing translations
  fixMissingTranslationsForShopLanguages();

  // Delete hover elements and editor buttons
  removeActiveItemElementDecorations();

  // We update template's configuration in state
  await updateTemplateConfiguration();

  // Create game prize templates if needed (duplicates current template for each new prize)
  const gamePrizeResult = await createGamePrizeTemplates();
  if (gamePrizeResult === false) {
    return false;
  }
  if (gamePrizeResult) {
    // Re-update sections and configuration since data-prizes changed with new templateIds
    updateSectionsInState(false);
    await updateTemplateConfiguration();
  }

  // We apply specific treatments according to template type
  const template = getTemplateIframeDocument();

  if (template) {
    let updateState = false;

    // Validate WhatsApp content
    if (isWhatsappTemplate(state.template?.type)) {
      if (!validateWhatsappContent(template, t)) {
        return false;
      }
      // Validate WhatsApp CTAs (phone numbers)
      if (!validateWhatsappCTAs(template, t)) {
        return false;
      }
    }

    // Validate RCS content
    if (isRichTextingTemplate(state.template?.type)) {
      if (!validateRcsContent(template, t)) {
        return false;
      }
      // Validate RCS CTAs (phone numbers)
      if (!validateRcsCTAs(template, t)) {
        return false;
      }
    }

    // Convert old variables to new format
    if (replaceOldVariables()) {
      updateState = true;
    }

    if (restoreSmartListsOriginalCode()) {
      // We restore original code for smart lists widgets
      updateState = true;
    }

    // Integration image widgets: restore the canonical src ({var=…} literal).
    // The editor displays a preview (example values) so the image loads; the
    // sent URL must keep the real variables for per-recipient resolution.
    if (restoreIntegrationImagesCanonicalSrc()) {
      updateState = true;
    }

    if (
      (isFacebookTemplate(state.template?.type) &&
        replaceFacebookProfilePicture()) ||
      (isDisplayTemplate(state.template?.type) &&
        (await checkDisplayTemplateFormat(t))) ||
      (isEmailTemplate(state.template?.type) &&
        (await checkEmailTemplateFormat(template, t)))
    ) {
      updateState = true;
    }

    if (checkBadFormattedLinks()) {
      updateState = true;
    }

    if (removeUnwantedAttributes()) {
      updateState = true;
    }

    if (updateState) {
      // In case of some changes were made, we update the sections in the state
      updateSectionsInState(false);
    }

    // We update template's form configuration in state
    if (isDisplayTemplate(state.template?.type)) {
      updateFormsInState();
    }
  }

  if (state.template) {
  }

  return true;
};

/**
 * Get sync elements ids in template
 */
export const getSyncElementNameAndTypeBySyncId = (
  syncElementId: string
): Record<string, string> | null => {
  const container = getTemplateIframeDocument();
  if (!container) return null;

  const syncElement = container.querySelector(
    `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}="${syncElementId}"]`
  );
  if (!syncElement) return null;

  return {
    syncElementId:
      syncElement.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER) || "",
    name: syncElement.getAttribute(TEMPLATE_SYNC_ELEMENT_NAME) || "",
    type: syncElement.hasAttribute("data-widgettype")
      ? TemplateStructureEnum.WIDGET
      : TemplateStructureEnum.SECTION,
    partType: syncElement.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) || "",
    subtype: syncElement.getAttribute("data-widgettype") || ""
  };
};

export const getSyncElementIds = (template: Template) => {
  const syncElementsIds = new Set();
  // eslint-disable-next-line no-restricted-syntax
  for (const section of template.sections) {
    const { html } = section;
    const $ = cheerio.load(html);
    const syncElements = $(`[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`);
    Array.from(syncElements).forEach(syncElement => {
      const syncElementId = $(syncElement).attr(
        TEMPLATE_SYNC_ELEMENT_IDENTIFIER
      );
      if (syncElementId) {
        syncElementsIds.add(syncElementId);
      }
    });
  }
  return Array.from(syncElementsIds);
};

const stableSortObject = (value: any): any => {
  if (value === null || value === undefined) return value;
  if (Array.isArray(value)) return value.map(v => stableSortObject(v));
  if (typeof value !== "object") return value;

  const sorted: Record<string, any> = {};
  Object.keys(value)
    .sort()
    .forEach(key => {
      sorted[key] = stableSortObject(value[key]);
    });
  return sorted;
};

const stableStringify = (value: any): string =>
  JSON.stringify(stableSortObject(value));

export const calculateWhatsappDataHash = (whatsappData: any): string => {
  let dataObj: any = whatsappData;
  if (typeof dataObj === "string") {
    try {
      dataObj = JSON.parse(dataObj);
    } catch (e) {
      dataObj = {};
    }
  }

  const cloned = JSON.parse(JSON.stringify(dataObj || {}));

  for (const lang of Object.keys(cloned)) {
    // If smartlist is disabled, strip all smartlist config except enabled: false
    // so that different smartlist params don't produce a different hash
    if (cloned[lang]?.smartlist && !cloned[lang].smartlist.enabled) {
      cloned[lang].smartlist = { enabled: false };
    }

    // Strip #redirect_xxx from quickReply CTA href values
    // since the redirect ID can change without the template content changing
    if (Array.isArray(cloned[lang]?.ctas)) {
      for (const cta of cloned[lang].ctas) {
        if (
          cta.actionType === "quickReply" &&
          typeof cta.href === "string" &&
          cta.href.includes("#redirect_")
        ) {
          cta.href = "";
        }
      }
    }
  }

  return calculatePartHash(stableStringify(cloned), "", "");
};

export const setInitialWhatsappDataHash = (fromScenario: boolean) => {
  state.isOpenedFromScenario = fromScenario;

  if (!state.template || !isWhatsappTemplate(state.template.type)) {
    state.initialWhatsappDataHash = null;
    return;
  }

  const existingHash = state.template.configuration?.whatsapp_hash ?? null;

  if (existingHash) {
    state.initialWhatsappDataHash = existingHash;
  } else {
    state.initialWhatsappDataHash = null;
  }
};

export const resetWhatsappDataHashTracking = () => {
  state.initialWhatsappDataHash = null;
  state.isOpenedFromScenario = false;
  state.whatsappHashChangeConfirmCallback = null;
  state.showWhatsappHashChangeModal = false;
  state.whatsappHashChanged = false;
};

export const resetWhatsappHashChanged = () => {
  state.whatsappHashChanged = false;
};

export const setWhatsappHashChangeConfirmCallback = (
  callback: (() => Promise<void>) | null
) => {
  state.whatsappHashChangeConfirmCallback = callback;
};

export const showWhatsappHashChangeConfirmModal = () => {
  state.showWhatsappHashChangeModal = true;
};

export const hideWhatsappHashChangeConfirmModal = () => {
  state.showWhatsappHashChangeModal = false;
};

export const confirmWhatsappHashChange = async () => {
  state.showWhatsappHashChangeModal = false;
  if (state.whatsappHashChangeConfirmCallback) {
    await state.whatsappHashChangeConfirmCallback();
  }
  state.whatsappHashChangeConfirmCallback = null;
};

export const cancelWhatsappHashChange = () => {
  state.showWhatsappHashChangeModal = false;
  state.whatsappHashChangeConfirmCallback = null;
};

export const isWhatsappTemplateSubmitted = (): boolean => {
  const validationStatus =
    state.template?.configuration?.templateValidationStatus;
  if (!validationStatus) return false;
  return (
    validationStatus === WhatsappValidationStatus.APPROVED ||
    validationStatus === WhatsappValidationStatus.REINSTATED ||
    isPendingStatus(validationStatus)
  );
};

export const shouldShowWhatsappHashChangeModal = (
  hashResult: { isNew: boolean; hasChanged: boolean } | null
): boolean => {
  if (!hashResult) return false;
  return hashResult.hasChanged && isWhatsappTemplateSubmitted();
};

/**
 * Check if WhatsApp template hash has changed and show confirmation modal if needed.
 * Call this before saveTemplate for WhatsApp templates opened from scenario.
 * @param onConfirm - Callback to execute if user confirms or no confirmation needed
 * @returns true if can proceed with save, false if modal is shown (pending confirmation)
 */
export const checkWhatsappHashChangeAndConfirm = (
  onConfirm: () => Promise<void>
): boolean => {
  if (!state.template || !isWhatsappTemplate(state.template.type)) {
    return true;
  }

  const hashResult = checkAndUpdateWhatsappDataHash(state.template);

  // Track if hash changed for use in OperatorEditForm
  if (hashResult) {
    state.whatsappHashChanged = hashResult.hasChanged;
  }

  if (shouldShowWhatsappHashChangeModal(hashResult)) {
    setWhatsappHashChangeConfirmCallback(onConfirm);
    showWhatsappHashChangeConfirmModal();
    return false;
  }

  return true;
};

export const checkAndUpdateWhatsappDataHash = (
  template: any
): {
  isNew: boolean;
  hasChanged: boolean;
  oldHash: string | null;
  newHash: string;
} | null => {
  if (!isWhatsappTemplate(template.type)) {
    return null;
  }

  const currentWhatsappData = template.configuration?.whatsapp_data;
  const newHash = calculateWhatsappDataHash(currentWhatsappData);

  setTemplateConfigurationKeyInState("whatsapp_hash", newHash, template);

  const initialHash = state.initialWhatsappDataHash;

  if (!initialHash) {
    return {
      isNew: true,
      hasChanged: false,
      oldHash: null,
      newHash
    };
  }

  if (initialHash !== newHash) {
    return {
      isNew: false,
      hasChanged: true,
      oldHash: initialHash,
      newHash
    };
  }

  return {
    isNew: false,
    hasChanged: false,
    oldHash: initialHash,
    newHash
  };
};

export const updateTemplateWhatsappData = (template: any) => {
  if (
    isWhatsappTemplate(template.type) &&
    template.sections &&
    template.sections.length > 0
  ) {
    let tempElement: any = document.createElement("div");
    tempElement.innerHTML = template.sections[0].html;

    tempElement = translateDocument(
      template.informations.lang,
      tempElement,
      template
    );

    const baseData = getWhatsappDataFromTemplate(tempElement);
    const grouped = groupBy(
      template.translations,
      itemTranslation => itemTranslation.language
    );

    const translatedData = Object.fromEntries(
      Object.entries(grouped).map(([lang, langTranslations]) => [
        lang,
        fillWhatsappDataTranslation(baseData, langTranslations, template)
      ])
    );

    setTemplateConfigurationKeyInState(
      "whatsapp_data",
      translatedData,
      template
    );
  }
};

export const updateTemplateForms = (template: any) => {
  if (
    isDisplayTemplate(template.type) &&
    template.sections &&
    template.sections.length > 0
  ) {
    let tempElement: any = document.createElement("div");
    tempElement.innerHTML = template.sections[0].html;

    tempElement = translateDocument(
      template.informations.lang,
      tempElement,
      template
    );

    updateFormsInState(template, tempElement);
  }
};

export const syncEmbedAttributesOnHtml = (
  html: string,
  selector: string | undefined,
  position: string | undefined
): string => {
  if (!selector && !position) {
    return html;
  }

  const replaceAttributeInTag = (
    tag: string,
    attributeName: string,
    attributeValue: string
  ): string => {
    const attributeRegex = new RegExp(
      `\\s${attributeName}\\s*=\\s*("([^"]*)"|'([^']*)')`,
      'i'
    );
    if (attributeRegex.test(tag)) {
      return tag.replace(attributeRegex, ` ${attributeName}="${attributeValue}"`);
    }
    return tag.replace(/>$/, ` ${attributeName}="${attributeValue}">`);
  };

  return html.replace(
    /<[^>]*\bid\s*=\s*("spm_body"|'spm_body')[^>]*>/i,
    (openingTag) => {
      let nextTag = openingTag;
      if (selector !== undefined) {
        nextTag = replaceAttributeInTag(
          nextTag,
          'data-target-element',
          selector
        );
      }
      if (position !== undefined) {
        nextTag = replaceAttributeInTag(
          nextTag,
          'data-target-element-position',
          position
        );
      }
      return nextTag;
    }
  );
};

export const applyEmbedSettingsToTemplate = (
  template: { configuration?: Record<string, any>; sections?: Section[] },
  selector: string | undefined,
  position: string | undefined
): { configurationChanged: boolean; sectionsChanged: boolean } => {
  let configurationChanged = false;
  let sectionsChanged = false;

  const nextConfiguration = {
    ...(template.configuration || {})
  };
  if (selector !== undefined && nextConfiguration.embedSelector !== selector) {
    nextConfiguration.embedSelector = selector;
    configurationChanged = true;
  }
  if (position !== undefined && nextConfiguration.embedPosition !== position) {
    nextConfiguration.embedPosition = position;
    configurationChanged = true;
  }
  template.configuration = nextConfiguration;

  if (Array.isArray(template.sections) && template.sections.length > 0) {
    template.sections = template.sections.map((section) => {
      const html = section?.html || '';
      if (!html || !/\bid\s*=\s*("spm_body"|'spm_body')/i.test(html)) {
        return section;
      }
      const syncedHtml = syncEmbedAttributesOnHtml(html, selector, position);
      if (syncedHtml === html) {
        return section;
      }
      sectionsChanged = true;
      return {
        ...section,
        html: syncedHtml
      };
    });
  }

  return {
    configurationChanged,
    sectionsChanged
  };
};

export const propagateEmbedSettingsToLoadedFunnel = (
  selector: string | undefined,
  position: string | undefined,
  includeCurrentTemplate = true
): boolean => {
  if (!state.template) return false;

  const originId = String(state.template.originTemplateId || state.template.id);
  const rootTemplateId = Number.parseInt(originId, 10);
  const templatesById = new Map<number, Template>();

  const addTemplate = (template?: Template | null) => {
    if (!template?.id || template.id <= 0) return;
    if (
      !includeCurrentTemplate &&
      String(template.id) === String(state.template?.id)
    ) return;
    templatesById.set(template.id, template);
  };

  addTemplate(state.template);
  addTemplate(state.templates.find(t => t.id === rootTemplateId));
  addTemplate(state.templatesLinkedToCampaign.find(t => t.id === rootTemplateId));
  (state.templatesFromFunnel[originId] || []).forEach(t => addTemplate(t));

  let hasChanges = false;
  templatesById.forEach((template) => {
    const { configurationChanged, sectionsChanged } = applyEmbedSettingsToTemplate(
      template,
      selector,
      position
    );
    if (configurationChanged || sectionsChanged) {
      hasChanges = true;
    }
  });

  return hasChanges;
};

const buildEmbedConfigurationUpdatesForFunnel = (
  templateToSave: Template,
  configurationUpdates: { id: number; configuration: Record<string, any> }[]
): Record<string, any>[] => {
  if (templateToSave.type !== TemplateTypeEnum.EMBED) {
    return [];
  }

  const embedSelector = templateToSave.configuration?.embedSelector;
  const embedPosition = templateToSave.configuration?.embedPosition;

  if (embedSelector === undefined && embedPosition === undefined) {
    return [];
  }

  const originId = String(templateToSave.originTemplateId || templateToSave.id);
  const rootTemplateId = Number.parseInt(originId, 10);

  const templatesById = new Map<number, Template>();
  const upsertTemplate = (tmpl?: Template | null) => {
    if (!tmpl?.id || tmpl.id <= 0) return;
    templatesById.set(tmpl.id, tmpl);
  };

  upsertTemplate(templateToSave);
  upsertTemplate(state.templates.find(t => t.id === rootTemplateId));
  upsertTemplate(
    state.templatesLinkedToCampaign.find(t => t.id === rootTemplateId)
  );
  (state.templatesFromFunnel[originId] || []).forEach(t => upsertTemplate(t));

  const updates: Record<string, any>[] = [];
  templatesById.forEach((tmpl) => {
    if (!tmpl.configuration || String(tmpl.id) === String(templateToSave.id)) {
      return;
    }

    const configFromPendingUpdate = configurationUpdates.find(
      update => update.id === tmpl.id
    )?.configuration;
    const currentConfig = {
      ...(tmpl.configuration || {}),
      ...(configFromPendingUpdate || {})
    };

    const draftTemplate = {
      configuration: { ...currentConfig },
      sections: Array.isArray(tmpl.sections)
        ? tmpl.sections.map(section => ({ ...section }))
        : []
    };
    const { configurationChanged, sectionsChanged } = applyEmbedSettingsToTemplate(
      draftTemplate,
      embedSelector,
      embedPosition
    );

    const nextUpdate: Record<string, any> = {
      id: tmpl.id
    };

    if (configurationChanged) {
      nextUpdate.configuration = draftTemplate.configuration;
    }

    if (sectionsChanged) {
      nextUpdate.sections = draftTemplate.sections;
    }

    if (nextUpdate.configuration || nextUpdate.sections) {
      updates.push(nextUpdate);
    }
  });

  return updates;
};

const mergeUpdatesByTemplateId = (
  updates: Record<string, any>[]
): Record<string, any>[] => {
  const mergedById = new Map<number, Record<string, any>>();

  updates.forEach((update) => {
    const templateId = Number(update.id);
    if (!Number.isFinite(templateId) || templateId <= 0) return;

    const existing = mergedById.get(templateId);
    if (!existing) {
      mergedById.set(templateId, {
        ...update,
        id: templateId,
        configuration: update.configuration
          ? { ...update.configuration }
          : update.configuration
      });
      return;
    }

    mergedById.set(templateId, {
      ...existing,
      ...update,
      id: templateId,
      configuration: {
        ...(existing.configuration || {}),
        ...(update.configuration || {})
      }
    });
  });

  return Array.from(mergedById.values());
};

const applySavedUpdatesToLocalState = (updates: Record<string, any>[]) => {
  const updatesById = new Map<number, Record<string, any>>();
  updates.forEach((update) => {
    const templateId = Number(update.id);
    if (!Number.isFinite(templateId) || templateId <= 0) return;
    updatesById.set(templateId, update);
  });

  if (updatesById.size === 0) return;

  const applyOnTemplate = (tmpl?: Template | null) => {
    if (!tmpl?.id) return;
    const update = updatesById.get(Number(tmpl.id));
    if (!update) return;

    if (update.configuration) {
      tmpl.configuration = {
        ...(tmpl.configuration || {}),
        ...update.configuration
      };
    }

    if (update.sections) {
      tmpl.sections = update.sections.map((section: Section) => ({ ...section }));
    }

    if (update.informations) {
      tmpl.informations = {
        ...(tmpl.informations || {}),
        ...update.informations
      };
    }

    if (update.content) {
      tmpl.content = {
        ...(tmpl.content || {}),
        ...update.content
      };
    }
  };

  applyOnTemplate(state.template);
  state.templates.forEach(applyOnTemplate);
  state.templatesLinkedToCampaign.forEach(applyOnTemplate);
  Object.values(state.templatesFromFunnel).forEach((templates) => {
    templates.forEach(applyOnTemplate);
  });
  Object.values(state.teaserTemplates).forEach(applyOnTemplate);
};

const executeSave = async (
  template: Template,
  whatsappHashChanged = false,
  additionalUpdates: Record<string, any>[] = []
) => {
  const templateToSave = template;
  if (templateToSave && UserState.activeShop) {
    updateTemplateWhatsappData(templateToSave);
    updateTemplateForms(templateToSave);

    // Synchronize VML button variables with HTML button variables for Email V4
    if (isEmailTemplate(templateToSave.type) && templateToSave.version === 4) {
      templateToSave.sections = synchronizeVmlWithButtons(
        templateToSave.sections
      );
    }
    const editingTemplateFromCampaign = getEditingTemplateFromCampaign();
    const idCampaign =
      templateToSave.idCampaign === null &&
      editingTemplateFromCampaign !== null &&
      editingTemplateFromCampaign.idTemplate === templateToSave.id
        ? editingTemplateFromCampaign.id_campaign
        : templateToSave.idCampaign;

    // Preview shell (status bar, header, messages-area wrapper) is now persisted
    // in the design section. No stripping needed — the shell is saved as part of the template.

    const templateInput = {
      id: templateToSave.id,
      content: templateToSave.content,
      type: templateToSave.type,
      idCampaign,
      informations: templateToSave.informations,
      sections: templateToSave.sections,
      configuration: {
        ...templateToSave.configuration
      }
    };

    // Only delete templateValidationStatus and templateCategory if the hash has changed (template was modified)
    if (isWhatsappTemplate(templateToSave.type) && whatsappHashChanged) {
      delete templateInput.configuration.templateValidationStatus;
      delete templateInput.configuration.templateCategory;

      // Clear status from the saved template in reactive state so the UI updates
      if (state.template?.configuration && state.template.id === template.id) {
        delete state.template.configuration.templateValidationStatus;
        delete state.template.configuration.templateCategory;
      }
      const tmplInState = state.templates.find(tmpl => tmpl.id === template.id);
      if (tmplInState?.configuration) {
        delete tmplInState.configuration.templateValidationStatus;
        delete tmplInState.configuration.templateCategory;
      }
      const tmplInCampaign = state.templatesLinkedToCampaign.find(
        tmpl => tmpl.id === template.id
      );
      if (tmplInCampaign?.configuration) {
        delete tmplInCampaign.configuration.templateValidationStatus;
        delete tmplInCampaign.configuration.templateCategory;
      }
      // Clear from funnel templates
      for (const funnelId of Object.keys(state.templatesFromFunnel)) {
        const funnelTmpl = state.templatesFromFunnel[funnelId]?.find(
          tmpl => tmpl.id === template.id
        );
        if (funnelTmpl?.configuration) {
          delete funnelTmpl.configuration.templateValidationStatus;
          delete funnelTmpl.configuration.templateCategory;
        }
      }
    }

    const { updateTemplates } = useTemplatesApi();

    // Collect root template update if its funnels list changed
    const configurationUpdates: {
      id: number;
      configuration: Record<string, any>;
    }[] = [];

    // Update funnel configuration for the current template and optionally the root
    if (state.template && state.template.originTemplateId) {
      const rootTemplateId = String(state.template.originTemplateId);
      const defaultLang = getShopDefaultLang();

      // Use the root template's funnel tree (not the current template which may be a teaser with an empty funnel)
      const rootTemplateInFunnel = state.templatesFromFunnel[
        rootTemplateId
      ]?.find(t => t.id === parseInt(rootTemplateId, 10));
      const funnelTree = rootTemplateInFunnel?.funnel ?? state.template?.funnel;

      // Collect all template IDs from the funnel tree
      const collectFunnelTemplates = (
        step: FunnelStep,
        result: { id: number; name: string; type: string }[]
      ) => {
        if (
          step.template &&
          step.template.id > 0 &&
          step.template.id !== parseInt(rootTemplateId, 10)
        ) {
          if (!result.find(t => t.id === step.template!.id)) {
            result.push({
              id: step.template.id,
              name: step.template.name,
              type: step.template.type
            });
          }
        }
        step.nextSteps.forEach(nextStep =>
          collectFunnelTemplates(nextStep, result)
        );
      };

      // Get direct children IDs for a given template from the funnel tree
      const getDirectChildrenIds = (
        step: FunnelStep,
        templateId: number
      ): number[] => {
        if (step.template?.id === templateId) {
          return [...new Set(
            step.nextSteps
              .filter(
                s => s.template && s.template.id > 0 && !s.template.isGameFunnel
              )
              .map(s => s.template!.id)
          )];
        }
        for (const nextStep of step.nextSteps) {
          const result = getDirectChildrenIds(nextStep, templateId);
          if (result.length > 0) return result;
        }
        return [];
      };

      const templateFunnelsToSave: {
        id: number;
        name: string;
        type: string;
      }[] = [];
      if (funnelTree) {
        collectFunnelTemplates(funnelTree, templateFunnelsToSave);
      }
      templateFunnelsToSave.sort((a, b) => a.id - b.id);

      // If we're saving the root template, update its funnel list
      if (String(template.id) === rootTemplateId) {
        if (templateFunnelsToSave.length) {
          templateInput.configuration.funnels = templateFunnelsToSave;
        } else {
          delete templateInput.configuration.funnels;
        }
      }

      // Other funnel templates don't need saving here — they are already saved
      // during step switches. Only the root's funnels list may need updating
      // if the funnel structure changed (e.g. new redirect template created).
      if (String(template.id) !== rootTemplateId && rootTemplateInFunnel) {
        const oldFunnels = rootTemplateInFunnel.configuration.funnels;
        const newFunnels = templateFunnelsToSave.length
          ? templateFunnelsToSave
          : undefined;
        if (JSON.stringify(oldFunnels) !== JSON.stringify(newFunnels)) {
          const rootConfigCopy = { ...rootTemplateInFunnel.configuration };
          if (newFunnels) {
            rootConfigCopy.funnels = newFunnels;
          } else {
            delete rootConfigCopy.funnels;
          }
          // Update state
          rootTemplateInFunnel.configuration.funnels = newFunnels;
          // Only send id + configuration for root (no content/sections/informations)
          configurationUpdates.push({
            id: rootTemplateInFunnel.id,
            configuration: rootConfigCopy
          });
        }
      }

      // Update current template's nextIdTemplate
      if (funnelTree) {
        const currentChildrenIds = getDirectChildrenIds(
          funnelTree,
          template.id
        );
        if (currentChildrenIds.length > 0) {
          templateInput.configuration.nextIdTemplate = {
            [defaultLang]: currentChildrenIds
          };
        } else {
          delete templateInput.configuration.nextIdTemplate;
        }
      }

    } else if (state.template && state.template.funnel) {
      // Root template (no originTemplateId): compute nextIdTemplate and funnels from its own funnel tree.
      // This ensures funnel child references are persisted even when
      // updateTemplateConfigurationNextIdTemplate() hasn't run yet (timing with handlePropertyValuesChange timeout).
      // Both nextIdTemplate AND funnels must be updated so that the /chain endpoint
      // (which reads funnels first) returns the correct templates.
      const defaultLang = getShopDefaultLang();
      const funnelTree = state.template.funnel;

      const collectAllFunnelTemplates = (
        step: FunnelStep,
        result: { id: number; name: string; type: string }[]
      ) => {
        if (
          step.template &&
          step.template.id > 0 &&
          step.template.id !== template.id
        ) {
          if (!result.find(t => t.id === step.template!.id)) {
            result.push({
              id: step.template.id,
              name: step.template.name,
              type: step.template.type
            });
          }
        }
        step.nextSteps.forEach(nextStep =>
          collectAllFunnelTemplates(nextStep, result)
        );
      };

      const getDirectChildrenIdsRoot = (
        step: FunnelStep,
        templateId: number
      ): number[] => {
        if (step.template?.id === templateId) {
          return [...new Set(
            step.nextSteps
              .filter(
                s => s.template && s.template.id > 0 && !s.template.isGameFunnel
              )
              .map(s => s.template!.id)
          )];
        }
        for (const nextStep of step.nextSteps) {
          const result = getDirectChildrenIdsRoot(nextStep, templateId);
          if (result.length > 0) return result;
        }
        return [];
      };

      const currentChildrenIds = getDirectChildrenIdsRoot(
        funnelTree,
        template.id
      );
      if (currentChildrenIds.length > 0) {
        templateInput.configuration.nextIdTemplate = {
          [defaultLang]: currentChildrenIds
        };
      } else {
        delete templateInput.configuration.nextIdTemplate;
      }

      // Update funnels list (used by /chain endpoint for batch fetching)
      const templateFunnelsToSave: { id: number; name: string; type: string }[] = [];
      collectAllFunnelTemplates(funnelTree, templateFunnelsToSave);
      if (templateFunnelsToSave.length > 0) {
        templateInput.configuration.funnels = templateFunnelsToSave;
      } else {
        delete templateInput.configuration.funnels;
      }
    }

    // When saving from a teaser, persist teaserId on the parent popup
    if (templateToSave.configuration?.parentPopupId && templateToSave.id !== templateToSave.configuration.parentPopupId) {
      const parentId = templateToSave.configuration.parentPopupId;
      const parentPopup = state.templates.find((t) => String(t.id) === String(parentId))
        || state.templatesLinkedToCampaign.find((t) => String(t.id) === String(parentId));

      if (parentPopup?.configuration?.teaserId) {
        const existingIdx = configurationUpdates.findIndex((u) => String(u.id) === String(parentPopup.id));
        if (existingIdx >= 0) {
          configurationUpdates[existingIdx].configuration.teaserId = parentPopup.configuration.teaserId;
        } else {
          configurationUpdates.push({
            id: parentPopup.id,
            configuration: { ...parentPopup.configuration },
          });
        }
      }
    }

    // Get all synced elements
    const syncElementsIds = getSyncElementIds(template);
    if (!templateInput.configuration[TEMPLATE_SYNC_ELEMENT_IDs]) {
      templateInput.configuration[TEMPLATE_SYNC_ELEMENT_IDs] = [];
    }
    if (syncElementsIds.length) {
      templateInput.configuration[TEMPLATE_SYNC_ELEMENT_IDs] = [
        ...syncElementsIds
      ];
    } else {
      delete templateInput.configuration[TEMPLATE_SYNC_ELEMENT_IDs];
    }

    if (!templateInput.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES]) {
      templateInput.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES] = [];
    }
    const syncElementsParts = getSyncElementPartsInTemplate();
    if (syncElementsParts.length) {
      templateInput.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES] = [
        ...syncElementsParts
      ];
    } else {
      delete templateInput.configuration[TEMPLATE_PART_ELEMENT_PART_TYPES];
    }

    const embedConfigurationUpdates = buildEmbedConfigurationUpdatesForFunnel(
      templateToSave,
      configurationUpdates
    );

    // Combine funnel template updates (if any) with the current template into a single batch call
    const allUpdates = mergeUpdatesByTemplateId([
      ...configurationUpdates,
      ...embedConfigurationUpdates,
      templateInput,
      ...additionalUpdates
    ]);
    const saveResult = await updateTemplates(allUpdates);

    if (saveResult.success) {
      applySavedUpdatesToLocalState(allUpdates);
      invalidateTemplateRawCache(templateToSave.id);
      const baseUrl = process.env.VUE_APP_URL_MEDIAL_IMAGE_PREFIX;
      const cryptedImageKey = CryptoJS.SHA1(
        `salt-${templateToSave.id}`
      ).toString();
      const idShop = UserState.activeShop?.id || 0;
      const potentialImageUrl = `${baseUrl}${idShop}_${cryptedImageKey}${
        isDisplayTemplate(templateToSave.type) ? "-isdisplay" : ""
      }-reloadcache.png`;
      loadImage(potentialImageUrl).catch((errTemp: any) => {
        // console.log('err', errTemp);
      });
      return true;
    }
  }

  return false;
};

/**
 * Synchronize VML button variables with HTML button variables for Email V4 templates
 * Called during save process to ensure VML and HTML buttons have matching translation variables
 * @param sections - Template sections to process
 * @returns Updated sections with synchronized VML
 */
export const synchronizeVmlWithButtons = (sections: Section[]): Section[] => {
  // Only process for Email V4 templates
  if (
    !isEmailTemplate(TemplateEditorState.template?.type) ||
    TemplateEditorState.template?.version !== 4
  ) {
    return sections;
  }

  return sections.map(section => {
    const updatedHtml = processVmlButtonSync(section.html);
    return { ...section, html: updatedHtml };
  });
};

/**
 * Process HTML to synchronize VML button variables with HTML button variables
 * @param html - HTML content to process
 * @returns Updated HTML with synchronized VML
 */
const processVmlButtonSync = (html: string): string => {
  // Regex to find button structures with their VML
  const buttonVmlPattern = /<!--\[if mso\]>\s*<v:roundrect[^>]*href="([^"]*)"[^>]*>(.*?)<\/v:roundrect>\s*<!\[endif\]-->\s*<!--\[if !mso\]><!-->\s*<a[^>]*href="([^"]*)"[^>]*>(.*?)<\/a>\s*<!--<!\[endif\]-->/gms;

  return html.replace(
    buttonVmlPattern,
    (match, vmlHref, vmlContent, htmlHref, htmlText) => {
      // Extract variables from HTML button href (support both {LANG_xxx} and {var=xxx})
      const htmlHrefVar =
        htmlHref.match(/\{(LANG_[^}]+|var=[^}]+)\}/)?.[0] || htmlHref;

      // Extract variables from HTML button text (handle spmtranslation tags)
      let htmlTextVar = htmlText;

      // Check if text contains spmtranslation tag
      const spmTranslationMatch = htmlText.match(
        /<spmtranslation[^>]*>([^<]*)<\/spmtranslation>/
      );
      if (spmTranslationMatch) {
        htmlTextVar = spmTranslationMatch[0]; // Keep the full spmtranslation tag
      } else {
        // Look for {LANG_xxx} variables in plain text
        const langMatch = htmlText.match(/\{LANG_[^}]+\}/);
        if (langMatch) {
          htmlTextVar = langMatch[0];
        }
      }

      // Only sync if HTML button has translation variables or spmtranslation
      const hasTranslatableContent =
        htmlHref.includes("{LANG_") ||
        htmlHref.includes("{var=") ||
        htmlText.includes("{LANG_") ||
        htmlText.includes("<spmtranslation");

      if (hasTranslatableContent) {
        let updatedMatch = match;

        // Replace VML v:roundrect href with HTML button href variable
        updatedMatch = updatedMatch.replace(
          /(<v:roundrect[^>]*href=")[^"]*(")/g,
          `$1${htmlHrefVar}$2`
        );

        // Replace VML internal anchor href with HTML button href variable
        updatedMatch = updatedMatch.replace(
          /(<center[^>]*>\s*<a[^>]*href=")[^"]*(")/g,
          `$1${htmlHrefVar}$2`
        );

        // Replace VML internal anchor text with HTML button text variable
        updatedMatch = updatedMatch.replace(
          /(<center[^>]*>\s*<a[^>]*>)[^<]*(<\/a>)/g,
          `$1${htmlTextVar}$2`
        );

        // Replace VML v:fill src with HTML img src variable (for rounded images)
        const imgSrcMatch = htmlText.match(/<img[^>]*src="([^"]*)"[^>]*>/);
        if (imgSrcMatch) {
          const htmlImgSrc =
            imgSrcMatch[1].match(/\{(LANG_[^}]+|var=[^}]+)\}/)?.[0] ||
            imgSrcMatch[1];
          updatedMatch = updatedMatch.replace(
            /(<v:fill[^>]*src=")[^"]*(")/g,
            `$1${htmlImgSrc}$2`
          );
        }

        return updatedMatch;
      }

      return match;
    }
  );
};

/**
 * Save template in database
 * Saves the current template and may propagate shared funnel configuration updates.
 * @returns true if save succeeded, false if failed
 */
export const saveTemplate = async (
  additionalUpdates: Record<string, any>[] = []
): Promise<boolean> => {
  if (!state.template) {
    return false;
  }

  // Check if WhatsApp hash changed (for deletion of validation status)
  let whatsappHashChanged = false;
  if (isWhatsappTemplate(state.template.type)) {
    const hashResult = checkAndUpdateWhatsappDataHash(state.template);
    if (hashResult) {
      whatsappHashChanged = hashResult.hasChanged;
    }
  }

  const result = await executeSave(
    state.template,
    whatsappHashChanged,
    additionalUpdates
  );
  if (result === true) {
    // Rename game prize templates in database to match current labels
    await updateGamePrizeTemplateLabels();
    await showToastSuccess("savedSuccessful");
    return true;
  }
  if (result === false) {
    await showToastError("noSave");
  }
  return false;
};

/**
 * Convert old widgets' placeholders to new format
 */
const convertOldWidgetsPlaceholders = () => {
  const template = getTemplateIframeDocument();
  (
    (Array.from(
      template.querySelectorAll(`[class*="${WIDGETS_PLACEHOLDER_IDENTIFIER}"]`)
    ) as HTMLElement[]) ?? []
  ).forEach((element: HTMLElement) => {
    // Remove content and insert new icon
    const parentColumn = element.parentElement;
    element.remove();
    const div = document.createElement("div");
    div.innerHTML = RAW_PLACEHOLDER_STRUCTURE_MAP[
      getTemplateParentTypeByType(TemplateEditorState.template?.type)
    ]();
    const placeholder = div.getElementsByClassName(
      WIDGETS_PLACEHOLDER_IDENTIFIER
    )[0];
    // eslint-disable-next-line no-unused-expressions
    parentColumn?.appendChild(placeholder);
  });
};

/**
 * Upgrade legacy email-v4 text widgets whose `.spm_rich_editor` sits directly
 * inside the `<th>` (old structure) to the new structure that wraps it in a
 * `<table class="spm_rich_editor_wrapper">`. Without this wrapper, the widget's
 * style panel selectors have no target and style changes have no effect.
 */
const upgradeLegacyTextWidgets = () => {
  if (!isEmailTemplate(TemplateEditorState.template?.type) || !isV4Template()) {
    return;
  }

  const template = getTemplateIframeDocument();
  const textWidgets = Array.from(
    template.querySelectorAll('.spm_widget_text')
  ) as HTMLElement[];

  textWidgets.forEach((widget) => {
    const richEditor = widget.querySelector(':scope > tbody > tr > th > .spm_rich_editor') as HTMLElement | null;
    if (!richEditor) return; // Already migrated or unexpected structure

    const parentTh = richEditor.parentElement;
    if (!parentTh) return;

    const wrapperTable = template.createElement('table');
    wrapperTable.className = 'spm_rich_editor_wrapper';
    wrapperTable.setAttribute('cellspacing', '0');
    wrapperTable.setAttribute('cellpadding', '0');
    wrapperTable.setAttribute('width', '100%');
    wrapperTable.setAttribute('style', 'border-collapse: collapse;');

    const wrapperTbody = template.createElement('tbody');
    const wrapperTr = template.createElement('tr');
    const wrapperTd = template.createElement('td');

    wrapperTable.appendChild(wrapperTbody);
    wrapperTbody.appendChild(wrapperTr);
    wrapperTr.appendChild(wrapperTd);

    parentTh.insertBefore(wrapperTable, richEditor);
    wrapperTd.appendChild(richEditor);
  });
};

/**
 * Remove contenteditable attributes from old templates
 */
const removeContentEditableFromOldTemplates = () => {
  const template = getTemplateIframeDocument();
  (
    (Array.from(
      template.querySelectorAll("[contenteditable]")
    ) as HTMLElement[]) ?? []
  ).forEach((element: HTMLElement) => {
    element.removeAttribute("contenteditable");
  });
};

/**
 * Add element's type as data attribute with state badges
 * @param element
 */
export const addElementTypeByLang = (element: HTMLElement) => {
  let elementType = "";

  if (element.matches(TEMPLATE_SECTION_IDENTIFIER)) {
    // Section
    elementType = translator.global.t("templateBuilder.widgets.section");
  } else if (element.matches(TEMPLATE_COLUMN_IDENTIFIER)) {
    elementType = translator.global.t("templateBuilder.widgets.columnTitle");
  } else if (element.classList.contains("spm_widget_integration")) {
    // Integration widget → show its declared name + the source integration
    // (both set on the block at drop) rather than the generic type label.
    const widgetName =
      element.getAttribute("data-widget-name") ||
      translator.global.t("templateBuilder.widgetsNameBubble.integration-widget");
    const integrationName = element.getAttribute("data-integration-name") || "";
    elementType = integrationName ? `${widgetName} · ${integrationName}` : widgetName;
  } else {
    // Widget
    const classOfElement = Array.from(element.classList).filter(
      className =>
        className !== WIDGET_DRAGGABLE_CLASS.replace(".", "") &&
        className !== "spm_widget"
    );
    const widgetType = getWidgetType(classOfElement[0]);
    elementType = translator.global.t(
      `templateBuilder.widgetsNameBubble.${widgetType}`
    );
  }

  element.setAttribute("data-spm-elementtype-text", elementType);

  // Add state badges
  updateStateBadges(element);
};

/**
 * Create and update state badges for an element (inline with label)
 * Uses a wrapper div containing both label span and badges for perfect alignment
 * @param element
 */
const updateStateBadges = (element: HTMLElement) => {
  // Check for states FIRST — we only touch the wrapper if we're going to recreate it.
  // (Previously this function removed the wrapper then early-returned for non-state
  // widgets, wiping out the hover wrapper created by dom-labels.ts.)
  const hasSyncElement =
    element.classList.contains(TEMPLATE_SYNC_ELEMENT_CLASS) &&
    !element.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE);
  const hasStyleSync =
    element.hasAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) &&
    element.getAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE) === "styles";
  const hasConditional = element.hasAttribute("s-segments");
  const hasLoop = element.classList.contains("spm_loop");

  // For sections (tables), always create wrapper because ::before is unreliable on tables
  const isSection = element.matches(TEMPLATE_SECTION_IDENTIFIER);

  // If no special states and not a section, leave any existing wrapper alone.
  // This preserves hover-created wrappers managed by dom-labels.ts.
  if (
    !hasSyncElement &&
    !hasStyleSync &&
    !hasConditional &&
    !hasLoop &&
    !isSection
  ) {
    return;
  }

  // We will recreate: remove existing direct-child wrapper only (not descendants).
  const existingWrapper = element.querySelector(":scope > .spm-label-wrapper");
  if (existingWrapper) {
    existingWrapper.remove();
  }

  // Get the label text
  const labelText = element.getAttribute("data-spm-elementtype-text") || "";

  // Create wrapper containing label + badges
  const wrapper = element.ownerDocument.createElement("div");
  wrapper.className = "spm-label-wrapper";

  // Create label span (replaces ::before visually)
  const labelSpan = element.ownerDocument.createElement("span");
  labelSpan.className = "spm-label-text";
  labelSpan.textContent = labelText;
  wrapper.appendChild(labelSpan);

  // SVG icons for badges (inline to avoid external dependencies)
  const syncIcon =
    '<svg class="spm-badge-icon" viewBox="0 0 24 24"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 16h5v5"/></svg>';
  const styleIcon =
    '<svg class="spm-badge-icon" viewBox="0 0 24 24"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>';
  const conditionalIcon =
    '<svg class="spm-badge-icon" viewBox="0 0 24 24"><line x1="6" y1="3" x2="6" y2="15"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 0 1-9 9"/></svg>';
  const loopIcon =
    '<svg class="spm-badge-icon" viewBox="0 0 24 24"><path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/></svg>';

  // Add badges based on states
  if (hasSyncElement) {
    const badge = element.ownerDocument.createElement("span");
    badge.className = "spm-state-badge spm-badge-sync";
    badge.innerHTML = `${syncIcon}<span class="spm-badge-text">Synchronisé</span>`;
    wrapper.appendChild(badge);
  }

  if (hasStyleSync) {
    const badge = element.ownerDocument.createElement("span");
    badge.className = "spm-state-badge spm-badge-style";
    badge.innerHTML = `${styleIcon}<span class="spm-badge-text">Style synchronisé</span>`;
    wrapper.appendChild(badge);
  }

  if (hasConditional) {
    const badge = element.ownerDocument.createElement("span");
    badge.className = "spm-state-badge spm-badge-conditional";
    badge.innerHTML = `${conditionalIcon}<span class="spm-badge-text">Condition</span>`;
    wrapper.appendChild(badge);
  }

  if (hasLoop) {
    const badge = element.ownerDocument.createElement("span");
    badge.className = "spm-state-badge spm-badge-loop";
    badge.innerHTML = `${loopIcon}<span class="spm-badge-text">Répétition</span>`;
    wrapper.appendChild(badge);
  }

  // Append wrapper to element
  element.appendChild(wrapper);
};

/**
 * Add type of each element as data attribute
 */
const addElementsTypesByLang = () => {
  const template = getTemplateIframeDocument();
  (Array.from(
    template.querySelectorAll(
      `${TEMPLATE_SECTION_IDENTIFIER}, ${TEMPLATE_WIDGET_IDENTIFIER}`
    ) ?? []
  ) as HTMLElement[]).forEach(element => addElementTypeByLang(element));
};

/**
 * Ensure spm_content div exists as first child of spm_body for display templates
 */
export const ensureSpmContentDivExists = () => {
  // Only apply to embed templates
  if (
    getTemplateParentTypeByType(state.template?.type) !==
    TemplateParentTypeEnum.EMBED
  ) {
    return;
  }

  const template = getTemplateIframeDocument();
  if (!template) return;

  const spmBody = template.querySelector("#spm_body");
  if (!spmBody) return;

  // Check if spm_content exists in spm_body
  const spmContent = spmBody.querySelector("#spm_content");

  if (spmContent) {
    // spm_content already exists, nothing to do
    return;
  }

  // spm_content doesn't exist, create it
  const newSpmContent = template.createElement("div");
  newSpmContent.id = "spm_content";
  newSpmContent.className = "spm_droppable_row";

  // Move all existing children into spm_content
  const childrenToMove = Array.from(spmBody.children);
  childrenToMove.forEach(child => {
    newSpmContent.appendChild(child);
  });

  // Insert spm_content as the only child of spm_body
  spmBody.appendChild(newSpmContent);
};

/**
 * Ensure required classes are present on [id^=spm_body].spm_display_V4 for display V4 templates
 */
export const ensureDisplayTemplateClasses = () => {
  const template = getTemplateIframeDocument();
  if (!template) return;

  const spmBody = template.querySelector("[id^=spm_body]");
  if (!spmBody) return;

  // Ensure spm_display_V4 class is present for version 4 templates
  if (
    state.template?.version === 4 &&
    !spmBody.classList.contains("spm_display_V4")
  ) {
    spmBody.classList.add("spm_display_V4");
  }

  // Only proceed with V4-specific classes if spm_display_V4 is present
  if (!spmBody.classList.contains("spm_display_V4")) return;

  const parentType = getTemplateParentTypeByType(state.template?.type);

  // Embed V4: ensure spm_embed class
  if (
    parentType === TemplateParentTypeEnum.EMBED &&
    !spmBody.classList.contains("spm_embed")
  ) {
    spmBody.classList.add("spm_embed");
  }
};

/**
 * Initialize whatsapp_data.smartlist with default values if it doesn't exist
 */
const initializeWhatsappSmartlistConfig = () => {
  if (!state.template || !isWhatsappTemplate(state.template.type)) return;

  const defaultLang = getShopDefaultLang();
  const configuration = state.template.configuration as
    | Record<string, any>
    | undefined;
  const whatsappData = configuration?.whatsapp_data as
    | Record<string, any>
    | undefined;

  // Check if smartlist already exists for default language
  if (whatsappData?.[defaultLang]?.smartlist) return;

  // Initialize smartlist config with default values for all languages
  const defaultSmartlistConfig = {
    enabled: "false",
    engine: "crossselling",
    nb_weeks: "4",
    nb: "3",
    ids: "",
    excluded_ids: "",
    excluded_categories: "",
    excluded_manufacturers: "",
    displayedElements: [
      "spm_product_list_element_title",
      "spm_product_list_element_image"
    ],
    buttonText: ""
  };

  const languages = UserState.activeShop?.langs.map(lang => lang.id) ?? [
    defaultLang
  ];
  const updatedWhatsappData = { ...(whatsappData ?? {}) };

  languages.forEach(lang => {
    if (!updatedWhatsappData[lang]) {
      updatedWhatsappData[lang] = {};
    }
    if (!updatedWhatsappData[lang].smartlist) {
      updatedWhatsappData[lang].smartlist = { ...defaultSmartlistConfig };
    }
  });

  setTemplateConfigurationKeyInState("whatsapp_data", updatedWhatsappData);
};

/**
 * Ensure the whatsapp smartlist carousel exists in the HTML
 * Creates a carousel with product cards including image, title, description, price and button
 */
const ensureWhatsappSmartlistCarousel = () => {
  if (!state.template || !isWhatsappTemplate(state.template.type)) return;

  const template = getTemplateIframeDocument();
  if (!template) return;

  // Carousel should be after .whatsapp-message (as a sibling), not inside it
  const whatsappMessage = template.querySelector(
    ".whatsapp-message"
  ) as HTMLElement | null;
  if (!whatsappMessage) return;

  const spmBody = template.querySelector("#spm_body") as HTMLElement | null;
  if (!spmBody) return;

  // Check if carousel already exists
  const existingCarousel = spmBody.querySelector(
    ".whatsapp-smartlist-carousel"
  ) as HTMLElement | null;
  if (existingCarousel) {
    // Check if navigation buttons exist, add them if missing
    const existingNavButtons = existingCarousel.querySelectorAll(
      ".whatsapp-smartlist-nav"
    );

    if (existingNavButtons.length === 0) {
      // Add prev button at the beginning
      const prevButton = template.createElement("button");
      prevButton.className =
        "whatsapp-smartlist-nav whatsapp-smartlist-nav--prev";
      prevButton.type = "button";
      prevButton.innerHTML = faChevronLeft;
      existingCarousel.insertBefore(prevButton, existingCarousel.firstChild);

      // Add next button after the cards container
      const nextButton = template.createElement("button");
      nextButton.className =
        "whatsapp-smartlist-nav whatsapp-smartlist-nav--next";
      nextButton.type = "button";
      nextButton.innerHTML = faChevronRight;
      const cardsContainer = existingCarousel.querySelector(
        ".whatsapp-smartlist-cards"
      );
      if (cardsContainer) {
        cardsContainer.after(nextButton);
      } else {
        existingCarousel.appendChild(nextButton);
      }
    }

    // Update visibility based on current enabled state
    const defaultLang = getShopDefaultLang();
    const whatsappData = state.template.configuration?.whatsapp_data as
      | Record<string, any>
      | undefined;
    const smartlistConfig = whatsappData?.[defaultLang]?.smartlist as
      | Record<string, any>
      | undefined;
    const isEnabled = smartlistConfig?.enabled === "true";
    if (isEnabled) {
      existingCarousel.classList.add("smartlist-enabled");
    } else {
      existingCarousel.classList.remove("smartlist-enabled");
    }
    // Attach navigation event listeners to existing carousel
    attachCarouselNavigation(existingCarousel);
    // Setup observer to sync button text
    setupButtonTextSync(existingCarousel);
    return;
  }

  const DEFAULT_BUTTON_TEXT = "Voir le produit";

  // Create the carousel container (no s-* attributes here - they go on the cards container)
  const carousel = template.createElement("div");
  carousel.classList.add("whatsapp-smartlist-carousel");

  // Create carousel inner HTML with navigation arrows and product cards
  // The s-* attributes are on whatsapp-smartlist-card so only the card element is duplicated
  carousel.innerHTML = `
    <button class="whatsapp-smartlist-nav whatsapp-smartlist-nav--prev" type="button">${faChevronLeft}</button>
    <div class="whatsapp-smartlist-cards spm_no_translate">
      <div class="whatsapp-smartlist-card" s-collection="products" s-item="product" s-grid="1" s-nb="3" s-engine="crossselling" s-ids="" s-excluded_ids="" s-excluded_categories="" s-excluded_manufacturers="" s-nb_weeks="4">
        <div class="whatsapp-smartlist-card__image spm_product_list_element_image">
          <img src="{var=product.image_url resize=400x400 resizeType=fill-to-fit}" alt="{var=product.name}" />
        </div>
        <div class="whatsapp-smartlist-card__content">
          <div class="whatsapp-smartlist-card__title spm_product_list_element_title">{var=product.name truncate="50"}</div>
          <div class="whatsapp-smartlist-card__description spm_product_list_element_description">{var=product.description_short truncate="100"}</div>
          <div class="whatsapp-smartlist-card__price spm_product_list_element_price">{var=product.price}</div>
        </div>
        <div class="whatsapp-smartlist-card__button">
          <span class="whatsapp-smartlist-buttontext">${DEFAULT_BUTTON_TEXT}</span>
        </div>
      </div>
    </div>
    <button class="whatsapp-smartlist-nav whatsapp-smartlist-nav--next" type="button">${faChevronRight}</button>
    <div class="whatsapp-smartlist-buttontext-source" style="position:absolute;left:-9999px;top:-9999px;pointer-events:none;">${DEFAULT_BUTTON_TEXT}</div>
  `;

  // Insert carousel after the whatsapp message (as a sibling)
  whatsappMessage.after(carousel);

  // Set initial visibility based on smartlist enabled state
  const defaultLang = getShopDefaultLang();
  const whatsappData = state.template.configuration?.whatsapp_data as
    | Record<string, any>
    | undefined;
  const smartlistConfig = whatsappData?.[defaultLang]?.smartlist as
    | Record<string, any>
    | undefined;
  const isEnabled = smartlistConfig?.enabled === "true";
  if (isEnabled) {
    carousel.classList.add("smartlist-enabled");
  }

  // Generate translation for the button text source element (hidden, used for translation panel)
  const buttonSourceElement = carousel.querySelector(
    ".whatsapp-smartlist-buttontext-source"
  ) as HTMLElement;
  if (buttonSourceElement) {
    const {
      newHtml,
      translationsArray
    } = generateTranslations(buttonSourceElement.outerHTML, {
      newElement: true
    });
    buttonSourceElement.outerHTML = newHtml;

    // Get section ID from template
    const sectionId = state.template.sections?.[0]?.id_template_elements ?? -1;

    // Add translations to state
    if (translationsArray.length > 0 && state.template) {
      const existingKeys = new Set(state.template.translations.map(t => t.key));

      translationsArray.forEach(t => {
        if (existingKeys.has(t.key)) {
          state.template!.translations.forEach(existing => {
            if (existing.key === t.key && existing.section === -1) {
              existing.section = sectionId as number;
            }
          });
        } else {
          state.template!.translations.push({ ...t, section: sectionId });
        }
      });
    }
  }

  // Attach navigation event listeners
  attachCarouselNavigation(carousel);

  // Setup observer to sync button text from source to visible buttons
  // Must be called after translation generation so we get the updated element
  setTimeout(() => {
    setupButtonTextSync(carousel);
    setupCtaSync();
  }, 0);
};

/**
 * Initialize richtexting_data.smartlist with default values if it doesn't exist
 */
const initializeRcsSmartlistConfig = () => {
  if (!state.template || !isRichTextingTemplate(state.template.type)) return;

  const defaultLang = getShopDefaultLang();
  const configuration = state.template.configuration as
    | Record<string, any>
    | undefined;
  const rcsData = configuration?.richtexting_data as
    | Record<string, any>
    | undefined;

  if (rcsData?.[defaultLang]?.smartlist) return;

  const defaultSmartlistConfig = {
    enabled: "false",
    engine: "crossselling",
    nb_weeks: "4",
    nb: "3",
    ids: "",
    excluded_ids: "",
    excluded_categories: "",
    excluded_manufacturers: "",
    displayedElements: [
      "spm_product_list_element_title",
      "spm_product_list_element_image"
    ],
    buttonText: ""
  };

  const languages = UserState.activeShop?.langs.map(lang => lang.id) ?? [
    defaultLang
  ];
  const updatedRcsData = { ...(rcsData ?? {}) };

  languages.forEach(lang => {
    if (!updatedRcsData[lang]) {
      updatedRcsData[lang] = {};
    }
    if (!updatedRcsData[lang].smartlist) {
      updatedRcsData[lang].smartlist = { ...defaultSmartlistConfig };
    }
  });

  setTemplateConfigurationKeyInState("richtexting_data", updatedRcsData);
};

/**
 * Ensure the RCS smartlist carousel exists in the HTML
 * Mirrors ensureWhatsappSmartlistCarousel exactly
 */
const ensureRcsSmartlistCarousel = () => {
  if (!state.template || !isRichTextingTemplate(state.template.type)) return;

  const template = getTemplateIframeDocument();
  if (!template) return;

  // Carousel should be after .rcs-message (as a sibling), not inside it
  const rcsMessage = template.querySelector(
    ".rcs-message"
  ) as HTMLElement | null;
  if (!rcsMessage) return;

  const spmBody = template.querySelector("#spm_body") as HTMLElement | null;
  if (!spmBody) return;

  // Check if carousel already exists
  const existingCarousel = spmBody.querySelector(
    ".rcs-smartlist-carousel"
  ) as HTMLElement | null;
  if (existingCarousel) {
    // If existing carousel is corrupted (missing cards container), remove it and recreate
    if (!existingCarousel.querySelector(".rcs-smartlist-cards")) {
      existingCarousel.remove();
    } else {
      // Remove legacy nav buttons if they exist
      existingCarousel
        .querySelectorAll(".rcs-smartlist-nav")
        .forEach(el => el.remove());

      // Update visibility based on current enabled state
      const defaultLang = getShopDefaultLang();
      const rcsData = state.template.configuration?.richtexting_data as
        | Record<string, any>
        | undefined;
      const smartlistConfig = rcsData?.[defaultLang]?.smartlist as
        | Record<string, any>
        | undefined;
      const isEnabled = smartlistConfig?.enabled === "true";
      if (isEnabled) {
        existingCarousel.classList.add("smartlist-enabled");
      } else {
        existingCarousel.classList.remove("smartlist-enabled");
      }
      // Setup observer to sync button text
      setupRcsButtonTextSync(existingCarousel);
      return;
    }
  }

  const DEFAULT_BUTTON_TEXT = "Voir le produit";

  // Create the carousel container
  const carousel = template.createElement("div");
  carousel.classList.add("rcs-smartlist-carousel");

  // Create carousel inner HTML with product cards (no navigation arrows, direct scroll)
  carousel.innerHTML = `
    <div class="rcs-smartlist-cards spm_no_translate">
      <div class="rcs-smartlist-card" s-collection="products" s-item="product" s-grid="1" s-nb="3" s-engine="crossselling" s-ids="" s-excluded_ids="" s-excluded_categories="" s-excluded_manufacturers="" s-nb_weeks="4">
        <div class="rcs-smartlist-card__image spm_product_list_element_image">
          <img src="{var=product.image_url resize=400x400 resizeType=fill-to-fit}" alt="{var=product.name}" />
        </div>
        <div class="rcs-smartlist-card__content">
          <div class="rcs-smartlist-card__title spm_product_list_element_title">{var=product.name truncate="50"}</div>
          <div class="rcs-smartlist-card__description spm_product_list_element_description">{var=product.description_short truncate="100"}</div>
          <div class="rcs-smartlist-card__price spm_product_list_element_price">{var=product.price}</div>
        </div>
        <div class="rcs-smartlist-card__button">
          <span class="rcs-smartlist-buttontext">${DEFAULT_BUTTON_TEXT}</span>
        </div>
      </div>
    </div>
    <div class="rcs-smartlist-buttontext-source" style="position:absolute;left:-9999px;top:-9999px;pointer-events:none;">${DEFAULT_BUTTON_TEXT}</div>
  `;

  // Insert carousel after the rcs message (as a sibling)
  rcsMessage.after(carousel);

  // Set initial visibility based on smartlist enabled state
  const defaultLang = getShopDefaultLang();
  const rcsData = state.template.configuration?.richtexting_data as
    | Record<string, any>
    | undefined;
  const smartlistConfig = rcsData?.[defaultLang]?.smartlist as
    | Record<string, any>
    | undefined;
  const isEnabled = smartlistConfig?.enabled === "true";
  if (isEnabled) {
    carousel.classList.add("smartlist-enabled");
  }

  // Generate translation for the button text source element (hidden, used for translation panel)
  const buttonSourceElement = carousel.querySelector(
    ".rcs-smartlist-buttontext-source"
  ) as HTMLElement;
  if (buttonSourceElement) {
    const {
      newHtml,
      translationsArray
    } = generateTranslations(buttonSourceElement.outerHTML, {
      newElement: true
    });
    buttonSourceElement.outerHTML = newHtml;

    // Get section ID from template
    const sectionId = state.template.sections?.[0]?.id_template_elements ?? -1;

    // Add translations to state
    if (translationsArray.length > 0 && state.template) {
      const existingKeys = new Set(state.template.translations.map(t => t.key));

      translationsArray.forEach(t => {
        if (existingKeys.has(t.key)) {
          state.template!.translations.forEach(existing => {
            if (existing.key === t.key && existing.section === -1) {
              existing.section = sectionId as number;
            }
          });
        } else {
          state.template!.translations.push({ ...t, section: sectionId });
        }
      });
    }
  }

  // Setup observer to sync button text from source to visible buttons
  // Must be called after translation generation so we get the updated element
  setTimeout(() => {
    setupRcsButtonTextSync(carousel);
    setupRcsCtaSync();
  }, 0);
};

/**
 * Setup MutationObserver to sync button text from hidden source to visible buttons
 */
const setupButtonTextSync = (carousel: HTMLElement) => {
  // Re-query from iframe document to get the updated element after outerHTML replacement
  const iframeDoc = getTemplateIframeDocument();
  const source = iframeDoc?.querySelector(
    ".whatsapp-smartlist-buttontext-source"
  ) as HTMLElement;
  if (!source) return;

  // Function to sync text from source to all visible buttons
  const syncButtonText = () => {
    const iframeDoc = getTemplateIframeDocument();
    if (!iframeDoc) return;

    // Re-query source element each time to get current state
    const currentSource = iframeDoc.querySelector(
      ".whatsapp-smartlist-buttontext-source"
    ) as HTMLElement;
    if (!currentSource) return;

    // Get text from translation node or source directly
    // Note: the tag is 'spmtranslation' (no hyphen) in the DOM
    const translationNode = currentSource.querySelector(
      "spmtranslation"
    ) as HTMLElement;
    const text = translationNode?.innerHTML ?? currentSource.textContent ?? "";

    // Update all visible buttons
    const buttons = iframeDoc.querySelectorAll(
      ".whatsapp-smartlist-buttontext"
    );
    buttons.forEach(button => {
      button.textContent = text;
    });
  };

  // Cleanup previous button text observers before creating new ones
  whatsappButtonTextObservers.forEach(obs => obs.disconnect());
  whatsappButtonTextObservers.length = 0;

  // Create observer to watch for changes in the source element and its children
  const observer = new MutationObserver(() => {
    syncButtonText();
  });

  // Observe the source element for child changes (when spm-translation is added)
  observer.observe(source, {
    childList: true,
    subtree: true,
    characterData: true
  });
  whatsappButtonTextObservers.push(observer);

  // Also observe the parent document for attribute changes on spm-translation elements
  // This catches when the translation system updates the content
  if (iframeDoc) {
    const docObserver = new MutationObserver(mutations => {
      // Check if any mutation affects our source element
      const affectsSource = mutations.some(m => {
        const target = m.target as HTMLElement;
        return target.closest?.(".whatsapp-smartlist-buttontext-source");
      });
      if (affectsSource) {
        syncButtonText();
      }
    });
    docObserver.observe(iframeDoc.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    whatsappButtonTextObservers.push(docObserver);
  }

  // Initial sync
  syncButtonText();
};

/**
 * Sync CTAs from body message to carousel cards
 */
const syncCtasToCarouselCards = () => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return;

  // Check if smartlist is enabled
  const carousel = iframeDoc.querySelector(".whatsapp-smartlist-carousel");
  if (!carousel?.classList.contains("smartlist-enabled")) return;

  // Get CTAs from body message
  const ctaListContainer = iframeDoc.querySelector(
    ".whatsapp-message__cta__list"
  );
  if (!ctaListContainer) return;

  const ctaElements = ctaListContainer.querySelectorAll(
    ".whatsapp-message__cta__item"
  );
  if (ctaElements.length === 0) return;

  // Get first CTA text (only 1 CTA allowed on carousel cards)
  const firstCta = ctaElements[0];
  const translationNode = firstCta.querySelector("spmtranslation");
  const ctaText = translationNode?.innerHTML || firstCta.textContent || "";
  const translationId =
    translationNode
      ?.getAttribute("id")
      ?.replace("LANG_", "")
      .split(".")[0] || "";

  // Update all CTA elements on carousel cards
  const carouselCtas = iframeDoc.querySelectorAll(".whatsapp-smartlist-cta");
  carouselCtas.forEach(cta => {
    cta.textContent = ctaText;
    cta.setAttribute("data-translation-id", translationId);
  });
};

/**
 * Setup MutationObserver to sync CTAs from body message to carousel cards
 */
const setupCtaSync = () => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return;

  const ctaListContainer = iframeDoc.querySelector(
    ".whatsapp-message__cta__list"
  );
  if (!ctaListContainer) return;

  // Cleanup previous CTA observers before creating new ones
  whatsappCtaObservers.forEach(obs => obs.disconnect());
  whatsappCtaObservers.length = 0;

  // Create observer to watch for changes in CTA elements
  const observer = new MutationObserver(() => {
    syncCtasToCarouselCards();
  });

  observer.observe(ctaListContainer, {
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true
  });
  whatsappCtaObservers.push(observer);

  // Also observe the whole body for CTA changes (in case elements are replaced)
  const bodyObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      // Check if any CTA-related element was modified
      if (mutation.target instanceof Element) {
        const target = mutation.target as Element;
        if (
          target.closest(".whatsapp-message__cta__item") ||
          target.classList?.contains("whatsapp-message__cta__item")
        ) {
          syncCtasToCarouselCards();
          break;
        }
      }
    }
  });

  bodyObserver.observe(iframeDoc.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
  whatsappCtaObservers.push(bodyObserver);

  // Initial sync
  syncCtasToCarouselCards();
};

/**
 * Setup MutationObserver to sync RCS button text from hidden source to visible buttons
 */
const setupRcsButtonTextSync = (carousel: HTMLElement) => {
  const iframeDoc = getTemplateIframeDocument();
  const source = iframeDoc?.querySelector(
    ".rcs-smartlist-buttontext-source"
  ) as HTMLElement;
  if (!source) return;

  const syncButtonText = () => {
    const iframeDoc = getTemplateIframeDocument();
    if (!iframeDoc) return;

    const currentSource = iframeDoc.querySelector(
      ".rcs-smartlist-buttontext-source"
    ) as HTMLElement;
    if (!currentSource) return;

    const translationNode = currentSource.querySelector(
      "spmtranslation"
    ) as HTMLElement;
    const text = translationNode?.innerHTML ?? currentSource.textContent ?? "";

    const buttons = iframeDoc.querySelectorAll(".rcs-smartlist-buttontext");
    buttons.forEach(button => {
      button.textContent = text;
    });
  };

  rcsButtonTextObservers.forEach(obs => obs.disconnect());
  rcsButtonTextObservers.length = 0;

  const observer = new MutationObserver(() => {
    syncButtonText();
  });

  observer.observe(source, {
    childList: true,
    subtree: true,
    characterData: true
  });
  rcsButtonTextObservers.push(observer);

  if (iframeDoc) {
    const docObserver = new MutationObserver(mutations => {
      const affectsSource = mutations.some(m => {
        const target = m.target as HTMLElement;
        return target.closest?.(".rcs-smartlist-buttontext-source");
      });
      if (affectsSource) {
        syncButtonText();
      }
    });
    docObserver.observe(iframeDoc.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    rcsButtonTextObservers.push(docObserver);
  }

  syncButtonText();
};

/**
 * Sync RCS CTAs from body message to carousel cards
 */
const syncRcsCtasToCarouselCards = () => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return;

  const carousel = iframeDoc.querySelector(".rcs-smartlist-carousel");
  if (!carousel?.classList.contains("smartlist-enabled")) return;

  const ctaListContainer = iframeDoc.querySelector(".rcs-message__cta__list");
  if (!ctaListContainer) return;

  const ctaElements = ctaListContainer.querySelectorAll(
    ".rcs-message__cta__item"
  );
  if (ctaElements.length === 0) return;

  const firstCta = ctaElements[0];
  const translationNode = firstCta.querySelector("spmtranslation");
  const ctaText = translationNode?.innerHTML || firstCta.textContent || "";
  const translationId =
    translationNode
      ?.getAttribute("id")
      ?.replace("LANG_", "")
      .split(".")[0] || "";

  const carouselCtas = iframeDoc.querySelectorAll(".rcs-smartlist-cta");
  carouselCtas.forEach(cta => {
    cta.textContent = ctaText;
    cta.setAttribute("data-translation-id", translationId);
  });
};

/**
 * Setup MutationObserver to sync RCS CTAs from body message to carousel cards
 */
const setupRcsCtaSync = () => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return;

  const ctaListContainer = iframeDoc.querySelector(".rcs-message__cta__list");
  if (!ctaListContainer) return;

  rcsCtaObservers.forEach(obs => obs.disconnect());
  rcsCtaObservers.length = 0;

  const observer = new MutationObserver(() => {
    syncRcsCtasToCarouselCards();
  });

  observer.observe(ctaListContainer, {
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true
  });
  rcsCtaObservers.push(observer);

  const bodyObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.target instanceof Element) {
        const target = mutation.target as Element;
        if (
          target.closest(".rcs-message__cta__item") ||
          target.classList?.contains("rcs-message__cta__item")
        ) {
          syncRcsCtasToCarouselCards();
          break;
        }
      }
    }
  });

  bodyObserver.observe(iframeDoc.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
  rcsCtaObservers.push(bodyObserver);

  syncRcsCtasToCarouselCards();
};

/**
 * Update carousel arrows visibility based on number of cards (WhatsApp only)
 * Exported so it can be called after refreshWhatsappSmartlist updates the cards
 */
export const updateCarouselArrowsVisibility = () => {
  const doc = getTemplateIframeDocument();
  if (!doc) return;

  // Handle WhatsApp carousel
  const waContainer = doc.querySelector(
    ".whatsapp-smartlist-cards"
  ) as HTMLElement;
  const waPrev = doc.querySelector(
    ".whatsapp-smartlist-nav--prev"
  ) as HTMLElement;
  const waNext = doc.querySelector(
    ".whatsapp-smartlist-nav--next"
  ) as HTMLElement;

  if (waContainer && waPrev && waNext) {
    const { scrollLeft } = waContainer;
    const maxScroll = waContainer.scrollWidth - waContainer.clientWidth;
    const cards = waContainer.querySelectorAll(".whatsapp-smartlist-card");

    if (cards.length <= 1) {
      waPrev.style.display = "none";
      waNext.style.display = "none";
    } else {
      waPrev.style.display = scrollLeft <= 0 ? "none" : "flex";
      waNext.style.display = scrollLeft >= maxScroll - 1 ? "none" : "flex";
      if (maxScroll <= 0) {
        waNext.style.display = "flex";
      }
    }
  }
};

const attachCarouselNavigation = (carousel: HTMLElement) => {
  const iframeDoc = getTemplateIframeDocument();
  if (!iframeDoc) return;

  const updateArrowsVisibility = () => {
    updateCarouselArrowsVisibility();
  };

  setTimeout(updateArrowsVisibility, 100);

  iframeDoc.body.addEventListener("click", e => {
    const target = e.target as HTMLElement;

    const nextBtn = target.closest(".whatsapp-smartlist-nav--next");
    if (nextBtn) {
      e.preventDefault();
      e.stopPropagation();
      const doc = getTemplateIframeDocument();
      const container = doc?.querySelector(
        ".whatsapp-smartlist-cards"
      ) as HTMLElement;
      const firstCard = doc?.querySelector(
        ".whatsapp-smartlist-card"
      ) as HTMLElement;
      const cardWidth = firstCard?.getBoundingClientRect().width || 350;
      if (container) {
        container.scrollBy({ left: cardWidth, behavior: "smooth" });
        setTimeout(updateArrowsVisibility, 350);
      }
      return;
    }

    const prevBtn = target.closest(".whatsapp-smartlist-nav--prev");
    if (prevBtn) {
      e.preventDefault();
      e.stopPropagation();
      const doc = getTemplateIframeDocument();
      const container = doc?.querySelector(
        ".whatsapp-smartlist-cards"
      ) as HTMLElement;
      const firstCard = doc?.querySelector(
        ".whatsapp-smartlist-card"
      ) as HTMLElement;
      const cardWidth = firstCard?.getBoundingClientRect().width || 350;
      if (container) {
        container.scrollBy({ left: -cardWidth, behavior: "smooth" });
        setTimeout(updateArrowsVisibility, 350);
      }
    }
  });

  const cardsContainer = iframeDoc.querySelector(
    ".whatsapp-smartlist-cards"
  ) as HTMLElement;
  if (cardsContainer) {
    cardsContainer.addEventListener("scroll", updateArrowsVisibility);
  }
};

/**
 * Prepare template for edition when opening
 */
/**
 * Rebuild data-prizes in the iframe DOM from template_config's games_data.
 * This ensures the HTML always reflects the saved configuration (source of truth),
 * fixing any desynchronization between the stored HTML and template_config.
 * Also ensures templateIds are base64 encoded as expected by spm-games.js.
 */
const ensureGamePrizeTemplateIdsEncoded = () => {
  const template = getTemplateIframeDocument();
  if (!template || !state.template) return;

  const gamesData = state.template.configuration.games_data;

  // Wheel
  const wheelElement = template.querySelector('.spm_widget_game_wheel');
  if (wheelElement) {
    const configPrizes = gamesData?.wheel?.prizes;

    // If games_data has prizes, rebuild data-prizes entirely from it (source of truth)
    if (configPrizes && configPrizes.length > 0) {
      const prizesForDom = configPrizes.map((prize: any) => ({
        label: prize.label || '',
        ...(prize.translationKey ? { translationKey: prize.translationKey } : {}),
        ...(prize.templateId ? { templateId: btoa(String(prize.templateId)) } : {}),
        probability: Number(prize.probability) || 0,
        color: prize.color || '',
        image: prize.image || '',
        // Stock limit is part of the saved config: without it the rebuild silently dropped
        // every stock on each reload, and the next save persisted the loss (SC-3828)
        ...(Number(prize.stock) > 0 ? { stock: Number(prize.stock) } : {}),
      }));
      wheelElement.setAttribute('data-prizes', JSON.stringify(prizesForDom));
    } else {
      // Fallback: no games_data — just fix base64 encoding on existing data-prizes
      try {
        const prizes = JSON.parse(wheelElement.getAttribute('data-prizes') || '[]');
        let needsUpdate = false;

        prizes.forEach((prize: any) => {
          if (typeof prize.templateId === 'number' && prize.templateId > 0) {
            prize.templateId = btoa(String(prize.templateId));
            needsUpdate = true;
          }
        });

        if (needsUpdate) {
          wheelElement.setAttribute('data-prizes', JSON.stringify(prizes));
        }
      } catch (e) {
        // Ignore parse errors
      }
    }
  }

  // Slot machine
  const slotElement = template.querySelector('.spm_widget_game_slot_machine');
  if (slotElement) {
    const configPrizes = gamesData?.slotMachine?.prizes;

    if (configPrizes && configPrizes.length > 0) {
      // Rebuild win-combinations templateIds from games_data (source of truth)
      try {
        const combinations = JSON.parse(slotElement.getAttribute('data-win-combinations') || '[]');
        let needsUpdate = false;
        configPrizes.forEach((prize: any, index: number) => {
          if (prize.templateId && combinations[index]) {
            combinations[index].templateId = btoa(String(prize.templateId));
            needsUpdate = true;
          }
        });
        if (needsUpdate) {
          slotElement.setAttribute('data-win-combinations', JSON.stringify(combinations));
        }
      } catch (e) {
        // Ignore parse errors
      }
    } else {
      // Fallback: fix base64 encoding on existing data-win-combinations
      try {
        const combinations = JSON.parse(slotElement.getAttribute('data-win-combinations') || '[]');
        let needsUpdate = false;

        combinations.forEach((combo: any) => {
          if (typeof combo.templateId === 'number' && combo.templateId > 0) {
            combo.templateId = btoa(String(combo.templateId));
            needsUpdate = true;
          }
        });

        if (needsUpdate) {
          slotElement.setAttribute('data-win-combinations', JSON.stringify(combinations));
        }
      } catch (e) {
        // Ignore parse errors
      }
    }
  }

  // Scratch card
  const scratchElement = template.querySelector('.spm_widget_game_scratch_card');
  if (scratchElement) {
    const configPrizes = gamesData?.scratchCard?.prizes;

    if (configPrizes && configPrizes.length > 0) {
      const prizesForDom = configPrizes.map((prize: any) => ({
        label: prize.label || '',
        ...(prize.translationKey ? { translationKey: prize.translationKey } : {}),
        ...(prize.templateId ? { templateId: btoa(String(prize.templateId)) } : {}),
        probability: Number(prize.probability) || 0,
        color: '',
        image: prize.image || '',
        // Same as the wheel: keep the stock limit stored in games_data (SC-3828)
        ...(Number(prize.stock) > 0 ? { stock: Number(prize.stock) } : {}),
      }));
      scratchElement.setAttribute('data-prizes', JSON.stringify(prizesForDom));
    } else {
      // Fallback: fix base64 encoding on existing data-prizes
      try {
        const prizes = JSON.parse(scratchElement.getAttribute('data-prizes') || '[]');
        let needsUpdate = false;

        prizes.forEach((prize: any) => {
          if (typeof prize.templateId === 'number' && prize.templateId > 0) {
            prize.templateId = btoa(String(prize.templateId));
            needsUpdate = true;
          }
        });

        if (needsUpdate) {
          scratchElement.setAttribute('data-prizes', JSON.stringify(prizes));
        }
      } catch (e) {
        // Ignore parse errors
      }
    }
  }
};

export const prepareTemplateForEdition = () => {
  // Convert old widgets' placeholders to new format
  convertOldWidgetsPlaceholders();

  // Wrap legacy email-v4 text widgets in .spm_rich_editor_wrapper so style panels apply
  upgradeLegacyTextWidgets();

  // Remove contenteditable attributes from old templates
  removeContentEditableFromOldTemplates();

  // Remove unused static CSS
  removeUnnecessaryStaticCss();

  // Add elements types by language
  addElementsTypesByLang();

  // Ensure spm_content div exists for display templates
  ensureSpmContentDivExists();

  // Ensure required classes are present on display V4 templates
  ensureDisplayTemplateClasses();

  // Initialize whatsapp smartlist config with default values
  initializeWhatsappSmartlistConfig();

  // Ensure whatsapp smartlist carousel exists
  ensureWhatsappSmartlistCarousel();

  // Refresh whatsapp smartlist products if enabled
  refreshWhatsappSmartlist();

  // Initialize RCS smartlist config with default values
  initializeRcsSmartlistConfig();

  // Ensure RCS smartlist carousel exists
  ensureRcsSmartlistCarousel();

  // Refresh RCS smartlist products if enabled
  refreshRcsSmartlist();

  // Ensure game prize templateIds are base64 encoded
  ensureGamePrizeTemplateIdsEncoded();
};

/**
 * Update section's ID for translations in case of a widget moves from a section to another
 * @param keys
 * @param newSectionId
 */
export const updateSectionIdOfTranslationsInState = (
  keys: string[],
  newSectionId: string | number
) => {
  if (state.template) {
    state.template.translations
      .filter((translation: Translation) =>
        keys.find(k => k === translation.key.split(".")[0])
      )
      .forEach((translation: Translation) => {
        // eslint-disable-next-line no-param-reassign
        translation.section = asInt(newSectionId);
      });
  }
};

export const moveWidgetFromSectionToAnother = (
  widgetHtml: string,
  widgetId: string,
  sectionFromId: string,
  sectionToId: string
) => {
  if (sectionFromId && sectionToId && sectionFromId !== sectionToId) {
    // We get all translation keys in widget to update their section's ID in state
    const regExpTranslations = new RegExp("LANG_[a-zA-Z0-9.]+", "g");

    // Matches all translation keys inside widget
    const matches = widgetHtml.matchAll(regExpTranslations);

    if (matches) {
      const keysList: string[] = [];

      // Loop on each translation key to store in array
      Array.from(matches, m => m[0]).forEach(match => {
        const key = match.split(".")[0].replace("LANG_", "");
        keysList.push(key);
      });

      // If we have keys to replace, we loop on translations in state to replace section's ID
      updateSectionIdOfTranslationsInState(keysList, sectionToId);
    }
    // Moves widget styles from one section to another in the document.
    moveDynamicStyleFromSectionToAnother(
      `#${widgetId}`,
      sectionFromId,
      sectionToId
    );
  }
};

/**
 * Insert an HTML string in a DOM element based on selector and position
 * @param template
 * @param element
 * @param selector
 * @param position
 */
export const insertEmbedTemplateInDom = (
  template: Document,
  element: Element,
  selector: string,
  position: string
) => {
  let targetElement = template.querySelector(selector);
  if (!targetElement) {
    targetElement = template.querySelector("body");
    position = "prepend";
  }
  if (targetElement) {
    switch (position) {
      case "append":
        // eslint-disable-next-line no-unused-expressions
        targetElement.insertAdjacentElement("beforeend", element);
        break;
      case "prepend":
        // eslint-disable-next-line no-unused-expressions
        targetElement.insertAdjacentElement("afterbegin", element);
        break;
      case "before":
        // eslint-disable-next-line no-unused-expressions
        targetElement.insertAdjacentElement("beforebegin", element);
        break;
      case "after":
        // eslint-disable-next-line no-unused-expressions
        targetElement.insertAdjacentElement("afterend", element);
        break;
      case "replace":
        // We add a class to the target element to hide it and insert the new element after
        targetElement.classList.add(BUILDER_EMBED_REPLACED_ELEMENT_CLASS);
        targetElement.insertAdjacentElement("afterend", element);
        break;
      default:
        // Insert at the end if no position
        targetElement.insertAdjacentElement("beforeend", element);
        break;
    }
  }
};

export const resetIframe = (element: HTMLElement | null = null) => {
  // Get shop's default language
  const defaultLanguage = getShopDefaultLang();

  triggerAdditionalEditorActivationFunctions();
  translateDocument(defaultLanguage, element);
  prepareTemplateForEdition();
  getSmartProductsListsOriginalStructure();
  resetListeners();
  refreshSmartProductList();
};

/**
 * Create HTML code for embedded element and insert in the chosen selector at chosen position
 */
export const insertEmbedTemplateInSelectedElement = () => {
  const template = getTemplateIframeDocument();

  // Remove current template if exists in DOM
  const element = template?.querySelector("spm-template");
  if (element) {
    element.remove();
  }

  // Remove class for hidden element on website
  const hiddenElement = template?.querySelector(
    `.${BUILDER_EMBED_REPLACED_ELEMENT_CLASS}`
  );
  if (hiddenElement) {
    hiddenElement.classList.remove(BUILDER_EMBED_REPLACED_ELEMENT_CLASS);
  }

  const spmTemplate = document.createElement("spm-template");
  spmTemplate.innerHTML = getActiveTemplateFullHtml();
  const selector = state.template?.configuration?.embedSelector;
  const position = state.template?.configuration?.embedPosition;
  insertEmbedTemplateInDom(template, spmTemplate, selector, position);
};
type TimeoutId = ReturnType<typeof setTimeout>;

const handlePropertyValuesChangeTimeouts: {
  [key: string]: TimeoutId | undefined;
} = {};

export const getCurrentTemplateVersion = (idShop: number) => {
  const template = getTemplateIframeDocument();
  if (!template) return null;
  const spmTemplate = template.querySelector('spm-template') as HTMLElement | null;
  if (!spmTemplate) return null;

  const data = {
    html: "",
    css: [] as string[]
  };
  const newHtml = sanitizeSection(spmTemplate, true);
  data.html = newHtml?.innerHTML as string;
  data.css = Array.from(
    template.querySelectorAll("style[data-spm-styles]")
  ).map(style => style.innerHTML);

  const params = {
    idShop,
    idTemplate: state.template?.id ?? 0
  };

  const url =
    template.querySelector("#spm_body")?.getAttribute("data-target-url") ||
    (UserState.activeShop?.url ? btoa(UserState.activeShop.url) : undefined);

  return { data, params, url };
};

export const updateTemplatePreviewDisplay = () => {
  if (isDisplayTemplate(state.template?.type)) {
    store.commit("liveEditor/setUpdateDisplayPreview", true);
  }
};

export const handlePropertyValuesChange = async (
  { selector, properties }: { selector: string; properties: Array<Property> },
  updateSelectedStructure?: {
    tabItemLabel?: string;
    fieldGroupLabel?: string;
    fieldLabel?: string;
    subGroupLabel?: string;
    nestedTabLabel?: string;
  }
) => {
  if (updateSelectedStructure) {
    store.dispatch("liveEditor/updateSelectedStructureParserValues", {
      properties,
      ...updateSelectedStructure
    });
  }

  // Générer une clé unique basée sur selector et properties
  const key = `${selector}-${JSON.stringify(properties.map(p => p.name))}`;

  if (handlePropertyValuesChangeTimeouts[key] !== undefined) {
    clearTimeout(handlePropertyValuesChangeTimeouts[key] as TimeoutId);
  }

  // Récupérer property.callbacks avant la réduction
  const propertyCallbacksArray = properties.map(
    property => property.callbacks ?? [false]
  );
  // Récupérer property.refreshWidgetFields avant la réduction
  const propertyRefreshFieldsArray = properties.map(
    property => property.refreshWidgetFields ?? [false]
  );

  let currentTimeout = 0;
  if (propertyCallbacksArray[0] || propertyRefreshFieldsArray[0]) {
    currentTimeout = 50;
  }

  handlePropertyValuesChangeTimeouts[key] = (setTimeout(async () => {
    if (store.getters["liveEditor/getSelectedStructure"]) {
      const widgetId =
        store.getters["liveEditor/getSelectedStructure"].identifier;
      let needRefreshWidgetFields = false;

      await properties.reduce(async (a, property: Property) => {
        await a;

        // if property has callbacks
        await (property.preCallbacks ?? []).reduce(
          async (b, callback: Function) => {
            await b;
            if (typeof callback === "function") {
              await callback(widgetId);
            }
          },
          Promise.resolve()
        );

        // Update Property
        property.setters.forEach((setter: Function) =>
          setter(property.customSelector ?? selector, property, widgetId)
        );

        // Update translation in state
        updateTranslation(selector, property);

        // if property has callbacks
        await (property.callbacks ?? []).reduce(
          async (b, callback: Function) => {
            await b;
            if (typeof callback === "function") {
              await callback(widgetId);
            }
          },
          Promise.resolve()
        );

        // if widget fields need to be refreshed
        if (property.refreshWidgetFields) {
          needRefreshWidgetFields = true;
        }
      }, Promise.resolve());

      // if widget fields need to be refreshed
      if (needRefreshWidgetFields) {
        store.dispatch("liveEditor/refreshWidgetFields");
      }

      setChangeInLeftToolbar();
      markTemplateAsEdited();

      updateTemplatePreviewDisplay();
      updateTemplateConfigurationNextIdTemplate();
      // Remove the timeout from the object after execution
      delete handlePropertyValuesChangeTimeouts[key];
      store.commit("liveEditor/setWaitForChanges", false);
      if (store.getters["liveEditor/getChangesCallback"]) {
        store.getters["liveEditor/getChangesCallback"]();
      }
    }
  }, currentTimeout) as unknown) as TimeoutId;
};
const INITIAL_TEMPLATE_STRING_REMOVAL = {
  find: [
    "overflow-wrap:\\s?break-word;",
    "hyphens:\\s?auto;",
    // eslint-disable-next-line max-len
    "(<!--\\[if( gte)? mso( 9)?\\]><xml>\\s*\\t*<o:OfficeDocumentSettings>\\s*\\t*<o:AllowPNG\\s*\\t*/?>(</o:AllowPNG>)?\\s*\\t*<o:PixelsPerInch>96</o:PixelsPerInch>\\s*\\t*</o:OfficeDocumentSettings></xml><!\\[endif\\]-->){2,}"
  ],
  replace: ["", "", ""]
};

/**
 * Does some checks on template before integrating in live view to add properties, elements, ...
 * @param iframeElement
 */
export const templateChecksOnOpening = (iframeElement: Document): Document => {
  /**
   * Checks to do on HTML Elements
   */
  // Add cellspacing and cellpadding properties on table elements
  const tablesElements = iframeElement.querySelectorAll("table");

  if (tablesElements.length > 0) {
    tablesElements.forEach(table => {
      if (!table.hasAttribute("cellpadding")) {
        table.setAttribute("cellpadding", "0");
      }

      if (!table.hasAttribute("cellspacing")) {
        table.setAttribute("cellspacing", "0");
      }
    });
  }

  /**
   * Checks to do on HTML string
   */
  // Remove useless CSS properties from elements and stylesheets
  let htmlOfTemplate = iframeElement.documentElement.outerHTML;
  htmlOfTemplate = htmlOfTemplate.replaceArray(
    INITIAL_TEMPLATE_STRING_REMOVAL.find,
    INITIAL_TEMPLATE_STRING_REMOVAL.replace
  );
  // Rebuild spm-template element
  return createDomFromString(htmlOfTemplate);
};

// Validate InformationPanel settings
export const informationPanelSettingsValidate = async (
  onlyName = false,
  customValue: string | undefined = undefined
): Promise<ErrorConfigForm> => {
  const templateType = getTemplateParentTypeByType(state.template?.type);

  const data = computed(() => {
    let returnValue: any = {
      name: customValue ?? state.template?.informations.name
    };

    if (!onlyName) {
      if (templateType === TemplateParentTypeEnum.EMAIL) {
        returnValue = {
          ...returnValue,
          subject: state.template?.informations.subject,
          fromName: state.template?.informations.fromName,
          fromEmail: state.template?.informations.fromEmail
        };
      } else if (templateType === TemplateParentTypeEnum.SMS) {
        returnValue = {
          ...returnValue,
          fromName: state.template?.informations.fromName
        };
      }
    }

    return returnValue;
  });

  const rules = computed(() => {
    let rulesByType: any = {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(128)
      }
    };

    if (!onlyName) {
      if (templateType === TemplateParentTypeEnum.EMAIL) {
        rulesByType = {
          ...rulesByType,
          subject: {
            localizedTextInputValidator: localizedTextInputValidator("text")
          },
          fromName: {
            localizedTextInputValidator: localizedTextInputValidator("text")
          },
          fromEmail: {
            localizedTextInputValidator: localizedTextInputValidator("email")
          }
        };
      } else if (templateType === TemplateParentTypeEnum.SMS) {
        rulesByType = {
          ...rulesByType,
          fromName: {
            localizedTextInputValidator: localizedTextInputValidator(
              "smsSenderName"
            )
          }
        };
      }
    }

    return rulesByType;
  });

  const v$ = useVuelidate(rules, data);

  const success = await v$.value.$validate();
  return {
    success,
    validate: v$
  };
};

export const updateLastRollbackGroupId = (groupId: number) => {
  state.lastRollbackId = groupId;
};

export const setTestEmailSent = (value: boolean) => {
  state.testEmailSent = value;
};

export const setTemplateManually = (template: Template) => {
  state.template = template;
};

export const setTemplateWidth = (width: string) => {
  state.templateWidth = width;
};

const reloadSelectedStructureConfiguration = () => {
  const currentStructure = store.getters["liveEditor/getSelectedStructure"];
  if (currentStructure) {
    store.dispatch("liveEditor/prepareStructureConfiguration", {
      type: currentStructure.type,
      identifier: currentStructure.identifier,
      widgetType:
        currentStructure.type === TemplateStructureEnum.WIDGET
          ? getWidgetTypeFromTemplate(currentStructure.identifier)
          : null
    });
  }
  store.commit("liveEditor/refreshConfigurationPanelKey");
};

export const setEditorViewport = (target: EditorDevice | "desktop") => {
  if (target !== "desktop") {
    state.mobileDevice = target;
  }
  const width =
    target === "desktop" ? TemplateWidth.DESKTOP : `${target.width}px`;
  state.templateWidth = width;
  store.commit("liveEditor/setMobileEditMode", isMobileViewportWidth(width));

  const iframe = getTemplateIframe();
  if (iframe) {
    iframe.style.transition = "none";
    iframe.style.width = width;
    // Force reflow so getComputedStyle reads correct values
    // eslint-disable-next-line no-unused-expressions
    iframe.offsetWidth;
    requestAnimationFrame(() => {
      iframe.style.transition = "";
    });
  }

  clearDynamicStylesCache();
  clearCssPropertyCache();
  // Wait for the iframe internal viewport to update before reading CSS values
  requestAnimationFrame(() => {
    reloadSelectedStructureConfiguration();
  });
};

export const isMobileViewport = () => isMobileViewportWidth(state.templateWidth);

export const refreshSmartProductsListsOriginalStructure = (
  restoreBefore: boolean | null = null
) => {
  if (state.template) {
    const smartLists: SmartLists = {};
    let storeSmartList = true;
    const template = getTemplateIframeDocument();
    if (template) {
      if (restoreBefore) {
        // Restore original code of all smart lists
        restoreSmartListsOriginalCode();
      }
      const type: TemplateParentTypeEnum = getTemplateParentTypeByType(
        state.template?.type
      );
      const productsLists = template.querySelectorAll(
        `.${PRODUCTS_LISTS_CLASSES[type]}`
      );

      if (productsLists) {
        Array.from(productsLists).forEach(list => {
          const originalCode = list.querySelector(".originalCode");

          if (originalCode) {
            const { parentElement } = originalCode;

            if (parentElement) {
              parentElement.innerHTML = originalCode.innerHTML.trim();
            }
          }
          const widgetId = list.getAttribute("id") ?? "";
          if (list.innerHTML.match("s-engine=")) {
            smartLists[widgetId] = getWidgetCodeWithoutVmlShape(
              list as HTMLElement
            );
          } else if (!restoreBefore) {
            // Stop loop and restart with restoreBefore = true
            refreshSmartProductsListsOriginalStructure(true);
            storeSmartList = false;
          } else {
            storeSmartList = false;
          }
        });
      }
      if (storeSmartList) {
        state.template.smartLists = smartLists;
      }
      if (restoreBefore) {
        // Recalculate smart list with default language
        refreshSmartProductList();
      }
    }
  }
};

export const refreshAttributeInDOM = (locale: string, defaultKey = "") => {
  if (state.template) {
    const template = getTemplateIframeDocument();

    let defaultConditon = (translation: any) =>
      translation.fieldType === "attribute" && translation.language === locale;
    if (defaultKey) {
      defaultConditon = (translation: any) =>
        translation.fieldType === "attribute" &&
        translation.language === locale &&
        translation.key === defaultKey;
    }

    const translationAttributes = state.template.translations.filter(
      defaultConditon
    );

    translationAttributes.forEach(translation => {
      const key = `LANG_${translation.key}`;
      const matchesAttributes = template.body.innerHTML.match(
        new RegExp(`data-spmtranslationid-([^=]+)="${key}"`, "g")
      );

      if (matchesAttributes && matchesAttributes.length) {
        matchesAttributes.forEach(matchesAttribute => {
          const attributeRegex = new RegExp(
            `(${TRANSLATION_ATTRIBUTE}-[^=]*)=`,
            "gm"
          );
          const matches = matchesAttribute.match(attributeRegex);
          if (matches && matches.length) {
            const attribute = matches[0].replace("=", "");
            const elements = template.querySelectorAll(
              `[${attribute}="${key}"]`
            );
            elements.forEach(element => {
              const attribut = Array.from(element.attributes).find(
                attr => attr.name === attribute
              );
              let attributeName = "";
              if (attribut) {
                attributeName = attribut.name.substring(
                  "data-spmtranslationid-".length
                );
              }
              if (attributeName && element.hasAttribute(attributeName)) {
                element.setAttribute(attributeName, translation.value);
              }
            });
          }
        });
      }
    });
  }
};

export const fixTranslationsHrefAttribute = () => {
  if (state.template) {
    const template = getTemplateIframeDocument();
    const translationAttributes = state.template.translations.filter(
      translation => translation.fieldType === "attribute"
    );

    const keysToUpdate = new Set<string>();

    translationAttributes.forEach(translation => {
      const key = `LANG_${translation.key}`;
      const elements = template.querySelectorAll(
        `[data-spmtranslationid-href="${key}"]`
      );
      if (elements && elements.length) {
        keysToUpdate.add(translation.key);
        elements.forEach(element => {
          element.setAttribute("data-spmtranslationid-href", `${key}.href`);
        });
      }
    });

    Array.from(keysToUpdate).forEach(keyToUpdate => {
      const translations = state.template?.translations.filter(
        translation => translation.key === keyToUpdate
      );
      if (translations && translations.length) {
        translations.forEach(translation => {
          translation.fieldType = "link";
          translation.key = `${translation.key}.href`;
        });
      }
    });
  }
};

export const createHtmlTemplateFromZipFile = async (
  idShop: number,
  zipFile: ZipFile,
  templateType: string,
  uploadedExternalImage = 0,
  returnAndNewElement = false,
  widgetId = ""
): Promise<any> => {
  let { html } = zipFile;

  const uploadImageAndReplace = async (regex: RegExp, image: string) => {
    // eslint-disable-next-line no-await-in-loop
    const uploadResult = await uploadFileToMedia(image, idShop);
    if (uploadResult.data === false) {
      throw new Error();
    }
    const newPath = `${uploadResult.data.replace("\\", "")}`;
    html = html.replace(regex, `${newPath}`);
  };

  if (uploadedExternalImage) {
    // Upload external images and update old images paths
    const externalImagePathRegex = /(https?:\/\/[^"')]+\.(?:png|jpg|jpeg|gif))/gm;
    let imageMatch;
    const uploadedExternalImages = new Set();
    // eslint-disable-next-line no-cond-assign
    while ((imageMatch = externalImagePathRegex.exec(html)) !== null) {
      const imageLink = imageMatch[0];
      try {
        // eslint-disable-next-line no-await-in-loop
        const base64 = await getBase64FromUrl(imageLink);

        if (!uploadedExternalImages.has(imageLink)) {
          uploadedExternalImages.add(imageLink);

          // eslint-disable-next-line no-await-in-loop
          await uploadImageAndReplace(new RegExp(imageLink, "g"), base64);
        }
        // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  }

  // Upload local images and Update old images paths
  const uploadedLocallImages = new Set();
  // eslint-disable-next-line no-restricted-syntax
  for (const image of zipFile.images) {
    const { originalPath } = image;

    const escapedOriginalPath = originalPath.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );
    const originalPathRegex = new RegExp(
      `(?<="|'|\\()(?:[^"'\\(]*?${escapedOriginalPath}[^"'\\)]*?)(?="|'|\\))`,
      "g"
    );

    let localImageMatch;
    // eslint-disable-next-line no-cond-assign
    while ((localImageMatch = originalPathRegex.exec(html)) !== null) {
      const localImageLink = localImageMatch[0];
      // Check if the image is really local but not an external url
      if (
        localImageLink.match(
          new RegExp(`(?<!https{0,1}:\\/\\/.{0,})${escapedOriginalPath}`, "g")
        )
      ) {
        // eslint-disable-next-line no-await-in-loop
        if (!uploadedLocallImages.has(localImageLink)) {
          uploadedLocallImages.add(localImageLink);

          // eslint-disable-next-line no-await-in-loop
          await uploadImageAndReplace(originalPathRegex, image.base64String);
        }
      }
    }
  }

  const css: Record<string, any> = {};

  const addToCss = (cssString: string) => {
    const mediaQueryRegex = /@media[^{]+{([^{}]*({[^{}]*}[^{}]*)*)}/g;

    let mqMatch;

    let mobileKey = "dynamic_persistent_mobile";
    let key = "dynamic";
    if (widgetId) {
      mobileKey = `${CUSTOM_WIDGET_CSS_PREFIX}${
        widgetId.split(TEMPLATE_WIDGET_IDENTIFIER_PREFIX)[1]
      }_mobile`;
      key = `${CUSTOM_WIDGET_CSS_PREFIX}${
        widgetId.split(TEMPLATE_WIDGET_IDENTIFIER_PREFIX)[1]
      }`;
    }

    // eslint-disable-next-line no-cond-assign
    while ((mqMatch = mediaQueryRegex.exec(cssString)) !== null) {
      const rules = mqMatch[0].trim().replace(/\s\s+/g, " ");
      if (!css[mobileKey]) {
        css[mobileKey] = "";
      }
      css[mobileKey] += `${rules}\n`;
    }
    // Remove media queries from the CSS
    const cleanedCSS = cssString
      .replace(mediaQueryRegex, "")
      .trim()
      .replace(/\s*([{}])\s*/g, "$1");
    if (cleanedCSS) {
      if (!css[key]) {
        css[key] = "";
      }
      css[key] += `${cleanedCSS}\n\n`;
    }
  };

  // Add external css if linked in html file
  // eslint-disable-next-line no-restricted-syntax
  for (const cssFile of zipFile.cssFiles) {
    const { originalPath, cssString } = cssFile;

    const escapedOriginalPath = originalPath.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );
    const cssLinkRegex = new RegExp(
      `<link[^>]+href=['"](\\.\\/)?${escapedOriginalPath}['"][^>]*>`,
      "g"
    );

    if (html.match(cssLinkRegex)) {
      // Remove link in the html
      html = html.replace(cssLinkRegex, "");
      // Add css rules to css (dynamic and dynamic_persistent_mobile)
      addToCss(cssString);
    }
  }

  // Add inline css to css object and remove it from html
  const styleRegex = /<style.*?>([\s\S]*?)<\/style>/gi;
  let match;
  // eslint-disable-next-line no-cond-assign
  while ((match = styleRegex.exec(html)) !== null) {
    const cssString = match[1];
    addToCss(cssString);
  }
  // Remove inline css style from html
  html = beautifier.html(html.replace(styleRegex, ""));

  const cssBeautifyOptions = {
    "brace-style": "collapse",
    "selector-separator-newline": false,
    "newline-between-rules": false,
    "end-with-newline": false,
    "indent-size": 0
  };

  if (widgetId) {
    Object.keys(css).forEach(cssKey => {
      css[cssKey] = addSelectorToRules(css[cssKey], `#${widgetId}`);
    });
  }

  Object.keys(css).forEach(cssKey => {
    css[cssKey] = beautifier
      .css(css[cssKey], cssBeautifyOptions)
      .replace(/\n/g, "");
  });

  let cssString = JSON.stringify(css);

  // Sort css keys
  const cssOrder = [
    "static",
    "static_persistent",
    "static_persistent_mobile",
    "dynamic",
    "dynamic_persistent",
    "dynamic_persistent_mobile"
  ];

  const jsonMap = new Map<string, any>();
  cssOrder.forEach(key => {
    if (key in css) {
      jsonMap.set(key, css[key]);
    }
  });

  cssString = JSON.stringify(Object.fromEntries(jsonMap));

  const { newHtml, translations } = generateTranslations(html, {
    newElement: returnAndNewElement,
    translateVariables: false
  });

  if (returnAndNewElement) {
    const orderedCss = new Map<string, any>();
    Object.keys(css).forEach(key => {
      if (!key.match(/_mobile/g)) {
        orderedCss.set(key, css[key]);
      }
    });
    Object.keys(css).forEach(key => {
      if (key.match(/_mobile/g)) {
        orderedCss.set(key, css[key]);
      }
    });
    return {
      html: newHtml,
      css: orderedCss
    };
  }

  const inputsElements: TemplatesInputItem[] = [
    {
      id_shop: idShop,
      label: zipFile.name,
      type: templateType,
      version: 3,
      deleted: false,
      id_relaunch: 11,
      date_creation: moment().format("YYYY-MM-DD HH:mm:ss"),
      date_modification: moment().format("YYYY-MM-DD HH:mm:ss")
    }
  ];

  const { id, err } = await Insert<TemplatesInputItem>({
    name: "Templates",
    input: inputsElements,
    type: "TemplatesInput"
  });

  if (err === "") {
    if (UserState.activeShop && UserState.activeShop.langs.length) {
      // const templateLangs: TemplatesLangInputItem[] = UserState.activeShop.langs.map((lang) => ({
      //   body: '',
      //   lang: lang.id,
      //   id_template: id,
      // }));
      // await Insert<TemplatesLangInputItem>({
      //   name: 'TemplatesLang',
      //   input: templateLangs,
      //   type: 'TemplatesLangInput',
      // });
    }

    const templateElements: TemplatesElementsInputItem[] = [
      {
        id_template: id,
        id_shop: idShop,
        type: "design",
        data: null,
        html: newHtml,
        css: cssString,
        translations: JSON.stringify(translations),
        date_creation: moment().format("YYYY-MM-DD HH:mm:ss"),
        date_modification: moment().format("YYYY-MM-DD HH:mm:ss")
      }
    ];

    const { id: idTemplateElements, err: errTemplate } = await Insert<
      TemplatesElementsInputItem
    >({
      name: "TemplatesElements",
      input: templateElements,
      type: "TemplatesElementsInput"
    });
    if (errTemplate === "") {
      const informations = {
        name: zipFile.name,
        lang: getShopDefaultLang(),
        imported: true
      };
      const templateInput = {
        id: parseInt(id.toString(), 10),
        content: {
          design: idTemplateElements,
          sections: []
        },
        type: templateType,
        informations,
        sections: [
          {
            css: cssString,
            data: null,
            html: newHtml,
            id_template_elements: idTemplateElements,
            translations: JSON.stringify(translations),
            type: "design"
          }
        ],
        configuration: {
          body_structure: {
            design: idTemplateElements,
            sections: [],
            sections_before_save: []
          },
          informations
        }
      };

      const { err: templateInputErr } = await CustomMutation<
        TemplateAndTemplateElementsUpdateInput
      >({
        name: "UpdateTemplateAndTemplateElements",
        input: {
          id_shop: idShop,
          template: JSON.stringify(templateInput)
        },
        type: "TemplateAndTemplateElementsUpdateInput"
      });

      if (templateInputErr === "") {
        return {
          id,
          type: templateType,
          label: zipFile.name
        };
      }
    }
  }
  throw new Error();
};

export const updateSectionCss = (css: Map<string, any>, widgetId: string) => {
  const activeSection = state.template?.sections.find(
    section => section.id_template_elements === state.template?.activeSection
  );
  if (activeSection) {
    css.forEach((value, styleType) => {
      const template = getTemplateIframeDocument();
      if (template) {
        const style = template.querySelector(
          `style[data-spm-section="${state.template?.activeSection}"][data-spm-styles="${styleType}"]`
        );
        if (style) {
          style.innerHTML = value;
        } else {
          const s = document.createElement("style");

          // If styles are for mobile devices, we add the media query rule if it's not in the CSS rule
          if (
            new RegExp("_mobile$").test(styleType) &&
            !new RegExp("@media").test(value)
          ) {
            s.innerHTML = `@media only screen and (max-width: 600px) { ${value} }`;
          } else {
            s.innerHTML = value;
          }

          s.setAttribute("data-spm-styles", styleType);
          s.setAttribute(
            "data-spm-section",
            state.template?.activeSection.toString() || ""
          );
          s.setAttribute("type", "text/css");

          template.head.appendChild(s);
        }
      }
    });
  }
};

/**
 * Rrturn the deepest child of an element
 * @param element
 */
const findDeepestChild = (element: any) => {
  while (element.firstElementChild) {
    element = element.firstElementChild;
  }
  return element;
};

export const fixBrokenSmartProductsLists = () => {
  let refreshSmartLists = false;

  if (state.template) {
    Object.keys(state.template.smartLists).forEach(widgetId => {
      const code = state.template?.smartLists[widgetId];

      // We check if the HTML code contains the collection attribute
      if (code && !/s-collection="[^"]+"/.test(code)) {
        // Attribute is not in the HTML code, we need to rebuild the code
        // We get widget's code
        const widget = getTemplateIframeDocument().querySelector(
          `#${widgetId}`
        );

        // Get products elements and remove all of them except first one. For the first one, we will reapply collection's attributes
        let products = widget?.querySelectorAll(
          ".spm_product_list_element_wrapper"
        );

        if (!products || products.length === 0) {
          products = widget?.querySelectorAll(".spm_product_list_element");
        }

        const nbProducts = (products ?? []).length;
        (products ?? []).forEach((product: any, index: number) => {
          if (index > 0) {
            product.remove();
          } else {
            product.setAttribute("s-collection", "products");
            product.setAttribute("s-item", "product");
            product.setAttribute("s-grid", nbProducts);
            product.setAttribute("s-nb", nbProducts);
            product.setAttribute("s-engine", "crossselling");
            product.setAttribute("s-ids", "");
            product.setAttribute("s-excluded_ids", "");
            product.setAttribute("s-excluded_categories", "");
            product.setAttribute("s-excluded_manufacturers", "");
            product.setAttribute("s-nb_weeks", "4");

            // Restore product title
            const title = product.querySelector(
              ".spm_product_list_element_title"
            );
            if (title) {
              // We need to check the children of the element (in case there is a link or other element)
              const { children } = title;
              if (Array.from(children).length > 0) {
                let removeChild = false;
                Array.from(children).forEach((child: any) => {
                  if (child.nodeName === "A") {
                    child.setAttribute("href", "{var=product.url}");
                    child.setAttribute("title", "{var=product.name}");
                    child.innerHTML = "{var=product.name}";
                  } else {
                    // Child is not a link, so we remove it because we don't know what to do according to its type
                    child.remove();
                    removeChild = true;
                  }
                });

                if (removeChild) {
                  title.innerHTML = "{var=product.name}";
                }
              } else {
                // Title doesn't have children, so we set its content with the product's name
                title.innerHTML = "{var=product.name}";
              }
            }

            // Restore product's description
            const description = product.querySelector(
              ".spm_product_list_element_description"
            );
            if (description) {
              const deepestChild = findDeepestChild(description);

              if (deepestChild) {
                deepestChild.innerHTML = "{var=product.description_short}";
              }
            }

            // Restore product's image
            const image = product.querySelector(
              ".spm_product_list_element_image"
            );
            if (image) {
              // Check if image has a parent and that the parent is a link. If true, we restore product's URL as href of the link
              const parent = image.parentElement;
              if (parent.nodeType === "A") {
                parent.setAttribute("href", "{var=product.url}");
              }

              // Restore image's src, alt and title attributes
              image.setAttribute(
                "src",
                "{var=product.image_url resize=300x150 resizeType=fill-to-fit}"
              );
              image.setAttribute("title", "{var=product.name}");
              image.setAttribute("alt", "{var=product.name}");
            }

            // Restore product's price and price strike
            const priceStrike = product.querySelector(
              ".spm_product_list_element_price_strike"
            );
            if (priceStrike) {
              priceStrike.innerHTML = "{var=product.price_strike}";

              if (
                priceStrike.nodeType === "SPAN" ||
                priceStrike.nodeType === "DIV"
              ) {
                // Add condition to hide the element if price and price strike are equal
                priceStrike.setAttribute("s-if", "product.price_strike");
                priceStrike.setAttribute("s-condition", "!=");
                priceStrike.setAttribute("s-value", "product.price");
              } else {
                // Apply condition to parent element
                const parentPriceStrike = priceStrike.parentElement;
                parentPriceStrike.setAttribute("s-if", "product.price_strike");
                parentPriceStrike.setAttribute("s-condition", "!=");
                parentPriceStrike.setAttribute("s-value", "product.price");
              }
            }

            const price = product.querySelector(
              ".spm_product_list_element_price"
            );
            if (price) {
              price.innerHTML = "{var=product.price}";
            }

            // Restore product's button
            const button = product.querySelector(
              ".spm_product_list_element_button a"
            );
            if (button) {
              // Restore product's URL in href attribute
              button.setAttribute("href", "{var=product.url}");
            }
          }
        });

        // Get widget's code and store in the state the refresh the widget
        const widgetHtml =
          widget && getWidgetCodeWithoutVmlShape(widget as HTMLElement);
        if (widgetHtml && state.template) {
          state.template.smartLists[widgetId] = widgetHtml;
          refreshSmartLists = true;
        }
      }

      // Fix product lists with image sizes set to 0
      const template = getTemplateIframeDocument();
      const images = template.querySelectorAll(
        "img.spm_product_list_element_image"
      );

      if (images && images.length) {
        images.forEach(image => {
          const hasSmartProductListWidgetParent = getParents(
            image,
            ".spm_smart_products_list"
          );
          // eslint-disable-next-line max-len
          if (
            hasSmartProductListWidgetParent &&
            hasSmartProductListWidgetParent.length &&
            typeof image.getAttribute("width") === "string" &&
            image.getAttribute("width") === "0"
          ) {
            const parentWidget = hasSmartProductListWidgetParent[0];
            const selector = `body #spm_body #${parentWidget.id} img.spm_product_list_element_image`;

            const currentSize = getCssPropertyByName(selector, "width");

            if (currentSize) {
              removeDynamicStyle(selector, { width: "" });
            }
            const property: Property = {
              name: "width", // Nom de la propriété
              getter: () => "", // Fonction getter
              setters: [], // Tableau de fonctions setters
              value: "150px" // Valeur de la largeur selon vos besoins
            };
            setSmartListImageWidth(selector, property, parentWidget.id);
            refreshSmartLists = true;
          }
        });
      }
    });
  }

  // If at least one code has been corrected, we refresh the smartlists
  if (refreshSmartLists) {
    refreshSmartProductList();
  }
};

export const removeTranslation = (key: string) => {
  if (state.template) {
    state.template.translations = state.template.translations.filter(
      translation => translation.key !== key
    );
  }
};

export const getTranslationIdFromImportedTemplateElement = (
  target: HTMLElement
): any => {
  const targetTagName = target.tagName.toLowerCase();

  const getTranslationId = (element: HTMLElement) => {
    const elementId = element.getAttribute("id");
    if (elementId) {
      return elementId.replace("LANG_", "");
    }
    return "";
  };

  if (targetTagName === "spm-template") {
    return "";
  }
  // Check if target element is a translation markup and get the attribute id
  if (targetTagName === TRANSLATION_MARKUP) {
    return getTranslationId(target);
  }
  // Check if the target element has a translation marku child
  if (target.children.length) {
    // eslint-disable-next-line no-restricted-syntax
    for (const childElement of Array.from(target.children)) {
      const elementId = getTranslationIdFromImportedTemplateElement(
        childElement as HTMLElement
      );
      if (elementId) {
        return elementId;
      }
    }
  }

  // Loop through parent until it finds the translation markup
  let parent: HTMLElement | null = target.parentElement;
  while (
    parent &&
    parent.tagName.toLowerCase() !== "body" &&
    parent.tagName.toLowerCase() !== "spm-template"
  ) {
    if (parent.tagName.toLowerCase() === TRANSLATION_MARKUP) {
      return getTranslationId(parent);
    }
    parent = parent.parentElement;
  }

  // Check attributes
  // eslint-disable-next-line no-restricted-syntax
  for (const attribute of Array.from(target.attributes)) {
    if (attribute.name.match(new RegExp(TRANSLATION_ATTRIBUTE))) {
      return attribute.value.replace("LANG_", "");
    }
  }

  return "";
};

export const setSelectedTranslationId = (translationId: string) => {
  state.selectedTranslationId = translationId;
};

export const setShowConfigurationPanelCallback = (
  showPanelCallback: Function | null
) => {
  state.showConfigurationPanelCallback = showPanelCallback;
};

export const cleanUpTranslations = () => {
  if (state.template) {
    const keysToDelete: string[] = [];
    state.template.translations.forEach(translation => {
      // For each translation key, we check if it exists in the HTML code, otherwise we delete the key from the translations
      const template = getTemplateIframeDocument();
      if (template) {
        const htmlContent = template.body.innerHTML;
        const existsInHtml = (new RegExp(`LANG_${translation.key}`)).test(htmlContent);
        // Game widget translations: key is already "xxx.data-spm-text", check it exists directly in HTML (inside data-prizes/data-symbols JSON)
        const isGameTranslation = translation.fieldType === 'data-spm-text'
          || translation.fieldType === 'data-spm-slot-symbol'
          || translation.fieldType === 'data-spm-slot-prize';
        const existsInGameData = isGameTranslation && htmlContent.includes(translation.key);
        if (!existsInHtml && !existsInGameData) {
          keysToDelete.push(translation.key);
        }
      }
    });

    keysToDelete.forEach(key => {
      removeTranslation(key);
    });
  }
};

export const removeItemFromSectionsToRefresh = (itemId: number) => {
  state.sectionsToRefresh = state.sectionsToRefresh.filter(
    sectionId => sectionId !== itemId
  );
};

export const fixBrokenWidgetVoucher = () => {
  if (state.template) {
    const template = getTemplateIframeDocument();
    if (template) {
      const voucherWidgets = template.body.querySelectorAll(
        ".spm_generate_voucher.spm_button.spm_inline_editing"
      );
      Array.from(voucherWidgets).forEach(voucherWidget => {
        if (
          voucherWidget.childNodes.length === 0 &&
          !voucherWidget.hasAttribute(`${TRANSLATION_ATTRIBUTE}-href`)
        ) {
          voucherWidget.remove();
        }
      });
    }
  }
};

export const linkSection = (
  sectionId: any,
  syncElementId: string,
  syncElementName: string,
  sectionType = ""
) => {
  const { index, template, templates } = state;
  if (template) {
    let section = sectionType
      ? template.sections.find(s => s.type === sectionType)
      : template.sections.find(
          s => s.id_template_elements === asInt(sectionId)
        );
    if (
      isDisplayTemplate(state.template?.type) &&
      sectionType === TemplateStructureEnum.DESIGN
    ) {
      // eslint-disable-next-line prefer-destructuring
      section = template.sections[0];
    }
    if (section) {
      const data = JSON.parse(section.data || "{}");
      data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] = syncElementId;
      data[TEMPLATE_SYNC_ELEMENT_NAME] = syncElementName;
      section.data = JSON.stringify(data);
    }
    templates[index] = template;
  }
};

export const addNewSyncElementToSection = (
  sectionId: any,
  syncElementId: string
) => {
  const { index, template, templates } = state;
  if (template) {
    const section = template.sections.find(
      s => s.id_template_elements === asInt(sectionId)
    );
    if (section) {
      const data = JSON.parse(section.data || "{}");
      if (!data[TEMPLATE_SYNC_ELEMENT_IDs]) {
        data[TEMPLATE_SYNC_ELEMENT_IDs] = [];
      }
      data[TEMPLATE_SYNC_ELEMENT_IDs].push(syncElementId);
      section.data = JSON.stringify(data);
    }
    templates[index] = template;
  }
};

export const resetSpecificDesignRules = (
  html: string,
  templateType: string
) => {
  const $ = cheerio.load(html);
  const customDataDefinitions =
    customDataDisplay[TemplateStructureEnum.DESIGN][templateType] || [];
  // eslint-disable-next-line no-restricted-syntax
  for (const customDataDefinition of customDataDefinitions) {
    const selectedElement = $("body").find(customDataDefinition.selector);
    if (selectedElement) {
      customDataDefinition.classes.forEach(cls => {
        selectedElement.removeClass(cls);
      });
      customDataDefinition.attributes.forEach(attr => {
        selectedElement.removeAttr(attr);
      });
    }
  }
  return $("body").html() || "";
};

export const applyNewSpecificDesignRules = (
  html: string,
  specificRules: any[]
) => {
  const $ = cheerio.load(html);
  // eslint-disable-next-line no-restricted-syntax
  for (const specificRule of specificRules) {
    const selectedElement = $("body").find(specificRule.selector);
    if (selectedElement) {
      specificRule.classes.forEach((cls: string) => {
        selectedElement.addClass(cls);
      });
      specificRule.attributes.forEach((attr: any) => {
        selectedElement.attr(attr.attribute, attr.value);
      });
    }
  }
  return $("body").html() || "";
};

export const loadDesign = (item: TemplatePart) => {
  const { template } = state;
  if (!template) return;

  let design = template.sections.find(
    sec => sec.type === TemplateStructureEnum.DESIGN
  );
  if (isDisplayTemplate(state.template?.type)) {
    // eslint-disable-next-line prefer-destructuring
    design = template.sections[0];
  }
  if (!design) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(item.html ?? "", "text/html");

  const itemData = JSON.parse(item.data || "{}");
  if (
    itemData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER] &&
    isEmailTemplate(state.template?.type) &&
    !isTemplateRelatedToCampaignBulk()
  ) {
    const { body } = doc;
    body.setAttribute(
      TEMPLATE_SYNC_ELEMENT_IDENTIFIER,
      itemData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER]
    );
    body.setAttribute(TEMPLATE_SYNC_ELEMENT_NAME, item.name ?? "");
  }
  if (
    itemData[HIDE_MOBILE_ATTRIBUTE] &&
    isEmailTemplate(state.template?.type)
  ) {
    const { body } = doc;
    body.setAttribute(HIDE_MOBILE_ATTRIBUTE, "true");
  } else if (
    !itemData[HIDE_MOBILE_ATTRIBUTE] &&
    isEmailTemplate(state.template?.type)
  ) {
    const { body } = doc;
    body.removeAttribute(HIDE_MOBILE_ATTRIBUTE);
  }

  if (isDisplayTemplate(state.template?.type)) {
    const objectCss = JSON.parse(item.css || "{}");
    const designCss = JSON.parse(design.css || "{}");
    Object.keys(objectCss).forEach(key => {
      if (key in designCss) {
        const regex = /([^{}]*#spm_(?:widget|column|row)_[a-zA-Z0-9]+[^{]*{[^}]*})/gm;
        const matches = [...designCss[key].matchAll(regex)];
        const capturedBlocks = matches.map(match => match[0]);

        designCss[key] = `${objectCss[key]} ${capturedBlocks.join(" ")}`;
      }
    });
    design.css = JSON.stringify(designCss);

    // Reset specific css rules and apply new rules
    const data = JSON.parse(item.data || "{}");
    design.html = resetSpecificDesignRules(
      design.html,
      getTemplateParentTypeByType(state.template?.type)
    );
    if (data.specificCssRules) {
      design.html = applyNewSpecificDesignRules(
        design.html,
        data.specificCssRules
      );
    }
  } else if (isEmailTemplate(state.template?.type)) {
    const updatedHtml = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN" "http://www.w3.org/TR/REC-html40/loose.dtd">${doc.documentElement.outerHTML}`;

    design.css = item.css ?? "";
    design.html = updatedHtml;
    design.data = item.data ?? "";

    if (isTemplateRelatedToCampaignBulk()) {
      design.html = design.html.replace(
        /\s*data-spm-element-sync-(name|id)="[^"]*"/g,
        ""
      );
      design.html = design.html.replace(/\s*spm_sync-element\s*/g, " ");
      const designData = JSON.parse(design.data || "{}");
      delete designData[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
      delete designData[TEMPLATE_SYNC_ELEMENT_NAME];

      design.data = Object.keys(designData).length
        ? JSON.stringify(designData)
        : "";
    }
  }

  const data = JSON.parse(item.data || "{}");
  const syncId = data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
  if (syncId && !isTemplateRelatedToCampaignBulk()) {
    const templateHtml = getTemplateIframeDocument();

    if (!templateHtml) return;

    const body = isEmailTemplate(state.template?.type)
      ? templateHtml.body
      : templateHtml.querySelector("#spm_body");
    if (!body) return;

    body.setAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER, syncId);
    body.setAttribute(TEMPLATE_SYNC_ELEMENT_NAME, item.name ?? "");
    linkSection("", syncId, item.name ?? "", TemplateStructureEnum.DESIGN);
  } else {
    const templateHtml = getTemplateIframeDocument();

    if (!templateHtml) return;

    const body = isEmailTemplate(state.template?.type)
      ? templateHtml.body
      : templateHtml.querySelector("#spm_body");
    if (!body) return;

    body.removeAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER);
    body.removeAttribute(TEMPLATE_SYNC_ELEMENT_NAME);
  }
};

export const unlinkDesign = () => {
  const { index, template: currentTemplate, templates } = state;
  if (!currentTemplate) return;

  let design = currentTemplate.sections.find(
    item => item.type === TemplateStructureEnum.DESIGN
  );
  if (isDisplayTemplate(currentTemplate.type)) {
    // eslint-disable-next-line prefer-destructuring
    design = currentTemplate.sections[0];
  }
  if (!design) return;

  const data = JSON.parse(design.data || "{}");
  delete data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
  delete data[TEMPLATE_SYNC_ELEMENT_NAME];

  design.data = Object.keys(data).length ? JSON.stringify(data) : "";
  templates[index] = currentTemplate;

  const template = getTemplateIframeDocument();
  if (!template) return;

  const body = isDisplayTemplate(currentTemplate.type)
    ? template.querySelector("#spm_body")
    : template.body;
  if (!body) return;

  body.removeAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER);
  body.removeAttribute(TEMPLATE_SYNC_ELEMENT_NAME);
};

export const unlinkSyncElement = (
  selectedSyncElement: { elementType: string; elementId: string },
  oldParentSectionId = ""
) => {
  const { elementType, elementId } = selectedSyncElement;

  if (elementType === TemplateStructureEnum.DESIGN) {
    unlinkDesign();
  } else {
    const template = getTemplateIframeDocument();
    if (!template) return;

    const element = template.body.querySelector(`#${elementId}`);
    if (!element) return;

    const syncElementId = element.getAttribute(
      TEMPLATE_SYNC_ELEMENT_IDENTIFIER
    );

    element.removeAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER);
    element.removeAttribute(TEMPLATE_SYNC_ELEMENT_NAME);
    element.removeAttribute(TEMPLATE_PART_ELEMENT_PART_TYPE);
    element.removeAttribute(TEMPLATE_PART_ELEMENT_IDENTIFIER);
    element.classList.remove(TEMPLATE_SYNC_ELEMENT_CLASS);

    const { index, template: currentTemplate, templates } = state;
    if (!currentTemplate) return;

    const updateSectionData = (section: any, data: any) => {
      section.data = Object.keys(data).length ? JSON.stringify(data) : "";
      templates[index] = currentTemplate;
    };

    const processSection = (sectionId: string, filterSyncElements = false) => {
      const section = currentTemplate.sections.find(
        item => asInt(item.id_template_elements) === asInt(sectionId)
      );
      if (!section) return;

      const data = JSON.parse(section.data || "{}");
      if (filterSyncElements && data[TEMPLATE_SYNC_ELEMENT_IDs]) {
        data[TEMPLATE_SYNC_ELEMENT_IDs] = data[
          TEMPLATE_SYNC_ELEMENT_IDs
        ].filter((item: string) => item !== syncElementId);
        if (!data[TEMPLATE_SYNC_ELEMENT_IDs].length)
          delete data[TEMPLATE_SYNC_ELEMENT_IDs];
      } else {
        delete data[TEMPLATE_SYNC_ELEMENT_IDENTIFIER];
        delete data[TEMPLATE_PART_ELEMENT_PART_TYPE];
        delete data[TEMPLATE_SYNC_ELEMENT_NAME];
      }
      updateSectionData(section, data);
    };

    if (elementType === TemplateStructureEnum.SECTION) {
      const id = element.getAttribute("data-spmelementid");
      if (!id) return;
      processSection(id);
    } else if (elementType === TemplateStructureEnum.WIDGET) {
      if (oldParentSectionId) {
        processSection(oldParentSectionId, true);
      } else {
        const parentSection = getSectionParent(element as HTMLElement);
        if (parentSection) {
          const parentSectionId = parentSection.getAttribute(
            "data-spmelementid"
          );
          if (parentSectionId) {
            processSection(parentSectionId, true);
          }
        }
      }
    }
  }
};

export const unlinkElementsInSection = (selector: string) => {
  const template = getTemplateIframeDocument();
  if (!template) return;

  const section = template.querySelector(selector);
  if (!section) return;

  const syncElements = section.querySelectorAll(
    `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`
  );
  Array.from(syncElements).forEach(syncElement => {
    unlinkSyncElement({
      elementType: TemplateStructureEnum.WIDGET,
      elementId: syncElement.id
    });
  });
};

export const hasSyncElements = (selector: string) => {
  const template = getTemplateIframeDocument();
  if (!template) return 0;

  const section = template.querySelector(selector);
  if (!section) return 0;

  const syncElements = Array.from(
    section.querySelectorAll(`[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`)
  );
  return syncElements.length;
};

export const updateUsedSyncElements = async (idShop: number) => {
  const checkSyncElements = store.getters["liveEditor/getCheckSyncElements"];
  if (checkSyncElements) {
    const template = getTemplateIframeDocument();
    if (!template) return;

    const syncElements = template.querySelectorAll(
      `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}]`
    );
    if (syncElements.length === 0) {
      store.commit("liveEditor/setCheckSyncElements", false);
      return;
    }

    let continueCheck = true;
    if (state.template && state.template.dateModification) {
      // Fetch fresh date_modification from DB to detect external changes
      const templateId = asInt(state.template.id);
      const response = await nestCall(
        "get",
        NestApiType.CLIENT_API,
        "/templates",
        {},
        "",
        undefined,
        true,
        {
          fields: "updated_at",
          limit: 1,
          "filters[0][field]": "id_template",
          "filters[0][operator]": "EQUALS",
          "filters[0][value]": templateId
        }
      );
      const remoteDate = response?.data?.[0]?.updated_at;

      if (remoteDate) {
        const dateModification = moment(state.template.dateModification);
        const existingDateModification = moment(remoteDate);
        if (
          dateModification.isValid() &&
          existingDateModification.isValid() &&
          existingDateModification.isSameOrBefore(dateModification)
        ) {
          continueCheck = false;
        }
        if (continueCheck && !state.preventDateModificationUpdate) {
          state.template.dateModification = remoteDate;
        }
      }
      if (store.getters["liveEditor/getForceUpdateSyncElements"]) {
        continueCheck = true;
        store.commit("liveEditor/setForceUpdateSyncElements", false);
      }
    }
    const fetchSavedElements = (elements: Element[]) =>
      getTemplatePartsBySyncElementIds(idShop, [
        ...new Set(
          elements
            .map(element =>
              element.getAttribute(TEMPLATE_SYNC_ELEMENT_IDENTIFIER)
            )
            .filter((syncElementId): syncElementId is string => !!syncElementId)
        )
      ]);

    const partOfSyncElement = (
      parts: TemplatesParts[],
      syncElement: Element
    ) => {
      const syncElementId = syncElement.getAttribute(
        TEMPLATE_SYNC_ELEMENT_IDENTIFIER
      );
      return syncElementId
        ? parts.find(
            (item: TemplatesParts) =>
              parseStoredJson(item.data ?? "")[
                TEMPLATE_SYNC_ELEMENT_IDENTIFIER
              ] === syncElementId
          )
        : undefined;
    };

    const reloadFromSavedElement = async (
      itemPart: TemplatesParts,
      syncElement: Element
    ) => {
      await insertSavedElement(
        itemPart,
        `#${syncElement.id}`,
        "top",
        false,
        syncElement.getAttribute("data-spmelementid") || ""
      );
      if (!parseStoredJson(itemPart.data ?? "")[TEMPLATE_PART_ELEMENT_PART_TYPE]) {
        syncElement.remove();
      }
    };

    if (continueCheck) {
      const result = await fetchSavedElements(Array.from(syncElements));
      const unlink = (syncElement: any) => {
        const elements = template.querySelectorAll(
          `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}="${syncElement.getAttribute(
            TEMPLATE_SYNC_ELEMENT_IDENTIFIER
          )}"]`
        );
        // eslint-disable-next-line no-loop-func
        Array.from(elements).forEach(element => {
          let elementType = TemplateStructureEnum.DESIGN;
          if (element.id.startsWith("spm_section")) {
            elementType = TemplateStructureEnum.SECTION;
          } else if (element.id.startsWith("spm_widget")) {
            elementType = TemplateStructureEnum.WIDGET;
          }
          unlinkSyncElement({ elementType, elementId: element.id });
        });
      };

      if (result.err) {
        // A failed request is not an empty result: synced elements keep their link to their saved elements
        console.error("Error fetching saved elements of synced elements:", result.err);
      } else if (result.items.length) {
        for (let i = 0; i < syncElements.length; i++) {
          const syncElement = syncElements.item(i);
          const itemPart = partOfSyncElement(result.items, syncElement);
          if (itemPart) {
            if (itemPart.type !== TemplateStructureEnum.DESIGN) {
              // eslint-disable-next-line no-await-in-loop
              await reloadFromSavedElement(itemPart, syncElement);
            } else {
              loadDesign(itemPart);
              // Reapply design css
              const activeStyleSheets = getActiveTemplateStylesheets(
                TemplateStructureEnum.DESIGN
              );
              activeStyleSheets.forEach((stylesheet: HTMLStyleElement) => {
                const stylesAttribute = stylesheet.getAttribute(
                  "data-spm-styles"
                );
                const sectionAttribute = stylesheet.getAttribute(
                  "data-spm-section"
                );
                const oldStyle = template.querySelector(
                  `style[data-spm-styles="${stylesAttribute}"][data-spm-section="${sectionAttribute}"]`
                );
                if (oldStyle) {
                  oldStyle.innerHTML = stylesheet.innerHTML;
                }
              });
            }
          } else {
            unlink(syncElement);
          }
        }
      } else {
        for (let i = 0; i < syncElements.length; i++) {
          const syncElement = syncElements.item(i);
          unlink(syncElement);
        }
      }
      updateSectionsInState(false);
    } else if (!isTemplateRelatedToCampaignBulk()) {
      // A synced element saved with its translations flattened on the default text gets them back from its saved element
      // (not in a bulk campaign, where reloading detaches the element from its saved element)
      // Best effort: a failure here must not stop the rest of the editor loading
      try {
        const defaultLanguage = getShopDefaultLang();
        const shopLanguages =
          UserState.activeShop?.langs?.map(lang => lang.id) ?? [];
        const instanceTranslations = (syncElement: Element) =>
          translationsReferencedBy(
            syncElement.outerHTML,
            state.template?.translations ?? []
          );
        const suspectedElements = Array.from(syncElements).filter(
          syncElement =>
            hasUntranslatedCopies(
              instanceTranslations(syncElement),
              defaultLanguage,
              shopLanguages
            )
        );

        if (suspectedElements.length) {
          const result = await fetchSavedElements(suspectedElements);
          let restored = false;
          for (let i = 0; i < suspectedElements.length; i++) {
            const syncElement = suspectedElements[i];
            // An unreadable saved element must not stop the restoration of the others
            try {
              const itemPart = partOfSyncElement(result.items, syncElement);
              if (
                syncElement.isConnected &&
                itemPart &&
                itemPart.type !== TemplateStructureEnum.DESIGN &&
                !parseStoredJson(itemPart.data ?? "")[TEMPLATE_PART_ELEMENT_PART_TYPE] &&
                hasLostSyncedTranslations(
                  instanceTranslations(syncElement),
                  savedTranslationsReferencedBy(
                    itemPart.html ?? "",
                    itemPart.translations ?? "",
                    state.template?.type ?? ""
                  ),
                  defaultLanguage,
                  shopLanguages
                )
              ) {
                // eslint-disable-next-line no-await-in-loop
                await reloadFromSavedElement(itemPart, syncElement);
                restored = true;
              }
            } catch (error) {
              console.error("Error restoring synced element translations:", error);
            }
          }
          if (restored) {
            updateSectionsInState(false);
            markTranslationsAsChanged();
          }
        }
      } catch (error) {
        console.error("Error restoring synced element translations:", error);
      }
    }
  }
  store.commit("liveEditor/setCheckSyncElements", false);
};

export const getAllSyncElements = (
  syncElementId: string,
  excludeId: string
) => {
  const template = getTemplateIframeDocument();
  if (!template) return [];

  const syncElements = Array.from(
    template.body.querySelectorAll(
      `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}="${syncElementId}"]`
    )
  );

  return syncElements.filter(element => element.id !== excludeId);
};

export const updateUsedSyncElementsName = (
  syncElementId: string,
  newName: string
) => {
  const template = getTemplateIframeDocument();
  if (!template) return;

  const syncElements = template.querySelectorAll(
    `[${TEMPLATE_SYNC_ELEMENT_IDENTIFIER}="${syncElementId}"]`
  );
  Array.from(syncElements).forEach(syncElement => {
    syncElement.setAttribute(TEMPLATE_SYNC_ELEMENT_NAME, newName);
  });

  updateSectionsInState(false);
};

export const updateOpenedTemplate = (
  templateId: number,
  sectionId: string | number,
  newSection: any
) => {
  const templateToUpdate = state.templates.find(
    template => template.id.toString() === templateId.toString()
  );
  if (templateToUpdate) {
    const sectionToUpdate = templateToUpdate.sections.find(
      s => s.id_template_elements.toString() === sectionId.toString()
    );
    if (sectionToUpdate) {
      sectionToUpdate.css = newSection.css;
      sectionToUpdate.html = newSection.html;
      sectionToUpdate.translations = newSection.translations;
      sectionToUpdate.data = JSON.stringify(newSection.data);
    }
    // Update translations
    templateToUpdate.translations = [];
    templateToUpdate.sections.forEach(section => {
      const sectionTranslation = JSON.parse(
        (section.translations && section.translations !== ""
          ? section.translations
          : "{}"
        ).replace(/(\r\n|\n|\r)/gm, " ")
      );

      Object.keys(sectionTranslation).forEach((language: string) => {
        Object.keys(sectionTranslation[language]).forEach((key: string) => {
          templateToUpdate.translations.push(
            ...(addTranslation(
              sectionTranslation[language],
              key,
              section.id_template_elements,
              language,
              templateToUpdate.type
            ) ?? [])
          );
        });
      });
    });
  }
};

export const getWidgetFromTranslationKey = (
  translationKey: string
): WidgetTypeEnum | null => {
  if (state.template) {
    const template = getTemplateIframeDocument();
    if (template) {
      const translationElement = template.body.querySelector(
        `[id="LANG_${translationKey}"]`
      );
      if (translationElement) {
        const widgetElement = translationElement.closest("[data-widgettype]");
        if (widgetElement) {
          return getWidgetType(
            widgetElement.getAttribute("data-widgettype") || ""
          );
        }
      }
    }
  }
  return null;
};

// Configuration-based form functions
export const addNewForm = (key: string, type: string, configs?: any) => {
  if (state.template) {
    if (!state.template.configuration) {
      state.template.configuration = {};
    }
    if (!state.template.configuration.forms) {
      state.template.configuration.forms = {};
    }

    // Check if widget already exists
    if (state.template.configuration.forms[key]) {
      // Merge new configs with existing ones, but don't overwrite existing values
      if (configs && state.template?.configuration?.forms?.[key]?.configs) {
        const existingConfigs = state.template.configuration.forms[key].configs;
        Object.keys(configs).forEach(configKey => {
          // Only add config if it doesn't exist yet
          if (!existingConfigs[configKey]) {
            existingConfigs[configKey] = configs[configKey];
          }
        });
      }
      return;
    }

    // Set default contactProperty based on widget type
    let defaultContactProperty = "";
    switch (type) {
      case "widget-input-email":
        defaultContactProperty = "email";
        break;
      case "widget-input-phone":
        defaultContactProperty = "phone_number";
        break;
      case "widget-input-password":
        defaultContactProperty = "password";
        break;
      case "widget-consent-checkbox":
        defaultContactProperty = "consent_email";
        break;
      default:
        defaultContactProperty = "";
    }

    const formConfigs: Record<string, any> = {
      contactProperty: defaultContactProperty,
      ...(configs || {})
    };

    // Persist consent channel in state for consent checkbox widgets
    if (
      type === "widget-consent-checkbox" &&
      !formConfigs["data-consent-channel"]
    ) {
      const channelMap: Record<string, string> = {
        consent_email: "email",
        consent_sms: "sms",
        consent_whatsapp: "whatsapp"
      };
      formConfigs["data-consent-channel"] =
        channelMap[defaultContactProperty] || "email";
    }

    state.template.configuration.forms[key] = {
      type,
      configs: formConfigs
    };
  }
};

export const updateFormContactProperty = (
  key: string,
  contactProperty: string
) => {
  if (state.template && state.template.configuration?.forms?.[key]) {
    if (!state.template.configuration.forms[key].configs) {
      state.template.configuration.forms[key].configs = {};
    }
    state.template.configuration.forms[
      key
    ].configs.contactProperty = contactProperty;
  }
};

export const updateFormFieldConfig = (
  key: string,
  field: string,
  config: any
) => {
  if (state.template) {
    if (!state.template.configuration) {
      state.template.configuration = {};
    }
    if (!state.template.configuration.forms) {
      state.template.configuration.forms = {};
    }
    if (!state.template.configuration.forms[key]) {
      state.template.configuration.forms[key] = {
        type: "",
        configs: {
          contactProperty: ""
        }
      };
    }
    state.template.configuration.forms[key].configs[field] = config;
  }
};

export const getFormByIdentifier = (identifier: string) =>
  state.template?.configuration?.forms?.[identifier];

export const getFormFieldConfig = (key: string, field: string) => {
  if (state.template?.configuration?.forms?.[key]?.configs) {
    return state.template.configuration.forms[key].configs[field];
  }
  return null;
};

export const getFormContactProperty = (key: string): string => {
  if (state.template?.configuration?.forms?.[key]) {
    // Try to get from configs first (new structure)
    if (state.template.configuration.forms[key].configs?.contactProperty) {
      return state.template.configuration.forms[key].configs.contactProperty;
    }
    // Fallback to old structure for backward compatibility
    return (
      (state.template.configuration.forms[key] as any).contactProperty || ""
    );
  }
  return "";
};

export const removeFormConfig = (key: string) => {
  if (state.template?.configuration?.forms) {
    delete state.template.configuration.forms[key.replace("#", "")];
  }
};

export const createNextStepTemplate = async (
  idShop: number,
  nextStep: NextStepEnum,
  name: string,
  t: Function,
  idCampaign: null | number = null,
  originCall: null | string = null
) => {
  if (state.template) {
    try {
      const { duplicateTemplate } = useTemplatesApi();
      const duplicatedResult = await duplicateTemplate(state.template.id, {
        name,
        idShopOfTemplate: idShop,
        originCall: originCall === "templateBuilder" ? null : originCall,
        idCampaign,
        originTemplateId: state.template.id,
        rootTemplateId: state.template.funnel.template?.id,
        skipRedirects: true,
        resetTeaser: true
      });
      if (
        duplicatedResult &&
        duplicatedResult.success &&
        duplicatedResult.data?.id_template
      ) {
        const newTemplateId = asInt(duplicatedResult.data.id_template);
        const preparedTemplate = await prepareTemplate(newTemplateId, "", "");
        if (preparedTemplate) {
          const { template } = preparedTemplate;

          // Find and store translation keys from form widgets to be removed later
          const translationKeysToRemove: string[] = [];

          // Store widget IDs to remove their CSS
          const widgetIdsToRemove: string[] = [];

          // Structure to store the first form widget position
          type FirstFormPosition = {
            sectionIndex: number;
            parentElement: HTMLElement;
            position: number; // index among siblings
          };

          let firstFormPosition: FirstFormPosition | null = null;
          const cssByWidgetType: Record<string, any> = {};

          // Process each section to remove form widgets and remember only the first position
          if (template && template.sections) {
            let foundFirstForm = false;

            template.sections.forEach((section, sectionIndex) => {
              // Create a temporary DOM element to parse the HTML
              const tempElement = document.createElement("div");
              tempElement.innerHTML = section.html;

              // Find all form widgets and game widgets (only one game widget per funnel)
              const formWidgetsSelectors = [
                ".spm_widget_form",
                '[data-widgettype="spm_form_newsletter"]',
                '[data-widgettype="spm_form_registration_unsubscribe"]',
                '[data-widgettype="spm_form_registration"]',
                '[data-widgettype="spm_display_call_to_action"]',
                ".whatsapp-message__cta__item",
                ".spm_widget_game_wheel",
                ".spm_widget_game_slot_machine",
                ".spm_widget_game_scratch_card"
              ];

              // For OFFER_VOUCHER, also remove content widgets (text, title, buttons, vouchers)
              // but keep images, separators, columns and structural elements
              if (nextStep === NextStepEnum.OFFER_VOUCHER) {
                formWidgetsSelectors.push(
                  '[data-widgettype="spm_widget_display_text"]',
                  '[data-widgettype="spm_widget_display_title"]',
                  '[data-widgettype="spm_widget_display_voucher"]'
                );
              }

              const formWidgets = tempElement.querySelectorAll(
                formWidgetsSelectors.join(", ")
              );

              // For each form widget, extract translation keys, remember first position, and remove
              formWidgets.forEach(widget => {
                // Extract the HTML content to find {LANG_key} patterns
                const widgetHTML = widget.outerHTML;
                const translationMatches = widgetHTML.match(/{LANG_([^}]+)}/g);

                if (translationMatches) {
                  translationMatches.forEach(match => {
                    // Extract the key from {LANG_key}
                    const key = match.replace("{LANG_", "").replace("}", "");
                    translationKeysToRemove.push(key);
                  });
                }

                // Remember only the first form position
                if (!foundFirstForm) {
                  const { parentElement } = widget;
                  if (parentElement) {
                    const siblings = Array.from(parentElement.children);
                    const position = siblings.indexOf(widget as Element);

                    firstFormPosition = {
                      sectionIndex,
                      parentElement,
                      position
                    };

                    foundFirstForm = true;
                  }
                }
                // Get the CSS of the widget by widget type
                const widgetType = widget.getAttribute("data-widgettype") || "";
                if (
                  widgetType &&
                  widget.classList.contains("spm_widget_form") &&
                  !cssByWidgetType[widgetType]
                ) {
                  const cssObject = JSON.parse(section.css || "{}");
                  cssByWidgetType[widgetType] = {
                    css: {},
                    widgetId: widget.id
                  };
                  Object.keys(cssObject).forEach(key => {
                    const style = document.createElement("style");
                    style.textContent = cssObject[key];

                    const fragment = document.createDocumentFragment();
                    fragment.appendChild(style);

                    document.head.appendChild(style);
                    const cssRules = style.sheet?.cssRules;
                    document.head.removeChild(style);

                    if (cssRules) {
                      const widgetCss = getElementStylesheet(
                        widget.id,
                        cssRules as CSSRuleList
                      );
                      if (widgetCss) {
                        cssByWidgetType[widgetType].css[key] = widgetCss;
                      }
                    }
                  });
                }

                // Remove the widget
                widget.remove();
              });

              // Update the section HTML
              section.html = tempElement.innerHTML;

              // Clean up CSS related to removed widgets
              if (section.css && widgetIdsToRemove.length > 0) {
                // Use a proper CSS parser approach instead of regex
                const styleSheet = document.createElement("style");
                styleSheet.textContent = section.css;
                document.head.appendChild(styleSheet);

                const cssRules = Array.from(styleSheet.sheet?.cssRules || []);
                const rulesToKeep: CSSRule[] = [];

                cssRules.forEach(rule => {
                  // Check if this rule targets any of the removed widgets
                  let shouldKeepRule = true;

                  if (rule.type === CSSRule.STYLE_RULE) {
                    const styleRule = rule as CSSStyleRule;
                    const { selectorText } = styleRule;

                    // Check if any of the widget IDs appear in this selector
                    // eslint-disable-next-line no-restricted-syntax
                    for (const widgetId of widgetIdsToRemove) {
                      if (selectorText.includes(`#${widgetId}`)) {
                        shouldKeepRule = false;
                        break;
                      }
                    }
                  }

                  if (shouldKeepRule) {
                    rulesToKeep.push(rule);
                  }
                });

                // Remove the temporary style element
                document.head.removeChild(styleSheet);

                // Rebuild the CSS with only the rules we want to keep
                let updatedCss = "";
                rulesToKeep.forEach(rule => {
                  updatedCss += `${rule.cssText}\n`;
                });

                // Update the section CSS
                section.css = updatedCss;
              }
            });

            // Remove the identified translation keys
            if (template.translations) {
              template.translations = template.translations.filter(
                translation =>
                  !translationKeysToRemove.some(
                    key =>
                      translation.key === key ||
                      translation.key.startsWith(`${key}.`)
                  )
              );
            }

            const formWidgets = getFormWidgetsForNextStep(
              nextStep,
              t,
              template.version === 4
            );
            if (formWidgets.length) {
              // Determine target section and position
              const targetSectionIndex = firstFormPosition
                ? (firstFormPosition as FirstFormPosition).sectionIndex
                : template.sections.length - 1;

              const targetSection = template.sections[targetSectionIndex];

              // Create temporary DOM element for the target section
              const sectionElement = document.createElement("div");
              sectionElement.innerHTML = targetSection.html;

              let targetContainer =
                sectionElement.querySelector(".spm_column") ||
                sectionElement.firstElementChild;
              if (firstFormPosition) {
                targetContainer = sectionElement.querySelector(
                  `#${
                    (firstFormPosition as FirstFormPosition).parentElement.id
                  }`
                );
              }

              if (targetContainer && targetSection) {
                let insertPosition = targetContainer.children.length;
                if (firstFormPosition) {
                  insertPosition = (firstFormPosition as FirstFormPosition)
                    .position;
                }

                const formOptions: Record<string, any> = {};
                const targetSectionCss = JSON.parse(targetSection.css || "{}");

                // eslint-disable-next-line no-restricted-syntax
                for (const widget of formWidgets) {
                  const widgetHtml = widget.getWidgetHtml(
                    getTemplateParentTypeByType(template.type)
                  );

                  // eslint-disable-next-line prefer-const
                  let { newHtml, translationsArray } = generateTranslations(
                    widgetHtml,
                    {
                      newElement: false,
                      translateVariables: true,
                      forceTranslateHiddenElement: true
                    }
                  );

                  // Create temporary element for the widget
                  const widgetElement = document.createElement("div");
                  widgetElement.innerHTML = newHtml;

                  const widgetId = widgetElement.firstElementChild?.id;
                  const widgetType =
                    widgetElement.firstElementChild?.getAttribute(
                      "data-widgettype"
                    ) || "";

                  // Insert at current position and increment for next widget
                  targetContainer.insertBefore(
                    widgetElement.firstElementChild as Element,
                    targetContainer.children[insertPosition] || null
                  );
                  insertPosition += 1; // Move to next position for the next widget

                  // Update translations array section id
                  translationsArray = translationsArray.map(translation => ({
                    ...translation,
                    section: targetSection.id_template_elements
                  }));

                  // Add translations to the template
                  if (translationsArray && translationsArray.length > 0) {
                    template.translations.push(...translationsArray);
                  }

                  // Add to formOptions
                  if (widgetId && widget.formOptions) {
                    formOptions[widgetId] = widget.formOptions;
                  }

                  // Add new css by widget type
                  if (widgetType && cssByWidgetType[widgetType]) {
                    const { css, widgetId: oldWidgetId } = cssByWidgetType[
                      widgetType
                    ];
                    Object.keys(css).forEach(cssKey => {
                      if (cssKey in targetSectionCss) {
                        const widgetCss = css[cssKey];
                        const reg = new RegExp(
                          `${oldWidgetId}(,?(\\.[a-zA-Z0-9_,-]*)? )`,
                          "gm"
                        );
                        targetSectionCss[cssKey] = `${
                          targetSectionCss[cssKey]
                        }\n${widgetCss.replace(reg, `${widgetId}$1`)}`;
                      }
                    });
                  }
                }

                // Update the section's HTML with the new content
                targetSection.html = sectionElement.innerHTML;

                // Update the section's CSS with the new content
                targetSection.css = JSON.stringify(targetSectionCss);

                // Update sections
                const sections = [];
                sections.push(
                  ...template.sections.map((current: Section) => ({
                    ...current,
                    translations: formatTranslationsForSection(
                      template.translations.filter(
                        (translation: Translation) =>
                          translation.section.toString() ===
                          current.id_template_elements.toString()
                      ) ?? []
                    )
                  }))
                );

                template.sections = sections;

                // Update template form configurations (forms are also removed, so clear hasForm)
                delete template.configuration.forms;
                template.configuration.hasForm = false;
                if (formOptions && Object.keys(formOptions).length > 0) {
                  template.configuration.forms = formOptions;
                  template.configuration.hasForm = true;
                }
              }
            }
            // Clear inherited configuration (game widgets and funnels are removed from duplicated templates)
            delete template.configuration.funnels;
            delete template.configuration.games_data;
            delete template.configuration.nextIdTemplate;
            delete template.configuration.teaserId;
            template.configuration.hasGame = false;

            if (nextStep === NextStepEnum.OFFER_VOUCHER) {
              template.configuration.hasVoucher = true;
            }

            updateTemplateWhatsappData(template);
          }

          return {
            item: ({ id_template: template.id } as unknown) as Templates,
            template
          };
        }
      }
    } catch (e) {
      return null;
    }
  }
  return null;
};

/**
 * Check if an email widget exists in the funnel (including current template)
 */
export const hasEmailWidgetInFunnel = (): boolean => {
  // Check current template first
  if (hasEmailWidgetInTemplate()) {
    return true;
  }

  // If not in a funnel, return false
  if (
    !state.template?.originTemplateId ||
    !state.templatesFromFunnel[state.template.originTemplateId]
  ) {
    return false;
  }

  // Check all templates in the funnel
  const funnelTemplates =
    state.templatesFromFunnel[state.template.originTemplateId];
  const hasEmailInFunnel = funnelTemplates.some((template: any) => {
    // Skip current template as we already checked it
    if (template.id === state.template?.id) {
      return false;
    }

    // Check if this template has an email widget
    if (template.configuration?.forms) {
      const hasEmailWidget = Object.values(template.configuration.forms).some(
        (formConfig: any) => formConfig.type === "widget-input-email"
      );
      if (hasEmailWidget) {
        return true;
      }
    }
    return false;
  });

  if (hasEmailInFunnel) {
    return true;
  }

  return false;
};

/**
 * Check if a phone widget exists in the funnel (including current template)
 */
export const hasPhoneWidgetInFunnel = (): boolean => {
  // Check current template first
  if (hasPhoneWidgetInTemplate()) {
    return true;
  }

  // If not in a funnel, return false
  if (
    !state.template?.originTemplateId ||
    !state.templatesFromFunnel[state.template.originTemplateId]
  ) {
    return false;
  }

  // Check all templates in the funnel
  const funnelTemplates =
    state.templatesFromFunnel[state.template.originTemplateId];
  return funnelTemplates.some((template: any) => {
    // Skip current template as we already checked it
    if (template.id === state.template?.id) {
      return false;
    }

    // Check if this template has a phone widget
    if (template.configuration?.forms) {
      const hasPhoneWidget = Object.values(template.configuration.forms).some(
        (formConfig: any) => formConfig.type === "widget-input-phone"
      );
      if (hasPhoneWidget) {
        return true;
      }
    }
    return false;
  });

  return false;
};

/**
 * Count password widgets in the entire funnel (including current template)
 */
export const countPasswordWidgetsInFunnel = (): number => {
  let totalCount = 0;

  // Count in current template
  totalCount += countPasswordWidgetsInTemplate();

  // If not in a funnel, return current count
  if (
    !state.template?.originTemplateId ||
    !state.templatesFromFunnel[state.template.originTemplateId]
  ) {
    return totalCount;
  }

  // Count password widgets in all templates of the funnel
  const funnelTemplates =
    state.templatesFromFunnel[state.template.originTemplateId];
  funnelTemplates.forEach((template: any) => {
    // Skip current template as we already counted it
    if (template.id === state.template?.id) {
      return;
    }

    // Count password widgets in this template
    if (template.configuration?.forms) {
      const passwordCount = Object.values(template.configuration.forms).filter(
        (formConfig: any) => formConfig.type === "widget-input-password"
      ).length;
      totalCount += passwordCount;
    }
  });

  return totalCount;
};

/**
 * Check if a disclosure widget already exists in the current template (iframe DOM)
 */
export const hasDisclosureWidgetInTemplate = (): boolean => {
  const template = getTemplateIframeDocument();
  if (template) {
    return !!template.querySelector(
      `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_disclosure"]`
    );
  }
  return false;
};

/**
 * Check if a disclosure widget exists in the funnel (including current template)
 */
export const hasDisclosureWidgetInFunnel = (): boolean => {
  if (hasDisclosureWidgetInTemplate()) {
    return true;
  }

  if (
    !state.template?.originTemplateId ||
    !state.templatesFromFunnel[state.template.originTemplateId]
  ) {
    return false;
  }

  const funnelTemplates =
    state.templatesFromFunnel[state.template.originTemplateId];
  return funnelTemplates.some((template: any) => {
    if (template.id === state.template?.id) {
      return false;
    }
    if (template.configuration?.forms) {
      return Object.values(template.configuration.forms).some(
        (formConfig: any) => formConfig.type === "widget-disclosure"
      );
    }
    return false;
  });
};

/**
 * Count consent checkbox widgets in the current template
 */
export const countConsentCheckboxesInTemplate = (): number => {
  const template = getTemplateIframeDocument();
  if (template) {
    return template.querySelectorAll(
      `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_consent_checkbox"]`
    ).length;
  }
  return 0;
};

/**
 * Get consent channels already used by consent checkbox widgets in the template
 * @param excludeWidgetId - optional widget ID to exclude (e.g. the currently active one)
 */
export const getUsedConsentChannelsInTemplate = (
  excludeWidgetId?: string
): string[] => {
  const template = getTemplateIframeDocument();
  if (!template) return [];

  const widgets = template.querySelectorAll(
    `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_consent_checkbox"]`
  );
  const channels: string[] = [];

  widgets.forEach(widget => {
    if (excludeWidgetId && widget.id === excludeWidgetId) return;
    const channel = widget.getAttribute("data-consent-channel");
    if (channel) channels.push(channel);
  });

  return channels;
};

/**
 * Check if an email or phone widget exists in the current template
 */
export const hasEmailOrPhoneWidgetInTemplate = (): boolean =>
  hasEmailWidgetInTemplate() || hasPhoneWidgetInTemplate();

/**
 * Get auto-selected disclosure channels based on present form fields in template
 */
export const getAutoDisclosureChannels = (): string[] => {
  const channels: string[] = [];
  if (hasEmailWidgetInTemplate() || hasEmailWidgetInFunnel()) {
    channels.push("email");
  }
  if (hasPhoneWidgetInTemplate() || hasPhoneWidgetInFunnel()) {
    channels.push("sms", "whatsapp");
  }
  return channels;
};

/**
 * After removing an email or phone widget, update disclosure channels to remove
 * channels that no longer have a corresponding identifier widget.
 * Also updates the disclosure message if it was a default message.
 */
export const updateDisclosureAfterWidgetRemoval = (): void => {
  if (!hasDisclosureWidgetInTemplate()) return;

  const template = getTemplateIframeDocument();
  if (!template) return;

  const disclosureWidget = template.querySelector(
    `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_disclosure"]`
  ) as HTMLElement;
  if (!disclosureWidget) return;

  const widgetId = disclosureWidget.id;
  const currentChannelsAttr =
    disclosureWidget.getAttribute("data-disclosure-channels") || "";
  const currentChannels = currentChannelsAttr.split(",").filter(Boolean);

  if (currentChannels.length === 0) return;

  // Recalculate valid channels based on remaining widgets
  const validChannels = getAutoDisclosureChannels();
  const filteredChannels = currentChannels.filter(ch =>
    validChannels.includes(ch)
  );

  // Only update if channels actually changed
  if (filteredChannels.length === currentChannels.length) return;

  // Use dynamic import to call the setter (which handles message update + state persistence)
  import("@/components/template-builder/setters/form").then(
    ({ setDisclosureChannels }) => {
      setDisclosureChannels(`#${widgetId}`, {
        name: "data-disclosure-channels",
        value: filteredChannels,
        getter: () => {},
        setters: []
      });
    }
  );
};

/**
 * Auto-update disclosure channels when an email or phone widget is added.
 * Adds newly available channels to the disclosure widget.
 * Also updates the disclosure message if it was a default message.
 */
export const updateDisclosureAfterWidgetAddition = (): void => {
  if (!hasDisclosureWidgetInTemplate()) return;

  const template = getTemplateIframeDocument();
  if (!template) return;

  const disclosureWidget = template.querySelector(
    `${TEMPLATE_WIDGET_IDENTIFIER}[data-widgettype="spm_widget_disclosure"]`
  ) as HTMLElement;
  if (!disclosureWidget) return;

  const widgetId = disclosureWidget.id;
  const currentChannelsAttr =
    disclosureWidget.getAttribute("data-disclosure-channels") || "";
  const currentChannels = currentChannelsAttr.split(",").filter(Boolean);

  // Recalculate all valid channels based on present widgets
  const autoChannels = getAutoDisclosureChannels();

  // Merge: keep existing + add new auto-detected channels
  const updatedChannels = [...new Set([...currentChannels, ...autoChannels])];

  // Only update if there are new channels to add
  if (updatedChannels.length === currentChannels.length) return;

  // Use dynamic import to call the setter (which handles message update + state persistence)
  import("@/components/template-builder/setters/form").then(
    ({ setDisclosureChannels }) => {
      setDisclosureChannels(`#${widgetId}`, {
        name: "data-disclosure-channels",
        value: updatedChannels,
        getter: () => {},
        setters: []
      });
    }
  );
};

/**
 * Check if a game widget already exists in the current template (iframe DOM)
 */
export const hasGameWidgetInCurrentTemplate = (): boolean => {
  const template = getTemplateIframeDocument();
  if (template) {
    return !!template.querySelector(
      ".spm_widget_game_wheel, .spm_widget_game_slot_machine, .spm_widget_game_scratch_card"
    );
  }
  return false;
};

/**
 * Check if a game widget exists in another template of the funnel (excluding current)
 */
export const hasGameWidgetInOtherFunnelTemplates = (): boolean => {
  if (
    !state.template?.originTemplateId ||
    !state.templatesFromFunnel[state.template.originTemplateId]
  ) {
    return false;
  }

  const funnelTemplates =
    state.templatesFromFunnel[state.template.originTemplateId];
  return funnelTemplates.some((tmpl: any) => {
    if (tmpl.id === state.template?.id) {
      return false;
    }
    return !!tmpl.configuration?.hasGame;
  });
};

/**
 * Check if a game widget exists in the current template or across the funnel
 */
export const hasGameWidgetInFunnel = (): boolean =>
  hasGameWidgetInCurrentTemplate() || hasGameWidgetInOtherFunnelTemplates();

/**
 * Validate if a widget can be added to the template based on existing widgets
 * @param widgetType - The type of widget to validate
 * @returns Object with validation result and message
 */
export const validateWidgetAddition = (
  widgetType: string
): { canAdd: boolean; message?: string } => {
  switch (widgetType) {
    case WidgetTypeEnum.INPUT_EMAIL:
      if (hasEmailWidgetInFunnel()) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.emailAlreadyExistsInFunnel"
        };
      }
      break;
    case WidgetTypeEnum.INPUT_PHONE:
      if (hasPhoneWidgetInFunnel()) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.phoneAlreadyExistsInFunnel"
        };
      }
      break;
    case WidgetTypeEnum.INPUT_PASSWORD: {
      const passwordCount = countPasswordWidgetsInFunnel();
      if (passwordCount >= 2) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.passwordLimitReachedInFunnel"
        };
      }
      break;
    }
    case WidgetTypeEnum.GAME_WHEEL:
    case WidgetTypeEnum.GAME_SLOT_MACHINE:
    case WidgetTypeEnum.GAME_SCRATCH_CARD:
      if (hasGameWidgetInCurrentTemplate()) {
        return {
          canAdd: false,
          message: "templateBuilder.widgetsAdditionErrors.gameAlreadyExists"
        };
      }
      if (hasGameWidgetInOtherFunnelTemplates()) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.gameAlreadyExistsInFunnel"
        };
      }
      break;
    case WidgetTypeEnum.CONSENT_CHECKBOX:
      if (countConsentCheckboxesInTemplate() >= 3) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.consentCheckboxLimitReached"
        };
      }
      break;
    case WidgetTypeEnum.DISCLOSURE:
      if (hasDisclosureWidgetInTemplate()) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.disclosureAlreadyExists"
        };
      }
      if (
        !hasEmailOrPhoneWidgetInTemplate() &&
        !hasEmailWidgetInFunnel() &&
        !hasPhoneWidgetInFunnel()
      ) {
        return {
          canAdd: false,
          message:
            "templateBuilder.widgetsAdditionErrors.disclosureRequiresEmailOrPhone"
        };
      }
      break;
    default:
      // Other widget types are allowed without restriction
      break;
  }

  return { canAdd: true };
};
